import { __decorate, __param, __rest, __awaiter } from 'tslib';
import * as i0 from '@angular/core';
import { Injectable, EventEmitter, ViewChild, Input, Output, Component, ViewEncapsulation, ChangeDetectionStrategy, Inject, ChangeDetectorRef, InjectionToken, forwardRef, Pipe, HostListener, Directive, ElementRef, HostBinding, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { takeUntil, pluck, first, observeOn, map, filter, take } from 'rxjs/operators';
import { Subject, BehaviorSubject, asyncScheduler, interval, Observable, fromEvent } from 'rxjs';
import moment$1 from 'moment';
import { FormControl, FormBuilder, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as libphonenumber from 'libphonenumber-js';
import { OwlDateTimeIntl, OWL_DATE_TIME_FORMATS, DateTimeAdapter, OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import * as i1 from '@angular/material/snack-bar';
import { MatSnackBarConfig, MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import * as i1$1 from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import * as Cleave from 'cleave.js/dist/cleave.js';
import * as _ from 'lodash';
import { CommonModule, registerLocaleData } from '@angular/common';
import { NgxMaskModule } from 'ngx-mask';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as d3 from 'd3v4';
import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule, MatDatepicker } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule, MatRippleModule, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { ClipboardModule } from '@angular/cdk/clipboard';
import localeNb from '@angular/common/locales/nb';
import localeNbExtra from '@angular/common/locales/extra/nb';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { AutosizeModule } from 'ngx-autosize';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from 'primeng/table';
import * as ɵngcc3 from 'primeng/api';
import * as ɵngcc4 from '@angular/forms';
import * as ɵngcc5 from '@angular/material/paginator';
import * as ɵngcc6 from 'ngx-mask';
import * as ɵngcc7 from '@angular/material/tooltip';
import * as ɵngcc8 from 'ngx-autosize';
import * as ɵngcc9 from '@danielmoncada/angular-datetime-picker';
import * as ɵngcc10 from '@angular/material/slide-toggle';
import * as ɵngcc11 from '@angular/router';
import * as ɵngcc12 from '@angular/material/input';
import * as ɵngcc13 from '@angular/material/datepicker';
import * as ɵngcc14 from '@angular/material/form-field';

const _c0 = ["table"];
function TableComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "h2", 18);
    ɵngcc0.ɵɵelementStart(2, "b");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.title);
} }
function TableComponent_ng_container_3_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 28);
    ɵngcc0.ɵɵlistener("click", function TableComponent_ng_container_3_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(2); return ctx_r23.addItem(); });
    ɵngcc0.ɵɵelement(1, "i", 29);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "localize");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r14.disabledInputs || ctx_r14.disabledAddButton);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 2, ctx_r14.addButtonText), " ");
} }
function TableComponent_ng_container_3_ng_container_4_div_1_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i");
} if (rf & 2) {
    const cfg_r26 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassMap(cfg_r26.icon);
} }
function TableComponent_ng_container_3_ng_container_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 31);
    ɵngcc0.ɵɵelementStart(1, "ano-button", 32);
    ɵngcc0.ɵɵlistener("click", function TableComponent_ng_container_3_ng_container_4_div_1_Template_ano_button_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r30); const cfg_r26 = restoredCtx.$implicit; return cfg_r26.action(); });
    ɵngcc0.ɵɵelementContainerStart(2);
    ɵngcc0.ɵɵtemplate(3, TableComponent_ng_container_3_ng_container_4_div_1_i_3_Template, 1, 3, "i", 33);
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "localize");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const cfg_r26 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", cfg_r26.buttonConfig);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", cfg_r26.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 3, cfg_r26.text));
} }
function TableComponent_ng_container_3_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TableComponent_ng_container_3_ng_container_4_div_1_Template, 7, 5, "div", 30);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r15.buttonsConfig);
} }
const _c1 = function (a0, a1, a2) { return { inputType: a0, placeholder: a1, selectOptions: a2 }; };
function TableComponent_ng_container_3_ng_container_6_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "ano-input", 37);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const filter_r32 = ctx.$implicit;
    const ctx_r31 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", filter_r32.name)("isEditMode", true)("noBorder", false)("config", ɵngcc0.ɵɵpureFunction3(4, _c1, filter_r32.isMultiselect ? ctx_r31.INPUT_TYPES.MULTISELECT : filter_r32.isMultiselectInSingleDropdown ? ctx_r31.INPUT_TYPES.MULTISELECT_IN_SINGLE_DROPDOWN : ctx_r31.INPUT_TYPES.SELECT, filter_r32.placeholder, filter_r32.selectOptions));
} }
function TableComponent_ng_container_3_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 34);
    ɵngcc0.ɵɵelementStart(2, "form", 35);
    ɵngcc0.ɵɵtemplate(3, TableComponent_ng_container_3_ng_container_6_ng_container_3_Template, 2, 8, "ng-container", 36);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r16.filtersForm);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r16.filtersList);
} }
function TableComponent_ng_container_3_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r35 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "ano-datepicker", 38);
    ɵngcc0.ɵɵlistener("changeDate", function TableComponent_ng_container_3_ng_container_7_Template_ano_datepicker_changeDate_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r35); const ctx_r34 = ɵngcc0.ɵɵnextContext(2); return ctx_r34.timeRangeFilter($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("startFromAll", ctx_r17.startFromAll);
} }
function TableComponent_ng_container_3_ng_template_8_ano_time_range_filter_0_Template(rf, ctx) { if (rf & 1) {
    const _r38 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ano-time-range-filter", 40);
    ɵngcc0.ɵɵlistener("filterByTimeRange$", function TableComponent_ng_container_3_ng_template_8_ano_time_range_filter_0_Template_ano_time_range_filter_filterByTimeRange__0_listener($event) { ɵngcc0.ɵɵrestoreView(_r38); const ctx_r37 = ɵngcc0.ɵɵnextContext(3); return ctx_r37.timeRangeFilter($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("config", ctx_r36.timeRangeConfig);
} }
function TableComponent_ng_container_3_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, TableComponent_ng_container_3_ng_template_8_ano_time_range_filter_0_Template, 1, 1, "ano-time-range-filter", 39);
} if (rf & 2) {
    const ctx_r19 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r19.timeRangeConfig);
} }
function TableComponent_ng_container_3_ano_linked_streams_filter_10_Template(rf, ctx) { if (rf & 1) {
    const _r40 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ano-linked-streams-filter", 41);
    ɵngcc0.ɵɵlistener("filterByLinkedStreams$", function TableComponent_ng_container_3_ano_linked_streams_filter_10_Template_ano_linked_streams_filter_filterByLinkedStreams__0_listener($event) { ɵngcc0.ɵɵrestoreView(_r40); const ctx_r39 = ɵngcc0.ɵɵnextContext(2); return ctx_r39.filterByLinkedStreams($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("filters", ctx_r20.linkedFilters);
} }
function TableComponent_ng_container_3_div_11_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r43 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "div", 43);
    ɵngcc0.ɵɵelementStart(2, "ano-filter-dropdown", 44);
    ɵngcc0.ɵɵlistener("change", function TableComponent_ng_container_3_div_11_ng_container_1_Template_ano_filter_dropdown_change_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r43); const ctx_r42 = ɵngcc0.ɵɵnextContext(3); return ctx_r42.searchByYear($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r41 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("values", ctx_r41.years)("value", "all");
} }
function TableComponent_ng_container_3_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 42);
    ɵngcc0.ɵɵtemplate(1, TableComponent_ng_container_3_div_11_ng_container_1_Template, 3, 2, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r21.withFilters && (ctx_r21.years == null ? null : ctx_r21.years.length) && !ctx_r21.timeRangeConfig);
} }
function TableComponent_ng_container_3_ano_search_12_Template(rf, ctx) { if (rf & 1) {
    const _r45 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ano-search", 45);
    ɵngcc0.ɵɵlistener("search$", function TableComponent_ng_container_3_ano_search_12_Template_ano_search_search__0_listener($event) { ɵngcc0.ɵɵrestoreView(_r45); const ctx_r44 = ɵngcc0.ɵɵnextContext(2); return ctx_r44.search($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("type", ctx_r22.searchInputType)("disabled", ctx_r22.disabledInputs);
} }
function TableComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 19);
    ɵngcc0.ɵɵelementStart(2, "div", 20);
    ɵngcc0.ɵɵtemplate(3, TableComponent_ng_container_3_button_3_Template, 4, 4, "button", 21);
    ɵngcc0.ɵɵtemplate(4, TableComponent_ng_container_3_ng_container_4_Template, 2, 1, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 22);
    ɵngcc0.ɵɵtemplate(6, TableComponent_ng_container_3_ng_container_6_Template, 4, 2, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(7, TableComponent_ng_container_3_ng_container_7_Template, 2, 1, "ng-container", 23);
    ɵngcc0.ɵɵtemplate(8, TableComponent_ng_container_3_ng_template_8_Template, 1, 1, "ng-template", null, 24, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(10, TableComponent_ng_container_3_ano_linked_streams_filter_10_Template, 1, 1, "ano-linked-streams-filter", 25);
    ɵngcc0.ɵɵtemplate(11, TableComponent_ng_container_3_div_11_Template, 2, 1, "div", 26);
    ɵngcc0.ɵɵtemplate(12, TableComponent_ng_container_3_ano_search_12_Template, 1, 2, "ano-search", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r18 = ɵngcc0.ɵɵreference(9);
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("align-content-between", (ctx_r1.buttonsConfig == null ? null : ctx_r1.buttonsConfig.length) || ctx_r1.addButton)("align-content-end", !(ctx_r1.buttonsConfig == null ? null : ctx_r1.buttonsConfig.length) && !ctx_r1.addButton);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.addButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.buttonsConfig == null ? null : ctx_r1.buttonsConfig.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("justify-content-end", !(ctx_r1.filtersList == null ? null : ctx_r1.filtersList.length) && !ctx_r1.timeRangeConfig && !(ctx_r1.config == null ? null : ctx_r1.config.filtersWidth100))("width100", ctx_r1.config == null ? null : ctx_r1.config.filtersWidth100);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.filtersList == null ? null : ctx_r1.filtersList.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showDatepicker)("ngIfElse", _r18);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.isLinkedStreamsFilters);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.withFilters);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.withSearch);
} }
function TableComponent_ano_loader_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ano-loader", 46);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵproperty("isOpen", ctx_r3.loading)("containerRef", _r2);
} }
function TableComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 47);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "localize");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r4.systemMessage || "table.noResults"), " ");
} }
const _c2 = function () { return { type: "button", styleType: "primary" }; };
function TableComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r47 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 48);
    ɵngcc0.ɵɵelementStart(1, "ano-button", 49);
    ɵngcc0.ɵɵlistener("click", function TableComponent_div_13_Template_ano_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r47); const ctx_r46 = ɵngcc0.ɵɵnextContext(); return ctx_r46.goToNoDataLink(ctx_r46.config == null ? null : ctx_r46.config.noDataLink == null ? null : ctx_r46.config.noDataLink.url); });
    ɵngcc0.ɵɵelementContainerStart(2);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "localize");
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", ɵngcc0.ɵɵpureFunction0(4, _c2));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 2, ctx_r5.config == null ? null : ctx_r5.config.noDataLink == null ? null : ctx_r5.config.noDataLink.title));
} }
function TableComponent_ng_template_16_tr_0_ng_container_1_th_1_p_sortIcon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "p-sortIcon", 54);
} if (rf & 2) {
    const col_r51 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("field", col_r51.sortField);
} }
function TableComponent_ng_template_16_tr_0_ng_container_1_th_1_Template(rf, ctx) { if (rf & 1) {
    const _r57 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "th", 51);
    ɵngcc0.ɵɵlistener("click", function TableComponent_ng_template_16_tr_0_ng_container_1_th_1_Template_th_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r57); const col_r51 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r55 = ɵngcc0.ɵɵnextContext(3); return col_r51.sortField && ctx_r55.resetTableData(); });
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵtemplate(2, TableComponent_ng_template_16_tr_0_ng_container_1_th_1_p_sortIcon_2_Template, 1, 1, "p-sortIcon", 52);
    ɵngcc0.ɵɵelementStart(3, "div", 53);
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "whiteSpace");
    ɵngcc0.ɵɵpipe(7, "localize");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r51 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵstyleProp("text-align", col_r51 == null ? null : col_r51.textAlign);
    ɵngcc0.ɵɵclassProp("cursor-pointer", col_r51.sortField);
    ɵngcc0.ɵɵproperty("pSortableColumn", col_r51.sortField);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap("head-cell head-cell-" + (col_r51.class || "left"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", col_r51.sortField);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 9, ɵngcc0.ɵɵpipeBind1(7, 11, col_r51.name)));
} }
function TableComponent_ng_template_16_tr_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TableComponent_ng_template_16_tr_0_ng_container_1_th_1_Template, 8, 13, "th", 50);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const col_r51 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !col_r51.hide);
} }
function TableComponent_ng_template_16_tr_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵtemplate(1, TableComponent_ng_template_16_tr_0_ng_container_1_Template, 2, 1, "ng-container", 36);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r49 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r49.config.columns);
} }
function TableComponent_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, TableComponent_ng_template_16_tr_0_Template, 2, 1, "tr", 2);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r7.data == null ? null : ctx_r7.data.length) > 0);
} }
function TableComponent_ng_template_17_ng_container_1_td_1_ng_container_1_ng_container_1_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const col_r62 = ɵngcc0.ɵɵnextContext(5).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", col_r62.units, " ");
} }
function TableComponent_ng_template_17_ng_container_1_td_1_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, TableComponent_ng_template_17_ng_container_1_td_1_ng_container_1_ng_container_1_ng_container_1_ng_container_2_Template, 2, 1, "ng-container", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const col_r62 = ɵngcc0.ɵɵnextContext(4).$implicit;
    const rowData_r59 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", rowData_r59[col_r62.dataField], " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", col_r62.units);
} }
function TableComponent_ng_template_17_ng_container_1_td_1_ng_container_1_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const col_r62 = ɵngcc0.ɵɵnextContext(4).$implicit;
    const rowData_r59 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", rowData_r59[col_r62.dataFieldUnit.parentField][col_r62.dataFieldUnit.value], " ", rowData_r59[col_r62.dataFieldUnit.parentField][col_r62.dataFieldUnit.unit], " ");
} }
function TableComponent_ng_template_17_ng_container_1_td_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TableComponent_ng_template_17_ng_container_1_td_1_ng_container_1_ng_container_1_ng_container_1_Template, 3, 2, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(2, TableComponent_ng_template_17_ng_container_1_td_1_ng_container_1_ng_container_1_ng_container_2_Template, 2, 2, "ng-container", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const col_r62 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", col_r62.dataField);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", col_r62.dataFieldUnit);
} }
function TableComponent_ng_template_17_ng_container_1_td_1_ng_container_1_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const col_r62 = ɵngcc0.ɵɵnextContext(4).$implicit;
    const rowData_r59 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r77 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r77.formatDate(rowData_r59[col_r62.dataField]), " ");
} }
function TableComponent_ng_template_17_ng_container_1_td_1_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TableComponent_ng_template_17_ng_container_1_td_1_ng_container_1_ng_container_2_ng_container_1_Template, 2, 1, "ng-container", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const col_r62 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", col_r62.dataField);
} }
function TableComponent_ng_template_17_ng_container_1_td_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TableComponent_ng_template_17_ng_container_1_td_1_ng_container_1_ng_container_1_Template, 3, 2, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(2, TableComponent_ng_template_17_ng_container_1_td_1_ng_container_1_ng_container_2_Template, 2, 1, "ng-container", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const col_r62 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !col_r62.boolean && !col_r62.date && !col_r62.image);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !col_r62.boolean && col_r62.date && !col_r62.image);
} }
function TableComponent_ng_template_17_ng_container_1_td_1_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c3 = function (a0) { return { rowData: a0 }; };
function TableComponent_ng_template_17_ng_container_1_td_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TableComponent_ng_template_17_ng_container_1_td_1_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 58);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const col_r62 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const rowData_r59 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", col_r62.tmpl)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c3, rowData_r59));
} }
function TableComponent_ng_template_17_ng_container_1_td_1_Template(rf, ctx) { if (rf & 1) {
    const _r87 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td", 57);
    ɵngcc0.ɵɵlistener("click", function TableComponent_ng_template_17_ng_container_1_td_1_Template_td_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r87); const col_r62 = ɵngcc0.ɵɵnextContext().$implicit; const rowData_r59 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r85 = ɵngcc0.ɵɵnextContext(); ctx_r85.onRowClick(rowData_r59); return ctx_r85.config.navigationUrl && !(col_r62 == null ? null : col_r62.preventNavigation) && ctx_r85.navigate(rowData_r59.id); });
    ɵngcc0.ɵɵtemplate(1, TableComponent_ng_template_17_ng_container_1_td_1_ng_container_1_Template, 3, 2, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(2, TableComponent_ng_template_17_ng_container_1_td_1_ng_container_2_Template, 2, 4, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r62 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r63 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(col_r62.class || "left");
    ɵngcc0.ɵɵstyleProp("text-align", col_r62 == null ? null : col_r62.textAlign);
    ɵngcc0.ɵɵclassProp("hover", ctx_r63.isOpportunityToSelect);
    ɵngcc0.ɵɵproperty("width", (col_r62 == null ? null : col_r62.width) || "auto");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !col_r62.tmpl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", col_r62.tmpl);
} }
function TableComponent_ng_template_17_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TableComponent_ng_template_17_ng_container_1_td_1_Template, 3, 9, "td", 56);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const col_r62 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !col_r62.hide);
} }
function TableComponent_ng_template_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr", 55);
    ɵngcc0.ɵɵtemplate(1, TableComponent_ng_template_17_ng_container_1_Template, 2, 1, "ng-container", 36);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const rowData_r59 = ctx.$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("hover", ctx_r8.isOpportunityToSelect)("selected", ctx_r8.selectedRowId && ctx_r8.selectedRowId === (rowData_r59 == null ? null : rowData_r59.id));
    ɵngcc0.ɵɵproperty("ngClass", ctx_r8.getHighlightClass(rowData_r59));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r8.config.columns);
} }
function TableComponent_18_ng_template_0_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TableComponent_18_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, TableComponent_18_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 60);
} if (rf & 2) {
    const ctx_r90 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r90.config.tableSummary);
} }
function TableComponent_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, TableComponent_18_ng_template_0_Template, 1, 1, "ng-template", 59);
} }
function TableComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    const _r93 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 61);
    ɵngcc0.ɵɵelementStart(1, "button", 62);
    ɵngcc0.ɵɵlistener("click", function TableComponent_div_19_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r93); const ctx_r92 = ɵngcc0.ɵɵnextContext(); return ctx_r92.download(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "localize");
    ɵngcc0.ɵɵelement(4, "ano-loader", 63);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵprojection(5, 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(3, 2, ctx_r10.downloadButtonText), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("isOpen", ctx_r10.isDownloadLoading);
} }
function TableComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r95 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 64);
    ɵngcc0.ɵɵelementStart(1, "button", 65);
    ɵngcc0.ɵɵlistener("click", function TableComponent_div_20_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r95); const ctx_r94 = ɵngcc0.ɵɵnextContext(); return ctx_r94.loadNextPage(); });
    ɵngcc0.ɵɵtext(2, "Weitere laden");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵprojection(3, 3);
    ɵngcc0.ɵɵelementEnd();
} }
const _c4 = function () { return [10, 20, 50]; };
function TableComponent_div_21_mat_paginator_1_Template(rf, ctx) { if (rf & 1) {
    const _r98 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-paginator", 68);
    ɵngcc0.ɵɵlistener("page", function TableComponent_div_21_mat_paginator_1_Template_mat_paginator_page_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r98); const ctx_r97 = ɵngcc0.ɵɵnextContext(2); return ctx_r97.goToPage($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r96 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("length", ctx_r96.totalItems)("pageSize", ctx_r96.itemsOnPage)("pageSizeOptions", ɵngcc0.ɵɵpureFunction0(3, _c4));
} }
function TableComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 66);
    ɵngcc0.ɵɵtemplate(1, TableComponent_div_21_mat_paginator_1_Template, 1, 4, "mat-paginator", 67);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r12.totalPages > 1);
} }
function TableComponent_span_22_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, " no config for the table ");
    ɵngcc0.ɵɵelementEnd();
} }
const _c5 = [[["", "role", "searchwithbuttons"]], [["", "role", "table-header"]], [["", "role", "bottombuttons"]], [["", "role", "bottombuttons"]]];
const _c6 = ["[role=searchWithButtons]", "[role=table-header]", "[role=bottomButtons]", "[role=bottomButtons]"];
const _c7 = ["multimediaUploader"];
const _c8 = ["input"];
const _c9 = ["inputDate"];
function InputComponent_ng_container_0_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelement(2, "i");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("disabled", !ctx_r17.defaultForm && (ctx_r17.disabled || ctx_r17.config.disabled));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("icon icon-", ctx_r17.config.prepend, "");
} }
function InputComponent_ng_container_0_ng_container_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "input", 8, 9);
    ɵngcc0.ɵɵlistener("blur", function InputComponent_ng_container_0_ng_container_1_ng_container_3_Template_input_blur_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(3); return ctx_r24.onBlur($event); })("ngModelChange", function InputComponent_ng_container_0_ng_container_1_ng_container_3_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r26 = ɵngcc0.ɵɵnextContext(3); return ctx_r26.value = $event; })("focus", function InputComponent_ng_container_0_ng_container_1_ng_container_3_Template_input_focus_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r27 = ɵngcc0.ɵɵnextContext(3); return ctx_r27.onFocus($event); })("input", function InputComponent_ng_container_0_ng_container_1_ng_container_3_Template_input_input_1_listener() { ɵngcc0.ɵɵrestoreView(_r25); const _r23 = ɵngcc0.ɵɵreference(2); const ctx_r28 = ɵngcc0.ɵɵnextContext(3); return ctx_r28.onInput(_r23.value); })("change", function InputComponent_ng_container_0_ng_container_1_ng_container_3_Template_input_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r25); const _r23 = ɵngcc0.ɵɵreference(2); const ctx_r29 = ɵngcc0.ɵɵnextContext(3); return ctx_r29.change(_r23.value); })("keyup", function InputComponent_ng_container_0_ng_container_1_ng_container_3_Template_input_keyup_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r30 = ɵngcc0.ɵɵnextContext(3); return ctx_r30.onKeyUp($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r18 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("form-control ", ctx_r18.config.classList, "");
    ɵngcc0.ɵɵclassProp("img-edit", !ctx_r18.isEditMode)("active", !ctx_r18.isEditMode)("inline-edit", ctx_r18.config.isInlineEditing && !ctx_r18.isFocused)("invalid", ctx_r18.invalid && (ctx_r18.isTouched || ctx_r18.isDirty))("disabled", !ctx_r18.defaultForm && (ctx_r18.disabled || ctx_r18.config.disabled))("append-text", ctx_r18.config.appendText);
    ɵngcc0.ɵɵproperty("type", ctx_r18.config.type || "text")("name", ctx_r18.name)("mask", ctx_r18.config.mask)("placeholder", ctx_r18.getPlaceholder(ctx_r18.config.placeholder, ctx_r18.config.isRequired))("required", ctx_r18.config.isRequired)("ngModel", ctx_r18.value)("readonly", ctx_r18.readonly)("disabled", ctx_r18.disabled || ctx_r18.config.disabled);
} }
function InputComponent_ng_container_0_ng_container_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "input", 10, 9);
    ɵngcc0.ɵɵlistener("blur", function InputComponent_ng_container_0_ng_container_1_ng_container_4_Template_input_blur_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r32 = ɵngcc0.ɵɵnextContext(3); return ctx_r32.onBlur($event); })("ngModelChange", function InputComponent_ng_container_0_ng_container_1_ng_container_4_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r34 = ɵngcc0.ɵɵnextContext(3); return ctx_r34.value = $event; })("focus", function InputComponent_ng_container_0_ng_container_1_ng_container_4_Template_input_focus_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r35 = ɵngcc0.ɵɵnextContext(3); return ctx_r35.onFocus($event); })("input", function InputComponent_ng_container_0_ng_container_1_ng_container_4_Template_input_input_1_listener() { ɵngcc0.ɵɵrestoreView(_r33); const _r31 = ɵngcc0.ɵɵreference(2); const ctx_r36 = ɵngcc0.ɵɵnextContext(3); return ctx_r36.onInput(_r31.value); })("change", function InputComponent_ng_container_0_ng_container_1_ng_container_4_Template_input_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r33); const _r31 = ɵngcc0.ɵɵreference(2); const ctx_r37 = ɵngcc0.ɵɵnextContext(3); return ctx_r37.change(_r31.value); })("keyup", function InputComponent_ng_container_0_ng_container_1_ng_container_4_Template_input_keyup_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r38 = ɵngcc0.ɵɵnextContext(3); return ctx_r38.onKeyUp($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r19 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("form-control ", ctx_r19.config.classList, "");
    ɵngcc0.ɵɵclassProp("inline-edit", ctx_r19.config.isInlineEditing && !ctx_r19.isFocused)("active", !ctx_r19.isEditMode)("invalid", ctx_r19.invalid && ctx_r19.isTouched)("append-text", ctx_r19.config.appendText)("disabled", !ctx_r19.defaultForm && (ctx_r19.disabled || ctx_r19.config.disabled));
    ɵngcc0.ɵɵproperty("type", ctx_r19.config.type || "text")("placeholder", ctx_r19.getPlaceholder(ctx_r19.config.placeholder, ctx_r19.config.isRequired))("required", ctx_r19.config.isRequired)("ngModel", ctx_r19.value)("readonly", ctx_r19.readonly)("disabled", ctx_r19.disabled || ctx_r19.config.disabled);
} }
function InputComponent_ng_container_0_ng_container_1_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r40 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 11);
    ɵngcc0.ɵɵlistener("click", function InputComponent_ng_container_0_ng_container_1_button_5_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r40); const ctx_r39 = ɵngcc0.ɵɵnextContext(3); return ctx_r39.enableInlineEditing(); });
    ɵngcc0.ɵɵelement(1, "i", 12);
    ɵngcc0.ɵɵelementEnd();
} }
function InputComponent_ng_container_0_ng_container_1_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "localize");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("disabled", !ctx_r21.defaultForm && (ctx_r21.disabled || ctx_r21.config.disabled))("invalid", ctx_r21.invalid && ctx_r21.isTouched);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 5, ctx_r21.config.appendText), " ");
} }
function InputComponent_ng_container_0_ng_container_1_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelement(2, "i");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("disabled", !ctx_r22.defaultForm && (ctx_r22.disabled || ctx_r22.config.disabled))("invalid", ctx_r22.invalid && ctx_r22.isTouched);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("icon icon-", ctx_r22.config.appendIcon, "");
} }
function InputComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtemplate(2, InputComponent_ng_container_0_ng_container_1_div_2_Template, 3, 5, "div", 3);
    ɵngcc0.ɵɵtemplate(3, InputComponent_ng_container_0_ng_container_1_ng_container_3_Template, 3, 23, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(4, InputComponent_ng_container_0_ng_container_1_ng_container_4_Template, 3, 19, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(5, InputComponent_ng_container_0_ng_container_1_button_5_Template, 2, 0, "button", 4);
    ɵngcc0.ɵɵtemplate(6, InputComponent_ng_container_0_ng_container_1_div_6_Template, 4, 7, "div", 5);
    ɵngcc0.ɵɵtemplate(7, InputComponent_ng_container_0_ng_container_1_div_7_Template, 3, 7, "div", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("group-append-text", ctx_r15.config.appendText && ctx_r15.isFocused)("disabled", !ctx_r15.defaultForm && (ctx_r15.disabled || ctx_r15.config.disabled));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.config.prepend);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.config == null ? null : ctx_r15.config.mask);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r15.config == null ? null : ctx_r15.config.mask));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.config.isInlineEditing && !ctx_r15.isFocused);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.config.appendText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.config.appendIcon);
} }
function InputComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r43 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "input", 10, 9);
    ɵngcc0.ɵɵlistener("blur", function InputComponent_ng_container_0_ng_container_2_Template_input_blur_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r43); const ctx_r42 = ɵngcc0.ɵɵnextContext(2); return ctx_r42.onBlur($event); })("ngModelChange", function InputComponent_ng_container_0_ng_container_2_Template_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r43); const ctx_r44 = ɵngcc0.ɵɵnextContext(2); return ctx_r44.value = $event; })("focus", function InputComponent_ng_container_0_ng_container_2_Template_input_focus_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r43); const ctx_r45 = ɵngcc0.ɵɵnextContext(2); return ctx_r45.onFocus($event); })("input", function InputComponent_ng_container_0_ng_container_2_Template_input_input_2_listener() { ɵngcc0.ɵɵrestoreView(_r43); const _r41 = ɵngcc0.ɵɵreference(3); const ctx_r46 = ɵngcc0.ɵɵnextContext(2); return ctx_r46.onInput(_r41.value); })("change", function InputComponent_ng_container_0_ng_container_2_Template_input_change_2_listener() { ɵngcc0.ɵɵrestoreView(_r43); const _r41 = ɵngcc0.ɵɵreference(3); const ctx_r47 = ɵngcc0.ɵɵnextContext(2); return ctx_r47.change(_r41.value); })("keyup", function InputComponent_ng_container_0_ng_container_2_Template_input_keyup_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r43); const ctx_r48 = ɵngcc0.ɵɵnextContext(2); return ctx_r48.onKeyUp($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 14);
    ɵngcc0.ɵɵelementStart(5, "span", 15);
    ɵngcc0.ɵɵlistener("click", function InputComponent_ng_container_0_ng_container_2_Template_span_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r43); const _r41 = ɵngcc0.ɵɵreference(3); const ctx_r49 = ɵngcc0.ɵɵnextContext(2); return ctx_r49.copyValue(_r41.value); });
    ɵngcc0.ɵɵelement(6, "i", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassMapInterpolate1("form-control ", ctx_r16.config.classList, "");
    ɵngcc0.ɵɵclassProp("active", !ctx_r16.isEditMode)("invalid", ctx_r16.invalid && ctx_r16.isTouched)("disabled", !ctx_r16.defaultForm && (ctx_r16.disabled || ctx_r16.config.disabled));
    ɵngcc0.ɵɵproperty("type", ctx_r16.config.type || "text")("placeholder", ctx_r16.getPlaceholder(ctx_r16.config.placeholder, ctx_r16.config.isRequired))("required", ctx_r16.config.isRequired)("ngModel", ctx_r16.value)("readonly", ctx_r16.readonly)("disabled", ctx_r16.disabled || ctx_r16.config.disabled);
} }
function InputComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, InputComponent_ng_container_0_ng_container_1_Template, 8, 10, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(2, InputComponent_ng_container_0_ng_container_2_Template, 7, 15, "ng-container", 0);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.config.copy && !ctx_r0.config.show);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.config.copy || ctx_r0.config.show);
} }
function InputComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r52 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "input", 10, 9);
    ɵngcc0.ɵɵlistener("blur", function InputComponent_ng_container_1_Template_input_blur_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r52); const ctx_r51 = ɵngcc0.ɵɵnextContext(); return ctx_r51.onBlur($event); })("ngModelChange", function InputComponent_ng_container_1_Template_input_ngModelChange_1_listener() { ɵngcc0.ɵɵrestoreView(_r52); const _r50 = ɵngcc0.ɵɵreference(2); const ctx_r53 = ɵngcc0.ɵɵnextContext(); return ctx_r53.change(_r50.value); })("focus", function InputComponent_ng_container_1_Template_input_focus_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r52); const ctx_r54 = ɵngcc0.ɵɵnextContext(); return ctx_r54.onFocus($event); })("input", function InputComponent_ng_container_1_Template_input_input_1_listener() { ɵngcc0.ɵɵrestoreView(_r52); const _r50 = ɵngcc0.ɵɵreference(2); const ctx_r55 = ɵngcc0.ɵɵnextContext(); return ctx_r55.onInput(_r50.value); })("change", function InputComponent_ng_container_1_Template_input_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r52); const _r50 = ɵngcc0.ɵɵreference(2); const ctx_r56 = ɵngcc0.ɵɵnextContext(); return ctx_r56.change(_r50.value); })("keyup", function InputComponent_ng_container_1_Template_input_keyup_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r52); const ctx_r57 = ɵngcc0.ɵɵnextContext(); return ctx_r57.onKeyUp($event); });
    ɵngcc0.ɵɵpipe(3, "iban");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("form-control ", ctx_r1.config.classList, "");
    ɵngcc0.ɵɵclassProp("active", !ctx_r1.isEditMode)("invalid", ctx_r1.invalid && ctx_r1.isTouched)("disabled", !ctx_r1.defaultForm && (ctx_r1.disabled || ctx_r1.config.disabled));
    ɵngcc0.ɵɵproperty("type", ctx_r1.config.type || "text")("placeholder", ctx_r1.getPlaceholder(ctx_r1.config.placeholder, ctx_r1.config.isRequired))("required", ctx_r1.config.isRequired)("ngModel", ɵngcc0.ɵɵpipeBind1(3, 15, ctx_r1.value))("readonly", ctx_r1.readonly)("disabled", ctx_r1.disabled || ctx_r1.config.disabled);
} }
function InputComponent_ng_container_2_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function InputComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r61 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 17);
    ɵngcc0.ɵɵelementStart(2, "div", 18);
    ɵngcc0.ɵɵelementStart(3, "input", 19, 9);
    ɵngcc0.ɵɵlistener("blur", function InputComponent_ng_container_2_Template_input_blur_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r61); const ctx_r60 = ɵngcc0.ɵɵnextContext(); return ctx_r60.onBlur($event); })("focus", function InputComponent_ng_container_2_Template_input_focus_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r61); const ctx_r62 = ɵngcc0.ɵɵnextContext(); return ctx_r62.onFocus($event); })("change", function InputComponent_ng_container_2_Template_input_change_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r61); const ctx_r63 = ɵngcc0.ɵɵnextContext(); return ctx_r63.checked($event); })("keyup", function InputComponent_ng_container_2_Template_input_keyup_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r61); const ctx_r64 = ɵngcc0.ɵɵnextContext(); return ctx_r64.onKeyUp($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "p", 20);
    ɵngcc0.ɵɵtemplate(6, InputComponent_ng_container_2_ng_container_6_Template, 1, 0, "ng-container", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵclassMapInterpolate1("form-control ", ctx_r2.config.classList, "");
    ɵngcc0.ɵɵclassProp("active", !ctx_r2.isEditMode)("invalid", ctx_r2.invalid && ctx_r2.isTouched)("disabled", !ctx_r2.defaultForm && (ctx_r2.disabled || ctx_r2.config.disabled));
    ɵngcc0.ɵɵproperty("type", "checkbox")("required", ctx_r2.config.isRequired)("checked", ctx_r2.value)("readonly", ctx_r2.readonly)("disabled", ctx_r2.disabled || ctx_r2.config.disabled);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.config.placeholder);
} }
function InputComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r67 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "input", 22, 9);
    ɵngcc0.ɵɵlistener("blur", function InputComponent_ng_container_3_Template_input_blur_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r67); const ctx_r66 = ɵngcc0.ɵɵnextContext(); return ctx_r66.onBlur($event); })("ngModelChange", function InputComponent_ng_container_3_Template_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r67); const ctx_r68 = ɵngcc0.ɵɵnextContext(); return ctx_r68.value = $event; })("focus", function InputComponent_ng_container_3_Template_input_focus_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r67); const ctx_r69 = ɵngcc0.ɵɵnextContext(); return ctx_r69.onFocus($event); })("input", function InputComponent_ng_container_3_Template_input_input_2_listener() { ɵngcc0.ɵɵrestoreView(_r67); const _r65 = ɵngcc0.ɵɵreference(3); const ctx_r70 = ɵngcc0.ɵɵnextContext(); return ctx_r70.onInput(_r65.value); })("change", function InputComponent_ng_container_3_Template_input_change_2_listener() { ɵngcc0.ɵɵrestoreView(_r67); const _r65 = ɵngcc0.ɵɵreference(3); const ctx_r71 = ɵngcc0.ɵɵnextContext(); return ctx_r71.change(_r65.value); })("keyup", function InputComponent_ng_container_3_Template_input_keyup_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r67); const ctx_r72 = ɵngcc0.ɵɵnextContext(); return ctx_r72.onKeyUp($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassMapInterpolate1("form-control ", ctx_r3.config.classList, "");
    ɵngcc0.ɵɵclassProp("active", !ctx_r3.isEditMode)("invalid", ctx_r3.invalid && ctx_r3.isTouched)("disabled", !ctx_r3.defaultForm && (ctx_r3.disabled || ctx_r3.config.disabled))("readonly", ctx_r3.readonly);
    ɵngcc0.ɵɵproperty("mask", ctx_r3.mask)("patterns", ctx_r3.customPatterns)("placeholder", ctx_r3.getPlaceholder(ctx_r3.config.placeholder, ctx_r3.config.isRequired))("required", ctx_r3.config.isRequired)("ngModel", ctx_r3.value)("readonly", ctx_r3.readonly)("disabled", ctx_r3.disabled || ctx_r3.config.disabled);
} }
function InputComponent_ng_container_4_img_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 25);
} if (rf & 2) {
    const ctx_r74 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("src", ctx_r74.cardType, ɵngcc0.ɵɵsanitizeUrl);
} }
function InputComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r76 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "input", 23, 9);
    ɵngcc0.ɵɵlistener("blur", function InputComponent_ng_container_4_Template_input_blur_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r76); const ctx_r75 = ɵngcc0.ɵɵnextContext(); return ctx_r75.onBlur($event); })("ngModelChange", function InputComponent_ng_container_4_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r76); const ctx_r77 = ɵngcc0.ɵɵnextContext(); return ctx_r77.value = $event; })("focus", function InputComponent_ng_container_4_Template_input_focus_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r76); const ctx_r78 = ɵngcc0.ɵɵnextContext(); return ctx_r78.onFocus($event); })("input", function InputComponent_ng_container_4_Template_input_input_1_listener() { ɵngcc0.ɵɵrestoreView(_r76); const _r73 = ɵngcc0.ɵɵreference(2); const ctx_r79 = ɵngcc0.ɵɵnextContext(); return ctx_r79.onInput(_r73.value); })("change", function InputComponent_ng_container_4_Template_input_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r76); const _r73 = ɵngcc0.ɵɵreference(2); const ctx_r80 = ɵngcc0.ɵɵnextContext(); return ctx_r80.change(_r73.value); })("keyup", function InputComponent_ng_container_4_Template_input_keyup_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r76); const ctx_r81 = ɵngcc0.ɵɵnextContext(); return ctx_r81.onKeyUp($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, InputComponent_ng_container_4_img_3_Template, 1, 1, "img", 24);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("form-control ", ctx_r4.config.classList, "");
    ɵngcc0.ɵɵclassProp("active", !ctx_r4.isEditMode)("invalid", ctx_r4.invalid && ctx_r4.isTouched)("disabled", !ctx_r4.defaultForm && (ctx_r4.disabled || ctx_r4.config.disabled));
    ɵngcc0.ɵɵproperty("placeholder", ctx_r4.getPlaceholder(ctx_r4.config.placeholder, ctx_r4.config.isRequired))("required", ctx_r4.config.isRequired)("ngModel", ctx_r4.value)("readonly", ctx_r4.readonly)("disabled", ctx_r4.disabled || ctx_r4.config.disabled);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.cardType);
} }
function InputComponent_ng_container_5_p_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 29);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "localize");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r82 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r82.accessOptions == null ? null : ctx_r82.accessOptions.desc), " ");
} }
const _c10 = function () { return { standalone: true }; };
function InputComponent_ng_container_5_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r88 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 32);
    ɵngcc0.ɵɵelementStart(1, "input", 33);
    ɵngcc0.ɵɵlistener("ngModelChange", function InputComponent_ng_container_5_div_4_div_1_Template_input_ngModelChange_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r88); const value_r85 = restoredCtx.$implicit; const ctx_r87 = ɵngcc0.ɵɵnextContext(3); return (ctx_r87.checkModel[value_r85.key] = $event); })("change", function InputComponent_ng_container_5_div_4_div_1_Template_input_change_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r88); const value_r85 = restoredCtx.$implicit; const ctx_r89 = ɵngcc0.ɵɵnextContext(3); return ctx_r89.changeCheck(value_r85.key); })("keyup", function InputComponent_ng_container_5_div_4_div_1_Template_input_keyup_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r88); const ctx_r90 = ɵngcc0.ɵɵnextContext(3); return ctx_r90.onKeyUp($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "label", 34);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "localize");
    ɵngcc0.ɵɵelement(5, "i", 35);
    ɵngcc0.ɵɵpipe(6, "localize");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const value_r85 = ctx.$implicit;
    const ctx_r84 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", value_r85.key)("ngModel", ctx_r84.checkModel[value_r85.key])("ngModelOptions", ɵngcc0.ɵɵpureFunction0(11, _c10))("disabled", ctx_r84.readonly);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("for", value_r85.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 7, value_r85.name), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("matTooltip", ɵngcc0.ɵɵpipeBind1(6, 9, value_r85.desc));
} }
function InputComponent_ng_container_5_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 30);
    ɵngcc0.ɵɵtemplate(1, InputComponent_ng_container_5_div_4_div_1_Template, 7, 12, "div", 31);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r83 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r83.accessOptions == null ? null : ctx_r83.accessOptions.values);
} }
function InputComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r92 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "ano-dropdown", 26);
    ɵngcc0.ɵɵlistener("change", function InputComponent_ng_container_5_Template_ano_dropdown_change_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r92); const ctx_r91 = ɵngcc0.ɵɵnextContext(); return ctx_r91.onChange($event); })("selectedValue", function InputComponent_ng_container_5_Template_ano_dropdown_selectedValue_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r92); const ctx_r93 = ɵngcc0.ɵɵnextContext(); return ctx_r93.selectedValue($event); })("focus", function InputComponent_ng_container_5_Template_ano_dropdown_focus_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r92); const ctx_r94 = ɵngcc0.ɵɵnextContext(); return ctx_r94.onFocus($event); })("blur", function InputComponent_ng_container_5_Template_ano_dropdown_blur_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r92); const ctx_r95 = ɵngcc0.ɵɵnextContext(); return ctx_r95.onBlur($event); })("keyup", function InputComponent_ng_container_5_Template_ano_dropdown_keyup_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r92); const ctx_r96 = ɵngcc0.ɵɵnextContext(); return ctx_r96.onKeyUp($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, InputComponent_ng_container_5_p_3_Template, 3, 3, "p", 27);
    ɵngcc0.ɵɵtemplate(4, InputComponent_ng_container_5_div_4_Template, 2, 1, "div", 28);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("readonly", ctx_r5.readonly);
    ɵngcc0.ɵɵproperty("noBorder", ctx_r5.noBorder)("isAutocomplete", ctx_r5.config.isAutocomplete)("isClearButton", ctx_r5.config.isClearButton)("isEditMode", ctx_r5.isEditMode)("readonly", ctx_r5.readonly)("invalid", ctx_r5.invalid)("touched", ctx_r5.isTouched)("disabled", ctx_r5.disabled || ctx_r5.config.disabled)("value", ctx_r5.value)("classList", ctx_r5.config.classList)("values", ctx_r5.config.selectOptions)("actionLink", ctx_r5.config.actionLink)("excludeSelected", ctx_r5.config.excludeSelected)("actionCallback", ctx_r5.config.actionCallback)("multiSelect", ctx_r5.config.inputType === ctx_r5.INPUT_TYPES.MULTISELECT)("multiselectInSingleDropdown", ctx_r5.config.inputType === ctx_r5.INPUT_TYPES.MULTISELECT_IN_SINGLE_DROPDOWN)("placeholder", ctx_r5.getPlaceholder(ctx_r5.config.placeholder, ctx_r5.config.isRequired));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r5.formConfig == null ? null : ctx_r5.formConfig.name) === "media" && ctx_r5.field.name === "paymentSystem" && ctx_r5.currentValue);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r5.formConfig == null ? null : ctx_r5.formConfig.name) === "media" && ctx_r5.field.name === "paymentSystem" && ctx_r5.currentValue);
} }
function InputComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r98 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "ano-radio-select", 36);
    ɵngcc0.ɵɵlistener("change", function InputComponent_ng_container_6_Template_ano_radio_select_change_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r98); const ctx_r97 = ɵngcc0.ɵɵnextContext(); return ctx_r97.onChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("value", ctx_r6.value)("values", ctx_r6.config.selectOptions);
} }
const _c11 = function () { return { resize: "none" }; };
function InputComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r101 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 37);
    ɵngcc0.ɵɵelementStart(2, "textarea", 38, 39);
    ɵngcc0.ɵɵlistener("blur", function InputComponent_ng_container_7_Template_textarea_blur_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r101); const ctx_r100 = ɵngcc0.ɵɵnextContext(); return ctx_r100.onBlur($event); })("ngModelChange", function InputComponent_ng_container_7_Template_textarea_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r101); const ctx_r102 = ɵngcc0.ɵɵnextContext(); return ctx_r102.value = $event; })("focus", function InputComponent_ng_container_7_Template_textarea_focus_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r101); const ctx_r103 = ɵngcc0.ɵɵnextContext(); return ctx_r103.onFocus($event); })("input", function InputComponent_ng_container_7_Template_textarea_input_2_listener() { ɵngcc0.ɵɵrestoreView(_r101); const _r99 = ɵngcc0.ɵɵreference(3); const ctx_r104 = ɵngcc0.ɵɵnextContext(); return ctx_r104.onInput(_r99.value); })("change", function InputComponent_ng_container_7_Template_textarea_change_2_listener() { ɵngcc0.ɵɵrestoreView(_r101); const _r99 = ɵngcc0.ɵɵreference(3); const ctx_r105 = ɵngcc0.ɵɵnextContext(); return ctx_r105.change(_r99.value); })("keyup", function InputComponent_ng_container_7_Template_textarea_keyup_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r101); const ctx_r106 = ɵngcc0.ɵɵnextContext(); return ctx_r106.onKeyUp($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("disabled", !ctx_r7.defaultForm && (ctx_r7.disabled || ctx_r7.config.disabled));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("form-control ", ctx_r7.config.classList, "");
    ɵngcc0.ɵɵclassProp("invalid", ctx_r7.invalid && ctx_r7.isTouched)("disabled", !ctx_r7.defaultForm && (ctx_r7.disabled || ctx_r7.config.disabled))("overflow-auto", !ctx_r7.config.autosize);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction0(19, _c11))("rows", ctx_r7.config.autosize ? 1 : 6)("autosize", !!ctx_r7.config.autosize)("placeholder", ctx_r7.getPlaceholder(ctx_r7.config.placeholder, ctx_r7.config.isRequired))("required", ctx_r7.config.isRequired)("readonly", ctx_r7.readonly)("disabled", ctx_r7.disabled || ctx_r7.config.disabled)("ngModel", ctx_r7.value);
} }
function InputComponent_ng_container_8_i_6_Template(rf, ctx) { if (rf & 1) {
    const _r111 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 45);
    ɵngcc0.ɵɵlistener("click", function InputComponent_ng_container_8_i_6_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r111); const ctx_r110 = ɵngcc0.ɵɵnextContext(2); return ctx_r110.clear(); });
    ɵngcc0.ɵɵelementEnd();
} }
function InputComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r113 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 37);
    ɵngcc0.ɵɵelementStart(2, "input", 40, 41);
    ɵngcc0.ɵɵlistener("blur", function InputComponent_ng_container_8_Template_input_blur_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r113); const ctx_r112 = ɵngcc0.ɵɵnextContext(); return ctx_r112.onBlur($event); })("focus", function InputComponent_ng_container_8_Template_input_focus_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r113); const ctx_r114 = ɵngcc0.ɵɵnextContext(); return ctx_r114.onFocus($event); })("dateTimeInput", function InputComponent_ng_container_8_Template_input_dateTimeInput_2_listener() { ɵngcc0.ɵɵrestoreView(_r113); const _r107 = ɵngcc0.ɵɵreference(3); const ctx_r115 = ɵngcc0.ɵɵnextContext(); return ctx_r115.writeDateValue(_r107.value); })("dateTimeChange", function InputComponent_ng_container_8_Template_input_dateTimeChange_2_listener() { ɵngcc0.ɵɵrestoreView(_r113); const _r107 = ɵngcc0.ɵɵreference(3); const ctx_r116 = ɵngcc0.ɵɵnextContext(); return ctx_r116.dateChange(_r107.value); })("keyup", function InputComponent_ng_container_8_Template_input_keyup_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r113); const ctx_r117 = ɵngcc0.ɵɵnextContext(); return ctx_r117.onKeyUp($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "owl-date-time", 42, 43);
    ɵngcc0.ɵɵlistener("afterPickerClosed", function InputComponent_ng_container_8_Template_owl_date_time_afterPickerClosed_4_listener() { ɵngcc0.ɵɵrestoreView(_r113); const _r108 = ɵngcc0.ɵɵreference(5); const ctx_r118 = ɵngcc0.ɵɵnextContext(); return ctx_r118.dateChange(_r108.selected); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, InputComponent_ng_container_8_i_6_Template, 1, 0, "i", 44);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r108 = ɵngcc0.ɵɵreference(5);
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("disabled", !ctx_r8.defaultForm && (ctx_r8.disabled || ctx_r8.config.disabled));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("form-control cursor-pointer ", ctx_r8.config.classList, "");
    ɵngcc0.ɵɵclassProp("active", ctx_r8.isEditMode && !(ctx_r8.disabled || ctx_r8.config.disabled))("invalid", ctx_r8.invalid && ctx_r8.isTouched)("disabled", !ctx_r8.defaultForm && (ctx_r8.disabled || ctx_r8.config.disabled))("readonly", ctx_r8.readonly);
    ɵngcc0.ɵɵproperty("placeholder", ctx_r8.getPlaceholder(ctx_r8.config.placeholder, ctx_r8.config.isRequired))("required", ctx_r8.config.isRequired)("readonly", true)("disabled", ctx_r8.disabled || ctx_r8.readonly || ctx_r8.config.disabled)("ngModel", ctx_r8.value)("owlDateTime", _r108)("owlDateTimeTrigger", _r108)("min", ctx_r8.minDate())("max", ctx_r8.maxDate());
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("pickerType", ctx_r8.config.datetimePickerType || "both");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.value && !ctx_r8.readonly && !ctx_r8.disabled);
} }
function InputComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r120 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "mat-slide-toggle", 46);
    ɵngcc0.ɵɵlistener("change", function InputComponent_ng_container_9_Template_mat_slide_toggle_change_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r120); const ctx_r119 = ɵngcc0.ɵɵnextContext(); return ctx_r119.toggleCheckbox($event); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("simple-toggle", ctx_r9.config.simpleToggle)("hidden-toggle", ctx_r9.config.hiddenToggle);
    ɵngcc0.ɵɵproperty("disabled", ctx_r9.disabledToggle || ctx_r9.disabled || ctx_r9.readonly || ctx_r9.config.disabled || ctx_r9.config.hiddenToggle)("checked", ctx_r9.value && !ctx_r9.disabledToggle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r9.getPlaceholder(ctx_r9.config.placeholder, ctx_r9.config.isRequired), " ");
} }
function InputComponent_ng_container_10_i_4_Template(rf, ctx) { if (rf & 1) {
    const _r124 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 49);
    ɵngcc0.ɵɵlistener("click", function InputComponent_ng_container_10_i_4_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r124); const ctx_r123 = ɵngcc0.ɵɵnextContext(2); return ctx_r123.clear(); });
    ɵngcc0.ɵɵelementEnd();
} }
function InputComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    const _r126 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "input", 47, 41);
    ɵngcc0.ɵɵlistener("blur", function InputComponent_ng_container_10_Template_input_blur_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r126); const ctx_r125 = ɵngcc0.ɵɵnextContext(); return ctx_r125.onBlur($event); })("focus", function InputComponent_ng_container_10_Template_input_focus_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r126); const ctx_r127 = ɵngcc0.ɵɵnextContext(); return ctx_r127.onFocus($event); })("input", function InputComponent_ng_container_10_Template_input_input_2_listener() { ɵngcc0.ɵɵrestoreView(_r126); const _r121 = ɵngcc0.ɵɵreference(3); const ctx_r128 = ɵngcc0.ɵɵnextContext(); return ctx_r128.onInput(_r121.value); })("change", function InputComponent_ng_container_10_Template_input_change_2_listener() { ɵngcc0.ɵɵrestoreView(_r126); const _r121 = ɵngcc0.ɵɵreference(3); const ctx_r129 = ɵngcc0.ɵɵnextContext(); return ctx_r129.change(_r121.value); })("keyup", function InputComponent_ng_container_10_Template_input_keyup_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r126); const ctx_r130 = ɵngcc0.ɵɵnextContext(); return ctx_r130.onKeyUp($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, InputComponent_ng_container_10_i_4_Template, 1, 0, "i", 48);
    ɵngcc0.ɵɵelementStart(5, "div", 13);
    ɵngcc0.ɵɵelementStart(6, "div", 7);
    ɵngcc0.ɵɵtext(7, " hh:mm:ss ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("disabled", !ctx_r10.defaultForm && (ctx_r10.disabled || ctx_r10.config.disabled));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("form-control cursor-pointer ", ctx_r10.config.classList, "");
    ɵngcc0.ɵɵclassProp("active", ctx_r10.isEditMode && !(ctx_r10.disabled || ctx_r10.config.disabled))("invalid", ctx_r10.invalid && ctx_r10.isTouched)("disabled", !ctx_r10.defaultForm && (ctx_r10.disabled || ctx_r10.config.disabled))("readonly", ctx_r10.readonly);
    ɵngcc0.ɵɵproperty("placeholder", ctx_r10.getPlaceholder(ctx_r10.config.placeholder, ctx_r10.config.isRequired))("required", ctx_r10.config.isRequired)("disabled", ctx_r10.disabled || ctx_r10.readonly || ctx_r10.config.disabled)("ngModel", ctx_r10.value || "00:00:00");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.value && !ctx_r10.readonly && !ctx_r10.disabled);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("disabled", !ctx_r10.defaultForm && (ctx_r10.disabled || ctx_r10.config.disabled))("invalid", ctx_r10.invalid && ctx_r10.isTouched);
} }
function InputComponent_ng_container_11_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r139 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 57);
    ɵngcc0.ɵɵlistener("click", function InputComponent_ng_container_11_ng_container_1_div_2_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r139); const ctx_r138 = ɵngcc0.ɵɵnextContext(3); return ctx_r138.clearImage(); });
    ɵngcc0.ɵɵelement(1, "i", 58);
    ɵngcc0.ɵɵelementEnd();
} }
function InputComponent_ng_container_11_ng_container_1_p_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 59);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r134 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵstyleMapInterpolate2("color: ", ctx_r134.coursePreview.color, "; text-shadow: 0 0 1em ", ctx_r134.coursePreview.color === "#fff" ? "#000" : "#fff", "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r134.coursePreview.text, " ");
} }
function InputComponent_ng_container_11_ng_container_1_button_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 60);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "localize");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "course.button.stillHere"));
} }
function InputComponent_ng_container_11_ng_container_1_img_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 61);
    ɵngcc0.ɵɵpipe(1, "image");
} if (rf & 2) {
    const ctx_r136 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵpropertyInterpolate("src", ɵngcc0.ɵɵpipeBind1(1, 1, ctx_r136.multimediaUrl), ɵngcc0.ɵɵsanitizeUrl);
} }
function InputComponent_ng_container_11_ng_container_1_ano_player_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ano-player", 62);
} if (rf & 2) {
    const ctx_r137 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("config", ctx_r137.playerConfig);
} }
function InputComponent_ng_container_11_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 50);
    ɵngcc0.ɵɵtemplate(2, InputComponent_ng_container_11_ng_container_1_div_2_Template, 2, 0, "div", 51);
    ɵngcc0.ɵɵelementStart(3, "div", 52);
    ɵngcc0.ɵɵtemplate(4, InputComponent_ng_container_11_ng_container_1_p_4_Template, 2, 5, "p", 53);
    ɵngcc0.ɵɵtemplate(5, InputComponent_ng_container_11_ng_container_1_button_5_Template, 3, 3, "button", 54);
    ɵngcc0.ɵɵtemplate(6, InputComponent_ng_container_11_ng_container_1_img_6_Template, 2, 3, "img", 55);
    ɵngcc0.ɵɵtemplate(7, InputComponent_ng_container_11_ng_container_1_ano_player_7_Template, 1, 1, "ano-player", 56);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r131 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("img-edit", !ctx_r131.isEditMode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r131.clearImageButton && !ctx_r131.disabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", (ctx_r131.coursePreview == null ? null : ctx_r131.coursePreview.position) ? (ctx_r131.coursePreview == null ? null : ctx_r131.coursePreview.position.toLowerCase()) + "-course" : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r131.config.isCourse);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r131.config.isCourse);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r131.multimediaType === "photo");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r131.multimediaType === "video" && ctx_r131.playerConfig);
} }
function InputComponent_ng_container_11_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r142 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "ano-drag-and-drop", 63, 64);
    ɵngcc0.ɵɵlistener("files", function InputComponent_ng_container_11_ng_container_2_Template_ano_drag_and_drop_files_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r142); const ctx_r141 = ɵngcc0.ɵɵnextContext(2); return ctx_r141.uploadPreviewMultimedia($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r132 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r132.disabled || ctx_r132.config.disabled)("accept", ctx_r132.accept)("videoDurationLimit", ctx_r132.config.videoDurationLimit)("maxSize", ctx_r132.config.maxFileSize);
} }
function InputComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, InputComponent_ng_container_11_ng_container_1_Template, 8, 8, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(2, InputComponent_ng_container_11_ng_container_2_Template, 3, 4, "ng-container", 0);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.multimediaUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.isEditMode && !ctx_r11.multimediaUrl);
} }
function InputComponent_ng_container_12_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelementStart(1, "span", 7);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r143 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("disabled", !ctx_r143.defaultForm && (ctx_r143.disabled || ctx_r143.config.disabled) || ctx_r143.readonly)("invalid", ctx_r143.invalid && ctx_r143.isTouched);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r143.currencyProfile);
} }
function InputComponent_ng_container_12_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "localize");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r145 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("disabled", !ctx_r145.defaultForm && (ctx_r145.disabled || ctx_r145.config.disabled))("invalid", ctx_r145.invalid && ctx_r145.isTouched);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 5, ctx_r145.config.appendText), " ");
} }
function InputComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    const _r147 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtemplate(2, InputComponent_ng_container_12_div_2_Template, 3, 5, "div", 65);
    ɵngcc0.ɵɵelementStart(3, "input", 66, 9);
    ɵngcc0.ɵɵlistener("change", function InputComponent_ng_container_12_Template_input_change_3_listener() { ɵngcc0.ɵɵrestoreView(_r147); const _r144 = ɵngcc0.ɵɵreference(4); const ctx_r146 = ɵngcc0.ɵɵnextContext(); return ctx_r146.change(_r144.value); })("blur", function InputComponent_ng_container_12_Template_input_blur_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r147); const ctx_r148 = ɵngcc0.ɵɵnextContext(); return ctx_r148.onBlur($event); })("focus", function InputComponent_ng_container_12_Template_input_focus_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r147); const ctx_r149 = ɵngcc0.ɵɵnextContext(); return ctx_r149.onFocus($event); })("input", function InputComponent_ng_container_12_Template_input_input_3_listener() { ɵngcc0.ɵɵrestoreView(_r147); const _r144 = ɵngcc0.ɵɵreference(4); const ctx_r150 = ɵngcc0.ɵɵnextContext(); return ctx_r150.onInput(_r144.value); })("keyup", function InputComponent_ng_container_12_Template_input_keyup_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r147); const ctx_r151 = ɵngcc0.ɵɵnextContext(); return ctx_r151.onKeyUp($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, InputComponent_ng_container_12_div_5_Template, 4, 7, "div", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r144 = ɵngcc0.ɵɵreference(4);
    const ctx_r12 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("group-append-text", ctx_r12.config.appendText && ctx_r12.isFocused)("disabled", !ctx_r12.defaultForm && (ctx_r12.disabled || ctx_r12.config.disabled));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r12.currencyProfile);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("form-control ", ctx_r12.config.classList, "");
    ɵngcc0.ɵɵclassProp("active", !ctx_r12.isEditMode)("invalid", ctx_r12.invalid && ctx_r12.isTouched)("disabled", !ctx_r12.defaultForm && (ctx_r12.disabled || ctx_r12.config.disabled));
    ɵngcc0.ɵɵproperty("cleaveValue", _r144.value)("type", ctx_r12.config.type || "text")("placeholder", ctx_r12.getPlaceholder(ctx_r12.config.placeholder, ctx_r12.config.isRequired))("required", ctx_r12.config.isRequired)("ngModel", ctx_r12.value)("readonly", ctx_r12.readonly)("disabled", ctx_r12.disabled || ctx_r12.config.disabled);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r12.config.appendText);
} }
function InputComponent_ng_container_13_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "localize");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const errorEntry_r152 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "error." + errorEntry_r152[0]), " ");
} }
function InputComponent_ng_container_13_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "localize");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const errorEntry_r152 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", ɵngcc0.ɵɵpipeBind1(2, 2, "error." + errorEntry_r152[0]), " ", errorEntry_r152[1].min, " ");
} }
function InputComponent_ng_container_13_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "localize");
    ɵngcc0.ɵɵpipe(3, "localize");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const errorEntry_r152 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate3(" ", ɵngcc0.ɵɵpipeBind1(2, 3, "error." + errorEntry_r152[0] + ".start"), " ", errorEntry_r152[1].requiredLength, " ", ɵngcc0.ɵɵpipeBind1(3, 5, "error." + errorEntry_r152[0] + ".end"), " ");
} }
function InputComponent_ng_container_13_div_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const errorEntry_r152 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", errorEntry_r152[1].value, " ");
} }
const _c12 = function (a0) { return { display: a0 }; };
function InputComponent_ng_container_13_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 68);
    ɵngcc0.ɵɵtemplate(1, InputComponent_ng_container_13_div_1_ng_container_1_Template, 3, 3, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(2, InputComponent_ng_container_13_div_1_ng_container_2_Template, 3, 4, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(3, InputComponent_ng_container_13_div_1_ng_container_3_Template, 4, 7, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(4, InputComponent_ng_container_13_div_1_ng_container_4_Template, 2, 1, "ng-container", 0);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const errorEntry_r152 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r153 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(5, _c12, ctx_r153.isTouched || ctx_r153.isDirty ? "block" : "none"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", errorEntry_r152[0] !== "min" && errorEntry_r152[0] !== "maxlength");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", errorEntry_r152[0] === "min");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", errorEntry_r152[0] === "maxlength");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", errorEntry_r152[1] === "value");
} }
function InputComponent_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, InputComponent_ng_container_13_div_1_Template, 5, 7, "div", 67);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r13.isEditMode);
} }
function InputComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 69);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "localize");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, ctx_r14.infoMessage));
} }
const _c13 = ["fileDropRef"];
const _c14 = function (a0) { return { width: a0 }; };
function RadioSelectComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵlistener("click", function RadioSelectComponent_div_0_ng_container_1_Template_div_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r4); const value_r2 = restoredCtx.$implicit; const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return !value_r2.selected && ctx_r3.select(value_r2); });
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const value_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("active-radio", value_r2.selected);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(4, _c14, 100 / ctx_r1.values.length + "%"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(value_r2.value);
} }
function RadioSelectComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, RadioSelectComponent_div_0_ng_container_1_Template, 4, 6, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.values);
} }
const _c15 = ["autocomplete"];
function DropdownComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵlistener("click", function DropdownComponent_div_2_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.toggle(); });
    ɵngcc0.ɵɵelementStart(1, "span", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "localize");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("form-control form-group-select ", ctx_r0.classList, "");
    ɵngcc0.ɵɵclassProp("cursor-pointer", !(ctx_r0.disabled || !ctx_r0.isEditMode))("invalid", ctx_r0.touched && ctx_r0.invalid)("select-opened", ctx_r0.opened)("readonly", ctx_r0.readonly)("disabled", ctx_r0.disabled)("placeholder", !ctx_r0.value);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 16, ctx_r0.getValue() || ctx_r0.placeholder));
} }
function DropdownComponent_input_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 9, 10);
    ɵngcc0.ɵɵlistener("click", function DropdownComponent_input_3_Template_input_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.toggle(); })("input", function DropdownComponent_input_3_Template_input_input_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const _r7 = ɵngcc0.ɵɵreference(1); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.updateValue(_r7.value); });
    ɵngcc0.ɵɵpipe(2, "localize");
    ɵngcc0.ɵɵpipe(3, "localize");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("form-control form-group-select ", ctx_r1.classList, "");
    ɵngcc0.ɵɵclassProp("cursor-pointer", !(ctx_r1.disabled || !ctx_r1.isEditMode))("invalid", ctx_r1.touched && ctx_r1.invalid)("select-opened", ctx_r1.opened)("disabled", ctx_r1.disabled && ctx_r1.isEditMode);
    ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(2, 15, ctx_r1.placeholder))("readonly", ctx_r1.readonly)("disabled", ctx_r1.disabled || !ctx_r1.isEditMode)("value", ɵngcc0.ɵɵpipeBind1(3, 17, ctx_r1.getValue()));
} }
function DropdownComponent_i_4_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 11);
    ɵngcc0.ɵɵlistener("click", function DropdownComponent_i_4_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.clear(); });
    ɵngcc0.ɵɵelementEnd();
} }
function DropdownComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 12);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("invalid-caret", ctx_r3.touched && ctx_r3.invalid)("disabled-caret", ctx_r3.disabled);
} }
function DropdownComponent_div_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 15);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "localize");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("form-control no-border dropdown-item-select ", ctx_r13.classList, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 4, "common.noItems"), " ");
} }
function DropdownComponent_div_6_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 15);
    ɵngcc0.ɵɵelementStart(2, "a", 16);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "localize");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("form-control no-border dropdown-item-select ", ctx_r14.classList, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r14.actionLink.link);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 5, ctx_r14.actionLink.text));
} }
function DropdownComponent_div_6_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 15);
    ɵngcc0.ɵɵelementStart(2, "a", 7);
    ɵngcc0.ɵɵlistener("click", function DropdownComponent_div_6_ng_container_3_Template_a_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.runCallback(); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "localize");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("form-control no-border dropdown-item-select ", ctx_r15.classList, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 4, ctx_r15.actionCallback.text));
} }
function DropdownComponent_div_6_ng_container_4_ng_container_1_ng_container_1_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 20);
} }
function DropdownComponent_div_6_ng_container_4_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 18);
    ɵngcc0.ɵɵlistener("click", function DropdownComponent_div_6_ng_container_4_ng_container_1_ng_container_1_Template_span_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r25); const val_r20 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r23 = ɵngcc0.ɵɵnextContext(3); return ctx_r23.selectValue(val_r20); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "localize");
    ɵngcc0.ɵɵtemplate(4, DropdownComponent_div_6_ng_container_4_ng_container_1_ng_container_1_i_4_Template, 1, 0, "i", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const val_r20 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r21 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("form-control dropdown-item-select ", ctx_r21.classList, "");
    ɵngcc0.ɵɵclassProp("no-border", ctx_r21.noBorder)("selected", ctx_r21.selected(val_r20))("multiselect-single-dropdown", ctx_r21.multiselectInSingleDropdown);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 11, val_r20.value), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r21.multiselectInSingleDropdown && ctx_r21.selected(val_r20));
} }
function DropdownComponent_div_6_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DropdownComponent_div_6_ng_container_4_ng_container_1_ng_container_1_Template, 5, 13, "ng-container", 14);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const val_r20 = ctx.$implicit;
    const ctx_r19 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r19.showValue(val_r20));
} }
function DropdownComponent_div_6_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DropdownComponent_div_6_ng_container_4_ng_container_1_Template, 2, 1, "ng-container", 17);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r16.values);
} }
function DropdownComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵtemplate(1, DropdownComponent_div_6_ng_container_1_Template, 4, 6, "ng-container", 14);
    ɵngcc0.ɵɵtemplate(2, DropdownComponent_div_6_ng_container_2_Template, 5, 7, "ng-container", 14);
    ɵngcc0.ɵɵtemplate(3, DropdownComponent_div_6_ng_container_3_Template, 5, 6, "ng-container", 14);
    ɵngcc0.ɵɵtemplate(4, DropdownComponent_div_6_ng_container_4_Template, 2, 1, "ng-container", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("invalid", ctx_r4.touched && ctx_r4.invalid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.values.length && !ctx_r4.actionLink && !ctx_r4.actionCallback);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.values.length && ctx_r4.actionLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.values.length && ctx_r4.actionCallback);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.values.length);
} }
const _c16 = ["*"];
const _c17 = ["searchInput"];
function SearchInputComponent_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 9);
    ɵngcc0.ɵɵlistener("click", function SearchInputComponent_a_2_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.close(); });
    ɵngcc0.ɵɵelement(1, "i", 10);
    ɵngcc0.ɵɵelementEnd();
} }
function SearchInputComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 11);
    ɵngcc0.ɵɵlistener("click", function SearchInputComponent_button_7_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.clearSearchResults(); });
    ɵngcc0.ɵɵelementStart(1, "span", 12);
    ɵngcc0.ɵɵtext(2, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function SearchInputComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 13);
    ɵngcc0.ɵɵelement(1, "i", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", !ctx_r3.form.get("searchString").value);
} }
function LoaderComponent_div_0_p_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "localize");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r1.loadingText));
} }
function LoaderComponent_div_0_p_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.progress);
} }
const _c18 = function (a0, a1, a2) { return { "avatar-spinner": a0, "rounded-spinner": a1, "block-spinner": a2 }; };
function LoaderComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, LoaderComponent_div_0_p_1_Template, 3, 3, "p", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelement(3, "div", 4);
    ɵngcc0.ɵɵelement(4, "div", 5);
    ɵngcc0.ɵɵelement(5, "div", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, LoaderComponent_div_0_p_6_Template, 2, 1, "p", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("width", ctx_r0.width || "100%");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(5, _c18, ctx_r0.theme === ctx_r0.LOADER_THEMES.AVATAR, ctx_r0.rounded, ctx_r0.theme === ctx_r0.LOADER_THEMES.BLOCK));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.loadingText);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.progress);
} }
function FilterDropdownComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "a", 4);
    ɵngcc0.ɵɵlistener("click", function FilterDropdownComponent_ng_container_5_Template_a_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r3); const val_r1 = restoredCtx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.selectValue(val_r1); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "localize");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const val_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, val_r1.value));
} }
const _c19 = function (a0, a1, a2, a3) { return { disabled: a0, inputType: a1, placeholder: a2, type: a3, prepend: "search" }; };
function TimeRangeFilterComponent_form_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "form", 2);
    ɵngcc0.ɵɵelement(1, "ano-input", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.timeRangeFilterForm);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r0.timeRangeFilterConfig.name)("isEditMode", true)("noBorder", false)("config", ɵngcc0.ɵɵpureFunction3(5, _c1, ctx_r0.INPUT_TYPES.SELECT, ctx_r0.timeRangeFilterConfig.placeholder, ctx_r0.timeRangeFilterConfig.selectOptions));
} }
function PasswordValidatorComponent_p_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "localize");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "registration_confirmation.validation.title"));
} }
const _c20 = ["tableComponent"];
function BillsTableComponent_h4_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h4");
    ɵngcc0.ɵɵelementStart(1, "b");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "localize");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, ctx_r0.config.title));
} }
function ModalComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelement(1, "h5", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.title, ɵngcc0.ɵɵsanitizeHtml);
} }
function ModalComponent_div_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.data.text, " ");
} }
function ModalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵtemplate(2, ModalComponent_div_4_ng_container_2_Template, 2, 1, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.data && ctx_r1.data.text);
} }
function ModalComponent_div_5_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 14);
    ɵngcc0.ɵɵlistener("click", function ModalComponent_div_5_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.apply(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "localize");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r4.submitButtonText));
} }
function ModalComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "button", 12);
    ɵngcc0.ɵɵlistener("click", function ModalComponent_div_5_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.dismiss(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "localize");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, ModalComponent_div_5_button_4_Template, 3, 3, "button", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("btn btn-danger ", ctx_r2.dismissButtonClass, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 5, ctx_r2.dismissButtonText));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.withoutSubmit);
} }
function WidgetComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 1);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("(", ctx_r0.config.additionalAmountInfo, ")");
} }
function WidgetComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("(", ctx_r1.config.additionalPeriodInfo, ")");
} }
function WidgetComponent_div_11_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 8);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r4.title);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(5, 2, item_r4.amount, ctx_r3.config == null ? null : ctx_r3.config.toFixed));
} }
function WidgetComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵtemplate(1, WidgetComponent_div_11_div_1_Template, 6, 5, "div", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.config.infoTable);
} }
const _c21 = function (a0, a1) { return { amount: a0, currency: a1 }; };
function LegendBoxComponent_label_1_input_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 5);
    ɵngcc0.ɵɵlistener("click", function LegendBoxComponent_label_1_input_6_Template_input_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const legendItem_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onCheck(legendItem_r1.label); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("checked", true);
} }
const _c22 = function (a0) { return { "backgroundColor": a0 }; };
function LegendBoxComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 2);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "localize");
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵelementStart(4, "b");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, LegendBoxComponent_label_1_input_6_Template, 1, 1, "input", 3);
    ɵngcc0.ɵɵelement(7, "span", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const legendItem_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 5, legendItem_r1.title), " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate2("", legendItem_r1.count, "", ctx_r0.suffix, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.readOnly);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(7, _c22, ctx_r0.colorScheme[legendItem_r1.label]));
} }
const _c23 = ".tooltip{position:absolute;text-align:center;padding:7px 28px;font:12px sans-serif;background:#b0c4de;border:1px solid hsla(0,0%,100%,.9);color:#fff;border-radius:4px;pointer-events:none;font-size:medium;font-weight:800}.chart-container[_ngcontent-%COMP%]{position:relative}";
function FormComponent_h2_6_small_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "small");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "localize");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("(", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r5.subTitle), ")");
} }
function FormComponent_h2_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h2", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "localize");
    ɵngcc0.ɵɵtemplate(3, FormComponent_h2_6_small_3_Template, 3, 3, "small", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("mb-25", ctx_r0.description);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 4, ctx_r0.title), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.subTitle);
} }
function FormComponent_p_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "localize");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r1.description));
} }
function FormComponent_ng_container_10_ng_container_1_label_2_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 19);
    ɵngcc0.ɵɵtext(1, "*");
    ɵngcc0.ɵɵelementEnd();
} }
function FormComponent_ng_container_10_ng_container_1_label_2_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 20);
    ɵngcc0.ɵɵtext(1, "(optional)");
    ɵngcc0.ɵɵelementEnd();
} }
function FormComponent_ng_container_10_ng_container_1_label_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "localize");
    ɵngcc0.ɵɵtemplate(3, FormComponent_ng_container_10_ng_container_1_label_2_span_3_Template, 2, 0, "span", 17);
    ɵngcc0.ɵɵtemplate(4, FormComponent_ng_container_10_ng_container_1_label_2_span_4_Template, 2, 0, "span", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r6 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("col-md-", ctx_r9.labelWidth || (ctx_r9.forcedViewMode ? 4 : ctx_r9.passwordValidation ? 7 : 6), " form-control-label");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 6, field_r6.config.label), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", field_r6.config.isRequired);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", field_r6.config.optional);
} }
function FormComponent_ng_container_10_ng_container_1_a_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 21);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r6 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("href", ctx_r10.getLink(ctx_r10.form.get(field_r6.name).value), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r10.getLink(ctx_r10.form.get(field_r6.name).value));
} }
const _c24 = function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15) { return { isAutocomplete: a0, inputType: a1, label: a2, placeholder: a3, isRequired: a4, selectOptions: a5, datetimeType: a6, type: a7, startDate: a8, endDate: a9, copy: a10, show: a11, accept: a12, mask: a13, removeSpaces: a14, autosize: a15 }; };
function FormComponent_ng_container_10_ng_container_1_ano_input_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ano-input", 22);
} if (rf & 2) {
    const field_r6 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formControl", ctx_r11.form.get(field_r6.name))("defaultForm", true)("disabled", !ctx_r11.defaultFields)("invalid", ctx_r11.form.get(field_r6.name).invalid)("isEditMode", ctx_r11.isEditMode || ctx_r11.defaultFields)("multimediaUrl", ctx_r11.photoUrl)("errors", ctx_r11.defaultFields || ctx_r11.showErrorsForViewMode ? ctx_r11.form.get(field_r6.name).errors : null)("isTouched", ctx_r11.defaultFields || ctx_r11.showErrorsForViewMode ? ctx_r11.form.get(field_r6.name).touched : null)("accept", field_r6.config.accept)("config", ɵngcc0.ɵɵpureFunctionV(10, _c24, [field_r6.config.isAutocomplete, field_r6.config.inputType, field_r6.config.label, field_r6.config.placeholder, field_r6.config.isRequired, field_r6.config.selectOptions, field_r6.config.datetimeType, field_r6.config.type, ctx_r11.getStartDate(), ctx_r11.getEndDate(), field_r6.config.copy, field_r6.config.show, field_r6.config.accept, field_r6.config.mask, field_r6.config.removeSpaces, field_r6.config.autosize]));
} }
const _c25 = function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13) { return { isAutocomplete: a0, inputType: a1, label: a2, placeholder: a3, isRequired: a4, selectOptions: a5, datetimeType: a6, type: a7, startDate: a8, endDate: a9, accept: a10, mask: a11, removeSpaces: a12, autosize: a13 }; };
function FormComponent_ng_container_10_ng_container_1_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵelementStart(1, "ano-input", 24);
    ɵngcc0.ɵɵlistener("onFileUpload$", function FormComponent_ng_container_10_ng_container_1_div_6_Template_ano_input_onFileUpload__1_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(3); return ctx_r18.uploadPreviewPhoto($event); })("clearImage$", function FormComponent_ng_container_10_ng_container_1_div_6_Template_ano_input_clearImage__1_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r20 = ɵngcc0.ɵɵnextContext(3); return ctx_r20.clearImage($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r6 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r12 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", field_r6.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControl", ctx_r12.form.get(field_r6.name))("defaultForm", true)("name", field_r6.name)("invalid", ctx_r12.form.get(field_r6.name).invalid)("disabled", field_r6.config.disabled)("errors", ctx_r12.form.get(field_r6.name).errors)("isTouched", ctx_r12.form.get(field_r6.name).touched)("columnImageUploader", ctx_r12.columnImageUploader)("clearImageButton", ctx_r12.clearImageButton)("multimediaUrl", ctx_r12.photoUrl)("accept", field_r6.config.accept)("config", ɵngcc0.ɵɵpureFunctionV(14, _c25, [field_r6.config.isAutocomplete, field_r6.config.inputType, field_r6.config.label, field_r6.config.placeholder, field_r6.config.isRequired, field_r6.config.selectOptions, field_r6.config.datetimeType, field_r6.config.type, ctx_r12.getStartDate(), ctx_r12.getEndDate(), field_r6.config.accept, field_r6.config.mask, field_r6.config.removeSpaces, field_r6.config.autosize]))("isEditMode", ctx_r12.isEditMode);
} }
function FormComponent_ng_container_10_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵtemplate(2, FormComponent_ng_container_10_ng_container_1_label_2_Template, 5, 8, "label", 13);
    ɵngcc0.ɵɵelementStart(3, "div");
    ɵngcc0.ɵɵtemplate(4, FormComponent_ng_container_10_ng_container_1_a_4_Template, 2, 2, "a", 14);
    ɵngcc0.ɵɵtemplate(5, FormComponent_ng_container_10_ng_container_1_ano_input_5_Template, 1, 27, "ano-input", 15);
    ɵngcc0.ɵɵtemplate(6, FormComponent_ng_container_10_ng_container_1_div_6_Template, 2, 29, "div", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const field_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("publisher-image", field_r6.name === "newPicture")("form-group", ctx_r8.borderForm)("align-items-top", field_r6.config.inputType !== ctx_r8.INPUT_TYPES.TEXTAREA)("text-area-wrapper", field_r6.config.inputType === ctx_r8.INPUT_TYPES.TEXTAREA);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", field_r6.config.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("col-md-", ctx_r8.fieldWidth || (ctx_r8.forcedViewMode ? 8 : ctx_r8.passwordValidation ? 5 : 6), "");
    ɵngcc0.ɵɵclassProp("form-control-border", ctx_r8.isEditMode || field_r6.config.isLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", field_r6.config.isLink && (!ctx_r8.isEditMode && !ctx_r8.forcedEditMode || ctx_r8.forcedEditMode && ctx_r8.defaultFields));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !field_r6.config.isLink && (!ctx_r8.isEditMode && !ctx_r8.forcedEditMode || ctx_r8.forcedEditMode && ctx_r8.defaultFields));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r8.isEditMode || ctx_r8.forcedEditMode) && !ctx_r8.defaultFields);
} }
function FormComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, FormComponent_ng_container_10_ng_container_1_Template, 7, 17, "ng-container", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const field_r6 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !field_r6.hidden);
} }
function FormComponent_div_11_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 35);
    ɵngcc0.ɵɵlistener("click", function FormComponent_div_11_div_4_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r29); const ctx_r28 = ɵngcc0.ɵɵnextContext(2); return ctx_r28.deleteAvatar(); });
    ɵngcc0.ɵɵelement(1, "i", 36);
    ɵngcc0.ɵɵelementEnd();
} }
function FormComponent_div_11_img_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 37);
} if (rf & 2) {
    const ctx_r24 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("src", ctx_r24.avatar, ɵngcc0.ɵɵsanitizeUrl);
} }
function FormComponent_div_11_img_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 38);
} }
function FormComponent_div_11_i_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 39);
} }
function FormComponent_div_11_div_9_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 43);
    ɵngcc0.ɵɵlistener("click", function FormComponent_div_11_div_9_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r31 = ɵngcc0.ɵɵnextContext(3); return ctx_r31.cancel(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "localize");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassMapInterpolate1("btn cancel-button ", ctx_r30.cancelButtonClass || "btn-danger", "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 4, "common.button.close"), " ");
} }
function FormComponent_div_11_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 40);
    ɵngcc0.ɵɵtemplate(1, FormComponent_div_11_div_9_button_1_Template, 3, 6, "button", 41);
    ɵngcc0.ɵɵelementStart(2, "button", 42);
    ɵngcc0.ɵɵlistener("click", function FormComponent_div_11_div_9_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r34); const ctx_r33 = ɵngcc0.ɵɵnextContext(2); return ctx_r33.changeEditMode(); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "localize");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r27.isEditMode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("btn-primary", !ctx_r27.isEditMode)("btn-success", ctx_r27.isEditMode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 6, ctx_r27.editButtonText()));
} }
function FormComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r36 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵelementStart(1, "div", 26);
    ɵngcc0.ɵɵelementStart(2, "div", 27);
    ɵngcc0.ɵɵelementStart(3, "div", 28);
    ɵngcc0.ɵɵtemplate(4, FormComponent_div_11_div_4_Template, 2, 0, "div", 29);
    ɵngcc0.ɵɵtemplate(5, FormComponent_div_11_img_5_Template, 1, 1, "img", 30);
    ɵngcc0.ɵɵtemplate(6, FormComponent_div_11_img_6_Template, 1, 0, "img", 31);
    ɵngcc0.ɵɵelementStart(7, "input", 32);
    ɵngcc0.ɵɵlistener("change", function FormComponent_div_11_Template_input_change_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r36); const ctx_r35 = ɵngcc0.ɵɵnextContext(); return ctx_r35.fileBrowseHandler($event.target["files"]); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, FormComponent_div_11_i_8_Template, 1, 0, "i", 33);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, FormComponent_div_11_div_9_Template, 5, 8, "div", 34);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.isEditMode && ctx_r3.avatar);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.avatar);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.avatar);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("cursor-pointer", ctx_r3.isEditMode);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r3.isEditMode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.isEditMode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.forcedViewMode);
} }
function FormComponent_div_12_ano_password_validator_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ano-password-validator", 48);
} if (rf & 2) {
    const ctx_r37 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("hideTitle", true)("password", ctx_r37.form.get("newPassword").value);
} }
function FormComponent_div_12_div_3_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r41 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 43);
    ɵngcc0.ɵɵlistener("click", function FormComponent_div_12_div_3_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r41); const ctx_r40 = ɵngcc0.ɵɵnextContext(3); return ctx_r40.cancel(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "localize");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r39 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassMapInterpolate1("btn cancel-button ", ctx_r39.cancelButtonClass || "btn-danger", "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 4, "common.button.close"));
} }
function FormComponent_div_12_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r43 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 49);
    ɵngcc0.ɵɵtemplate(1, FormComponent_div_12_div_3_button_1_Template, 3, 6, "button", 41);
    ɵngcc0.ɵɵelementStart(2, "button", 50);
    ɵngcc0.ɵɵlistener("click", function FormComponent_div_12_div_3_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r43); const ctx_r42 = ɵngcc0.ɵɵnextContext(2); return ctx_r42.changeEditMode(); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "localize");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r38.isEditMode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("btn-primary", !ctx_r38.isEditMode)("btn-success", ctx_r38.isEditMode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 6, ctx_r38.editButtonText()));
} }
function FormComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 44);
    ɵngcc0.ɵɵelementStart(1, "div", 45);
    ɵngcc0.ɵɵtemplate(2, FormComponent_div_12_ano_password_validator_2_Template, 1, 2, "ano-password-validator", 46);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, FormComponent_div_12_div_3_Template, 5, 8, "div", 47);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("edit-col", ctx_r4.buttonsCol5 && ctx_r4.isEditMode)("col", ctx_r4.passwordValidation || !ctx_r4.buttonsCol5 || ctx_r4.buttonsCol5 && !ctx_r4.isEditMode)("col-5", ctx_r4.buttonsCol5 && ctx_r4.isEditMode);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.passwordValidation && ctx_r4.isEditMode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.withoutSave);
} }
const _c26 = function (a0) { return [a0]; };
function LinkedStreamsFilterComponent_form_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "form", 2);
    ɵngcc0.ɵɵelement(1, "ano-input", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.linkedStreamsFilterForm);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r0.linkedStreamsFilterConfig.name)("isEditMode", true)("noBorder", false)("config", ɵngcc0.ɵɵpureFunction3(5, _c1, ctx_r0.INPUT_TYPES.SELECT, ctx_r0.linkedStreamsFilterConfig.placeholder, ctx_r0.linkedStreamsFilterConfig.selectOptions));
} }
function SpeedometerComponent_p_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "localize");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r0.topText));
} }
function PieChartUsedComponent_p_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "localize");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r0.topText));
} }
const _c27 = function (a0, a1) { return { value1: a0, value2: a1 }; };
const _c28 = function () { return { label1: "#0e54a9", label2: "#e6eef6" }; };
const _c29 = ".no-white-space[_ngcontent-%COMP%]{white-space:nowrap}";
function DatepickerComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, " All ");
    ɵngcc0.ɵɵelementEnd();
} }
function DatepickerComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵlistener("click", function DatepickerComponent_div_3_Template_div_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.clearDate($event); });
    ɵngcc0.ɵɵelement(1, "i", 8);
    ɵngcc0.ɵɵelementEnd();
} }
function PlayerComponent_ng_container_1_span_1_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i");
} if (rf & 2) {
    const infoLine_r2 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵclassMapInterpolate1("icon icon-", infoLine_r2.cssIconClass, "");
} }
function PlayerComponent_ng_container_1_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 4);
    ɵngcc0.ɵɵlistener("click", function PlayerComponent_ng_container_1_span_1_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const infoLine_r2 = ɵngcc0.ɵɵnextContext().$implicit; return infoLine_r2 == null ? null : infoLine_r2.action(); });
    ɵngcc0.ɵɵtemplate(1, PlayerComponent_ng_container_1_span_1_i_1_Template, 1, 3, "i", 5);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "localize");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    const i_r3 = ctx_r10.index;
    const infoLine_r2 = ctx_r10.$implicit;
    ɵngcc0.ɵɵclassMapInterpolate2("status-video status-video-", i_r3 + 1, " ", infoLine_r2.cssClass, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", infoLine_r2.cssIconClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 6, infoLine_r2.text), " ");
} }
function PlayerComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PlayerComponent_ng_container_1_span_1_Template, 4, 8, "span", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const infoLine_r2 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", infoLine_r2 && (infoLine_r2.showOn !== ctx_r0.STATE.PLAY || ctx_r0.state === ctx_r0.STATE.PLAY) && (infoLine_r2.showOn !== ctx_r0.STATE.STOP || ctx_r0.state === ctx_r0.STATE.STOP));
} }
function PlayerComponent_ano_videojs_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ano-videojs", 6);
    ɵngcc0.ɵɵlistener("videoEnded", function PlayerComponent_ano_videojs_2_Template_ano_videojs_videoEnded_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.onVideoEnd(); })("videoClicked", function PlayerComponent_ano_videojs_2_Template_ano_videojs_videoClicked_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.onVideoClick(); })("playerSignal", function PlayerComponent_ano_videojs_2_Template_ano_videojs_playerSignal_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onPlayerSignal($event); })("overlayClicked", function PlayerComponent_ano_videojs_2_Template_ano_videojs_overlayClicked_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.onOverlayClick($event); })("overlayViewed", function PlayerComponent_ano_videojs_2_Template_ano_videojs_overlayViewed_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.onOverlayViewed($event); })("fullscreenToggle", function PlayerComponent_ano_videojs_2_Template_ano_videojs_fullscreenToggle_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.onFullscreenChange($event); })("timeUpdate", function PlayerComponent_ano_videojs_2_Template_ano_videojs_timeUpdate_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.onTimeUpdate($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("config", ctx_r1.config)("buttonsConfig", ctx_r1.buttonsConfig)("currentLivestreamTime", ctx_r1.currentLivestreamTime)("marketingSocket", ctx_r1.marketingSocket)("playerController", ctx_r1.playerController);
} }
const _c30 = function (a0) { return { "background-image": a0, "background-size": "cover", "background-position": "center" }; };
const _c31 = ["videoWrapper"];
const _c32 = ["target"];
var TEMPLATE_ID;
(function (TEMPLATE_ID) {
    TEMPLATE_ID[TEMPLATE_ID["DATE"] = 0] = "DATE";
    TEMPLATE_ID[TEMPLATE_ID["PRICE"] = 1] = "PRICE";
    TEMPLATE_ID[TEMPLATE_ID["VALUE_UNIT"] = 2] = "VALUE_UNIT";
    TEMPLATE_ID[TEMPLATE_ID["DATE_RANGE"] = 3] = "DATE_RANGE";
    TEMPLATE_ID[TEMPLATE_ID["ACTIONS"] = 4] = "ACTIONS";
    TEMPLATE_ID[TEMPLATE_ID["STATUS"] = 5] = "STATUS";
    TEMPLATE_ID[TEMPLATE_ID["SUBSCRIPTION_TYPE"] = 6] = "SUBSCRIPTION_TYPE";
    TEMPLATE_ID[TEMPLATE_ID["PROLONGATION"] = 7] = "PROLONGATION";
    TEMPLATE_ID[TEMPLATE_ID["MEDIA_ID"] = 8] = "MEDIA_ID";
    TEMPLATE_ID[TEMPLATE_ID["ACTION_DOWNLOAD"] = 9] = "ACTION_DOWNLOAD";
})(TEMPLATE_ID || (TEMPLATE_ID = {}));
var FILTER_MEDIA_TYPES;
(function (FILTER_MEDIA_TYPES) {
    FILTER_MEDIA_TYPES["STREAM"] = "STREAM";
    FILTER_MEDIA_TYPES["VIDEO_ON_DEMAND"] = "VIDEO";
    FILTER_MEDIA_TYPES["STREAM_RECORDING"] = "STREAM_RECORDING";
})(FILTER_MEDIA_TYPES || (FILTER_MEDIA_TYPES = {}));
var DATETIME_INPUT_TYPE;
(function (DATETIME_INPUT_TYPE) {
    DATETIME_INPUT_TYPE[DATETIME_INPUT_TYPE["START"] = 0] = "START";
    DATETIME_INPUT_TYPE[DATETIME_INPUT_TYPE["END"] = 1] = "END";
})(DATETIME_INPUT_TYPE || (DATETIME_INPUT_TYPE = {}));
var DATETIME_PICKER_TYPE;
(function (DATETIME_PICKER_TYPE) {
    DATETIME_PICKER_TYPE["CALENDAR"] = "calendar";
    DATETIME_PICKER_TYPE["TIMER"] = "timer";
    DATETIME_PICKER_TYPE["BOTH"] = "both";
})(DATETIME_PICKER_TYPE || (DATETIME_PICKER_TYPE = {}));
var INPUT_TYPES;
(function (INPUT_TYPES) {
    INPUT_TYPES[INPUT_TYPES["INPUT"] = 0] = "INPUT";
    INPUT_TYPES[INPUT_TYPES["PASSWORD"] = 1] = "PASSWORD";
    INPUT_TYPES[INPUT_TYPES["SELECT"] = 2] = "SELECT";
    INPUT_TYPES[INPUT_TYPES["CHECKBOX"] = 3] = "CHECKBOX";
    INPUT_TYPES[INPUT_TYPES["TEXTAREA"] = 4] = "TEXTAREA";
    INPUT_TYPES[INPUT_TYPES["DATETIME"] = 5] = "DATETIME";
    INPUT_TYPES[INPUT_TYPES["IMAGE"] = 6] = "IMAGE";
    INPUT_TYPES[INPUT_TYPES["PHONE"] = 7] = "PHONE";
    INPUT_TYPES[INPUT_TYPES["IBAN"] = 8] = "IBAN";
    INPUT_TYPES[INPUT_TYPES["MULTISELECT"] = 9] = "MULTISELECT";
    INPUT_TYPES[INPUT_TYPES["SIMPLE_CHECKBOX"] = 10] = "SIMPLE_CHECKBOX";
    INPUT_TYPES[INPUT_TYPES["CURRENCY_AMOUNT"] = 11] = "CURRENCY_AMOUNT";
    INPUT_TYPES[INPUT_TYPES["CREDIT_CARD"] = 12] = "CREDIT_CARD";
    INPUT_TYPES[INPUT_TYPES["RADIO"] = 13] = "RADIO";
    INPUT_TYPES[INPUT_TYPES["TIMER"] = 14] = "TIMER";
    INPUT_TYPES[INPUT_TYPES["MULTISELECT_IN_SINGLE_DROPDOWN"] = 15] = "MULTISELECT_IN_SINGLE_DROPDOWN";
})(INPUT_TYPES || (INPUT_TYPES = {}));
var CARD_TYPE;
(function (CARD_TYPE) {
    CARD_TYPE["NONE"] = "";
    CARD_TYPE["VISA"] = "../assets/img/visa.png";
    CARD_TYPE["VISA_ELECTRON"] = "../assets/img/ve.png";
    CARD_TYPE["MASTERCARD"] = "../assets/img/mc.jpg";
})(CARD_TYPE || (CARD_TYPE = {}));
var EXTERNAL_PLAYER_SIGNAL;
(function (EXTERNAL_PLAYER_SIGNAL) {
    EXTERNAL_PLAYER_SIGNAL[EXTERNAL_PLAYER_SIGNAL["START"] = 0] = "START";
    EXTERNAL_PLAYER_SIGNAL[EXTERNAL_PLAYER_SIGNAL["STOP"] = 1] = "STOP";
})(EXTERNAL_PLAYER_SIGNAL || (EXTERNAL_PLAYER_SIGNAL = {}));
var STATE;
(function (STATE) {
    STATE[STATE["PLAY"] = 0] = "PLAY";
    STATE[STATE["STOP"] = 1] = "STOP";
})(STATE || (STATE = {}));
var MEDIA_TYPE;
(function (MEDIA_TYPE) {
    MEDIA_TYPE["STREAM"] = "STREAM";
    MEDIA_TYPE["VIDEO_ON_DEMAND"] = "VIDEO_ON_DEMAND";
    MEDIA_TYPE["STREAM_RECORDING"] = "STREAM_RECORDING";
    MEDIA_TYPE["VIDEO"] = "VIDEO";
})(MEDIA_TYPE || (MEDIA_TYPE = {}));
var MEDIA_FORMAT;
(function (MEDIA_FORMAT) {
    MEDIA_FORMAT["VIDEO"] = "video/mp4";
    MEDIA_FORMAT["STREAM"] = "application/x-mpegURL";
})(MEDIA_FORMAT || (MEDIA_FORMAT = {}));
var MEDIA_SUBTYPE;
(function (MEDIA_SUBTYPE) {
    MEDIA_SUBTYPE["TEASER"] = "TEASER";
    MEDIA_SUBTYPE["TRAILER"] = "TRAILER";
    MEDIA_SUBTYPE["MAIN"] = "MAIN";
})(MEDIA_SUBTYPE || (MEDIA_SUBTYPE = {}));
var OVERLAY_TYPE;
(function (OVERLAY_TYPE) {
    OVERLAY_TYPE["LEFT"] = "LEFT";
    OVERLAY_TYPE["RIGHT"] = "RIGHT";
    OVERLAY_TYPE["BOTTOM"] = "BOTTOM";
})(OVERLAY_TYPE || (OVERLAY_TYPE = {}));
var SURVEY_STATUS;
(function (SURVEY_STATUS) {
    SURVEY_STATUS["ACTIVE"] = "ACTIVE";
    SURVEY_STATUS["INACTIVE"] = "INACTIVE";
})(SURVEY_STATUS || (SURVEY_STATUS = {}));
var MARKETING_ACTION;
(function (MARKETING_ACTION) {
    MARKETING_ACTION["HIDE"] = "HIDE";
    MARKETING_ACTION["SHOW"] = "SHOW";
    MARKETING_ACTION["UPDATE_STATUS"] = "UPDATE_STATUS";
    MARKETING_ACTION["PUBLISH_RESULTS"] = "PUBLISH_RESULTS";
})(MARKETING_ACTION || (MARKETING_ACTION = {}));
var MARKETING_ENTITY_TYPE;
(function (MARKETING_ENTITY_TYPE) {
    MARKETING_ENTITY_TYPE["OVERLAY"] = "OVERLAY";
    MARKETING_ENTITY_TYPE["SURVEY"] = "SURVEY";
})(MARKETING_ENTITY_TYPE || (MARKETING_ENTITY_TYPE = {}));
var ApiUrls;
(function (ApiUrls) {
    ApiUrls["ROOT_URL"] = "ROOT_URL";
})(ApiUrls || (ApiUrls = {}));
var LOADER_THEMES;
(function (LOADER_THEMES) {
    LOADER_THEMES[LOADER_THEMES["DEFAULT"] = 0] = "DEFAULT";
    LOADER_THEMES[LOADER_THEMES["AVATAR"] = 1] = "AVATAR";
    LOADER_THEMES[LOADER_THEMES["BLOCK"] = 2] = "BLOCK";
})(LOADER_THEMES || (LOADER_THEMES = {}));
var BILL_TYPE;
(function (BILL_TYPE) {
    BILL_TYPE["MEDIA"] = "MEDIA";
    BILL_TYPE["SUBSCRIPTION"] = "SUBSCRIPTION";
    BILL_TYPE["BANDWIDTH"] = "BANDWIDTH";
    BILL_TYPE["STORAGE_SPACE"] = "STORAGE_SPACE";
    BILL_TYPE["MULTIBITRATE"] = "MULTIBITRATE";
    BILL_TYPE["STREAM"] = "STREAM";
    BILL_TYPE["STREAM_GROUP"] = "STREAM_GROUP";
    BILL_TYPE["STREAM_RECORDING"] = "STREAM_RECORDING";
    BILL_TYPE["VIDEO_ON_DEMAND"] = "VIDEO_ON_DEMAND";
})(BILL_TYPE || (BILL_TYPE = {}));
var BILL_STATUS;
(function (BILL_STATUS) {
    BILL_STATUS["PAID"] = "PAID";
    BILL_STATUS["UNPAID"] = "UNPAID";
})(BILL_STATUS || (BILL_STATUS = {}));
var BILL_MEDIA_TYPE;
(function (BILL_MEDIA_TYPE) {
    BILL_MEDIA_TYPE["VOD"] = "VOD";
    BILL_MEDIA_TYPE["LS"] = "LS";
})(BILL_MEDIA_TYPE || (BILL_MEDIA_TYPE = {}));
var SUBSCRIPTION_TYPE;
(function (SUBSCRIPTION_TYPE) {
    SUBSCRIPTION_TYPE["ADVANCED"] = "Advanced";
})(SUBSCRIPTION_TYPE || (SUBSCRIPTION_TYPE = {}));
var MEDIA_FILTERS_FIELDS;
(function (MEDIA_FILTERS_FIELDS) {
    MEDIA_FILTERS_FIELDS["MEDIA_TYPE"] = "MEDIA_TYPE";
    MEDIA_FILTERS_FIELDS["STREAM_STATUS"] = "STREAM_STATUS";
    MEDIA_FILTERS_FIELDS["EXCLUDE_ID"] = "EXCLUDE_ID";
    MEDIA_FILTERS_FIELDS["PUBLISHER"] = "PUBLISHER";
    MEDIA_FILTERS_FIELDS["PURCHASED_BY"] = "PURCHASED_BY";
    MEDIA_FILTERS_FIELDS["GROUP_ID"] = "GROUP_ID";
    MEDIA_FILTERS_FIELDS["VISIBLE"] = "VISIBLE";
    MEDIA_FILTERS_FIELDS["HAS_ACCESS"] = "HAS_ACCESS";
})(MEDIA_FILTERS_FIELDS || (MEDIA_FILTERS_FIELDS = {}));
var STREAM_STATUS;
(function (STREAM_STATUS) {
    STREAM_STATUS["SCHEDULED"] = "SCHEDULED";
    STREAM_STATUS["RESCHEDULING"] = "RESCHEDULING";
    STREAM_STATUS["ACTIVATION"] = "ACTIVATION";
    STREAM_STATUS["ACTIVATED"] = "ACTIVATED";
    STREAM_STATUS["CONNECTED"] = "CONNECTED";
    STREAM_STATUS["PAUSED"] = "PAUSED";
    STREAM_STATUS["LIVE"] = "LIVE";
    STREAM_STATUS["FINISHED"] = "FINISHED";
    STREAM_STATUS["VIDEO"] = "VIDEO";
    STREAM_STATUS["WAITING"] = "WAITING";
})(STREAM_STATUS || (STREAM_STATUS = {}));
var RECORD_STATUS;
(function (RECORD_STATUS) {
    RECORD_STATUS["NONE"] = "NONE";
    RECORD_STATUS["RECORDING"] = "RECORDING";
    RECORD_STATUS["STORING"] = "STORING";
    RECORD_STATUS["RECORDED"] = "RECORDED";
})(RECORD_STATUS || (RECORD_STATUS = {}));
var CURRENCY_SYMBOLS;
(function (CURRENCY_SYMBOLS) {
    CURRENCY_SYMBOLS["EUR"] = "EUR";
    CURRENCY_SYMBOLS["USD"] = "USD";
})(CURRENCY_SYMBOLS || (CURRENCY_SYMBOLS = {}));
const CUR_SYM = {
    EUR: '€',
    USD: '$'
};
const CURRENCY_VALUES = {
    '€': 'EUR',
    '$': 'USD'
};
var PUBLISHER_FILTERS;
(function (PUBLISHER_FILTERS) {
    PUBLISHER_FILTERS["SORT"] = "SORT";
    PUBLISHER_FILTERS["STATUS"] = "STATUS";
    PUBLISHER_FILTERS["APPROVED"] = "APPROVED";
    PUBLISHER_FILTERS["PREMIUM_SUBSCRIPTION_PLAN"] = "PREMIUM_SUBSCRIPTION_PLAN";
    PUBLISHER_FILTERS["SUBSCRIPTION_TYPE"] = "SUBSCRIPTION_TYPE";
    PUBLISHER_FILTERS["WAITING_FOR_APPROVAL"] = "WAITING_FOR_APPROVAL";
    PUBLISHER_FILTERS["ACCOUNT_EVOLUTION"] = "ACCOUNT_EVOLUTION";
    PUBLISHER_FILTERS["PUBLISHER_TYPE"] = "PUBLISHER_TYPE";
})(PUBLISHER_FILTERS || (PUBLISHER_FILTERS = {}));
var VIEWER_FILTERS;
(function (VIEWER_FILTERS) {
    VIEWER_FILTERS["VIEW_ACCESS_TYPE"] = "VIEW_ACCESS_TYPE";
    VIEWER_FILTERS["FREE"] = "FREE";
    VIEWER_FILTERS["PAYMENT"] = "PAYMENT";
    VIEWER_FILTERS["LEAD_REGISTRATION"] = "LEAD_REGISTRATION";
    VIEWER_FILTERS["PAYMENT_VOUCHER"] = "PAYMENT_VOUCHER";
})(VIEWER_FILTERS || (VIEWER_FILTERS = {}));
var WIDGET_TYPE;
(function (WIDGET_TYPE) {
    WIDGET_TYPE["PRIMARY"] = "primary";
    WIDGET_TYPE["WARNING"] = "warning";
    WIDGET_TYPE["SUCCESS"] = "success";
    WIDGET_TYPE["DANGER"] = "danger";
})(WIDGET_TYPE || (WIDGET_TYPE = {}));
var PAYMENT_SYSTEM;
(function (PAYMENT_SYSTEM) {
    PAYMENT_SYSTEM["AVAILABLE_FOR_EVERYONE"] = "AVAILABLE_FOR_EVERYONE";
    PAYMENT_SYSTEM["ONLY_WITH_VOUCHER"] = "ONLY_WITH_VOUCHER";
    PAYMENT_SYSTEM["FREE"] = "FREE";
    PAYMENT_SYSTEM["LEAD_GENERATION"] = "LEAD_GENERATION";
    PAYMENT_SYSTEM["FREE_ACCESS"] = "FREE_ACCESS";
    PAYMENT_SYSTEM["LIMIT_ACCESS"] = "LIMIT_ACCESS";
    PAYMENT_SYSTEM["VOUCHER"] = "VOUCHER";
    PAYMENT_SYSTEM["PAY_PER_VIEW"] = "PAY_PER_VIEW";
    PAYMENT_SYSTEM["ENTERPRISE_LOGIN"] = "ENTERPRISE_LOGIN";
    PAYMENT_SYSTEM["COURSE_ACCESS"] = "COURSE_ACCESS";
})(PAYMENT_SYSTEM || (PAYMENT_SYSTEM = {}));
var StreamMarketingToolsOverlaysTypes;
(function (StreamMarketingToolsOverlaysTypes) {
    StreamMarketingToolsOverlaysTypes["OVERLAY"] = "overlay";
    StreamMarketingToolsOverlaysTypes["COURSES"] = "course";
    StreamMarketingToolsOverlaysTypes["LEADGENERATION"] = "leadgeneration";
})(StreamMarketingToolsOverlaysTypes || (StreamMarketingToolsOverlaysTypes = {}));
var USER_TYPE;
(function (USER_TYPE) {
    USER_TYPE["VIEWER"] = "VIEWER";
    USER_TYPE["PUBLISHER"] = "PUBLISHER";
    USER_TYPE["SUB_ACCOUNT"] = "SUB_ACCOUNT";
})(USER_TYPE || (USER_TYPE = {}));
const PaymentsVideo = [
    {
        key: 'FREE_ACCESS',
        value: 'stream.payments.free',
        desc: 'stream.payments.free.desc',
        values: [],
    },
    {
        key: 'LIMIT_ACCESS',
        value: 'stream.payments.limit',
        desc: 'stream.payments.limit.desc',
        values: [
            {
                name: 'stream.payments.payView.name',
                key: 'psPayPerView',
                desc: 'stream.payments.payView.desc',
                required: true,
            },
            {
                name: 'stream.payments.slots.name',
                key: 'psSlot',
                desc: 'stream.payments.slots.desc',
                required: true,
            },
            {
                name: 'stream.payments.voucher.name',
                key: 'psVoucher',
                desc: 'stream.payments.voucher.desc',
                required: true,
            },
            {
                name: 'stream.payments.leadGeneration.name',
                key: 'psLeadGeneration',
                desc: 'stream.payments.leadGeneration.desc',
                required: true,
            }
        ],
    },
    {
        key: 'COURSE_ACCESS',
        value: 'stream.payments.courses.name',
        desc: 'stream.payments.courses.desc',
        values: [
            {
                name: 'stream.payments.payView.name',
                key: 'psPayPerView',
                desc: 'stream.payments.payView.desc',
                required: true,
            },
            {
                name: 'stream.payments.voucher.name',
                key: 'psVoucher',
                desc: 'stream.payments.voucher.desc',
                required: true,
            },
            {
                name: 'stream.payments.leadGeneration.name',
                key: 'psLeadGeneration',
                desc: 'stream.payments.leadGeneration.desc',
                required: true,
            },
            {
                name: 'stream.payments.customIntegration.name',
                key: 'psCustomIntegration',
                desc: 'stream.payments.customIntegration.desc',
                required: true,
            }
        ],
    }
];
const NewPaymentsSlots$1 = [
    {
        key: 'FREE',
        value: 'stream.payments.free',
        desc: 'stream.payments.free.desc',
    },
    {
        key: 'VOUCHER',
        value: 'stream.payments.voucher.name',
        desc: 'stream.payments.free.desc',
    },
    {
        key: 'PAY_PER_VIEW',
        value: 'stream.payments.payView.name',
        desc: 'stream.payments.free.desc',
    },
];
const PaymentsStream = [
    {
        key: 'FREE_ACCESS',
        value: 'stream.payments.free',
        desc: 'stream.payments.free.desc',
        values: [],
    },
    {
        key: 'LIMIT_ACCESS',
        value: 'stream.payments.limit',
        desc: 'stream.payments.limit.desc',
        values: [
            {
                name: 'stream.payments.payView.name',
                key: 'psPayPerView',
                desc: 'stream.payments.payView.desc',
                required: true,
            },
            {
                name: 'stream.payments.slots.name',
                key: 'psSlot',
                desc: 'stream.payments.slots.desc',
                required: true,
            },
            {
                name: 'stream.payments.voucher.name',
                key: 'psVoucher',
                desc: 'stream.payments.voucher.desc',
                required: true,
            },
            {
                name: 'stream.payments.leadGeneration.name',
                key: 'psLeadGeneration',
                desc: 'stream.payments.leadGeneration.desc',
                required: true,
            }
        ],
    },
    {
        key: 'COURSE_ACCESS',
        value: 'stream.payments.courses.name',
        desc: 'stream.payments.courses.desc',
        values: [
            {
                name: 'stream.payments.payView.name',
                key: 'psPayPerView',
                desc: 'stream.payments.payView.desc',
                required: true,
            },
            {
                name: 'stream.payments.voucher.name',
                key: 'psVoucher',
                desc: 'stream.payments.voucher.desc',
                required: true,
            },
            {
                name: 'stream.payments.leadGeneration.name',
                key: 'psLeadGeneration',
                desc: 'stream.payments.leadGeneration.desc',
                required: true,
            },
            {
                name: 'stream.payments.customIntegration.name',
                key: 'psCustomIntegration',
                desc: 'stream.payments.customIntegration.desc',
                required: true,
            }
        ],
    }
];
var FILTER_TYPES;
(function (FILTER_TYPES) {
    FILTER_TYPES["SORT"] = "SORT";
    FILTER_TYPES["MEDIA_TYPE"] = "MEDIA_TYPE";
    FILTER_TYPES["GENRE"] = "GENRE";
    FILTER_TYPES["CONTENT_ACCESS_TYPE"] = "CONTENT_ACCESS_TYPE";
    FILTER_TYPES["COUNTRY"] = "COUNTRY";
    FILTER_TYPES["HAS_ACCESS_MEDIA_GROUP"] = "HAS_ACCESS_MEDIA_GROUP";
    FILTER_TYPES["PUBLISHER_GROUP"] = "PUBLISHER_GROUP";
})(FILTER_TYPES || (FILTER_TYPES = {}));
var COURSE_COLOR;
(function (COURSE_COLOR) {
    COURSE_COLOR["WHITE"] = "WHITE";
    COURSE_COLOR["BLACK"] = "BLACK";
})(COURSE_COLOR || (COURSE_COLOR = {}));
var SUB_ACCOUNT_TYPE;
(function (SUB_ACCOUNT_TYPE) {
    SUB_ACCOUNT_TYPE["DIRECT"] = "DIRECT";
    SUB_ACCOUNT_TYPE["INVITED"] = "INVITED";
})(SUB_ACCOUNT_TYPE || (SUB_ACCOUNT_TYPE = {}));
const SPEEDOMETER_SEGMENT_SIZE = 20;
var ACTIONS;
(function (ACTIONS) {
    ACTIONS["EDIT"] = "edit";
    ACTIONS["ADD"] = "save";
    ACTIONS["SAVE"] = "save";
    ACTIONS["CANCEL"] = "cancel";
    ACTIONS["DELETE"] = "delete";
    ACTIONS["SUBMIT"] = "submit";
})(ACTIONS || (ACTIONS = {}));
var ITimeType;
(function (ITimeType) {
    ITimeType[ITimeType["MEDIA_TIME"] = 0] = "MEDIA_TIME";
    ITimeType[ITimeType["CLOCK_TIME"] = 1] = "CLOCK_TIME";
})(ITimeType || (ITimeType = {}));

class DateHelper {
    static formatDateTime(timestamp, format = 'DD MMMM YYYY, HH:mm') {
        const language = localStorage.getItem('localLanguage');
        const hrs = language === 'EN' ? 'h' : 'Uhr';
        return moment$1(timestamp).locale(language).format(format) + hrs;
    }
    static formatDate(timestamp, format = 'DD MMMM YYYY', localTime = false) {
        const language = localStorage.getItem('localLanguage');
        if (localTime) {
            return moment$1(timestamp).locale(language).format(format);
        }
        return moment$1.utc(timestamp).utcOffset('+00:00').locale(language).format(format);
    }
    static formatTime(timestamp, format = 'HH:mm') {
        const language = localStorage.getItem('localLanguage');
        return moment$1(timestamp).locale(language).format(format);
    }
    static formatDayAndTime(timestamp) {
        const language = localStorage.getItem('localLanguage');
        const hrs = language === 'EN' ? ' h' : ' Uhr';
        return moment$1(new Date(timestamp)).locale(language).format('dddd, HH:mm') + hrs;
    }
    static inRange(value, rangeMin, rangeMax) {
        return value >= rangeMin && value <= rangeMax;
    }
    static timePassed(timestamp, minutes) {
        return timestamp - (minutes * 60 * 1000) <= (new Date().getTime());
    }
    static timeInRange(timestamp, minutes) {
        return DateHelper.inRange(new Date().getTime(), timestamp - minutes * 60 * 1000, timestamp);
    }
    static parseTime(time, type) {
        const duration = time.split(':');
        if (!duration.length) {
            return time;
        }
        if (type === TIME_TYPE.MINUTES) {
            return (+duration[0]);
        }
        if (type === TIME_TYPE.MILLISECONDS) {
            return ((+duration[0] * 60) + (+duration[1] || 0)) * 1000;
        }
        return (+duration[0] * 60) + (+duration[1] || 0);
    }
}
var TIME_TYPE;
(function (TIME_TYPE) {
    TIME_TYPE[TIME_TYPE["MINUTES"] = 0] = "MINUTES";
    TIME_TYPE[TIME_TYPE["MILLISECONDS"] = 1] = "MILLISECONDS";
})(TIME_TYPE || (TIME_TYPE = {}));

let AutoDestroyService = class AutoDestroyService extends Subject {
    ngOnDestroy() {
        this.next();
        this.complete();
    }
};
AutoDestroyService.ɵfac = /*@__PURE__*/ function () { let ɵAutoDestroyService_BaseFactory; return function AutoDestroyService_Factory(t) { return (ɵAutoDestroyService_BaseFactory || (ɵAutoDestroyService_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(AutoDestroyService)))(t || AutoDestroyService); }; }();
AutoDestroyService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AutoDestroyService, factory: function (t) { return AutoDestroyService.ɵfac(t); } });

let TableComponent = class TableComponent {
    constructor(fb, destroy$, cdRef) {
        this.fb = fb;
        this.destroy$ = destroy$;
        this.cdRef = cdRef;
        this.INPUT_TYPES = INPUT_TYPES;
        this.withFilters = false;
        this.withSearch = false;
        this.startFromAll = false;
        this.height = 'auto';
        this.addButton = false;
        this.downloadButton = false;
        this.isDownloadLoading = false;
        this.sortOrder = 1;
        this.searchInputType = 'search';
        this.disabledAddButton = false;
        this.showDatepicker = false;
        this.addItem$ = new EventEmitter();
        this.download$ = new EventEmitter();
        this.navigate$ = new EventEmitter();
        this.timeRangeFilter$ = new EventEmitter();
        this.filterByLinkedStreams$ = new EventEmitter();
        this.select$ = new EventEmitter();
        this.searchTerm = '';
        this.years = [
            {
                key: new Date().getFullYear().toString(),
                value: new Date().getFullYear().toString()
            }
        ];
        this.callCanceler = new Subject();
        this.cachedSort = {};
        this.notAppend = false;
        this.itemsOnPage = 10;
        this.totalItems = 30;
        this.totalPages = 0;
        this.loading = false;
        this.page = 0;
        this.filterOpened = false;
        this.yearFilter = [];
        this.paginator = true;
        this.isSearch = false;
        this.pagingEvent = {
            filters: {},
            first: 0,
            globalFilter: null,
            multiSortMeta: undefined,
            rows: 10,
            sortField: undefined,
            sortOrder: 1
        };
        this.showLoadMore = true;
        this.search$ = new EventEmitter();
        this.searchByYear$ = new EventEmitter();
        this.filter$ = new EventEmitter();
    }
    set tableConfig(config) {
        var _a, _b;
        this.config = config;
        this.config.customScroll = true;
        if ((_a = this.config) === null || _a === void 0 ? void 0 : _a.itemsOnPage) {
            this.itemsOnPage = (_b = this.config) === null || _b === void 0 ? void 0 : _b.itemsOnPage;
        }
    }
    set filters(filters) {
        var _a;
        this._filters = (filters === null || filters === void 0 ? void 0 : filters.filters) || [];
        if (!((_a = this._filters) === null || _a === void 0 ? void 0 : _a.length)) {
            this.filtersList = [];
            return;
        }
        this.filtersList = filters.filterListItems;
        this.filtersForm = this.fb.group({});
        this._filters.forEach(filter => {
            this.filtersForm.addControl(filter, new FormControl('', []));
        });
        this.filtersForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(newValue => {
            const filters = [];
            Object.keys(newValue).forEach(key => {
                filters.push({
                    field: key,
                    value: newValue[key]
                });
            });
            this.filter$.emit(filters);
        });
    }
    ngOnInit() {
        this.config.matPaginator = true;
    }
    ngOnChanges(changes) {
        var _a, _b;
        this.config.matPaginator = true;
        if ((_a = changes === null || changes === void 0 ? void 0 : changes.yearsFilters) === null || _a === void 0 ? void 0 : _a.currentValue) {
            this.years = [];
            (_b = changes === null || changes === void 0 ? void 0 : changes.yearsFilters) === null || _b === void 0 ? void 0 : _b.currentValue.forEach(yearOption => {
                this.years.push({
                    key: yearOption.year.toString(),
                    value: yearOption.year.toString()
                });
            });
            this.years.push({
                key: 'all',
                value: 'streams.text.table.filter-by-year.placeholder'
            });
            this.years.reverse();
        }
        else {
            this.years.push({
                key: 'all',
                value: 'streams.text.table.filter-by-year.placeholder'
            });
            this.years.reverse();
        }
    }
    refreshData(event) {
        this.loading = true;
        setTimeout(() => {
            var _a;
            this.pagingEvent = ((_a = Object.keys(event)) === null || _a === void 0 ? void 0 : _a.length) ? event : this.pagingEvent;
            this.callCanceler.next();
            if (!this.config) {
                return;
            }
            if (!this.config.searchWithFilters) {
                this.simpleSearch(event);
            }
            if (this.config.searchWithFilters) {
                this.searchWithFilters(event);
            }
        });
    }
    simpleSearch(event) {
        this.config.searchFn(this.buildSortBody(event), {
            itemsOnPage: this.itemsOnPage,
            page: this.page,
        })
            .pipe(takeUntil(this.callCanceler))
            .subscribe(({ results }) => {
            var _a;
            if (this.config.withoutPaging) {
                this.data = results[this.config.dataField].items;
                this.loading = false;
                this.totalItems = results[this.config.dataField].items.length;
                this.itemsOnPage = results[this.config.dataField].items.length;
                this.paginator = false;
                this.showLoadMore = false;
            }
            else {
                this.data = this.data && !((_a = this.config) === null || _a === void 0 ? void 0 : _a.matPaginator) && !this.notAppend && !this.isSearch ? this.data.concat(results[this.config.dataField].items) : results[this.config.dataField].items;
                this.notAppend = false;
                this.isSearch = false;
                this.loading = false;
                this.totalItems = results[this.config.dataField].paging.items;
                this.showLoadMore = !(this.data.length === this.totalItems || !this.totalItems);
                this.totalPages = this.totalItems / this.itemsOnPage;
            }
            this.reRender();
        }, () => { this.loading = false; this.isClear = false; });
    }
    searchWithFilters(event) {
        this.config.searchWithFilters$(this.searchTerm, [
            ...this.config.defaultFilter,
            ...this.yearFilter
        ], this.buildSortBody(event), {
            itemsOnPage: this.itemsOnPage,
            page: this.page,
        }, this.currentTimeRange)
            .pipe(takeUntil(this.callCanceler))
            .subscribe(({ results }) => {
            var _a;
            this.data = this.data && !this.notAppend && !this.isSearch && !((_a = this.config) === null || _a === void 0 ? void 0 : _a.matPaginator) ? this.data.concat(results[this.config.dataField].items) : results[this.config.dataField].items;
            this.notAppend = false;
            this.isSearch = false;
            this.loading = false;
            this.totalItems = results[this.config.dataField].paging.items;
            this.itemsOnPage = 10;
            this.showLoadMore = !(this.data.length === this.totalItems || !this.totalItems);
            this.totalPages = this.totalItems / this.itemsOnPage;
            this.reRender();
        }, () => this.loading = false);
    }
    buildSortBody(event) {
        const sort = event.sortField && [{
                field: event.sortField,
                order: event.sortOrder === 1 ? 'ASC' : 'DESC'
            }];
        if (event.sortField === this.cachedSort.sortField && event.sortOrder === this.cachedSort.sortOrder) {
            this.page = Math.floor(event.first / this.itemsOnPage);
        }
        else {
            this.page = 0;
            this.cachedSort = { sortField: event.sortField, sortOrder: event.sortOrder };
        }
        return sort || undefined;
    }
    resetTableData() {
        this.notAppend = true;
    }
    resetTable() {
        if (this.table) {
            try {
                this.table.reset();
            }
            catch (e) {
            }
        }
        this.page = 0;
    }
    formatDate(timestamp) {
        return DateHelper.formatDateTime(timestamp, 'DD MMM YYYY, HH:mm');
    }
    lessThanOneDay(timestamp) {
        return timestamp < new Date().getTime() - (86400000);
    }
    toggleSort() {
        this.notAppend = true;
    }
    loadNextPage() {
        this.pagingEvent.first += this.pagingEvent.rows;
        this.refreshData(this.pagingEvent);
    }
    goToPage(page) {
        this.itemsOnPage = page.pageSize;
        this.pagingEvent.first = (page.pageIndex) * page.pageSize;
        this.refreshData(this.pagingEvent);
    }
    refreshPage() {
        this.refreshData(this.pagingEvent);
    }
    toggleFilter() {
        this.filterOpened = !this.filterOpened;
    }
    search(event) {
        this.page = 0;
        this.isSearch = true;
        this.search$.emit(event);
        if (this.config.searchWithFilters) {
            this.searchTerm = event;
            this.refreshData(this.pagingEvent);
        }
    }
    searchByYear(event) {
        this.page = 0;
        this.isSearch = true;
        if (event === 'all') {
            this.searchByYear$.emit('');
        }
        else {
            this.searchByYear$.emit(event);
        }
        if (this.config.searchWithFilters) {
            this.yearFilter = event === 'all' ? [] : [{
                    field: 'YEAR',
                    value: event
                }];
            this.refreshData(this.pagingEvent);
        }
    }
    timeRangeFilter(event) {
        this.timeRangeFilter$.emit(event);
        if (this.config.searchWithFilters) {
            this.currentTimeRange = event;
            this.resetTableData();
            this.refreshData({});
        }
    }
    addItem() {
        this.addItem$.emit(true);
    }
    download() {
        this.download$.emit(this.data);
    }
    navigate(id) {
        const navigationUrl = this.config.navigationUrl.replace('{id}', id);
        this.navigate$.emit(navigationUrl);
    }
    getHighlightClass(data) {
        if (!this.config.highlight) {
            return null;
        }
        return this.config.highlight(data);
    }
    reRender() {
        this.cdRef.markForCheck();
    }
    clearSearch() {
        this.isClear = true;
    }
    filterByLinkedStreams(event) {
        this.filterByLinkedStreams$.emit(event);
    }
    onRowClick(item) {
        this.selectedRowId = this.isOpportunityToSelect ? item === null || item === void 0 ? void 0 : item.id : '';
        this.select$.emit(item);
    }
    goToNoDataLink(url) {
        this.navigate$.emit(url);
    }
    updateData(item, findIndexFn) {
        const tableItemIndex = findIndexFn(this.data);
        if (!tableItemIndex) {
            return;
        }
        this.data[tableItemIndex] = item;
    }
};
TableComponent.ɵfac = function TableComponent_Factory(t) { return new (t || TableComponent)(ɵngcc0.ɵɵdirectiveInject(FormBuilder), ɵngcc0.ɵɵdirectiveInject(AutoDestroyService), ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef)); };
TableComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TableComponent, selectors: [["ano-table"]], viewQuery: function TableComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.table = _t.first);
    } }, inputs: { withFilters: "withFilters", withSearch: "withSearch", startFromAll: "startFromAll", height: "height", addButton: "addButton", downloadButton: "downloadButton", isDownloadLoading: "isDownloadLoading", sortOrder: "sortOrder", searchInputType: "searchInputType", disabledAddButton: "disabledAddButton", showDatepicker: "showDatepicker", tableConfig: "tableConfig", filters: "filters", selectedRowId: "selectedRowId", buttonsConfig: "buttonsConfig", title: "title", addButtonText: "addButtonText", downloadButtonText: "downloadButtonText", yearsFilters: "yearsFilters", defaultSortField: "defaultSortField", timeRangeConfig: "timeRangeConfig", isLinkedStreamsFilters: "isLinkedStreamsFilters", linkedFilters: "linkedFilters", disabledInputs: "disabledInputs", systemMessage: "systemMessage", isOpportunityToSelect: "isOpportunityToSelect" }, outputs: { addItem$: "addItem$", download$: "download$", navigate$: "navigate$", timeRangeFilter$: "timeRangeFilter$", filterByLinkedStreams$: "filterByLinkedStreams$", select$: "select$", search$: "search$", searchByYear$: "searchByYear$", filter$: "filter$" }, features: [ɵngcc0.ɵɵProvidersFeature([AutoDestroyService]), ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c6, decls: 23, vars: 23, consts: [[1, "card"], ["class", "card-header bg-transparent p-0", 4, "ngIf"], [4, "ngIf"], [1, "table-responsive"], [1, "table", "table-material"], ["tableElement", ""], [3, "isOpen", "containerRef", 4, "ngIf"], [1, "table-wrapper-border", "p-0"], ["class", "text-center no-results", 4, "ngIf"], ["class", "no-data-button-container", 4, "ngIf"], [3, "value", "lazy", "tableStyleClass", "rows", "totalRecords", "sortField", "sortOrder", "onLazyLoad"], ["table", ""], ["pTemplate", "header"], ["pTemplate", "body"], ["class", "table-footer-area align-content-end align-items-center", 4, "ngIf"], ["class", "table-footer-area align-content-center align-items-center", 4, "ngIf"], ["class", "align-content-end bg-white", 4, "ngIf"], [1, "card-header", "bg-transparent", "p-0"], [1, "title-card"], [1, "table-header-area", "align-items-center"], [1, "buttons-container"], ["class", "btn btn-primary add-button", 3, "disabled", "click", 4, "ngIf"], [1, "filter-and-search"], [4, "ngIf", "ngIfElse"], ["timeRange", ""], [3, "filters", "filterByLinkedStreams$", 4, "ngIf"], ["class", "year-filter", 4, "ngIf"], ["class", "border-form input-form", 3, "type", "disabled", "search$", 4, "ngIf"], [1, "btn", "btn-primary", "add-button", 3, "disabled", "click"], [1, "icon", "icon-plus-circle"], ["class", "form-group no-margin", 4, "ngFor", "ngForOf"], [1, "form-group", "no-margin"], [3, "config", "click"], [3, "class", 4, "ngIf"], [1, "blue-theme-filter", "table-filters"], [3, "formGroup"], [4, "ngFor", "ngForOf"], [3, "formControlName", "isEditMode", "noBorder", "config"], [1, "pr-2", 3, "startFromAll", "changeDate"], [3, "config", "filterByTimeRange$", 4, "ngIf"], [3, "config", "filterByTimeRange$"], [3, "filters", "filterByLinkedStreams$"], [1, "year-filter"], [1, "dropdown"], [3, "values", "value", "change"], [1, "border-form", "input-form", 3, "type", "disabled", "search$"], [3, "isOpen", "containerRef"], [1, "text-center", "no-results"], [1, "no-data-button-container"], [1, "cancel-button", 3, "config", "click"], [3, "cursor-pointer", "text-align", "pSortableColumn", "click", 4, "ngIf"], [3, "pSortableColumn", "click"], ["ariaLabel", "Activate to sort", "ariaLabelDesc", "Activate to sort in descending order", "ariaLabelAsc", "Activate to sort in ascending order", 3, "field", 4, "ngIf"], [1, "head-cell-text"], ["ariaLabel", "Activate to sort", "ariaLabelDesc", "Activate to sort in descending order", "ariaLabelAsc", "Activate to sort in ascending order", 3, "field"], [3, "ngClass"], [3, "width", "class", "text-align", "hover", "click", 4, "ngIf"], [3, "width", "click"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["pTemplate", "summary"], [4, "ngTemplateOutlet"], [1, "table-footer-area", "align-content-end", "align-items-center"], [1, "btn", "btn-success", 3, "click"], [3, "isOpen"], [1, "table-footer-area", "align-content-center", "align-items-center"], [1, "btn", "btn-primary", 3, "click"], [1, "align-content-end", "bg-white"], [3, "length", "pageSize", "pageSizeOptions", "page", 4, "ngIf"], [3, "length", "pageSize", "pageSizeOptions", "page"]], template: function TableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c5);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, TableComponent_div_1_Template, 4, 1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵtemplate(3, TableComponent_ng_container_3_Template, 13, 16, "ng-container", 2);
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "table", 4, 5);
        ɵngcc0.ɵɵtemplate(7, TableComponent_ano_loader_7_Template, 1, 2, "ano-loader", 6);
        ɵngcc0.ɵɵelementStart(8, "thead");
        ɵngcc0.ɵɵprojection(9, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "tbody");
        ɵngcc0.ɵɵelementStart(11, "div", 7);
        ɵngcc0.ɵɵtemplate(12, TableComponent_div_12_Template, 3, 3, "div", 8);
        ɵngcc0.ɵɵtemplate(13, TableComponent_div_13_Template, 5, 5, "div", 9);
        ɵngcc0.ɵɵelementStart(14, "p-table", 10, 11);
        ɵngcc0.ɵɵlistener("onLazyLoad", function TableComponent_Template_p_table_onLazyLoad_14_listener($event) { return ctx.refreshData($event); });
        ɵngcc0.ɵɵtemplate(16, TableComponent_ng_template_16_Template, 1, 1, "ng-template", 12);
        ɵngcc0.ɵɵtemplate(17, TableComponent_ng_template_17_Template, 2, 6, "ng-template", 13);
        ɵngcc0.ɵɵtemplate(18, TableComponent_18_Template, 1, 0, undefined, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(19, TableComponent_div_19_Template, 6, 4, "div", 14);
        ɵngcc0.ɵɵtemplate(20, TableComponent_div_20_Template, 4, 0, "div", 15);
        ɵngcc0.ɵɵtemplate(21, TableComponent_div_21_Template, 2, 1, "div", 16);
        ɵngcc0.ɵɵtemplate(22, TableComponent_span_22_Template, 2, 0, "span", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("table-container", ctx.config == null ? null : ctx.config.fullHeight);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.withSearch || ctx.timeRangeConfig);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("custom-scroll", ctx.config == null ? null : ctx.config.customScroll);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loading);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵclassProp("no-data", (ctx.data == null ? null : ctx.data.length) === 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.length) === 0 && !(ctx.config == null ? null : ctx.config.noDataLink));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.length) === 0 && (ctx.config == null ? null : ctx.config.noDataLink));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("value", ctx.data)("lazy", true)("tableStyleClass", "table table-sm table-border")("rows", ctx.itemsOnPage)("totalRecords", ctx.totalItems)("sortField", ctx.defaultSortField)("sortOrder", ctx.sortOrder);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config == null ? null : ctx.config.tableSummary);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.downloadButton && !ctx.loading && (ctx.data == null ? null : ctx.data.length));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.config.matPaginator && ctx.showLoadMore && !ctx.loading && (ctx.data == null ? null : ctx.data.length) > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.matPaginator && (ctx.data == null ? null : ctx.data.length) > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.config);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc2.Table, ɵngcc3.PrimeTemplate, ɵngcc1.NgForOf, ButtonComponent, ɵngcc4.ɵNgNoValidate, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, InputComponent, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName, DatepickerComponent, TimeRangeFilterComponent, LinkedStreamsFilterComponent, FilterDropdownComponent, SearchComponent, LoaderComponent, ɵngcc2.SortableColumn, ɵngcc2.SortIcon, ɵngcc1.NgClass, ɵngcc1.NgTemplateOutlet, ɵngcc5.MatPaginator]; }, pipes: function () { return [LocalizationPipe, WhiteSpacePipe]; }, styles: [".input-form{height:40px}.input-form .form-control{line-height:1.65}.tr-flex{display:flex;align-items:center}.middle{vertical-align:middle!important;text-align:center!important}.left{text-align:left!important}tr td{vertical-align:middle;white-space:nowrap}tr td.price{width:100px;text-align:right!important}tr td.date{width:165px}tr td.actions{width:130px}tr td .long-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}tr th{text-align:center;outline:none;white-space:nowrap}.align-content-center{display:flex;justify-content:center}.icon-info{margin-left:4px;font-size:15px;position:relative;top:1px}.icon-plus-circle{margin-right:8px}.icon-plus-circle:before{vertical-align:middle}.no-results{margin:20px 0;color:#0e54a9;font-size:14px}.no-data{padding:0!important}.filter-and-search{display:flex;align-items:center;justify-content:space-between}.year-filter{margin-right:30px}.table-wrapper-border{min-height:61px}.custom-scroll:after,.custom-scroll:before{content:\"\";flex:1}.custom-scroll::-webkit-scrollbar{width:20px}.custom-scroll::-webkit-scrollbar-track{box-shadow:none;border-radius:0;background:#efefef}.custom-scroll::-webkit-scrollbar-thumb{background:#0e54a9;border-radius:3px}.table-responsive{position:relative}.no-margin{margin:0}.ui-table-wrapper thead tr th{background-color:#fff}.head-cell{align-items:center}.price{text-align:right!important}tr.hover:hover{cursor:pointer;background-color:rgba(0,126,140,.08)}tr.selected{background-color:#007e8c}tr.selected:hover{background-color:rgba(0,126,140,.3)}.table tbody .btn-box{padding-top:15px}.table tbody .btn-box .btn+.btn{margin-top:10px}.table .action-list{list-style-type:none;padding:0;margin:0;display:flex}.table .action-list li+li{margin-left:10px}.table .action-list li .icon{font-size:20px}.table .icon-waiting{font-size:15px;position:relative;top:2px}.table .icon-login{font-size:14px;position:relative;top:2px}.table .icon-download{position:relative}.table-calculate{margin-bottom:1.25rem}.table-calculate thead .price{background-color:#fff;color:#0e54a9;border:1px solid #252525;display:block;text-align:center;min-width:109px}.table-calculate tbody tr td{font-size:.875rem;color:#0e54a9}.table-calculate .dropdown-toggle:after{content:\"\";font-size:0!important;border-left:4px solid transparent!important;border-right:4px solid transparent!important;border-top:6px solid #252525!important;right:5px}.table-calculate .btn-outline-secondary{font-family:Poppins-Regular,sans-serif!important;color:#0e54a9}.table-payout thead tr th{padding-left:20px;padding-right:20px}.table-payout tr td{text-align:center}.table-payout tr td:first-child{text-align:left}.table-payout tbody tr td.title{padding-top:1rem;padding-bottom:.5rem;text-transform:uppercase}.table-wrapper-border{border:1px solid #efefef;padding:5px 20px}.table-wrapper-border .table{margin-bottom:0}.table-border thead th{border-top:none;font-size:14px;line-height:1.2;text-transform:uppercase;color:#0e54a9;font-family:Poppins-Bold,sans-serif;vert-align:middle;border-bottom:1px solid #efefef;background:#fff}.table-border thead.without-background th{background:none;border-bottom:none}.table-border tbody tr td{font-size:12px;color:#252525;border-top:1px solid #efefef}.table-border tbody tr.no-border td,.table-border tbody tr:first-child td{border-top:none}.table-border tfoot tr td{font-size:14px;line-height:1.2;text-transform:uppercase;color:#0e54a9;font-family:Poppins-Bold,sans-serif;border-top:1px solid #efefef}.table-sm tr th{padding-top:13px;padding-bottom:13px}.table-sm tr td{padding-top:5px;padding-bottom:5px}.table-sm.table-material thead th{font-size:20px;text-transform:uppercase;font-family:Poppins-Bold,sans-serif;letter-spacing:.025rem}.table-md tr td{padding:6px 15px;height:57px}.table-header-area{padding-bottom:20px;padding-top:20px}.table-footer-area{padding-top:30px;display:flex}.table-footer-area.align-content-end .btn+.btn{margin-left:30px}.table thead.align-top th{min-height:58px;vertical-align:top}.table thead.transparent th{background:transparent;border-bottom:none!important}.table .icon-edit,.table .icon-trash{margin-left:4px;font-size:15px;position:relative;top:1px}.table-middle tr td{vertical-align:middle}.table-material{margin:0}.table-material td{padding-left:1.25rem;padding-right:1.25rem;border:none;vert-align:middle}.table-material>thead{background-color:#0c1d3f}.table-material>thead tr th{font-size:1rem;line-height:2.6rem;padding-top:11px;padding-bottom:11px;border-bottom:none;letter-spacing:.04rem;text-transform:uppercase;color:#fff}.table-material>thead tr th:first-child{padding-left:.75rem}.table-material tbody{background-color:#fff}.table-material tbody tr td{font-size:.75rem;padding-top:4px;padding-bottom:5px;line-height:30px;color:#252525}.table-material tbody tr td.title{font-size:.875rem;font-family:Poppins-Bold,sans-serif;color:#0e54a9;vertical-align:bottom;line-height:18px}.table-material tfoot{background-color:#0e54a9;color:#fff}.table-material tfoot tr td{padding-top:.5rem;padding-bottom:.5rem;text-transform:uppercase}.table-link{display:flex;cursor:pointer;align-items:center}.table-link:hover{opacity:.8}.table-link i{margin-right:5px;font-size:16px}.table.table-striped thead.align-middle th{vertical-align:middle}.table.table-striped thead th{border-bottom:2px solid #0e54a9;border-top:none;font-size:14px;line-height:1.2;text-transform:uppercase;color:#0e54a9;font-family:Poppins-Bold,sans-serif}.table.table-striped td,.table.table-striped th{border-top:none;font-size:13px;color:#252525}.table.table-striped td:first-child,.table.table-striped th:first-child{padding-left:30px}.table.table-striped td:first-child.pl-normal,.table.table-striped th:first-child.pl-normal{padding:.75rem}.table.table-striped tbody tr:nth-of-type(odd){background-color:#efefef}.table.table-striped tbody th{color:#0e54a9;font-family:Poppins-Bold,sans-serif}.table.table-striped tbody th .info-block{color:#252525;font-family:Poppins-Regular,sans-serif}.table thead.text-lg th{text-transform:none;font-size:20px}.table .table-title-tr{background:none!important}.table .table-title-tr td{padding-left:.75rem!important}.table-title-box{display:block;margin-left:-3px}.table-title-box a{display:inline-block;color:#0e54a9;margin-bottom:5px;margin-top:5px}.table-title-box a .flex-block{display:flex}.table-title-box a i{position:relative;left:-3px;display:flex;width:20px;height:20px;align-items:center;justify-content:center;font-size:10px;text-decoration:none!important;transform:rotate(-90deg)}.table-title-box a span.text-block{display:block;font-size:20px;line-height:22px;font-family:Poppins-Bold,sans-serif}.table-title-box a:hover{text-decoration:none}.table-title-box a:hover span.text-block{text-decoration:underline}.table-title-box.active i{transform:rotate(0deg)}.table-col-2{width:16.666667%}.table tbody+tbody{border:none}.section-dashboard .container .wrapper-content{position:relative;min-height:calc(100vh - 25px - 55px - 21px - 28px - 24px - 28px)}.material-form .form-control-label{font-size:14px;line-height:21px;padding:20px 0;font-family:Poppins-Bold,sans-serif;color:#0e54a9;border-bottom:1px solid #efefef;margin:0}.material-form .form-control-label .light{font-family:Poppins-Regular,sans-serif}.material-form.view .form-control{font-size:14px;line-height:21px;padding:20px 0;border:none;border-bottom:1px solid #efefef!important;border-radius:0;height:auto}.material-form.view .form-control::-webkit-input-placeholder{color:#252525}.material-form.view .form-control:-moz-placeholder,.material-form.view .form-control::-moz-placeholder{color:#252525}.material-form.view .form-control:-ms-input-placeholder{color:#252525}.material-form.view select.form-control{height:100%;border-radius:0;padding-left:2px;-webkit-appearance:none}.material-form.view .form-group-select:after{display:none}.material-form.edit .form-control{font-size:14px;line-height:21px;border-radius:5px;padding:0 17px;height:30px}.material-form.edit .form-control::-webkit-input-placeholder{color:#252525}.material-form.edit .form-control:-moz-placeholder,.material-form.edit .form-control::-moz-placeholder{color:#252525}.material-form.edit .form-control:-ms-input-placeholder{color:#252525}.material-form.edit .form-control:active,.material-form.edit .form-control:focus,.material-form.edit .form-control:hover{outline:none;box-shadow:none}.material-form.edit .form-group{margin-top:12px;margin-bottom:0}.material-form.edit .form-group input:not(.invalid),.material-form.edit .form-group select:not(.invalid){border:1px solid #0c1d3f!important}.material-form.edit .row:last-child .form-control-border,.material-form.edit .row:last-child .image-wrapper{border-bottom:none}.default-form{padding:20px}.default-form .form-control{border:1px solid #0c1d3f;font-size:14px;line-height:21px;border-radius:5px;padding:10px 17px}.default-form .form-control::-webkit-input-placeholder{color:#252525}.default-form .form-control:-moz-placeholder,.default-form .form-control::-moz-placeholder{color:#252525}.default-form .form-control:-ms-input-placeholder{color:#252525}.default-form .form-control:active,.default-form .form-control:focus,.default-form .form-control:hover{outline:none;box-shadow:none}.default-form .form-group{margin-bottom:20px}.default-form input:disabled,.default-form select:disabled,.default-form textarea:disabled{color:#bebebe;border:1px solid #bebebe}.default-form input:disabled::-moz-placeholder,.default-form select:disabled::-moz-placeholder,.default-form textarea:disabled::-moz-placeholder{color:#bebebe}.default-form input:disabled:-ms-input-placeholder,.default-form select:disabled:-ms-input-placeholder,.default-form textarea:disabled:-ms-input-placeholder{color:#bebebe}.default-form input:disabled::placeholder,.default-form select:disabled::placeholder,.default-form textarea:disabled::placeholder{color:#bebebe}.page-title{margin-top:26px}.ui-breadcrumb-chevron{display:none}.ui-breadcrumb{margin:0;padding:20px 30px;background:transparent;border-radius:0}.ui-breadcrumb ul{list-style:none;display:flex;flex-direction:row;font-size:12px;padding:0}.ui-breadcrumb ul a{color:#252525}.ui-breadcrumb ul.ui-menuitem-link{color:#0e54a9}.ui-breadcrumb ul .ui-menuitem-link:before{display:inline-block;padding-right:.5rem;padding-left:.5rem;color:#485057;content:\">\"}.ui-breadcrumb ul .ui-breadcrumb-home .ui-menuitem-link:before{display:none!important}.padding-top-20{padding-top:20px!important}.padding-bottom-20{padding-bottom:20px!important}.margin-left-20{margin-left:20%!important}.dropdown-menu-xs{min-width:57px!important}.dropdown-menu-xs .dropdown-item{padding:10px 13px 10px 8px!important}.publisher .material-form.edit textarea,.withdrawal .material-form.edit textarea{height:100%!important;margin-bottom:26px!important}.withdrawal .material-form.edit input{margin-top:12px}.withdrawal .inline-form.edit textarea{height:100%!important}.withdrawal .inline-form.edit input{margin-top:0;padding-bottom:.275rem}.new-password .card-body{padding-bottom:0!important}.new-password .invalid-feedback{position:absolute!important;top:100%!important;z-index:101;font-size:11px}.page-description{font-size:.875rem!important;line-height:1.313rem!important;color:#252525!important}.video-on-demand-upload .card-body,.video-on-demand-upload>[class*=col]{padding-left:0;padding-right:0}.min-width-fit{min-width:-webkit-fit-content;min-width:-moz-fit-content;min-width:fit-content}.flex{display:flex}.padding-0{padding:0!important}.min-width-100{min-width:100%}input[type=checkbox]{width:14px}.text-align-center{text-align:center}.video-on-demand-upload .col-xl-12{padding:0}.video-on-demand-upload .title-level-3{margin-top:30px!important;margin-bottom:30px!important}.table-sm tr th{vertical-align:text-top}.change-password .invalid-feedback{position:absolute;top:35px}.image-wrapper .close{position:absolute;right:0}.summary{border-top:1px solid #efefef;font-family:Poppins-Bold,sans-serif}.summary td{text-align:center}.form-group-select.invalid:after{top:37%}.back-details .col-5.edit-col .card-body{padding:0 15px 25px}.spinner-container{display:block;position:absolute;width:70px;height:30px}.donation .input-group-text{margin-top:0!important;border:1px solid #0c1d3f!important}.donation .invalid .input-group-text{border:1px solid #fc4349!important}.back-button{margin-right:10px}.validator-container{height:123px}.head-cell{display:flex;flex-direction:row;align-items:start}.head-cell,.head-cell .head-cell-text{justify-content:center}.width100{width:100%;display:flex;justify-content:space-between}.width100 .border-form{margin-left:auto}.table-filters ano-input{margin-right:10px}.layout-fixed{table-layout:fixed}.long-text,.long-text span{white-space:nowrap}.table-sm tr th{padding-left:1.25rem!important;padding-right:1.25rem!important}::ng-deep .mat-form-field-wrapper{padding-bottom:0!important}.add-button{margin-right:20px}.buttons-container{display:flex}.dropdown-actions{width:200px;display:block}.center{text-align:center}.right{text-align:right}.left{text-align:left}.center>*{text-align:center}.right>*{text-align:right}.left>*{text-align:left}.head-cell-text{display:flex}.head-cell-center,.head-cell-center .head-cell-text{justify-content:center}.head-cell-center .head-cell-text span{text-align:center}.head-cell-right,.head-cell-right .head-cell-text{justify-content:flex-end}.head-cell-right .head-cell-text span{text-align:right}.head-cell-left,.head-cell-left .head-cell-text{justify-content:left}.head-cell-left .head-cell-text span{text-align:left}.head-cell-text span{white-space:pre-line}.no-white-space .head-cell-text span{white-space:nowrap!important}.deactivated{background-color:rgba(0,0,0,.1)}.warning{background-color:rgba(255,190,0,.2);color:#ffbe00}.no-data-button-container{display:flex;justify-content:center;margin:20px 0}"], encapsulation: 2, changeDetection: 0 });
__decorate([
    ViewChild('table', { static: false })
], TableComponent.prototype, "table", void 0);
__decorate([
    Input()
], TableComponent.prototype, "tableConfig", null);
__decorate([
    Input()
], TableComponent.prototype, "buttonsConfig", void 0);
__decorate([
    Input()
], TableComponent.prototype, "title", void 0);
__decorate([
    Input()
], TableComponent.prototype, "withFilters", void 0);
__decorate([
    Input()
], TableComponent.prototype, "withSearch", void 0);
__decorate([
    Input()
], TableComponent.prototype, "startFromAll", void 0);
__decorate([
    Input()
], TableComponent.prototype, "height", void 0);
__decorate([
    Input()
], TableComponent.prototype, "addButtonText", void 0);
__decorate([
    Input()
], TableComponent.prototype, "addButton", void 0);
__decorate([
    Input()
], TableComponent.prototype, "downloadButton", void 0);
__decorate([
    Input()
], TableComponent.prototype, "downloadButtonText", void 0);
__decorate([
    Input()
], TableComponent.prototype, "isDownloadLoading", void 0);
__decorate([
    Input()
], TableComponent.prototype, "yearsFilters", void 0);
__decorate([
    Input()
], TableComponent.prototype, "defaultSortField", void 0);
__decorate([
    Input()
], TableComponent.prototype, "sortOrder", void 0);
__decorate([
    Input()
], TableComponent.prototype, "timeRangeConfig", void 0);
__decorate([
    Input()
], TableComponent.prototype, "isLinkedStreamsFilters", void 0);
__decorate([
    Input()
], TableComponent.prototype, "linkedFilters", void 0);
__decorate([
    Input()
], TableComponent.prototype, "disabledInputs", void 0);
__decorate([
    Input()
], TableComponent.prototype, "searchInputType", void 0);
__decorate([
    Input()
], TableComponent.prototype, "systemMessage", void 0);
__decorate([
    Input()
], TableComponent.prototype, "disabledAddButton", void 0);
__decorate([
    Input()
], TableComponent.prototype, "filters", null);
__decorate([
    Input()
], TableComponent.prototype, "isOpportunityToSelect", void 0);
__decorate([
    Input()
], TableComponent.prototype, "selectedRowId", void 0);
__decorate([
    Input()
], TableComponent.prototype, "showDatepicker", void 0);
__decorate([
    Output()
], TableComponent.prototype, "addItem$", void 0);
__decorate([
    Output()
], TableComponent.prototype, "download$", void 0);
__decorate([
    Output()
], TableComponent.prototype, "navigate$", void 0);
__decorate([
    Output()
], TableComponent.prototype, "timeRangeFilter$", void 0);
__decorate([
    Output()
], TableComponent.prototype, "filterByLinkedStreams$", void 0);
__decorate([
    Output()
], TableComponent.prototype, "select$", void 0);
__decorate([
    Output()
], TableComponent.prototype, "search$", void 0);
__decorate([
    Output()
], TableComponent.prototype, "searchByYear$", void 0);
__decorate([
    Output()
], TableComponent.prototype, "filter$", void 0);
TableComponent = __decorate([ __param(0, Inject(FormBuilder)),
    __param(1, Inject(AutoDestroyService)),
    __param(2, Inject(ChangeDetectorRef))
], TableComponent);

var AC = "40123";
var AD = "312345";
var AE = "501234567";
var AF = "701234567";
var AG = "2684641234";
var AI = "2642351234";
var AL = "672123456";
var AM = "77123456";
var AO = "923123456";
var AR = "91123456789";
var AS = "6847331234";
var AT = "664123456";
var AU = "412345678";
var AW = "5601234";
var AX = "412345678";
var AZ = "401234567";
var BA = "61123456";
var BB = "2462501234";
var BD = "1812345678";
var BE = "470123456";
var BF = "70123456";
var BG = "48123456";
var BH = "36001234";
var BI = "79561234";
var BJ = "90011234";
var BL = "690001234";
var BM = "4413701234";
var BN = "7123456";
var BO = "71234567";
var BQ = "3181234";
var BR = "11961234567";
var BS = "2423591234";
var BT = "17123456";
var BW = "71123456";
var BY = "294911911";
var BZ = "6221234";
var CA = "5062345678";
var CC = "412345678";
var CD = "991234567";
var CF = "70012345";
var CG = "061234567";
var CH = "781234567";
var CI = "01234567";
var CK = "71234";
var CL = "221234567";
var CM = "671234567";
var CN = "13123456789";
var CO = "3211234567";
var CR = "83123456";
var CU = "51234567";
var CV = "9911234";
var CW = "95181234";
var CX = "412345678";
var CY = "96123456";
var CZ = "601123456";
var DE = "15123456789";
var DJ = "77831001";
var DK = "32123456";
var DM = "7672251234";
var DO = "8092345678";
var DZ = "551234567";
var EC = "991234567";
var EE = "51234567";
var EG = "1001234567";
var EH = "650123456";
var ER = "7123456";
var ES = "612345678";
var ET = "911234567";
var FI = "412345678";
var FJ = "7012345";
var FK = "51234";
var FM = "3501234";
var FO = "211234";
var FR = "612345678";
var GA = "06031234";
var GB = "7400123456";
var GD = "4734031234";
var GE = "555123456";
var GF = "694201234";
var GG = "7781123456";
var GH = "231234567";
var GI = "57123456";
var GL = "221234";
var GM = "3012345";
var GN = "601123456";
var GP = "690001234";
var GQ = "222123456";
var GR = "6912345678";
var GT = "51234567";
var GU = "6713001234";
var GW = "955012345";
var GY = "6091234";
var HK = "51234567";
var HN = "91234567";
var HR = "921234567";
var HT = "34101234";
var HU = "201234567";
var ID = "812345678";
var IE = "850123456";
var IL = "502345678";
var IM = "7924123456";
var IN = "8123456789";
var IO = "3801234";
var IQ = "7912345678";
var IR = "9123456789";
var IS = "6111234";
var IT = "3123456789";
var JE = "7797712345";
var JM = "8762101234";
var JO = "790123456";
var JP = "9012345678";
var KE = "712123456";
var KG = "700123456";
var KH = "91234567";
var KI = "72001234";
var KM = "3212345";
var KN = "8697652917";
var KP = "1921234567";
var KR = "1020000000";
var KW = "50012345";
var KY = "3453231234";
var KZ = "7710009998";
var LA = "2023123456";
var LB = "71123456";
var LC = "7582845678";
var LI = "660234567";
var LK = "712345678";
var LR = "770123456";
var LS = "50123456";
var LT = "61234567";
var LU = "628123456";
var LV = "21234567";
var LY = "912345678";
var MA = "650123456";
var MC = "612345678";
var MD = "62112345";
var ME = "67622901";
var MF = "690001234";
var MG = "321234567";
var MH = "2351234";
var MK = "72345678";
var ML = "65012345";
var MM = "92123456";
var MN = "88123456";
var MO = "66123456";
var MP = "6702345678";
var MQ = "696201234";
var MR = "22123456";
var MS = "6644923456";
var MT = "96961234";
var MU = "52512345";
var MV = "7712345";
var MW = "991234567";
var MX = "12221234567";
var MY = "123456789";
var MZ = "821234567";
var NA = "811234567";
var NC = "751234";
var NE = "93123456";
var NF = "381234";
var NG = "8021234567";
var NI = "81234567";
var NL = "612345678";
var NO = "40612345";
var NP = "9841234567";
var NR = "5551234";
var NU = "8884012";
var NZ = "211234567";
var OM = "92123456";
var PA = "61234567";
var PE = "912345678";
var PF = "87123456";
var PG = "70123456";
var PH = "9051234567";
var PK = "3012345678";
var PL = "512345678";
var PM = "551234";
var PR = "7872345678";
var PS = "599123456";
var PT = "912345678";
var PW = "6201234";
var PY = "961456789";
var QA = "33123456";
var RE = "692123456";
var RO = "712034567";
var RS = "601234567";
var RU = "9123456789";
var RW = "720123456";
var SA = "512345678";
var SB = "7421234";
var SC = "2510123";
var SD = "911231234";
var SE = "701234567";
var SG = "81234567";
var SH = "51234";
var SI = "31234567";
var SJ = "41234567";
var SK = "912123456";
var SL = "25123456";
var SM = "66661212";
var SN = "701234567";
var SO = "71123456";
var SR = "7412345";
var SS = "977123456";
var ST = "9812345";
var SV = "70123456";
var SX = "7215205678";
var SY = "944567890";
var SZ = "76123456";
var TA = "8999";
var TC = "6492311234";
var TD = "63012345";
var TG = "90112345";
var TH = "812345678";
var TJ = "917123456";
var TK = "7290";
var TL = "77212345";
var TM = "66123456";
var TN = "20123456";
var TO = "7715123";
var TR = "5012345678";
var TT = "8682911234";
var TV = "901234";
var TW = "912345678";
var TZ = "621234567";
var UA = "501234567";
var UG = "712345678";
var US = "2015550123";
var UY = "94231234";
var UZ = "912345678";
var VA = "3123456789";
var VC = "7844301234";
var VE = "4121234567";
var VG = "2843001234";
var VI = "3406421234";
var VN = "912345678";
var VU = "5912345";
var WF = "501234";
var WS = "7212345";
var XK = "43201234";
var YE = "712345678";
var YT = "639012345";
var ZA = "711234567";
var ZM = "955123456";
var ZW = "712345678";
var examples = {
	"001": "",
	AC: AC,
	AD: AD,
	AE: AE,
	AF: AF,
	AG: AG,
	AI: AI,
	AL: AL,
	AM: AM,
	AO: AO,
	AR: AR,
	AS: AS,
	AT: AT,
	AU: AU,
	AW: AW,
	AX: AX,
	AZ: AZ,
	BA: BA,
	BB: BB,
	BD: BD,
	BE: BE,
	BF: BF,
	BG: BG,
	BH: BH,
	BI: BI,
	BJ: BJ,
	BL: BL,
	BM: BM,
	BN: BN,
	BO: BO,
	BQ: BQ,
	BR: BR,
	BS: BS,
	BT: BT,
	BW: BW,
	BY: BY,
	BZ: BZ,
	CA: CA,
	CC: CC,
	CD: CD,
	CF: CF,
	CG: CG,
	CH: CH,
	CI: CI,
	CK: CK,
	CL: CL,
	CM: CM,
	CN: CN,
	CO: CO,
	CR: CR,
	CU: CU,
	CV: CV,
	CW: CW,
	CX: CX,
	CY: CY,
	CZ: CZ,
	DE: DE,
	DJ: DJ,
	DK: DK,
	DM: DM,
	DO: DO,
	DZ: DZ,
	EC: EC,
	EE: EE,
	EG: EG,
	EH: EH,
	ER: ER,
	ES: ES,
	ET: ET,
	FI: FI,
	FJ: FJ,
	FK: FK,
	FM: FM,
	FO: FO,
	FR: FR,
	GA: GA,
	GB: GB,
	GD: GD,
	GE: GE,
	GF: GF,
	GG: GG,
	GH: GH,
	GI: GI,
	GL: GL,
	GM: GM,
	GN: GN,
	GP: GP,
	GQ: GQ,
	GR: GR,
	GT: GT,
	GU: GU,
	GW: GW,
	GY: GY,
	HK: HK,
	HN: HN,
	HR: HR,
	HT: HT,
	HU: HU,
	ID: ID,
	IE: IE,
	IL: IL,
	IM: IM,
	IN: IN,
	IO: IO,
	IQ: IQ,
	IR: IR,
	IS: IS,
	IT: IT,
	JE: JE,
	JM: JM,
	JO: JO,
	JP: JP,
	KE: KE,
	KG: KG,
	KH: KH,
	KI: KI,
	KM: KM,
	KN: KN,
	KP: KP,
	KR: KR,
	KW: KW,
	KY: KY,
	KZ: KZ,
	LA: LA,
	LB: LB,
	LC: LC,
	LI: LI,
	LK: LK,
	LR: LR,
	LS: LS,
	LT: LT,
	LU: LU,
	LV: LV,
	LY: LY,
	MA: MA,
	MC: MC,
	MD: MD,
	ME: ME,
	MF: MF,
	MG: MG,
	MH: MH,
	MK: MK,
	ML: ML,
	MM: MM,
	MN: MN,
	MO: MO,
	MP: MP,
	MQ: MQ,
	MR: MR,
	MS: MS,
	MT: MT,
	MU: MU,
	MV: MV,
	MW: MW,
	MX: MX,
	MY: MY,
	MZ: MZ,
	NA: NA,
	NC: NC,
	NE: NE,
	NF: NF,
	NG: NG,
	NI: NI,
	NL: NL,
	NO: NO,
	NP: NP,
	NR: NR,
	NU: NU,
	NZ: NZ,
	OM: OM,
	PA: PA,
	PE: PE,
	PF: PF,
	PG: PG,
	PH: PH,
	PK: PK,
	PL: PL,
	PM: PM,
	PR: PR,
	PS: PS,
	PT: PT,
	PW: PW,
	PY: PY,
	QA: QA,
	RE: RE,
	RO: RO,
	RS: RS,
	RU: RU,
	RW: RW,
	SA: SA,
	SB: SB,
	SC: SC,
	SD: SD,
	SE: SE,
	SG: SG,
	SH: SH,
	SI: SI,
	SJ: SJ,
	SK: SK,
	SL: SL,
	SM: SM,
	SN: SN,
	SO: SO,
	SR: SR,
	SS: SS,
	ST: ST,
	SV: SV,
	SX: SX,
	SY: SY,
	SZ: SZ,
	TA: TA,
	TC: TC,
	TD: TD,
	TG: TG,
	TH: TH,
	TJ: TJ,
	TK: TK,
	TL: TL,
	TM: TM,
	TN: TN,
	TO: TO,
	TR: TR,
	TT: TT,
	TV: TV,
	TW: TW,
	TZ: TZ,
	UA: UA,
	UG: UG,
	US: US,
	UY: UY,
	UZ: UZ,
	VA: VA,
	VC: VC,
	VE: VE,
	VG: VG,
	VI: VI,
	VN: VN,
	VU: VU,
	WF: WF,
	WS: WS,
	XK: XK,
	YE: YE,
	YT: YT,
	ZA: ZA,
	ZM: ZM,
	ZW: ZW
};

let SnackBarService = class SnackBarService {
    constructor(snackBarRef) {
        this.snackBarRef = snackBarRef;
        this.config = new MatSnackBarConfig();
        this.defaultDuration = 3000;
        this.onSnackBarSubject = new Subject();
        this.onSnackBar$ = this.onSnackBarSubject.asObservable();
        this.config.duration = 3000;
        this.onSnackBar$.subscribe(config => {
            if (this.openedType === config.type) {
                return;
            }
            const cfg = this.getConfig(config.type);
            this.openedType = config.type;
            this.snackBarRef.open(config.message, null, cfg);
            setTimeout(() => this.openedType = null, cfg.duration);
        });
    }
    open(message, duration = this.defaultDuration) {
        this.onSnackBarSubject.next({ message });
    }
    openError(message) {
        this.onSnackBarSubject.next({ message, type: 'error' });
    }
    showInfo(message) {
        this.onSnackBarSubject.next({ message, type: 'info' });
    }
    getConfig(type) {
        const config = this.config;
        if (type === 'error') {
            config.duration = 5000;
            config.panelClass = 'error-snack';
        }
        else if (type === 'info') {
            config.duration = 3000;
            config.panelClass = 'info-notice';
        }
        else if (type === 'feedback') {
            config.duration = 6000;
            config.panelClass = 'info-feedback';
        }
        return config;
    }
};
SnackBarService.ɵfac = function SnackBarService_Factory(t) { return new (t || SnackBarService)(ɵngcc0.ɵɵinject(MatSnackBar)); };
SnackBarService.ɵprov = i0.ɵɵdefineInjectable({ factory: function SnackBarService_Factory() { return new SnackBarService(i0.ɵɵinject(i1.MatSnackBar)); }, token: SnackBarService, providedIn: "root" });
SnackBarService = __decorate([ __param(0, Inject(MatSnackBar))
], SnackBarService);

let StreamEventsService = class StreamEventsService {
    constructor() {
        this.toggleStream = new EventEmitter();
    }
};
StreamEventsService.ɵfac = function StreamEventsService_Factory(t) { return new (t || StreamEventsService)(); };
StreamEventsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StreamEventsService_Factory() { return new StreamEventsService(); }, token: StreamEventsService, providedIn: "root" });

const ENVIRONMENT = new InjectionToken('ENVIRONMENT');

const NewPaymentsNoPremiun = [
    {
        key: 'FREE_ACCESS',
        value: 'stream.payments.free',
        desc: 'stream.payments.free.desc',
        values: [],
    }
];
const NewPayments = [
    {
        key: 'FREE_ACCESS',
        value: 'stream.payments.free',
        desc: 'stream.payments.free.desc',
        values: [
            {
                name: 'stream.payments.slots.name',
                key: 'psSlot',
                desc: 'stream.payments.slots.desc',
            },
            {
                name: 'stream.payments.donations.name',
                key: 'psDonation',
                desc: 'stream.payments.donations.desc',
            }
        ],
    },
    {
        key: 'LIMIT_ACCESS',
        value: 'stream.payments.limit',
        desc: 'stream.payments.limit.desc',
        values: [
            {
                name: 'stream.payments.payView.name',
                key: 'psPayPerView',
                desc: 'stream.payments.payView.desc',
                required: true,
            },
            {
                name: 'stream.payments.slots.name',
                key: 'psSlot',
                desc: 'stream.payments.slots.desc',
                required: true,
            },
            {
                name: 'stream.payments.voucher.name',
                key: 'psVoucher',
                desc: 'stream.payments.voucher.desc',
                required: true,
            },
            {
                name: 'stream.payments.donations.name',
                key: 'psDonation',
                desc: 'stream.payments.donations.desc',
            },
            {
                name: 'stream.payments.leadGeneration.name',
                key: 'psLeadGeneration',
                desc: 'stream.payments.leadGeneration.desc',
                required: true,
            }
        ],
    }
];
const NewPaymentsSlots = [
    {
        key: 'FREE',
        value: 'stream.payments.free',
        desc: 'stream.payments.free.desc',
    },
    {
        key: 'VOUCHER',
        value: 'stream.payments.voucher.name',
        desc: 'stream.payments.free.desc',
    },
    {
        key: 'PAY_PER_VIEW',
        value: 'stream.payments.payView.name',
        desc: 'stream.payments.free.desc',
    },
];

const API_URLS = new InjectionToken('API_URLS');

var ApiService_1;
let ApiService = ApiService_1 = class ApiService {
    constructor(http, apiUrls, environment) {
        this.http = http;
        this.apiUrls = apiUrls;
        this.environment = environment;
        this.language = this.environment.withoutLanguageHeader ? null : { language: ApiService_1.localLanguage };
        this.apiUrl = this.environment.backendApiHost;
        this.baseRequestOptions = {
            isWithoutRootUrl: false,
            responseType: 'json',
        };
        if (localStorage.getItem('localLanguage') !== null) {
            ApiService_1.localLanguage = localStorage.getItem('localLanguage');
        }
    }
    static setLanguageToStorage(language) {
        ApiService_1.localLanguage = language || ApiService_1.defaultLanguage;
        localStorage.setItem('localLanguage', ApiService_1.localLanguage);
    }
    get(url, _a = this.baseRequestOptions) {
        var { host, openApi, isWithoutRootUrl, responseType } = _a, rest = __rest(_a, ["host", "openApi", "isWithoutRootUrl", "responseType"]);
        const requestUrl = `${host || this.apiUrl}/${isWithoutRootUrl ? '' : this.apiUrls.ROOT_URL}` + url;
        const headers = !this.language ? null : { language: ApiService_1.localLanguage };
        return this.http.get(requestUrl, Object.assign({ responseType, headers, withCredentials: true }, rest));
    }
    post(url, body, _a = this.baseRequestOptions) {
        var { isWithoutRootUrl, responseType, token } = _a, rest = __rest(_a, ["isWithoutRootUrl", "responseType", "token"]);
        const requestUrl = `${this.apiUrl || ''}/${isWithoutRootUrl ? '' : this.apiUrls.ROOT_URL}` + url;
        const headers = !this.language ? null : { language: ApiService_1.localLanguage, token: token || '' };
        return this.http.post(requestUrl, body, Object.assign({ responseType, headers, withCredentials: true }, rest));
    }
    put(url, body, _a = this.baseRequestOptions) {
        var { isWithoutRootUrl, responseType } = _a, rest = __rest(_a, ["isWithoutRootUrl", "responseType"]);
        const requestUrl = `${this.apiUrl || ''}/${isWithoutRootUrl ? '' : this.apiUrls.ROOT_URL}` + url;
        const headers = !this.language ? null : { language: ApiService_1.localLanguage };
        return this.http.put(requestUrl, body, Object.assign({ responseType, headers, withCredentials: true }, rest));
    }
    delete(url, _a = this.baseRequestOptions) {
        var { isWithoutRootUrl, responseType } = _a, rest = __rest(_a, ["isWithoutRootUrl", "responseType"]);
        const requestUrl = `${this.apiUrl || ''}/${isWithoutRootUrl ? '' : this.apiUrls.ROOT_URL}` + url;
        const headers = !this.language ? null : { language: ApiService_1.localLanguage };
        return this.http.delete(requestUrl, Object.assign({ responseType, headers, withCredentials: true }, rest));
    }
};
ApiService.ɵfac = function ApiService_Factory(t) { return new (t || ApiService)(ɵngcc0.ɵɵinject(HttpClient), ɵngcc0.ɵɵinject(API_URLS), ɵngcc0.ɵɵinject(ENVIRONMENT)); };
ApiService.defaultLanguage = 'DE';
ApiService.localLanguage = ApiService_1.defaultLanguage;
ApiService.ɵprov = i0.ɵɵdefineInjectable({ factory: function ApiService_Factory() { return new ApiService(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(API_URLS), i0.ɵɵinject(ENVIRONMENT)); }, token: ApiService, providedIn: "root" });
ApiService = ApiService_1 = __decorate([ __param(0, Inject(HttpClient)),
    __param(1, Inject(API_URLS)),
    __param(2, Inject(ENVIRONMENT))
], ApiService);

const DEFAULT_ERROR_MESSAGE = 'Error';
let LocalizationProvider = class LocalizationProvider {
    constructor(http, apiService, apiUrls, environment) {
        this.http = http;
        this.apiService = apiService;
        this.apiUrls = apiUrls;
        this.environment = environment;
        this.errorKeysPrefix = 'error';
        this.loaded = true;
        this.localizationList = {};
    }
    load() {
        return new Promise((resolve, reject) => {
            if (ApiService.localLanguage === 'KEY') {
                this.localizationList = {};
                resolve(true);
                return;
            }
            this.getMessages(this.environment.cmsHost).pipe(pluck('results', 'messages')).subscribe((res) => {
                this.localizationList = res;
                resolve(true);
            }, () => {
                this.loaded = false;
                resolve(false);
            });
        });
    }
    getMessages(host) {
        return this.apiService.get(this.apiUrls.GET_LOCALIZATION_MESSAGES, { host, isWithoutRootUrl: true });
    }
    getByKey(key) {
        return this.localizationList[key] || key;
    }
    getByErrorKey(errorKey) {
        const key = `${this.errorKeysPrefix}.${errorKey}`;
        return this.getByKey(key);
    }
};
LocalizationProvider.ɵfac = function LocalizationProvider_Factory(t) { return new (t || LocalizationProvider)(ɵngcc0.ɵɵinject(HttpClient), ɵngcc0.ɵɵinject(ApiService), ɵngcc0.ɵɵinject(API_URLS), ɵngcc0.ɵɵinject(ENVIRONMENT)); };
LocalizationProvider.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: LocalizationProvider, factory: function (t) { return LocalizationProvider.ɵfac(t); } });
LocalizationProvider = __decorate([ __param(0, Inject(HttpClient)),
    __param(1, Inject(ApiService)),
    __param(2, Inject(API_URLS)),
    __param(3, Inject(ENVIRONMENT))
], LocalizationProvider);

var InputComponent_1;
const CURRENT_CURRENCY = new InjectionToken('CURRENT_CURRENCY');
const PHONE_MASK = '000000000000000';
const PHONE_NUMBER_LENGTH = 15;
const MY_NATIVE_FORMATS = {
    fullPickerInput: { year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric', seconds: 'numeric' },
    datePickerInput: { year: 'numeric', month: '2-digit', day: '2-digit' },
    timePickerInput: { hour: 'numeric', minute: 'numeric', seconds: 'numeric' },
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' }
};
let DefaultIntl = class DefaultIntl extends OwlDateTimeIntl {
    constructor() {
        super();
        this.cancelBtnLabel = '';
        this.setBtnLabel = '';
        // this.language = localStorage.getItem('localLanguage') || 'DE';
        this.language = 'EN';
        this.cancelBtnLabel = this.getCancelButtonText();
        this.setBtnLabel = this.getSetButtonText();
    }
    getCancelButtonText() {
        return this.language === 'EN' ? 'Close' : 'Abbrechen';
    }
    getSetButtonText() {
        return this.language === 'EN' ? 'Apply' : 'Speichern';
    }
};
DefaultIntl.ɵfac = function DefaultIntl_Factory(t) { return new (t || DefaultIntl)(); };
DefaultIntl.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DefaultIntl, factory: function (t) { return DefaultIntl.ɵfac(t); } });
let InputComponent = InputComponent_1 = class InputComponent {
    constructor(destroy$, snackBarService, cdRef, dateTimeAdapter, localizationProvider, streamEventsService, environment, currentCurrency) {
        this.destroy$ = destroy$;
        this.snackBarService = snackBarService;
        this.cdRef = cdRef;
        this.dateTimeAdapter = dateTimeAdapter;
        this.localizationProvider = localizationProvider;
        this.streamEventsService = streamEventsService;
        this.environment = environment;
        this.currentCurrency = currentCurrency;
        this.config = {};
        this.multimediaUrl = '';
        this.multimediaType = 'photo';
        this.clearImageButton = false;
        this.isCleanable = false;
        this.isTextarea = false;
        this.isInputShow = true;
        this.disabled = false;
        this.isClearButton = false;
        this.readonly = false;
        this.disabledToggle = false;
        this.columnImageUploader = false;
        this.invalid = false;
        this.isEditMode = false;
        this.noBorder = true;
        this.accept = '*.*';
        this.blur = new EventEmitter();
        this.input$ = new EventEmitter();
        this.onFileUpload$ = new EventEmitter();
        this.clearImage$ = new EventEmitter();
        this.toggle$ = new EventEmitter();
        this.checked$ = new EventEmitter();
        this.checkedPayments$ = new EventEmitter();
        this.format = '';
        this.today = new Date();
        // public localizationList = this.localizationProvider.localizationList;
        this.isDate = false;
        this.isFocused = false;
        this.INPUT_TYPES = INPUT_TYPES;
        this.mask = '';
        this.showPassword = false;
        // public INPUT_ERRORS = INPUT_ERRORS;
        this.DATETIME_PICKER_TYPE = DATETIME_PICKER_TYPE;
        this.cardType = '';
        this.checkModel = {
            psVoucher: false,
            psSlot: false,
            psLeadGeneration: false,
            psPayPerView: false,
            psDonation: false,
            psEntrepriseLogin: false,
            psCustomIntegration: false,
        };
        this.maskCurrency = 'separator.2';
        this.thousandSeparatorCurrency = ',';
        this.decimalMarker = '.';
        this.onChange = (event) => {
            if (event === PAYMENT_SYSTEM.LIMIT_ACCESS || event === PAYMENT_SYSTEM.FREE_ACCESS || event === PAYMENT_SYSTEM.COURSE_ACCESS) {
                this.selectedValue(event);
                this.getCurrentPaymentModel();
                this.setAccessOptionsCheckbox();
            }
        };
        this.onTouched = () => {
        };
        this.language = localStorage.getItem('localLanguage') || 'DE';
        if (this.language === 'DE') {
            this.dateTimeAdapter.setLocale('DE');
        }
        else {
            this.dateTimeAdapter.setLocale('EN');
        }
    }
    get errorEntries() {
        return Object.entries(this.errors || {});
    }
    ngOnInit() {
        // if (this.field) {
        //     this.config = {
        //         ...this.config,
        //         ...this.field.config,
        //     };
        // }
        var _a, _b;
        if (this.currentCurrency) {
            this.currentCurrency
                .pipe(takeUntil(this.destroy$))
                .subscribe((currency) => {
                if (!currency) {
                    return;
                }
                this.currencyProfile = CURRENCY_SYMBOLS[currency];
            });
        }
        this.setAccessOptionsCheckbox();
        if (this.config.type && this.config.type === 'date') {
            this.isDate = true;
        }
        if (((_a = this.field) === null || _a === void 0 ? void 0 : _a.name) === 'paymentSystem' && this.field.model) {
            this.checkModel = this.field.model;
            this.changeCheck();
        }
        this.selectOptions = this.config.selectOptions;
        this.customPatterns = { '0': { pattern: new RegExp('[0-9]') }, 'B': { pattern: new RegExp('[\\D]|[0-9]') } };
        this.streamEventsService.toggleStream.pipe(takeUntil(this.destroy$)).subscribe(event => {
            if (event.form === 'programSettings') {
                this.checkModel.psSlot = event.value;
            }
            else if (event.form === 'donationSettings') {
                this.checkModel.psDonation = event.value;
            }
        });
        switch ((_b = this.config) === null || _b === void 0 ? void 0 : _b.datetimePickerType) {
            case DATETIME_PICKER_TYPE.CALENDAR: {
                this.today = new Date(new Date().setHours(0, 0, 0, 0));
                this.format = 'DD.MM.YYYY';
                break;
            }
            case DATETIME_PICKER_TYPE.TIMER: {
                this.format = 'HH:mm:ss';
                break;
            }
            default: {
                this.format = 'DD.MM.YYYY, HH:mm';
                break;
            }
        }
        this.value = 360;
        // this.minDate = this.minDate();
        // this.maxDate = this.maxDate();
    }
    ngAfterViewInit() {
        if (this.value && this.config.inputType === INPUT_TYPES.PHONE) {
            this.onInput(this.value);
        }
        if (this.value && this.config.inputType === INPUT_TYPES.TIMER) {
            const duration = this.value * 1000;
            this.value = moment$1.utc(duration).format('HH') + moment$1.utc(duration).format(':mm') + moment$1.utc(duration).format(':ss');
            this.onInput(this.value);
        }
    }
    writeValue(value) {
        this.value = value;
        this.onChange(value);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    mergeObjects(obj1, obj2) {
        return Object.assign(Object.assign({}, obj1), obj2);
    }
    isEmpty() {
        if (!this.value) {
            return true;
        }
        return this.value.length === 0;
    }
    clear() {
        this.value = '';
        this.onTouched();
        this.onChange(this.value);
    }
    onKeyUp(event) {
        if (this.config.removeSpaces || this.config.url) {
            event.target.value = event.target.value.split(' ').join('');
        }
    }
    onInput(value) {
        if (this.config && this.config.showErrorsOnDirty) {
            this.onTouched();
        }
        if (this.config.removeSpaces || this.config.url) {
            value = value.split(' ').join('');
        }
        if (this.config.inputType === INPUT_TYPES.PHONE) {
            if (value.toString().indexOf('+') === -1 && value.toString().length > 0) {
                // value = '+' + value;
            }
            if (value === '+') {
                // this.mask = '00000000000000';
                this.mask = '00 000 000 0000';
            }
            else {
                this.mask = PHONE_MASK;
            }
            const parsedPhone = libphonenumber.formatIncompletePhoneNumber(value);
            const as = new libphonenumber.AsYouType();
            as.input(parsedPhone);
            // obj = parsedPhone;
            if (as.getNumber()) {
                if (as.getNumber().country) {
                    if (as.getNumber().country === 'DE') {
                        this.mask = '00 000 00000000';
                    }
                    else {
                        const exampleNumber = libphonenumber.getExampleNumber(as.country, examples).number.toString();
                        // const maskedPhone = libphonenumber.parsePhoneNumberFromString(parsedPhone);
                        // if (maskedPhone) {
                        //   this.mask = this.replaceSpaces(maskedPhone
                        //       .formatInternational()
                        //       .replace(/[0-9]/g, '0'), 2);
                        // } else {
                        this.mask = this.replaceSpaces(libphonenumber
                            .parsePhoneNumberFromString(exampleNumber)
                            .formatInternational()
                            .replace(/[0-9]/g, '0'), 2);
                        this.cdRef.detectChanges();
                        // }
                    }
                }
            }
            else {
                // this.mask = '';
                this.cdRef.detectChanges();
            }
        }
        if (this.config.inputType === INPUT_TYPES.CREDIT_CARD) {
            this.getCreditCardType(value);
        }
        // if (this.config.inputType === INPUT_TYPES.TIMER) {
        //     value = moment(value, 'HH:mm:ss: A').diff(moment().startOf('day'), 'seconds');
        // }
        this.value = value;
        this.input$.emit(this.value);
        this.writeValue(value);
    }
    change(value, selectOptions) {
        this.value = value;
        this.writeValue(value);
    }
    dateChange(value) {
        var _a, _b, _c;
        if (!((_a = this.config) === null || _a === void 0 ? void 0 : _a.dateFrontiers)) {
            if (this.config.datetimeType === DATETIME_INPUT_TYPE.START && new Date(value).getTime() < new Date().getTime()) {
                value = moment$1(new Date(), this.format, this.language.toLowerCase()).toDate();
            }
            if (this.config.datetimeType === DATETIME_INPUT_TYPE.START) {
                this.config.endDate = null;
            }
            if (this.config.datetimeType === DATETIME_INPUT_TYPE.END
                && (new Date(value).getTime() < new Date(this.config.startDate).getTime()) || (!value)) {
                value = moment$1(((_b = this.config) === null || _b === void 0 ? void 0 : _b.startDate) || new Date(), this.format, this.language.toLowerCase()).toDate();
            }
        }
        if ((_c = this.config) === null || _c === void 0 ? void 0 : _c.dateFrontiers) {
            const frontier = this.config.dateFrontiers[this.formIndex];
            const value = (frontier === null || frontier === void 0 ? void 0 : frontier.start) || this.config.startDate;
            this.value = moment$1(value, this.format, this.language.toLowerCase()).toDate();
        }
        if (value) {
            this.value = moment$1(value, this.format, this.language.toLowerCase()).toDate();
        }
        this.writeValue(this.value);
    }
    messageInput(value) {
        this.onInput(value);
    }
    onFocus(event) {
        if (this.readonly) {
            return;
        }
        if (this.config && this.config.showErrorsOnFocus) {
            this.onTouched();
        }
        this.isFocused = true;
        if (this.config.type === 'date') {
            event.target.type = 'date';
        }
    }
    onBlur(event) {
        var _a;
        this.onTouched();
        if (this.readonly || this.invalid || this.config.disabled || this.disabled) {
            return;
        }
        if (this.config.min && this.value < this.config.min) {
            this.change(this.config.min);
        }
        if (this.config.max && this.value > this.config.max) {
            this.change(this.config.max);
        }
        this.blur.emit((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value);
        this.isFocused = false;
        if (this.config.type === 'date' && !this.value) {
            event.target.type = 'text';
        }
    }
    writeDateValue(obj) {
        if (obj) {
            this.value = moment$1(obj, this.format, this.language.toLowerCase()).toDate();
        }
        else {
            if (this.config.datetimeType === DATETIME_INPUT_TYPE.END && this.config.startDate) {
                this.value = moment$1(this.config.startDate, this.format, this.language.toLowerCase()).toDate();
            }
        }
        this.onChange(this.value);
    }
    writeTimerValue(obj) {
        this.value = obj;
        this.onChange(this.value);
    }
    dateFocus(evt) {
        this.isFocused = true;
        this.onFocus(evt);
    }
    clearDate() {
        this.writeDateValue('');
    }
    minDate() {
        var _a, _b, _c, _d, _e, _f;
        if (((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.dateFrontiers) === null || _b === void 0 ? void 0 : _b.length) && ((_c = this.config.dateFrontiers[this.formIndex]) === null || _c === void 0 ? void 0 : _c.start)) {
            return moment$1((_d = this.config.dateFrontiers[this.formIndex]) === null || _d === void 0 ? void 0 : _d.start, this.format, this.language.toLowerCase()).toDate();
        }
        if (this.config.datetimeType === DATETIME_INPUT_TYPE.END && this.config.startDate && !((_f = (_e = this.config) === null || _e === void 0 ? void 0 : _e.dateFrontiers) === null || _f === void 0 ? void 0 : _f.length)) {
            return moment$1(this.config.startDate, this.format, this.language.toLowerCase()).toDate();
        }
        return this.today;
    }
    maxDate() {
        var _a, _b, _c, _d, _e, _f;
        if (((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.dateFrontiers) === null || _b === void 0 ? void 0 : _b.length) && ((_c = this.config.dateFrontiers[this.formIndex]) === null || _c === void 0 ? void 0 : _c.end)) {
            return moment$1((_d = this.config.dateFrontiers[this.formIndex]) === null || _d === void 0 ? void 0 : _d.end, this.format, this.language.toLowerCase()).toDate();
        }
        if (this.config.datetimeType === DATETIME_INPUT_TYPE.END && this.config.startDate && !((_f = (_e = this.config) === null || _e === void 0 ? void 0 : _e.dateFrontiers) === null || _f === void 0 ? void 0 : _f.length)) {
            const maxDate = new Date((this.config.startDate.getTime() + 57600000));
            return moment$1(maxDate, this.format, this.language.toLowerCase()).toDate();
        }
        return null;
    }
    uploadPreviewMultimedia(fileUploadResponse) {
        this.multimediaUploader.fileDropRef.nativeElement.value = '';
        this.onFileUpload$.emit(fileUploadResponse);
    }
    clearImage() {
        this.multimediaUrl = '';
        this.clearImage$.emit(true);
    }
    replaceSpaces(str, firstSpaceIndexToRemove) {
        let res = '';
        const split = str.split(' ');
        split.forEach((item, index) => {
            res += item;
            if (index < firstSpaceIndexToRemove) {
                res += ' ';
            }
        });
        return res;
    }
    copyValue(value) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = value;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        this.snackBarService.showInfo('Copied "' + this.localizationProvider.getByKey(this.config.label) + '"');
    }
    togglePasswordShowing() {
        this.showPassword = !this.showPassword;
        this.config.type = this.showPassword ? 'text' : 'password';
    }
    toggleCheckbox(value) {
        this.value = value.checked;
        this.onChange(this.value);
        this.toggle$.emit(this.value);
    }
    checked(event) {
        if (!event.target) {
            return;
        }
        this.checked$.emit(event.target.checked);
    }
    enableInlineEditing() {
        this.readonly = false;
        this.input.nativeElement.focus();
    }
    getPlaceholder(key = '', isRequired) {
        if (key) {
            return `${this.localizationProvider.getByKey(key)}${isRequired ? '*' : ''}`;
        }
        else {
            return '';
        }
    }
    getCreditCardType(value) {
        let re = new RegExp('^(4026|417500|4508|4844|491(3|7))');
        if (value.match(re) != null) {
            this.cardType = CARD_TYPE.VISA_ELECTRON;
            return;
        }
        re = new RegExp('^4');
        if (value.match(re) != null) {
            this.cardType = CARD_TYPE.VISA;
            return;
        }
        // Mastercard
        re = new RegExp('^5[1-5]');
        if (value.match(re) != null) {
            this.cardType = CARD_TYPE.MASTERCARD;
            return;
        }
        this.cardType = CARD_TYPE.NONE;
        return;
    }
    selectedValue($event) {
        this.currentValue = $event;
        this.setAccessOptionsCheckbox();
    }
    getCurrentPaymentModel() {
        if (!this.formConfig.premiumPublisher) {
            return NewPaymentsNoPremiun.find(item => item.key === this.currentValue);
        }
        if (this.formConfig.mediaType === MEDIA_TYPE.VIDEO_ON_DEMAND) {
            return PaymentsVideo.find(item => item.key === this.currentValue);
        }
        else {
            return PaymentsStream.find(item => item.key === this.currentValue);
        }
    }
    changeCheck(key) {
        this.checkedPayments$.emit({ key, checkModel: this.checkModel });
    }
    setAccessOptionsCheckbox() {
        var _a;
        if (((_a = this.formConfig) === null || _a === void 0 ? void 0 : _a.name) === 'media' && this.field.name === 'paymentSystem') {
            this.accessOptions = this.getCurrentPaymentModel();
        }
    }
};
InputComponent.ɵfac = function InputComponent_Factory(t) { return new (t || InputComponent)(ɵngcc0.ɵɵdirectiveInject(AutoDestroyService), ɵngcc0.ɵɵdirectiveInject(SnackBarService), ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DateTimeAdapter), ɵngcc0.ɵɵdirectiveInject(LocalizationProvider), ɵngcc0.ɵɵdirectiveInject(StreamEventsService), ɵngcc0.ɵɵdirectiveInject(ENVIRONMENT), ɵngcc0.ɵɵdirectiveInject(CURRENT_CURRENCY)); };
InputComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InputComponent, selectors: [["ano-input"]], viewQuery: function InputComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c7, 5);
        ɵngcc0.ɵɵviewQuery(_c8, 5);
        ɵngcc0.ɵɵviewQuery(_c9, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.multimediaUploader = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputDate = _t.first);
    } }, inputs: { config: "config", multimediaUrl: "multimediaUrl", multimediaType: "multimediaType", clearImageButton: "clearImageButton", isCleanable: "isCleanable", isTextarea: "isTextarea", isInputShow: "isInputShow", disabled: "disabled", isClearButton: "isClearButton", readonly: "readonly", disabledToggle: "disabledToggle", columnImageUploader: "columnImageUploader", invalid: "invalid", isEditMode: "isEditMode", noBorder: "noBorder", accept: "accept", defaultForm: "defaultForm", formConfig: "formConfig", field: "field", coursePreview: "coursePreview", errors: "errors", infoMessage: "infoMessage", formIndex: "formIndex", isTouched: "isTouched", isDirty: "isDirty", name: "name", playerConfig: "playerConfig", formMain: "formMain" }, outputs: { blur: "blur", input$: "input$", onFileUpload$: "onFileUpload$", clearImage$: "clearImage$", toggle$: "toggle$", checked$: "checked$", checkedPayments$: "checkedPayments$" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => InputComponent_1),
                multi: true
            },
            {
                provide: OwlDateTimeIntl,
                useClass: DefaultIntl
            },
            { provide: OWL_DATE_TIME_FORMATS, useValue: MY_NATIVE_FORMATS },
            AutoDestroyService
        ])], decls: 15, vars: 15, consts: [[4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "input-group"], ["class", "input-group-prepend", 4, "ngIf"], ["class", "btn btn-primary", 3, "click", 4, "ngIf"], ["class", "input-group-append", 4, "ngIf"], [1, "input-group-prepend"], [1, "input-group-text"], ["autocomplete", "new-password", 3, "type", "name", "mask", "placeholder", "required", "ngModel", "readonly", "disabled", "blur", "ngModelChange", "focus", "input", "change", "keyup"], ["input", ""], [3, "type", "placeholder", "required", "ngModel", "readonly", "disabled", "blur", "ngModelChange", "focus", "input", "change", "keyup"], [1, "btn", "btn-primary", 3, "click"], [1, "icon", "icon-edit", "margin-left-3"], [1, "input-group-append"], [1, "input-group-append", "cursor-pointer"], [1, "input-group-text", 3, "click"], [1, "icon", "icon-copy"], [1, "form-group", "flex-row", "flex", "align-items-center"], [1, "flex-checkbox"], [3, "type", "required", "checked", "readonly", "disabled", "blur", "focus", "change", "keyup"], [1, "mb-0"], [4, "ngTemplateOutlet"], ["type", "tel", 3, "mask", "patterns", "placeholder", "required", "ngModel", "readonly", "disabled", "blur", "ngModelChange", "focus", "input", "change", "keyup"], ["type", "tel", 3, "placeholder", "required", "ngModel", "readonly", "disabled", "blur", "ngModelChange", "focus", "input", "change", "keyup"], ["class", "card-type", 3, "src", 4, "ngIf"], [1, "card-type", 3, "src"], [3, "noBorder", "isAutocomplete", "isClearButton", "isEditMode", "readonly", "invalid", "touched", "disabled", "value", "classList", "values", "actionLink", "excludeSelected", "actionCallback", "multiSelect", "multiselectInSingleDropdown", "placeholder", "change", "selectedValue", "focus", "blur", "keyup"], ["class", "mt-10 mb-5", 4, "ngIf"], ["class", "row row-padding-10 row-check", 4, "ngIf"], [1, "mt-10", "mb-5"], [1, "row", "row-padding-10", "row-check"], ["class", "form-check mt-5 col-6", 4, "ngFor", "ngForOf"], [1, "form-check", "mt-5", "col-6"], ["type", "checkbox", 1, "form-check-input", 3, "id", "ngModel", "ngModelOptions", "disabled", "ngModelChange", "change", "keyup"], [1, "form-check-label", 3, "for"], [1, "icon", "icon-info", 3, "matTooltip"], [3, "value", "values", "change"], [1, "input-group", "with-border-radius"], [3, "ngStyle", "rows", "autosize", "placeholder", "required", "readonly", "disabled", "ngModel", "blur", "ngModelChange", "focus", "input", "change", "keyup"], ["inputTextArea", ""], [3, "placeholder", "required", "readonly", "disabled", "ngModel", "owlDateTime", "owlDateTimeTrigger", "min", "max", "blur", "focus", "dateTimeInput", "dateTimeChange", "keyup"], ["inputDate", "ngModel"], [3, "pickerType", "afterPickerClosed"], ["dt1", ""], ["class", "icon icon-close", 3, "click", 4, "ngIf"], [1, "icon", "icon-close", 3, "click"], [3, "disabled", "checked", "change"], ["type", "time", "min", "00:00:00", "max", "16:00:00", "step", "1", 3, "placeholder", "required", "disabled", "ngModel", "blur", "focus", "input", "change", "keyup"], ["class", "icon icon-close icon-close-timer", 3, "click", 4, "ngIf"], [1, "icon", "icon-close", "icon-close-timer", 3, "click"], [1, "image-wrapper"], ["class", "close", 3, "click", 4, "ngIf"], [1, "image-container", 3, "ngClass"], ["class", "text-course", 3, "style", 4, "ngIf"], ["class", "btn btn-primary btn-still", 4, "ngIf"], [3, "src", 4, "ngIf"], [3, "config", 4, "ngIf"], [1, "close", 3, "click"], [1, "icon", "icon-trash2"], [1, "text-course"], [1, "btn", "btn-primary", "btn-still"], [3, "src"], [3, "config"], [3, "disabled", "accept", "videoDurationLimit", "maxSize", "files"], ["multimediaUploader", ""], ["class", "input-group-prepend", 3, "disabled", "invalid", 4, "ngIf"], ["cleaveMask", "", 3, "cleaveValue", "type", "placeholder", "required", "ngModel", "readonly", "disabled", "change", "blur", "focus", "input", "keyup"], ["class", "invalid-feedback", 3, "ngStyle", 4, "ngIf"], [1, "invalid-feedback", 3, "ngStyle"], [1, "info-message"]], template: function InputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, InputComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, InputComponent_ng_container_1_Template, 4, 17, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(2, InputComponent_ng_container_2_Template, 7, 15, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(3, InputComponent_ng_container_3_Template, 4, 18, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(4, InputComponent_ng_container_4_Template, 4, 15, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(5, InputComponent_ng_container_5_Template, 5, 21, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(6, InputComponent_ng_container_6_Template, 2, 2, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(7, InputComponent_ng_container_7_Template, 4, 20, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(8, InputComponent_ng_container_8_Template, 7, 24, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(9, InputComponent_ng_container_9_Template, 3, 7, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(10, InputComponent_ng_container_10_Template, 8, 22, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(11, InputComponent_ng_container_11_Template, 3, 2, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(12, InputComponent_ng_container_12_Template, 6, 22, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(13, InputComponent_ng_container_13_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(14, InputComponent_ng_container_14_Template, 4, 3, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.inputType === ctx.INPUT_TYPES.INPUT || ctx.config.inputType === ctx.INPUT_TYPES.PASSWORD);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.inputType === ctx.INPUT_TYPES.IBAN);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.inputType === ctx.INPUT_TYPES.SIMPLE_CHECKBOX);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.inputType === ctx.INPUT_TYPES.PHONE);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.inputType === ctx.INPUT_TYPES.CREDIT_CARD);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.inputType === ctx.INPUT_TYPES.SELECT || ctx.config.inputType === ctx.INPUT_TYPES.MULTISELECT || ctx.config.inputType === ctx.INPUT_TYPES.MULTISELECT_IN_SINGLE_DROPDOWN);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.inputType === ctx.INPUT_TYPES.RADIO);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.inputType === ctx.INPUT_TYPES.TEXTAREA);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.inputType === ctx.INPUT_TYPES.DATETIME);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.inputType === ctx.INPUT_TYPES.CHECKBOX);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.inputType === ctx.INPUT_TYPES.TIMER);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.inputType === ctx.INPUT_TYPES.IMAGE);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.inputType === ctx.INPUT_TYPES.CURRENCY_AMOUNT);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.errorEntries);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.infoMessage && ctx.isFocused);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc4.DefaultValueAccessor, ɵngcc6.MaskDirective, ɵngcc4.RequiredValidator, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc1.NgTemplateOutlet, DropdownComponent, ɵngcc4.CheckboxControlValueAccessor, ɵngcc7.MatTooltip, RadioSelectComponent, ɵngcc1.NgStyle, ɵngcc8.AutosizeDirective, ɵngcc9.OwlDateTimeInputDirective, ɵngcc9.OwlDateTimeTriggerDirective, ɵngcc9.OwlDateTimeComponent, ɵngcc10.MatSlideToggle, ɵngcc1.NgClass, DragAndDropComponent, CleaveMaskDirective]; }, pipes: function () { return [LocalizationPipe, IbanPipe, ImagePipe]; }, styles: ["@charset \"UTF-8\";.is-empty[_ngcontent-%COMP%], .is-invalid[_ngcontent-%COMP%]{background-image:unset}.not-empty[_ngcontent-%COMP%]{position:absolute;width:25px;height:13px;top:19px;right:2%;background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='gray' viewBox='-2 -2 7 7'%3e%3cpath stroke='gray' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E\");background-repeat:no-repeat;background-position:center right calc(.375em + .1875rem);background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.help-textarea[_ngcontent-%COMP%]{resize:none;height:200px}input[type=date][_ngcontent-%COMP%]{position:relative;color:#fff;background-color:#fff}input[type=date][_ngcontent-%COMP%]::-webkit-datetime-edit{color:transparent;background-color:transparent}input[type=date][_ngcontent-%COMP%]:before{position:absolute;background-color:#fff;top:0;left:0;padding:10px 15px;content:attr(data-date);display:inline-block;color:#000;width:94%;height:48px;border-radius:25px}input[type=date][_ngcontent-%COMP%]:after{content:\"\u25BC\";color:#555;padding:0 5px;position:absolute;top:14px;right:10px}input[type=date][_ngcontent-%COMP%]::-webkit-calendar-picker-indicator{position:absolute;top:0;left:0;right:0;bottom:0;width:auto;height:auto;color:transparent;background:transparent}input[type=date][_ngcontent-%COMP%]::-webkit-inner-spin-button{z-index:1}input[type=date][_ngcontent-%COMP%]::-webkit-clear-button{display:none}.input-clear-icon[_ngcontent-%COMP%]{top:12px;right:8%;z-index:100;opacity:0}.input-clear-icon-visible[_ngcontent-%COMP%]{opacity:1}.medical-textarea[_ngcontent-%COMP%]{padding-left:15px!important;padding-right:15px!important;font-size:1rem!important;font-weight:400!important;line-height:1.5!important}.row[_ngcontent-%COMP%]{display:flex;justify-content:center}.column-reverse[_ngcontent-%COMP%]{flex-direction:column}.image-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row-reverse;justify-content:space-between;padding:0 0 15px}.image-wrapper[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%}.image-container[_ngcontent-%COMP%]{position:relative;width:100%}input[_ngcontent-%COMP%]:disabled, select[_ngcontent-%COMP%]:disabled, textarea[_ngcontent-%COMP%]:disabled{background-color:#fff}input[_ngcontent-%COMP%]:disabled::-moz-placeholder, select[_ngcontent-%COMP%]:disabled::-moz-placeholder, textarea[_ngcontent-%COMP%]:disabled::-moz-placeholder{color:#b6bbc5}input[_ngcontent-%COMP%]:disabled:-ms-input-placeholder, select[_ngcontent-%COMP%]:disabled:-ms-input-placeholder, textarea[_ngcontent-%COMP%]:disabled:-ms-input-placeholder{color:#b6bbc5}input[_ngcontent-%COMP%]:disabled::placeholder, select[_ngcontent-%COMP%]:disabled::placeholder, textarea[_ngcontent-%COMP%]:disabled::placeholder{color:#b6bbc5}.invalid[_ngcontent-%COMP%]{color:#fc4349!important;border-color:#fc4349!important}.invalid[_ngcontent-%COMP%]::-moz-placeholder{color:#fc4349}.invalid[_ngcontent-%COMP%]:-ms-input-placeholder{color:#fc4349}.invalid[_ngcontent-%COMP%]::placeholder{color:#fc4349}.invalid-feedback[_ngcontent-%COMP%]{color:#fc4349}.info-message[_ngcontent-%COMP%]{font-size:12px;line-height:1.2;margin-top:0;color:#ffcc14}  .form-control-select{outline:none}.form-control-select[_ngcontent-%COMP%]:after{content:\"\";border-left:5px solid transparent;border-right:5px solid transparent;border-top:7px solid #0c1d3f;display:inline-block;position:absolute;right:40px;top:28%}.disabled.form-control-select[_ngcontent-%COMP%]:after{border:none!important}.flex-form-group[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between}.flex-form-group[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{width:60%;overflow:auto}.flex-form-group[_ngcontent-%COMP%]   .flex-form-group-buttons[_ngcontent-%COMP%]{width:40%;padding:0 5px;display:flex;flex-direction:row;justify-content:space-between;align-items:center;border-bottom:1px solid #ddd}select[_ngcontent-%COMP%]{outline:none}  .mat-slide-toggle .mat-slide-toggle-ripple{display:none}  .mat-slide-toggle-content{color:#252525;font-family:Poppins-Regular,sans-serif;font-size:14px}  .mat-slide-toggle.mat-checked .mat-slide-toggle-thumb{background:#bad668!important}  .mat-slide-toggle-bar{background-color:#efefef!important;width:40px!important;height:20px!important;border-radius:20px!important}  .mat-slide-toggle-thumb{background-color:#727272}  .mat-slide-toggle.mat-checked .mat-slide-toggle-bar{background-color:#efefef!important;width:40px!important;height:20px!important;border-radius:20px!important}  .mat-slide-toggle-thumb-container{top:0!important}  .mat-slide-toggle.mat-checked .mat-slide-toggle-thumb-container{transform:translate3d(20px,0,0)!important;top:0!important}  label.mat-slide-toggle-label{flex-direction:row-reverse;justify-content:space-between}  mat-slide-toggle.mat-slide-toggle{display:flex}  mat-slide-toggle.mat-slide-toggle.simple-toggle{height:auto}  .mat-select-arrow-wrapper{opacity:0!important}  .mat-select-panel{transform:translateX(3px) translateY(38px) scale(1)!important;border:1px solid #0c1d3f!important;padding-top:5px!important;min-width:calc(100% + 27px)!important;box-shadow:none!important}  .mat-form-field-infix{border:none!important;padding-top:3px!important}  .mat-form-field-appearance-legacy .mat-form-field-underline{display:none!important}  mat-slide-toggle.mat-slide-toggle.simple-toggle .mat-slide-toggle-label{margin-bottom:0!important}  mat-slide-toggle.mat-slide-toggle.simple-toggle .mat-slide-toggle-content{white-space:normal!important;line-height:1.5}  mat-slide-toggle.mat-slide-toggle.simple-toggle .mat-slide-toggle-bar{margin-right:0!important}  .mat-autocomplete-panel.mat-autocomplete-visible{height:auto}  .mat-select{box-shadow:none!important}  .mat-slide-toggle.hidden-toggle .mat-slide-toggle-bar{opacity:.38!important}  .mat-disabled.hidden-toggle{opacity:1!important}.alert[_ngcontent-%COMP%], h3[_ngcontent-%COMP%]{text-align:center}.group-append-text[_ngcontent-%COMP%]{border-radius:5px;box-shadow:0 0 0 .2rem rgba(14,84,169,.25)}.with-border-radius[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-top-right-radius:5px!important;border-bottom-right-radius:5px!important}.append-text[_ngcontent-%COMP%]{border-right:none!important}.append-text[_ngcontent-%COMP%]:focus{box-shadow:none}.input-group-text.invalid[_ngcontent-%COMP%]{border-color:#fc4349}.flex-checkbox[_ngcontent-%COMP%]{width:26px}.flex-checkbox[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{height:20px}.flex[_ngcontent-%COMP%]{display:flex}.inline-edit[_ngcontent-%COMP%]{margin-right:15px;border-top-right-radius:5px!important;border-bottom-right-radius:5px!important}.margin-left-3[_ngcontent-%COMP%]{margin-left:3px}.card-type[_ngcontent-%COMP%]{position:absolute;width:40px;right:6px;top:4px}.input-group[_ngcontent-%COMP%]{box-shadow:none!important}.input-group[_ngcontent-%COMP%]   ano-dropdown[_ngcontent-%COMP%]{width:100%}.icon-close[_ngcontent-%COMP%]{zoom:.8;cursor:pointer;position:absolute;right:30px;top:20px}.icon-close-timer[_ngcontent-%COMP%]{right:88px;top:19px}input[type=search][_ngcontent-%COMP%]::-webkit-search-cancel-button:hover, input[type=search][_ngcontent-%COMP%]::-webkit-search-decoration:hover{cursor:pointer}.input-group.disabled[_ngcontent-%COMP%]:not(.default-form)   .form-control[_ngcontent-%COMP%]{color:#bebebe;border-color:#bebebe}.input-group.disabled[_ngcontent-%COMP%]:not(.default-form)   .form-control[_ngcontent-%COMP%]::-moz-placeholder{color:#bebebe}.input-group.disabled[_ngcontent-%COMP%]:not(.default-form)   .form-control[_ngcontent-%COMP%]:-ms-input-placeholder{color:#bebebe}.input-group.disabled[_ngcontent-%COMP%]:not(.default-form)   .form-control[_ngcontent-%COMP%]::placeholder{color:#bebebe}.input-group.disabled[_ngcontent-%COMP%]:not(.default-form)   .form-control[_ngcontent-%COMP%]:disabled::-moz-placeholder{color:#bebebe}.input-group.disabled[_ngcontent-%COMP%]:not(.default-form)   .form-control[_ngcontent-%COMP%]:disabled:-ms-input-placeholder{color:#bebebe}.input-group.disabled[_ngcontent-%COMP%]:not(.default-form)   .form-control[_ngcontent-%COMP%]:disabled::placeholder{color:#bebebe}.input-group.disabled[_ngcontent-%COMP%]:not(.default-form)   .input-group-text[_ngcontent-%COMP%]{color:#bebebe;border-color:#bebebe!important}.input-group-text.disabled[_ngcontent-%COMP%]{color:#bebebe;border-color:#bebebe}.input-group-text.disabled[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%], .input-group.disabled[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{color:#bebebe}.row-check[_ngcontent-%COMP%]{justify-content:flex-start}.form-check-input[_ngcontent-%COMP%]{margin:0!important;position:relative}.form-check-label[_ngcontent-%COMP%]{margin-left:10px}.form-check[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .form-check[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{cursor:pointer}input[_ngcontent-%COMP%]:disabled{color:#bebebe;border-color:#bebebe}.input-group-prepend.disabled[_ngcontent-%COMP%]   .input-group-text[_ngcontent-%COMP%]{border-color:#bebebe!important;color:#bebebe!important}"] });
__decorate([
    ViewChild('multimediaUploader', { static: false })
], InputComponent.prototype, "multimediaUploader", void 0);
__decorate([
    ViewChild('input', { static: false })
], InputComponent.prototype, "input", void 0);
__decorate([
    ViewChild('inputDate', { static: false })
], InputComponent.prototype, "inputDate", void 0);
__decorate([
    Input()
], InputComponent.prototype, "defaultForm", void 0);
__decorate([
    Input()
], InputComponent.prototype, "formConfig", void 0);
__decorate([
    Input()
], InputComponent.prototype, "field", void 0);
__decorate([
    Input()
], InputComponent.prototype, "coursePreview", void 0);
__decorate([
    Input()
], InputComponent.prototype, "config", void 0);
__decorate([
    Input()
], InputComponent.prototype, "multimediaUrl", void 0);
__decorate([
    Input()
], InputComponent.prototype, "multimediaType", void 0);
__decorate([
    Input()
], InputComponent.prototype, "clearImageButton", void 0);
__decorate([
    Input()
], InputComponent.prototype, "errors", void 0);
__decorate([
    Input()
], InputComponent.prototype, "infoMessage", void 0);
__decorate([
    Input()
], InputComponent.prototype, "formIndex", void 0);
__decorate([
    Input()
], InputComponent.prototype, "isTouched", void 0);
__decorate([
    Input()
], InputComponent.prototype, "isDirty", void 0);
__decorate([
    Input()
], InputComponent.prototype, "isCleanable", void 0);
__decorate([
    Input()
], InputComponent.prototype, "isTextarea", void 0);
__decorate([
    Input()
], InputComponent.prototype, "isInputShow", void 0);
__decorate([
    Input()
], InputComponent.prototype, "disabled", void 0);
__decorate([
    Input()
], InputComponent.prototype, "isClearButton", void 0);
__decorate([
    Input()
], InputComponent.prototype, "readonly", void 0);
__decorate([
    Input()
], InputComponent.prototype, "disabledToggle", void 0);
__decorate([
    Input()
], InputComponent.prototype, "columnImageUploader", void 0);
__decorate([
    Input()
], InputComponent.prototype, "invalid", void 0);
__decorate([
    Input()
], InputComponent.prototype, "isEditMode", void 0);
__decorate([
    Input()
], InputComponent.prototype, "noBorder", void 0);
__decorate([
    Input()
], InputComponent.prototype, "name", void 0);
__decorate([
    Input()
], InputComponent.prototype, "accept", void 0);
__decorate([
    Input()
], InputComponent.prototype, "playerConfig", void 0);
__decorate([
    Input()
], InputComponent.prototype, "formMain", void 0);
__decorate([
    Output()
], InputComponent.prototype, "blur", void 0);
__decorate([
    Output()
], InputComponent.prototype, "input$", void 0);
__decorate([
    Output()
], InputComponent.prototype, "onFileUpload$", void 0);
__decorate([
    Output()
], InputComponent.prototype, "clearImage$", void 0);
__decorate([
    Output()
], InputComponent.prototype, "toggle$", void 0);
__decorate([
    Output()
], InputComponent.prototype, "checked$", void 0);
__decorate([
    Output()
], InputComponent.prototype, "checkedPayments$", void 0);
InputComponent = InputComponent_1 = __decorate([ __param(0, Inject(AutoDestroyService)),
    __param(1, Inject(SnackBarService)),
    __param(2, Inject(ChangeDetectorRef)),
    __param(3, Inject(DateTimeAdapter)),
    __param(4, Inject(LocalizationProvider)),
    __param(5, Inject(StreamEventsService)),
    __param(6, Inject(ENVIRONMENT)),
    __param(7, Inject(CURRENT_CURRENCY))
], InputComponent);

let WhiteSpacePipe = class WhiteSpacePipe {
    transform(value) {
        if (!value) {
            return null;
        }
        return value.replace('-', '- ');
    }
};
WhiteSpacePipe.ɵfac = function WhiteSpacePipe_Factory(t) { return new (t || WhiteSpacePipe)(); };
WhiteSpacePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "whiteSpace", type: WhiteSpacePipe, pure: true });

let DragAndDropComponent = class DragAndDropComponent {
    constructor() {
        this.disabled = false;
        this.maxSize = 0;
        this.files = new EventEmitter();
    }
    ngOnInit() {
    }
    onFileDropped($event) {
        this.prepareFilesList($event);
    }
    fileBrowseHandler(files) {
        this.prepareFilesList(files);
    }
    isVideoDurationValid(file) {
        return new Promise(resolve => {
            const video = document.createElement('video');
            video.preload = 'metadata';
            video.onloadedmetadata = () => {
                window.URL.revokeObjectURL(video.src);
                resolve(video.duration <= this.videoDurationLimit);
            };
            video.src = URL.createObjectURL(file);
        });
    }
    prepareFilesList(files) {
        return __awaiter(this, void 0, void 0, function* () {
            const fileUploadResponse = {
                success: true,
                files: files[0]
            };
            if (this.maxSize && !this.isFileValid(files[0])) {
                delete fileUploadResponse.files;
                fileUploadResponse.success = false;
                fileUploadResponse.rejectReason = 'maxFileSize' + this.maxSize + 'MB';
            }
            if (this.videoDurationLimit && !(yield this.isVideoDurationValid(files[0]))) {
                delete fileUploadResponse.files;
                fileUploadResponse.success = false;
                fileUploadResponse.rejectReason = 'durationLimitReached';
            }
            this.files.emit(fileUploadResponse);
        });
    }
    isFileValid(file) {
        return file.size < this.maxSize * 1024 * 1024;
    }
};
DragAndDropComponent.ɵfac = function DragAndDropComponent_Factory(t) { return new (t || DragAndDropComponent)(); };
DragAndDropComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DragAndDropComponent, selectors: [["ano-drag-and-drop"]], viewQuery: function DragAndDropComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c13, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fileDropRef = _t.first);
    } }, inputs: { disabled: "disabled", maxSize: "maxSize", accept: "accept", videoDurationLimit: "videoDurationLimit" }, outputs: { files: "files" }, decls: 13, vars: 13, consts: [["appDnd", "", 1, "wrapper-drag-and-drop", 3, "fileDropped"], ["type", "file", "id", "fileDropRef", "multiple", "", 3, "disabled", "accept", "change"], ["fileDropRef", ""], [1, "icon", "icon-plus"], [1, "text-xlg"], [1, "text-xs"], [1, "btn", "btn-primary", "btn-sm", 3, "click"]], template: function DragAndDropComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("fileDropped", function DragAndDropComponent_Template_div_fileDropped_0_listener($event) { return ctx.onFileDropped($event); });
        ɵngcc0.ɵɵelementStart(1, "input", 1, 2);
        ɵngcc0.ɵɵlistener("change", function DragAndDropComponent_Template_input_change_1_listener($event) { return ctx.fileBrowseHandler($event.target.files); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "i", 3);
        ɵngcc0.ɵɵelementStart(4, "span", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "localize");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "span", 5);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵpipe(9, "localize");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "button", 6);
        ɵngcc0.ɵɵlistener("click", function DragAndDropComponent_Template_button_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r1); const _r0 = ɵngcc0.ɵɵreference(2); return _r0.click(); });
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵpipe(12, "localize");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("accept", ctx.accept);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 7, "video.drag"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(9, 9, "video.or"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(12, 11, "video.select"));
    } }, directives: function () { return [DndDirective]; }, pipes: function () { return [LocalizationPipe]; }, styles: [".wrapper-drag-and-drop[_ngcontent-%COMP%]{text-align:center;margin:0 auto;position:relative}.wrapper-drag-and-drop[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{opacity:0;position:absolute;z-index:2;width:100%;height:100%;top:0;left:0}.wrapper-drag-and-drop[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{z-index:4}.wrapper-drag-and-drop.disabled[_ngcontent-%COMP%]{border-color:#b6bbc5!important}.wrapper-drag-and-drop.disabled[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%], .wrapper-drag-and-drop.disabled[_ngcontent-%COMP%]   .text-xlg[_ngcontent-%COMP%], .wrapper-drag-and-drop.disabled[_ngcontent-%COMP%]   .text-xs[_ngcontent-%COMP%]{color:#b6bbc5!important}.wrapper-drag-and-drop.disabled[_ngcontent-%COMP%]   .btn-primary[_ngcontent-%COMP%]{background-color:#b6bbc5!important}.fileover[_ngcontent-%COMP%]{-webkit-animation:shake 1s;animation:shake 1s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}@-webkit-keyframes shake{0%{transform:translate(1px,1px) rotate(0deg)}10%{transform:translate(-1px,-2px) rotate(-1deg)}20%{transform:translate(-3px) rotate(1deg)}30%{transform:translate(3px,2px) rotate(0deg)}40%{transform:translate(1px,-1px) rotate(1deg)}50%{transform:translate(-1px,2px) rotate(-1deg)}60%{transform:translate(-3px,1px) rotate(0deg)}70%{transform:translate(3px,1px) rotate(-1deg)}80%{transform:translate(-1px,-1px) rotate(1deg)}90%{transform:translate(1px,2px) rotate(0deg)}to{transform:translate(1px,-2px) rotate(-1deg)}}@keyframes shake{0%{transform:translate(1px,1px) rotate(0deg)}10%{transform:translate(-1px,-2px) rotate(-1deg)}20%{transform:translate(-3px) rotate(1deg)}30%{transform:translate(3px,2px) rotate(0deg)}40%{transform:translate(1px,-1px) rotate(1deg)}50%{transform:translate(-1px,2px) rotate(-1deg)}60%{transform:translate(-3px,1px) rotate(0deg)}70%{transform:translate(3px,1px) rotate(-1deg)}80%{transform:translate(-1px,-1px) rotate(1deg)}90%{transform:translate(1px,2px) rotate(0deg)}to{transform:translate(1px,-2px) rotate(-1deg)}}"] });
__decorate([
    Input()
], DragAndDropComponent.prototype, "disabled", void 0);
__decorate([
    Input()
], DragAndDropComponent.prototype, "accept", void 0);
__decorate([
    Input()
], DragAndDropComponent.prototype, "videoDurationLimit", void 0);
__decorate([
    Input()
], DragAndDropComponent.prototype, "maxSize", void 0);
__decorate([
    Output()
], DragAndDropComponent.prototype, "files", void 0);
__decorate([
    ViewChild('fileDropRef', { static: false })
], DragAndDropComponent.prototype, "fileDropRef", void 0);

const VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CleaveMaskDirective),
    multi: true
};
/**
 * TODO: Problem with cleave directive and input component
 * writeValue of cleave mask conflicts with input component (when we add onInput).
 *
 * When deleting value in currency input onInput calls writeValue of input component and writeValue of cleave mask
 * which immediately rewrites our changes with mask. Moreover it is called not on every input. Usual order:
 *
 * <we have 11.00 in input>
 * <user deletes symbol>
 * writeValue(input-component)
 * writeValue(cleave-component)
 *
 * <we have 11.00 in input>
 * <user deletes symbol>
 * writeValue(input-component)
 *
 * <we have 11.0 in input>
 * <user deletes symbol>
 * writeValue(input-component)
 * writeValue(cleave-component)
 *
 * <we have 11.00 in input>
 */
let CleaveMaskDirective = class CleaveMaskDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.appCleaveMask = DEFAULT_CONFIG;
        this._value = new BehaviorSubject(0);
        this.isInitial = true;
        this.mask = null;
        this.onChange = (_) => {
        };
        this.onTouched = () => {
        };
        this.initMask();
    }
    set value(value) {
        this._value.next(value);
    }
    get value() {
        return this._value.getValue();
    }
    initMask() {
        if (this.mask) {
            this.mask.destroy();
        }
        const { nativeElement } = this.elementRef;
        const config = this.appCleaveMask || DEFAULT_CONFIG;
        setTimeout(() => {
            this.mask = new Cleave(nativeElement, {
                numeral: true,
                numeralDecimalScale: config.decimalScale,
                numeralPositiveOnly: true,
                onValueChanged: ({ target }) => {
                    if (this.rawValue === target.rawValue) {
                        return;
                    }
                    this.rawValue = target.rawValue;
                    this.onChange(target.rawValue);
                }
            });
            this.setMaskValue(this.rawValue);
        });
    }
    ngOnInit() {
        // Take first not empty number
        this._value.pipe(first(val => val && val > 0)).subscribe(val => {
            if (this.isInitial) {
                setTimeout(() => {
                    this.writeValue(val);
                    this.isInitial = false;
                }, 0);
            }
        });
    }
    onInput() {
        this.isInitial = false;
    }
    onKeyPress(e) {
        if (this.rawValue.replace('.00', '').length >= 6) {
            e.preventDefault();
        }
    }
    onBlur() {
        this.writeValue(this.rawValue);
        this.onTouched();
    }
    getWithDecimals(val) {
        if (val === '') {
            return '';
        }
        // Format value with thousands separator
        const formatWithThousandsSeparator = (val) => val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        val = formatWithThousandsSeparator(val);
        const config = this.appCleaveMask || DEFAULT_CONFIG;
        const [integer, decimal] = val.split('.');
        if (decimal) {
            const difference = config.decimalScale - decimal.length;
            return integer + '.' + decimal.split('').concat(Array(difference).fill(0)).join('');
        }
        else {
            return val + `${val.includes('.') ? '' : '.'}00`;
        }
    }
    writeValue(val) {
        if (!val) {
            this.setMaskValue('');
        }
        this.rawValue = this.getWithDecimals(String(val));
        this.setMaskValue(this.rawValue);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setMaskValue(val) {
        if (this.mask) {
            this.mask.setRawValue(val);
        }
    }
};
CleaveMaskDirective.ɵfac = function CleaveMaskDirective_Factory(t) { return new (t || CleaveMaskDirective)(ɵngcc0.ɵɵdirectiveInject(ElementRef)); };
CleaveMaskDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CleaveMaskDirective, selectors: [["", "cleaveMask", ""]], hostBindings: function CleaveMaskDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function CleaveMaskDirective_input_HostBindingHandler() { return ctx.onInput(); })("keypress", function CleaveMaskDirective_keypress_HostBindingHandler($event) { return ctx.onKeyPress($event); })("blur", function CleaveMaskDirective_blur_HostBindingHandler() { return ctx.onBlur(); });
    } }, inputs: { appCleaveMask: "appCleaveMask", value: ["cleaveValue", "value"] }, features: [ɵngcc0.ɵɵProvidersFeature([])] });
__decorate([
    Input()
], CleaveMaskDirective.prototype, "appCleaveMask", void 0);
__decorate([
    Input('cleaveValue')
], CleaveMaskDirective.prototype, "value", null);
__decorate([
    HostListener('input')
], CleaveMaskDirective.prototype, "onInput", null);
__decorate([
    HostListener('keypress', ['$event'])
], CleaveMaskDirective.prototype, "onKeyPress", null);
__decorate([
    HostListener('blur')
], CleaveMaskDirective.prototype, "onBlur", null);
CleaveMaskDirective = __decorate([ __param(0, Inject(ElementRef))
], CleaveMaskDirective);
const DEFAULT_CONFIG = {
    decimalScale: 2,
    prefix: '$',
};

let DndDirective = class DndDirective {
    constructor() {
        this.fileDropped = new EventEmitter();
    }
    // Dragover listener
    onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = true;
    }
    // Dragleave listener
    onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = false;
    }
    // Drop listener
    ondrop(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = false;
        const files = evt.dataTransfer.files;
        if (files.length > 0) {
            this.fileDropped.emit(files);
        }
    }
};
DndDirective.ɵfac = function DndDirective_Factory(t) { return new (t || DndDirective)(); };
DndDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DndDirective, selectors: [["", "appDnd", ""]], hostVars: 2, hostBindings: function DndDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("dragover", function DndDirective_dragover_HostBindingHandler($event) { return ctx.onDragOver($event); })("dragleave", function DndDirective_dragleave_HostBindingHandler($event) { return ctx.onDragLeave($event); })("drop", function DndDirective_drop_HostBindingHandler($event) { return ctx.ondrop($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("fileover", ctx.fileOver);
    } }, outputs: { fileDropped: "fileDropped" } });
__decorate([
    HostBinding('class.fileover')
], DndDirective.prototype, "fileOver", void 0);
__decorate([
    Output()
], DndDirective.prototype, "fileDropped", void 0);
__decorate([
    HostListener('dragover', ['$event'])
], DndDirective.prototype, "onDragOver", null);
__decorate([
    HostListener('dragleave', ['$event'])
], DndDirective.prototype, "onDragLeave", null);
__decorate([
    HostListener('drop', ['$event'])
], DndDirective.prototype, "ondrop", null);

let RadioSelectComponent = class RadioSelectComponent {
    constructor() {
        this.change = new EventEmitter();
    }
    ngOnInit() {
    }
    select(value) {
        this.values.forEach(item => item.selected = false);
        value.selected = true;
        this.value = value.key;
        this.change.emit(this.value);
    }
};
RadioSelectComponent.ɵfac = function RadioSelectComponent_Factory(t) { return new (t || RadioSelectComponent)(); };
RadioSelectComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RadioSelectComponent, selectors: [["ano-radio-select"]], inputs: { value: "value", values: "values" }, outputs: { change: "change" }, decls: 1, vars: 1, consts: [["class", "radio-select", 4, "ngIf"], [1, "radio-select"], [4, "ngFor", "ngForOf"], [1, "radio-item", "active-radio", 3, "ngStyle", "click"]], template: function RadioSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, RadioSelectComponent_div_0_Template, 2, 1, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.values == null ? null : ctx.values.length);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc1.NgStyle], styles: [".radio-select[_ngcontent-%COMP%]{width:100%;height:40px;border:1px solid #0e54a9;border-left:none;display:flex;flex-direction:row;justify-content:center}.radio-select[_ngcontent-%COMP%]   .radio-item[_ngcontent-%COMP%]{border-left:1px solid #0e54a9;text-align:center;vertical-align:center;display:flex;justify-content:center;align-items:center;cursor:pointer;color:#0e54a9}.radio-select[_ngcontent-%COMP%]   .radio-item.active-radio[_ngcontent-%COMP%]{background:#0e54a9;color:#fff}"] });
__decorate([
    Input()
], RadioSelectComponent.prototype, "value", void 0);
__decorate([
    Input()
], RadioSelectComponent.prototype, "values", void 0);
__decorate([
    Output()
], RadioSelectComponent.prototype, "change", void 0);

let DropdownComponent = class DropdownComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.isClearButton = false;
        this.multiSelect = false;
        this.multiselectInSingleDropdown = false;
        this.isAutocomplete = false;
        this.isEditMode = false;
        this.readonly = false;
        this.noBorder = true;
        this.excludeSelected = true;
        this.change = new EventEmitter();
        this.focus = new EventEmitter();
        this.blur = new EventEmitter();
        this.selectedValue = new EventEmitter();
        this.clearInput = true;
        this.opened = false;
    }
    set values(values) {
        this._values = values.filter((val) => !val.hide);
        if (!this.initValues) {
            this.initValues = values;
        }
    }
    get values() {
        return this._values;
    }
    closeDropdown(event) {
        if (!this.elementRef.nativeElement.contains(event.target) && this.opened) {
            this.opened = false;
            this.blur.emit();
            if (this.isAutocomplete && this.searchString) {
                const autocompleteValue = this.values.find(val => val.value.toLowerCase().includes(this.searchString.toLowerCase()));
                if (autocompleteValue === null || autocompleteValue === void 0 ? void 0 : autocompleteValue.key) {
                    this.filterValues(autocompleteValue.value);
                    this.value = autocompleteValue.key;
                }
                else {
                    this.values = this.initValues;
                    this.value = '';
                    this.autocomplete.nativeElement.value = '';
                }
                this.change.emit(this.value);
            }
        }
    }
    ngOnInit() {
        this._values = this.excludeSelected ? this._values.filter(value => (this.value === value.key) || (this.value !== value.key && !value.selected)) : this._values;
        this.initValues = this.values;
        this.value = this.multiselectInSingleDropdown ? [] : this.value || '';
    }
    toggle() {
        if (this.disabled || this.readonly || !this.isEditMode) {
            return;
        }
        this.opened = !this.opened;
        if (this.opened) {
            this.focus.emit();
        }
        if (!this.opened) {
            this.blur.emit();
            this.change.emit(this.value);
        }
    }
    selected(val) {
        var _a, _b;
        if (!this.value) {
            return false;
        }
        if (this.multiselectInSingleDropdown) {
            return this.value.some((selectedValue) => {
                if (typeof selectedValue === 'number') {
                    return +val.key === +selectedValue;
                }
                return _.isEqual(val.key, selectedValue);
            });
        }
        if (typeof this.value === 'number') {
            return +val.key === +this.value;
        }
        if (val.key.constructor.name === 'Array') {
            return _.isEqual(this.value[0], val.key[0]);
        }
        return ((_a = val.key) === null || _a === void 0 ? void 0 : _a.toString()) === ((_b = this.value) === null || _b === void 0 ? void 0 : _b.toString());
    }
    getValue() {
        if ((!this.values || !this.values.length) && this.clearInput) {
            return '';
        }
        if (!this.multiselectInSingleDropdown) {
            if (this.value === null || this.value === undefined || this.value === '') {
                return '';
            }
            const val = this.values.find(value => { var _a, _b; return ((_a = value === null || value === void 0 ? void 0 : value.key) === null || _a === void 0 ? void 0 : _a.toString()) === ((_b = this.value) === null || _b === void 0 ? void 0 : _b.toString()); });
            if (!val) {
                return this.clearInput ? '' : this.searchString;
            }
            return val.value;
        }
        const selectedValues = this.values.filter(value => {
            if (this.value.includes(value.key)) {
                return value;
            }
        });
        if (selectedValues.length === 0) {
            return '';
        }
        const selectedValuesString = selectedValues.map(value => value.value).join(', ');
        return selectedValuesString;
    }
    selectValue(value) {
        if (value.callback) {
            value.callback(value.args);
            this.opened = false;
            return;
        }
        if (this.multiselectInSingleDropdown) {
            if (!value.key) {
                this.value = [];
                this.emitValueUpdateEvents();
                return;
            }
            const selectedValueIndex = this.value.indexOf(value.key);
            if (selectedValueIndex !== -1 && value.selected) {
                this.value.splice(selectedValueIndex, 1);
                if (this.value.length === 0) {
                    this.opened = false;
                }
            }
            else {
                value.selected = true;
                if (!this.value.includes(value.key)) {
                    this.value.push(value.key);
                }
            }
            this.emitValueUpdateEvents();
        }
        else {
            if (this.value === value.key && value.selected) {
                this.opened = false;
                return;
            }
            const prevValue = this.value;
            value.selected = true;
            this.value = value.key;
            if (this.isAutocomplete) {
                this.filterValues(value === null || value === void 0 ? void 0 : value.value);
            }
            this.opened = false;
            this.emitValueUpdateEvents();
            const found = this.values.find(item => item.key === prevValue);
            if (!this.multiSelect && found) {
                found.selected = false;
            }
        }
    }
    emitValueUpdateEvents() {
        this.change.emit(this.value);
        this.selectedValue.emit(this.value);
        this.blur.emit();
    }
    showValue(value) {
        if (value.hide) {
            return false;
        }
        if (!this.multiSelect) {
            return true;
        }
        if (this.multiSelect && value.selected && this.value && value.key !== this.value) {
            return false;
        }
        if (this.multiSelect && value.selected && !this.value) {
            return false;
        }
        if (this.multiSelect && value.selected && this.value && value.key === this.value) {
            return true;
        }
        return true;
    }
    updateValue(searchString) {
        this.searchString = searchString;
        if (searchString) {
            this.opened = true;
            this.filterValues(searchString, false);
        }
        else {
            this.searchString = null;
            this.values = this.initValues;
            this.value = '';
            const found = this.initValues.find(value => value.selected);
            if (found) {
                found.selected = false;
            }
            this.change.emit(this.value);
        }
    }
    filterValues(value, clearIfNoVal = true) {
        this.clearInput = clearIfNoVal;
        this.values = this.initValues.filter(val => val.value.toLowerCase().includes(value.toLowerCase()))
            .sort((a) => {
            return a.value.toString().toLowerCase().startsWith(value.toLowerCase()) ? -1 : 1;
        });
    }
    runCallback() {
        this.actionCallback.action();
    }
    clear() {
        this.updateValue('');
        if (this.autocomplete) {
            this.autocomplete.nativeElement.value = '';
        }
    }
};
DropdownComponent.ɵfac = function DropdownComponent_Factory(t) { return new (t || DropdownComponent)(ɵngcc0.ɵɵdirectiveInject(ElementRef)); };
DropdownComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DropdownComponent, selectors: [["ano-dropdown"]], viewQuery: function DropdownComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c15, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.autocomplete = _t.first);
    } }, hostBindings: function DropdownComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function DropdownComponent_click_HostBindingHandler($event) { return ctx.closeDropdown($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { isClearButton: "isClearButton", multiSelect: "multiSelect", multiselectInSingleDropdown: "multiselectInSingleDropdown", isAutocomplete: "isAutocomplete", isEditMode: "isEditMode", readonly: "readonly", noBorder: "noBorder", excludeSelected: "excludeSelected", values: "values", value: "value", classList: "classList", placeholder: "placeholder", disabled: "disabled", touched: "touched", invalid: "invalid", actionLink: "actionLink", actionCallback: "actionCallback" }, outputs: { change: "change", focus: "focus", blur: "blur", selectedValue: "selectedValue" }, decls: 7, vars: 6, consts: [[1, "dropdown-wrapper"], ["type", "hidden", 3, "value"], [3, "class", "cursor-pointer", "invalid", "select-opened", "readonly", "disabled", "placeholder", "click", 4, "ngIf"], ["autocomplete", "no", 3, "class", "cursor-pointer", "invalid", "select-opened", "disabled", "placeholder", "readonly", "value", "click", "input", 4, "ngIf"], ["class", "icon icon-close", 3, "click", 4, "ngIf"], ["class", "caret down", 3, "invalid-caret", "disabled-caret", 4, "ngIf"], ["class", "form-control select-dropdown", 3, "invalid", 4, "ngIf"], [3, "click"], [1, "cut-placeholder"], ["autocomplete", "no", 3, "placeholder", "readonly", "disabled", "value", "click", "input"], ["autocomplete", ""], [1, "icon", "icon-close", 3, "click"], [1, "caret", "down"], [1, "form-control", "select-dropdown"], [4, "ngIf"], [2, "position", "relative"], [3, "routerLink"], [4, "ngFor", "ngForOf"], [2, "position", "relative", 3, "click"], ["class", "icon icon-check", 4, "ngIf"], [1, "icon", "icon-check"]], template: function DropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "input", 1);
        ɵngcc0.ɵɵtemplate(2, DropdownComponent_div_2_Template, 4, 18, "div", 2);
        ɵngcc0.ɵɵtemplate(3, DropdownComponent_input_3_Template, 4, 19, "input", 3);
        ɵngcc0.ɵɵtemplate(4, DropdownComponent_i_4_Template, 1, 0, "i", 4);
        ɵngcc0.ɵɵtemplate(5, DropdownComponent_span_5_Template, 1, 4, "span", 5);
        ɵngcc0.ɵɵtemplate(6, DropdownComponent_div_6_Template, 5, 6, "div", 6);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("value", ctx.value);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isAutocomplete);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAutocomplete);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isClearButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAutocomplete && ctx.isEditMode);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.opened);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc11.RouterLinkWithHref, ɵngcc1.NgForOf]; }, pipes: function () { return [LocalizationPipe]; }, styles: [".select-opened[_ngcontent-%COMP%]{border-radius:5px 5px 0 0!important;border-bottom-color:transparent!important}.select-dropdown[_ngcontent-%COMP%]{position:absolute!important;top:40px;border-top-color:transparent!important;border-radius:0 0 5px 5px!important;z-index:102!important;height:auto!important;max-height:250px;overflow:scroll;padding:0!important;background-color:#fff!important}.select-dropdown[_ngcontent-%COMP%]::-webkit-scrollbar{display:none}.form-group-select[_ngcontent-%COMP%]{cursor:default}.form-group-select[_ngcontent-%COMP%]:after{top:49%}.dropdown-input[_ngcontent-%COMP%]{cursor:auto}.selected[_ngcontent-%COMP%]{font-family:Poppins-Bold,sans-serif}.dropdown-wrapper[_ngcontent-%COMP%]{position:relative}.dropdown-item-select[_ngcontent-%COMP%]{cursor:default;border-radius:0!important;color:#0e54a9;border:none;white-space:normal}.dropdown-item-select[_ngcontent-%COMP%]:last-child{border-radius:0 0 3px 3px!important}.dropdown-item-select[_ngcontent-%COMP%]:hover{background-color:#efefef!important}.placeholder[_ngcontent-%COMP%]{color:#252525}.invalid[_ngcontent-%COMP%]{color:#fc4349;border-color:#fc4349!important}.invalid[_ngcontent-%COMP%]:after{border-top:7px solid #fc4349}.invalid[_ngcontent-%COMP%]::-moz-placeholder{color:#fc4349}.invalid[_ngcontent-%COMP%]:-ms-input-placeholder{color:#fc4349}.invalid[_ngcontent-%COMP%]::placeholder{color:#fc4349}.invalid[_ngcontent-%COMP%]   .input-group-text[_ngcontent-%COMP%]{border-color:#fc4349}.disabled[_ngcontent-%COMP%]{border-color:#b6bbc5!important;color:#b6bbc5!important}.disabled-caret[_ngcontent-%COMP%]{display:none!important}.readonly[_ngcontent-%COMP%]:after{display:none}.dropdown-item-select[_ngcontent-%COMP%], .form-group-select[_ngcontent-%COMP%]{display:flex!important;align-items:center!important}.caret[_ngcontent-%COMP%]{display:block;position:absolute;right:10px;top:18px;border-left:5px solid transparent;border-right:5px solid transparent;border-top:7px solid #0c1d3f;z-index:11}.invalid-caret[_ngcontent-%COMP%]{border-top-color:#fc4349}.disabled.form-group-select[_ngcontent-%COMP%]:after{border-color:transparent!important}.cut-placeholder[_ngcontent-%COMP%]{max-width:190px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.form-control.select-dropdown[_ngcontent-%COMP%]{margin-top:-4px}.form-control.select-dropdown[_ngcontent-%COMP%]   .dropdown-item-select[_ngcontent-%COMP%]{padding-top:10px;padding-bottom:10px}.no-border[_ngcontent-%COMP%]{border-color:transparent!important}i.icon-close[_ngcontent-%COMP%]{position:absolute;top:13px;right:30px;font-size:13px;cursor:pointer;font-weight:700}i.icon-close[_ngcontent-%COMP%]:hover{color:#666}.multiselect-single-dropdown[_ngcontent-%COMP%]{justify-content:space-between}.multiselect-single-dropdown[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{font-size:14px}"] });
__decorate([
    ViewChild('autocomplete')
], DropdownComponent.prototype, "autocomplete", void 0);
__decorate([
    Input()
], DropdownComponent.prototype, "classList", void 0);
__decorate([
    Input()
], DropdownComponent.prototype, "value", void 0);
__decorate([
    Input()
], DropdownComponent.prototype, "placeholder", void 0);
__decorate([
    Input()
], DropdownComponent.prototype, "disabled", void 0);
__decorate([
    Input()
], DropdownComponent.prototype, "isClearButton", void 0);
__decorate([
    Input()
], DropdownComponent.prototype, "touched", void 0);
__decorate([
    Input()
], DropdownComponent.prototype, "invalid", void 0);
__decorate([
    Input()
], DropdownComponent.prototype, "actionLink", void 0);
__decorate([
    Input()
], DropdownComponent.prototype, "actionCallback", void 0);
__decorate([
    Input()
], DropdownComponent.prototype, "multiSelect", void 0);
__decorate([
    Input()
], DropdownComponent.prototype, "multiselectInSingleDropdown", void 0);
__decorate([
    Input()
], DropdownComponent.prototype, "isAutocomplete", void 0);
__decorate([
    Input()
], DropdownComponent.prototype, "isEditMode", void 0);
__decorate([
    Input()
], DropdownComponent.prototype, "readonly", void 0);
__decorate([
    Input()
], DropdownComponent.prototype, "noBorder", void 0);
__decorate([
    Input()
], DropdownComponent.prototype, "excludeSelected", void 0);
__decorate([
    Output()
], DropdownComponent.prototype, "change", void 0);
__decorate([
    Output()
], DropdownComponent.prototype, "focus", void 0);
__decorate([
    Output()
], DropdownComponent.prototype, "blur", void 0);
__decorate([
    Output()
], DropdownComponent.prototype, "selectedValue", void 0);
__decorate([
    Input()
], DropdownComponent.prototype, "values", null);
__decorate([
    HostListener('document: click', ['$event'])
], DropdownComponent.prototype, "closeDropdown", null);
DropdownComponent = __decorate([ __param(0, Inject(ElementRef))
], DropdownComponent);

let ButtonComponent = class ButtonComponent {
    constructor() {
        this.isDisabled = false;
        this.emitterButtonAction = new EventEmitter();
    }
    ngOnInit() {
    }
    emitAction(id) {
        this.emitterButtonAction.emit(id);
    }
};
ButtonComponent.ɵfac = function ButtonComponent_Factory(t) { return new (t || ButtonComponent)(); };
ButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ButtonComponent, selectors: [["ano-button"]], inputs: { isDisabled: "isDisabled", config: "config" }, outputs: { emitterButtonAction: "emitterButtonAction" }, ngContentSelectors: _c16, decls: 2, vars: 9, consts: [[3, "type", "disabled"]], template: function ButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate5("btn btn-", ctx.config.styleType, " ", ctx.config.sizeType ? "btn-" + ctx.config.sizeType : "", " ", ctx.config.marginRight ? "margin-right" : "", " ", ctx.config.marginBottom, " ", ctx.config.classList, "");
        ɵngcc0.ɵɵproperty("type", ctx.config.type)("disabled", ctx.config.isDisabled || ctx.isDisabled);
    } }, styles: [".margin-bottom[_ngcontent-%COMP%]{margin-bottom:20px}.icon-back-arrow[_ngcontent-%COMP%]{font-size:30px;position:absolute;left:6px;top:6px;font-weight:800}.width110px[_ngcontent-%COMP%]{width:110px;text-align:end}.width100perc[_ngcontent-%COMP%]{width:110%}.full-width[_ngcontent-%COMP%]{width:100%}"] });
__decorate([
    Input()
], ButtonComponent.prototype, "config", void 0);
__decorate([
    Input()
], ButtonComponent.prototype, "isDisabled", void 0);
__decorate([
    Output()
], ButtonComponent.prototype, "emitterButtonAction", void 0);

// import {LocalizationProvider} from '../../services/localization/localization.service';
let SearchInputComponent = class SearchInputComponent {
    constructor(fb) {
        this.fb = fb;
        this.searchStringEmitter = new EventEmitter();
        this.searchCloseEmitter = new EventEmitter();
        this.searchStatus = { clear: false };
    }
    ngOnInit() {
        this.form = this.fb.group({
            searchString: this.searchString
        });
    }
    getSearchResults() {
        // setTimeout(() => {
        this.searchStatus.clear = true;
        // });
        this.setSearchStringEmitter(this.form.controls['searchString'].value);
    }
    clearSearchResults() {
        this.form.controls['searchString'].setValue(null);
        this.setSearchStringEmitter(this.form.controls['searchString'].value);
        // this.searchCloseEmitter.emit();
        this.searchStatus.clear = false;
    }
    setSearchStringEmitter(searchString) {
        this.searchStringEmitter.emit(searchString);
    }
    searchModelChange() {
        this.searchStatus.clear = false;
    }
    close() {
        this.form.controls['searchString'].setValue(null);
        this.setSearchStringEmitter(this.form.controls['searchString'].value);
        this.searchCloseEmitter.emit();
        this.searchStatus.clear = false;
    }
};
SearchInputComponent.ɵfac = function SearchInputComponent_Factory(t) { return new (t || SearchInputComponent)(ɵngcc0.ɵɵdirectiveInject(FormBuilder)); };
SearchInputComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SearchInputComponent, selectors: [["ano-search-input"]], viewQuery: function SearchInputComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c17, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.searchInput = _t.first);
    } }, inputs: { rounded: "rounded", isShowBackButton: "isShowBackButton" }, outputs: { searchStringEmitter: "searchStringEmitter", searchCloseEmitter: "searchCloseEmitter" }, decls: 9, vars: 9, consts: [["id", "searchHeader", 1, "header", "search-header"], [1, "container"], ["class", "header-nav", 3, "click", 4, "ngIf"], [1, "form-group", "header-field", "search-btn-group"], ["action", ".", 3, "formGroup", "ngSubmit"], ["formControlName", "searchString", "type", "search", "name", "search", "id", "act_search", 1, "form-control", 3, "placeholder", "input"], ["searchInput", ""], ["class", "close", "type", "button", 3, "click", 4, "ngIf"], ["class", "close", "type", "submit", 3, "disabled", 4, "ngIf"], [1, "header-nav", 3, "click"], [1, "icon-close"], ["type", "button", 1, "close", 3, "click"], ["aria-hidden", "true"], ["type", "submit", 1, "close", 3, "disabled"], [1, "icon-search"]], template: function SearchInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "header", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, SearchInputComponent_a_2_Template, 2, 0, "a", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "form", 4);
        ɵngcc0.ɵɵlistener("ngSubmit", function SearchInputComponent_Template_form_ngSubmit_4_listener() { return ctx.getSearchResults(); });
        ɵngcc0.ɵɵelementStart(5, "input", 5, 6);
        ɵngcc0.ɵɵlistener("input", function SearchInputComponent_Template_input_input_5_listener() { return ctx.searchModelChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, SearchInputComponent_button_7_Template, 3, 0, "button", 7);
        ɵngcc0.ɵɵtemplate(8, SearchInputComponent_button_8_Template, 2, 1, "button", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("flex", ctx.isShowBackButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isShowBackButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("width-90", ctx.isShowBackButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("placeholder", "searchInput.placeholder.search");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.searchStatus.clear);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.searchStatus.clear);
    } }, directives: [ɵngcc1.NgIf, ɵngcc4.ɵNgNoValidate, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc4.DefaultValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName], styles: [".header-nav[_ngcontent-%COMP%]{width:10%}.width-90[_ngcontent-%COMP%]{width:90%}.flex[_ngcontent-%COMP%]{display:flex}"] });
__decorate([
    ViewChild('searchInput', { static: false })
], SearchInputComponent.prototype, "searchInput", void 0);
__decorate([
    Output()
], SearchInputComponent.prototype, "searchStringEmitter", void 0);
__decorate([
    Output()
], SearchInputComponent.prototype, "searchCloseEmitter", void 0);
__decorate([
    Input()
], SearchInputComponent.prototype, "rounded", void 0);
__decorate([
    Input()
], SearchInputComponent.prototype, "isShowBackButton", void 0);
SearchInputComponent = __decorate([ __param(0, Inject(FormBuilder))
], SearchInputComponent);

let LocalizationPipe = class LocalizationPipe {
    constructor(localizationProvider) {
        this.localizationProvider = localizationProvider;
    }
    transform(key) {
        return this.localizationProvider.getByKey(key);
    }
};
LocalizationPipe.ɵfac = function LocalizationPipe_Factory(t) { return new (t || LocalizationPipe)(ɵngcc0.ɵɵdirectiveInject(LocalizationProvider, 16)); };
LocalizationPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "localize", type: LocalizationPipe, pure: true });
LocalizationPipe = __decorate([ __param(0, Inject(LocalizationProvider))
], LocalizationPipe);

let LoaderComponent = class LoaderComponent {
    constructor() {
        this.LOADER_THEMES = LOADER_THEMES;
        this.isOpen = false;
        this.loadingText = '';
        this.progress = '';
        this.theme = LOADER_THEMES.DEFAULT;
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        if (this.containerRef) {
            this.width = this.containerRef.clientWidth + 'px';
        }
    }
};
LoaderComponent.ɵfac = function LoaderComponent_Factory(t) { return new (t || LoaderComponent)(); };
LoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LoaderComponent, selectors: [["ano-loader"]], inputs: { isOpen: "isOpen", loadingText: "loadingText", progress: "progress", theme: "theme", containerRef: "containerRef" }, decls: 1, vars: 1, consts: [["class", "full-spinner", 3, "ngClass", "width", 4, "ngIf"], [1, "full-spinner", 3, "ngClass"], [4, "ngIf"], [1, "css-spinner"], [1, "bounce1"], [1, "bounce2"], [1, "bounce3"], ["class", "progress-text", 4, "ngIf"], [1, "progress-text"]], template: function LoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, LoaderComponent_div_0_Template, 7, 9, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isOpen);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass], pipes: [LocalizationPipe], styles: [".wrapper[_ngcontent-%COMP%]{position:absolute;top:0;left:0;z-index:9999;background:#212529;height:calc(100vh - 61px);width:100%;display:flex;align-items:center;justify-content:center}.full-spinner[_ngcontent-%COMP%]{flex-direction:column}.progress-text[_ngcontent-%COMP%]{font-size:16px}"] });
__decorate([
    Input()
], LoaderComponent.prototype, "containerRef", void 0);
__decorate([
    Input()
], LoaderComponent.prototype, "isOpen", void 0);
__decorate([
    Input()
], LoaderComponent.prototype, "loadingText", void 0);
__decorate([
    Input()
], LoaderComponent.prototype, "progress", void 0);
__decorate([
    Input()
], LoaderComponent.prototype, "theme", void 0);

let FilterDropdownComponent = class FilterDropdownComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.change = new EventEmitter();
        this.focus = new EventEmitter();
        this.blur = new EventEmitter();
        this.opened = false;
    }
    closeDropdown(event) {
        if (!this.elementRef.nativeElement.contains(event.target) && this.opened) {
            this.opened = false;
            this.blur.emit();
        }
    }
    ngOnInit() {
    }
    toggleFilter() {
        this.opened = !this.opened;
    }
    getValue() {
        const val = this.values.find(value => value.key.toString() === this.value.toString());
        if (!val) {
            return this.values[0];
        }
        return val.value;
    }
    selectValue(value) {
        if (value.notSelectable) {
            return;
        }
        this.value = value.key;
        this.opened = false;
        this.change.emit(this.value);
        this.blur.emit();
    }
};
FilterDropdownComponent.ɵfac = function FilterDropdownComponent_Factory(t) { return new (t || FilterDropdownComponent)(ɵngcc0.ɵɵdirectiveInject(ElementRef)); };
FilterDropdownComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FilterDropdownComponent, selectors: [["ano-filter-dropdown"]], hostBindings: function FilterDropdownComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function FilterDropdownComponent_click_HostBindingHandler($event) { return ctx.closeDropdown($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { value: "value", classList: "classList", values: "values", placeholder: "placeholder", disabled: "disabled", touched: "touched", invalid: "invalid" }, outputs: { change: "change", focus: "focus", blur: "blur" }, decls: 6, vars: 8, consts: [[1, "dropdown", "cursor-pointer"], [1, "btn", "btn-outline-primary", "dropdown-toggle", "btn-dropdown-xs", 3, "click"], [1, "dropdown-menu", "dropdown-menu-xs"], [4, "ngFor", "ngForOf"], [1, "dropdown-item", 2, "position", "relative", 3, "click"]], template: function FilterDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "button", 1);
        ɵngcc0.ɵɵlistener("click", function FilterDropdownComponent_Template_button_click_1_listener() { return ctx.toggleFilter(); });
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "localize");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵtemplate(5, FilterDropdownComponent_ng_container_5_Template, 4, 3, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("show", ctx.opened);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 6, ctx.getValue()), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("show", ctx.opened);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.values);
    } }, directives: [ɵngcc1.NgForOf], pipes: [LocalizationPipe], styles: [".dropdown-menu[_ngcontent-%COMP%]{max-height:137px;overflow:scroll;-ms-overflow-style:none}.dropdown-menu[_ngcontent-%COMP%]::-webkit-scrollbar{display:none}.dropdown-toggle[_ngcontent-%COMP%]{text-transform:none;min-width:90px}.btn-dropdown-xs[_ngcontent-%COMP%]{height:38px;border-radius:5px}.dropdown[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:after{margin-top:1px}"] });
__decorate([
    Input()
], FilterDropdownComponent.prototype, "classList", void 0);
__decorate([
    Input()
], FilterDropdownComponent.prototype, "value", void 0);
__decorate([
    Input()
], FilterDropdownComponent.prototype, "values", void 0);
__decorate([
    Input()
], FilterDropdownComponent.prototype, "placeholder", void 0);
__decorate([
    Input()
], FilterDropdownComponent.prototype, "disabled", void 0);
__decorate([
    Input()
], FilterDropdownComponent.prototype, "touched", void 0);
__decorate([
    Input()
], FilterDropdownComponent.prototype, "invalid", void 0);
__decorate([
    Output()
], FilterDropdownComponent.prototype, "change", void 0);
__decorate([
    Output()
], FilterDropdownComponent.prototype, "focus", void 0);
__decorate([
    Output()
], FilterDropdownComponent.prototype, "blur", void 0);
__decorate([
    HostListener('document: click', ['$event'])
], FilterDropdownComponent.prototype, "closeDropdown", null);
FilterDropdownComponent = __decorate([ __param(0, Inject(ElementRef))
], FilterDropdownComponent);

let SearchComponent = class SearchComponent {
    constructor(fb, destroy$) {
        this.fb = fb;
        this.destroy$ = destroy$;
        this.searchForm = this.fb.group({
            search: [''],
        });
        this.INPUT_TYPES = INPUT_TYPES;
        this.search$ = new EventEmitter();
        this.type = 'search';
        this.debounceTimeoutTime = 1000;
    }
    set searchClear(isClear) {
        if (isClear) {
            this.searchForm.get('search').setValue('');
        }
    }
    ngOnInit() {
        this.searchForm.get('search').valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe((res) => {
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
            }
            this.debounceTimeout = setTimeout(() => {
                this.search$.emit(res);
            }, this.debounceTimeoutTime);
        });
    }
};
SearchComponent.ɵfac = function SearchComponent_Factory(t) { return new (t || SearchComponent)(ɵngcc0.ɵɵdirectiveInject(FormBuilder), ɵngcc0.ɵɵdirectiveInject(AutoDestroyService)); };
SearchComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SearchComponent, selectors: [["ano-search"]], inputs: { type: "type", searchClear: "searchClear", disabled: "disabled" }, outputs: { search$: "search$" }, features: [ɵngcc0.ɵɵProvidersFeature([AutoDestroyService])], decls: 4, vars: 12, consts: [["action", ".", 1, "border-form", 3, "formGroup", "ngStyle"], [1, "form-group"], ["formControlName", "search", 3, "config"]], template: function SearchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "ano-input", 2);
        ɵngcc0.ɵɵpipe(3, "localize");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.searchForm)("ngStyle", ɵngcc0.ɵɵpureFunction1(5, _c14, 100 + "%"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("config", ɵngcc0.ɵɵpureFunction4(7, _c19, ctx.disabled, ctx.INPUT_TYPES.INPUT, ɵngcc0.ɵɵpipeBind1(3, 3, "common.search"), ctx.type));
    } }, directives: [ɵngcc4.ɵNgNoValidate, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc1.NgStyle, InputComponent, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName], pipes: [LocalizationPipe], styles: [""] });
__decorate([
    Output()
], SearchComponent.prototype, "search$", void 0);
__decorate([
    Input()
], SearchComponent.prototype, "disabled", void 0);
__decorate([
    Input()
], SearchComponent.prototype, "type", void 0);
__decorate([
    Input()
], SearchComponent.prototype, "searchClear", null);
SearchComponent = __decorate([ __param(0, Inject(FormBuilder)),
    __param(1, Inject(AutoDestroyService))
], SearchComponent);

let TimeRangeFilterComponent = class TimeRangeFilterComponent {
    constructor(
    // private localizationProvider: LocalizationProvider,
    formBuilder, destroy$) {
        this.formBuilder = formBuilder;
        this.destroy$ = destroy$;
        this.filterByTimeRange$ = new EventEmitter();
        this.timeRangeFilterForm = this.formBuilder.group({
            timeRange: ['']
        });
        this.timeRangeFilterConfig = {
            name: 'timeRange',
            placeholder: this.localize('media-list.filter.timerange.placeholder'),
            selectOptions: [
                {
                    key: 'all',
                    value: this.localize('media-list.filters.all')
                }
            ]
        };
        this.INPUT_TYPES = INPUT_TYPES;
    }
    set config(config) {
        var _a;
        if (((_a = config === null || config === void 0 ? void 0 : config.filters) === null || _a === void 0 ? void 0 : _a.length) || (config === null || config === void 0 ? void 0 : config.withoutFilters)) {
            this._config = config;
            this.getTimeRanges();
        }
    }
    ;
    ngOnInit() {
        this.listenToTimeRangeChange();
    }
    listenToTimeRangeChange() {
        this.timeRangeFilterForm.get('timeRange').valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe(timeRangeYear => {
            if (timeRangeYear && timeRangeYear !== this.selectedTimeRangeYear) {
                this.selectedTimeRangeYear = timeRangeYear;
                if (timeRangeYear === 'all') {
                    this.filterByTimeRange(null);
                }
                else {
                    this.filterByTimeRange(timeRangeYear);
                }
            }
        });
    }
    filterByTimeRange(timeRangeYear) {
        if (timeRangeYear) {
            if (typeof timeRangeYear === 'string') {
                const timeRangeArr = timeRangeYear.split('-');
                const timeRangeQuery = this.timeRanges.find(timeRange => timeRange.year === +timeRangeArr[1] && timeRange.month === timeRangeArr[0]);
                this.filterByTimeRange$.emit(timeRangeQuery === null || timeRangeQuery === void 0 ? void 0 : timeRangeQuery.timeRange);
            }
            else {
                const timeRangeQuery = this.timeRanges.find(timeRange => timeRange.year === timeRangeYear);
                this.filterByTimeRange$.emit(timeRangeQuery === null || timeRangeQuery === void 0 ? void 0 : timeRangeQuery.timeRange);
            }
        }
        else {
            this.filterByTimeRange$.emit(null);
        }
    }
    getTimeRanges() {
        if (this.timeRangeSubscription) {
            return;
        }
        this.timeRangeSubscription = this._config.fetchMethod(this._config.filters).pipe(takeUntil(this.destroy$)).subscribe(timeRanges => {
            var _a, _b, _c, _d;
            this.timeRanges = timeRanges;
            if (this._config.withoutAll) {
                this.timeRangeFilterConfig.selectOptions = [];
            }
            this.timeRangeFilterConfig.selectOptions.push(...this.timeRanges.map(timeRange => ({
                value: timeRange.month ? timeRange.month + ' ' + timeRange.year : timeRange.year,
                key: timeRange.month ? timeRange.month + '-' + timeRange.year : timeRange.year
            })));
            if (this._config.withoutAll && ((_b = (_a = this.timeRangeFilterConfig) === null || _a === void 0 ? void 0 : _a.selectOptions) === null || _b === void 0 ? void 0 : _b.length)) {
                this.timeRangeFilterConfig.selectOptions[((_c = this._config) === null || _c === void 0 ? void 0 : _c.preselectMonthIndex) || 0].selected = true;
                this.timeRangeFilterForm.get('timeRange').setValue(this.timeRangeFilterConfig.selectOptions[((_d = this._config) === null || _d === void 0 ? void 0 : _d.preselectMonthIndex) || 0].key);
            }
        });
    }
    localize(key) {
        return key;
        // return this.localizationProvider.getByKey(key);
    }
};
TimeRangeFilterComponent.ɵfac = function TimeRangeFilterComponent_Factory(t) { return new (t || TimeRangeFilterComponent)(ɵngcc0.ɵɵdirectiveInject(FormBuilder), ɵngcc0.ɵɵdirectiveInject(AutoDestroyService)); };
TimeRangeFilterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TimeRangeFilterComponent, selectors: [["ano-time-range-filter"]], inputs: { config: "config" }, outputs: { filterByTimeRange$: "filterByTimeRange$" }, features: [ɵngcc0.ɵɵProvidersFeature([AutoDestroyService])], decls: 2, vars: 1, consts: [[1, "blue-theme-filter"], [3, "formGroup", 4, "ngIf"], [3, "formGroup"], [3, "formControlName", "isEditMode", "noBorder", "config"]], template: function TimeRangeFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, TimeRangeFilterComponent_form_1_Template, 2, 9, "form", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.timeRangeFilterConfig == null ? null : ctx.timeRangeFilterConfig.selectOptions == null ? null : ctx.timeRangeFilterConfig.selectOptions.length);
    } }, directives: [ɵngcc1.NgIf, ɵngcc4.ɵNgNoValidate, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, InputComponent, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName], styles: [""] });
__decorate([
    Output()
], TimeRangeFilterComponent.prototype, "filterByTimeRange$", void 0);
__decorate([
    Input()
], TimeRangeFilterComponent.prototype, "config", null);
TimeRangeFilterComponent = __decorate([ __param(0, Inject(FormBuilder)),
    __param(1, Inject(AutoDestroyService))
], TimeRangeFilterComponent);

let IbanPipe = class IbanPipe {
    transform(value) {
        return value.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
    }
};
IbanPipe.ɵfac = function IbanPipe_Factory(t) { return new (t || IbanPipe)(); };
IbanPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "iban", type: IbanPipe, pure: true });

function asBoolean(input) {
    return (input === null || input === void 0 ? void 0 : input.toLowerCase()) === 'true';
}
function obfuscateEmail(email) {
    const address = email.substring(0, email.lastIndexOf('@'));
    const domain = email.substring(email.lastIndexOf('@') + 1, email.length);
    const domainAddress = domain.substring(0, domain.indexOf('.'));
    const topLevelDomain = domain.substring(domain.indexOf('.') + 1, domain.length);
    let obfuscatedEmail = address[0] + address[1];
    for (let i = 0; i < address.length - 3; i++) {
        obfuscatedEmail += '.';
    }
    let obfuscatedDomain = domainAddress[0];
    for (let i = 0; i < domainAddress.length - 2; i++) {
        obfuscatedDomain += '.';
    }
    return obfuscatedEmail + '@' + obfuscatedDomain + '.' + topLevelDomain;
}
function cutString(string, from, to) {
    if (!string) {
        return null;
    }
    return string.substring(from, to);
}
function revertString(string) {
    if (!string) {
        return null;
    }
    return string.split('').reverse().join('');
}

let StringCutPipe = class StringCutPipe {
    transform(value, ...args) {
        return cutString(value, 0, 8);
    }
};
StringCutPipe.ɵfac = function StringCutPipe_Factory(t) { return new (t || StringCutPipe)(); };
StringCutPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "stringCut", type: StringCutPipe, pure: true });

let FormService = class FormService {
    constructor() {
        this.submitInvalid$ = new EventEmitter();
    }
};
FormService.ɵfac = function FormService_Factory(t) { return new (t || FormService)(); };
FormService.ɵprov = i0.ɵɵdefineInjectable({ factory: function FormService_Factory() { return new FormService(); }, token: FormService, providedIn: "root" });

let ScrollToFirstErrorDirective = class ScrollToFirstErrorDirective {
    constructor(formService, autoDestroyService) {
        this.formService = formService;
        this.autoDestroyService = autoDestroyService;
    }
    ngAfterContentInit() {
        this.formService.submitInvalid$
            .pipe(takeUntil(this.autoDestroyService))
            .subscribe(() => {
            this.scrollToFirstErrorField();
        });
    }
    scrollToFirstErrorField() {
        let firstErrorFieldName = '';
        this.forms.forEach(form => {
            if (firstErrorFieldName) {
                return;
            }
            Object.keys(form.controls).forEach(control => {
                if (firstErrorFieldName) {
                    return;
                }
                if (form.get(control).invalid) {
                    firstErrorFieldName = control;
                    return;
                }
            });
        });
        const errorField = document.getElementById(firstErrorFieldName);
        if (!errorField) {
            return;
        }
        errorField.scrollIntoView({
            block: 'center',
            behavior: 'smooth'
        });
    }
};
ScrollToFirstErrorDirective.ɵfac = function ScrollToFirstErrorDirective_Factory(t) { return new (t || ScrollToFirstErrorDirective)(ɵngcc0.ɵɵdirectiveInject(FormService), ɵngcc0.ɵɵdirectiveInject(AutoDestroyService)); };
ScrollToFirstErrorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ScrollToFirstErrorDirective, selectors: [["", "anoScrollToFirstError", ""]], inputs: { forms: "forms" }, features: [ɵngcc0.ɵɵProvidersFeature([AutoDestroyService])] });
__decorate([
    Input()
], ScrollToFirstErrorDirective.prototype, "forms", void 0);
ScrollToFirstErrorDirective = __decorate([ __param(0, Inject(FormService)),
    __param(1, Inject(AutoDestroyService))
], ScrollToFirstErrorDirective);

const NEW_ID_PARAM = 'new';
function isAlphanumeric(str) {
    return /^[a-z0-9]+$/i.test(str);
}
// @dynamic
class CustomValidators {
    static passwordsShouldNotMatch(equalControl) {
        let subscribe = false;
        return (control) => {
            if (!subscribe) {
                subscribe = true;
                equalControl.valueChanges.subscribe(() => {
                    control.updateValueAndValidity();
                });
            }
            return equalControl.value === control.value ? { 'passwordsShouldNotMatch': true } : null;
        };
    }
    static passwordsMatch(equalControl) {
        let subscribe = false;
        return (control) => {
            if (!subscribe) {
                subscribe = true;
                equalControl.valueChanges.subscribe(() => {
                    control.updateValueAndValidity();
                });
            }
            return equalControl.value !== control.value && control.value ? { 'passwordsMatch': true } : null;
        };
    }
    static password(formControl) {
        const password = formControl.value;
        const isPasswordValid = () => {
            return password.length >= 12 && password.toLowerCase() !== password && !isAlphanumeric(password);
        };
        return !password || isPasswordValid() ? null : { password: true };
    }
    static noWhitespaceValidator(control) {
        if (control && control.value === '') {
            return null;
        }
        const isWhitespace = (control && control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'whitespace': true };
    }
    static URL(formControl) {
        const URL = formControl.value;
        const isValidURL = (URL) => /^((http|ftp|https):\/\/)?([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/.test(URL);
        return !URL || isValidURL(URL) ? null : { url: true };
    }
    static domain(formControl) {
        const domain = formControl.value;
        const isValidDomain = (value) => /^([a-zA-Z0-9\_]+)$/.test(value);
        return !domain || isValidDomain(domain) ? null : { domain: true };
    }
    static email(formControl) {
        const email = formControl.value.toLowerCase();
        const isValidEmail = (_email) => /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])/.test(_email);
        return !email || isValidEmail(email) ? null : { email: true };
    }
    static bic(formControl) {
        const bic = formControl.value;
        const isValidBic = (_bic) => /^([A-Z]{6}[A-Z2-9]{1}[A-NP-Z1-2]{1})(X{3}|[A-WY-Z0-9]{1}[A-Z0-9]{2})?$/.test(_bic);
        return !bic || isValidBic(bic) ? null : { bic: true };
    }
    static priceAmount(targetAmount, type = PRICE_VALIDATION_TYPE.MIN) {
        return (formControl) => {
            let val = formControl.value;
            const processFormattedValue = function process(str) {
                // Remove unnecessary symbols from formatted value
                str = str.replace(/[^\d.]/g, '');
                return str.replace(/^([^.]*\.)(.*)$/, function (a, b, c) {
                    return b + c.replace(/\./g, '');
                });
            };
            if (typeof val === 'string') {
                val = processFormattedValue(val);
            }
            // Convert value to number
            // TODO: Math.abs is quick fix for mask which doesn't let you enter "-" but on validation we obtain value before mask with "-"
            const valNum = Math.abs(+val);
            const isValidPriceAmountMin = (_amount) => type === PRICE_VALIDATION_TYPE.MIN ? (_amount >= 0 && _amount >= targetAmount) : _amount > 0;
            const isValidPriceAmountMax = (_amount) => {
                if (!_amount) {
                    return true;
                }
                if (type === PRICE_VALIDATION_TYPE.MIN) {
                    return _amount > 0 && _amount <= 100000;
                }
                return _amount > 0 && _amount <= targetAmount;
            };
            return !val || isValidPriceAmountMin(valNum) ? isValidPriceAmountMax(valNum) ? null : (type === PRICE_VALIDATION_TYPE.MIN ? { priceMaxAmount: true } : { priceCustomMaxAmount: true }) : { min: { min: type === PRICE_VALIDATION_TYPE.MIN ? targetAmount : 0.01 } };
        };
    }
}
var PRICE_VALIDATION_TYPE;
(function (PRICE_VALIDATION_TYPE) {
    PRICE_VALIDATION_TYPE["MAX"] = "MAX";
    PRICE_VALIDATION_TYPE["MIN"] = "MIN";
})(PRICE_VALIDATION_TYPE || (PRICE_VALIDATION_TYPE = {}));

let PasswordValidatorComponent = class PasswordValidatorComponent {
    constructor() {
        this.passwordValidators = {
            hasNonAlphanumeric: false,
            hasUpperCaseCharacter: false,
            twelveCharactersLong: false
        };
    }
    set password(password) {
        this.passwordValidators.hasNonAlphanumeric = password ? !isAlphanumeric(password) : false;
        this.passwordValidators.hasUpperCaseCharacter = password.toLowerCase() !== password;
        this.passwordValidators.twelveCharactersLong = password.length > 11;
    }
    ngOnInit() {
    }
};
PasswordValidatorComponent.ɵfac = function PasswordValidatorComponent_Factory(t) { return new (t || PasswordValidatorComponent)(); };
PasswordValidatorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PasswordValidatorComponent, selectors: [["ano-password-validator"]], inputs: { password: "password", hideTitle: "hideTitle" }, decls: 14, vars: 34, consts: [["class", "mb-5", 4, "ngIf"], [1, "bullet-list"], [1, "icon"], [1, "mb-5"]], template: function PasswordValidatorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, PasswordValidatorComponent_p_0_Template, 3, 3, "p", 0);
        ɵngcc0.ɵɵelementStart(1, "ul", 1);
        ɵngcc0.ɵɵelementStart(2, "li");
        ɵngcc0.ɵɵelement(3, "i", 2);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵpipe(5, "localize");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "li");
        ɵngcc0.ɵɵelement(7, "i", 2);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵpipe(9, "localize");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "li");
        ɵngcc0.ɵɵelement(11, "i", 2);
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵpipe(13, "localize");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hideTitle);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("text-success", ctx.passwordValidators.twelveCharactersLong)("text-danger", !ctx.passwordValidators.twelveCharactersLong);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("icon-check", ctx.passwordValidators.twelveCharactersLong)("icon-minus", !ctx.passwordValidators.twelveCharactersLong);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(5, 28, "registration_confirmation.validation.has-12-characters"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("text-success", ctx.passwordValidators.hasUpperCaseCharacter)("text-danger", !ctx.passwordValidators.hasUpperCaseCharacter);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("icon-check", ctx.passwordValidators.hasUpperCaseCharacter)("icon-minus", !ctx.passwordValidators.hasUpperCaseCharacter);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(9, 30, "registration_confirmation.validation.has-uppercase"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("text-success", ctx.passwordValidators.hasNonAlphanumeric)("text-danger", !ctx.passwordValidators.hasNonAlphanumeric);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("icon-check", ctx.passwordValidators.hasNonAlphanumeric)("icon-minus", !ctx.passwordValidators.hasNonAlphanumeric);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(13, 32, "registration_confirmation.validation.has-non-alphanumeric"), " ");
    } }, directives: [ɵngcc1.NgIf], pipes: [LocalizationPipe], styles: [".bullet-list[_ngcontent-%COMP%]{margin-bottom:25px;padding-left:15px;list-style-type:none}.bullet-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{font-size:12px}"] });
__decorate([
    Input()
], PasswordValidatorComponent.prototype, "hideTitle", void 0);
__decorate([
    Input()
], PasswordValidatorComponent.prototype, "password", null);

let BillsTableComponent = class BillsTableComponent {
    constructor() {
        this.timeRangeFilter$ = new EventEmitter();
    }
    ngOnInit() {
    }
    onTimeRangeFilter(event) {
        this.timeRangeFilter$.emit(event);
    }
};
BillsTableComponent.ɵfac = function BillsTableComponent_Factory(t) { return new (t || BillsTableComponent)(); };
BillsTableComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BillsTableComponent, selectors: [["ano-bills-table"]], viewQuery: function BillsTableComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c20, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.table = _t.first);
    } }, inputs: { config: "config", timeRangeConfig: "timeRangeConfig" }, outputs: { timeRangeFilter$: "timeRangeFilter$" }, decls: 2, vars: 6, consts: [[4, "ngIf"], [1, "bills", 3, "tableConfig", "showDatepicker", "startFromAll", "withSearch", "timeRangeConfig", "timeRangeFilter$"]], template: function BillsTableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BillsTableComponent_h4_0_Template, 4, 3, "h4", 0);
        ɵngcc0.ɵɵelementStart(1, "ano-table", 1);
        ɵngcc0.ɵɵlistener("timeRangeFilter$", function BillsTableComponent_Template_ano_table_timeRangeFilter__1_listener($event) { return ctx.onTimeRangeFilter($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("tableConfig", ctx.config.tableConfig)("showDatepicker", ctx.config.withTimeRange)("startFromAll", true)("withSearch", ctx.config.withSearch)("timeRangeConfig", ctx.config.withTimeRange && ctx.timeRangeConfig);
    } }, directives: [ɵngcc1.NgIf, TableComponent], pipes: [LocalizationPipe], styles: [""] });
__decorate([
    ViewChild('tableComponent', { static: true })
], BillsTableComponent.prototype, "table", void 0);
__decorate([
    Input()
], BillsTableComponent.prototype, "config", void 0);
__decorate([
    Input()
], BillsTableComponent.prototype, "timeRangeConfig", void 0);
__decorate([
    Output()
], BillsTableComponent.prototype, "timeRangeFilter$", void 0);

let DateFormatPipe = class DateFormatPipe {
    transform(timestamp, format = 'DD MMM YYYY', localTime, ...args) {
        return DateHelper.formatDate(timestamp, format, localTime);
    }
};
DateFormatPipe.ɵfac = function DateFormatPipe_Factory(t) { return new (t || DateFormatPipe)(); };
DateFormatPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "dateFormat", type: DateFormatPipe, pure: true });

function getWithDecimals(val) {
    if (val === '') {
        return '';
    }
    // Format value with thousands separator
    const formatWithThousandsSeparator = (val) => val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    val = formatWithThousandsSeparator(val);
    const config = {
        decimalScale: 2,
        prefix: '$',
    };
    const [integer, decimal] = val.split('.');
    if (decimal) {
        const difference = config.decimalScale - decimal.length;
        return integer + '.' + decimal.split('').concat(Array(difference).fill(0)).join('');
    }
    else {
        return val + `${val.includes('.') ? '' : '.'}00`;
    }
}

let CurrencyPipe = class CurrencyPipe {
    transform(value, withSymbol = true) {
        if (value === null || value === void 0 ? void 0 : value.currency) {
            let res = (withSymbol ? CUR_SYM[value.currency] + ' ' : '') + getWithDecimals(Math.abs(value.amount).toFixed(2));
            if (Math.sign(value.amount) === -1) {
                res = '-' + res;
            }
            return res;
        }
        return null;
    }
};
CurrencyPipe.ɵfac = function CurrencyPipe_Factory(t) { return new (t || CurrencyPipe)(); };
CurrencyPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "currency", type: CurrencyPipe, pure: true });

// @dynamic
let ModalComponent = class ModalComponent {
    constructor(data) {
        this.data = data;
        this.dismissButtonText = 'common.button.close';
        this.submitButtonText = 'common.button.apply';
        this.dismissButtonClass = 'btn-secondary';
        this.loadingText = '';
        this.isConfirmation = false;
        this.withoutSubmit = false;
        this.isLoading = false;
        this.validate = new EventEmitter();
    }
    ngOnInit() {
        if (this.isConfirmation) {
            this.submitButtonText = 'common.modal.button.confirm';
            this.dismissButtonText = 'common.modal.button.deny';
        }
    }
    dismiss() {
        this.dialogRef.close(false);
    }
    apply() {
        if (this.form && this.form.invalid) {
            this.validate.emit();
            return;
        }
        this.dialogRef.close(true);
    }
};
ModalComponent.ɵfac = function ModalComponent_Factory(t) { return new (t || ModalComponent)(ɵngcc0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
ModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ModalComponent, selectors: [["ano-modal"]], inputs: { dismissButtonText: "dismissButtonText", submitButtonText: "submitButtonText", dismissButtonClass: "dismissButtonClass", loadingText: "loadingText", isConfirmation: "isConfirmation", withoutSubmit: "withoutSubmit", isLoading: "isLoading", dialogRef: "dialogRef", title: "title", form: "form" }, outputs: { validate: "validate" }, ngContentSelectors: _c16, decls: 7, vars: 5, consts: [[1, "modal", "show"], ["role", "document", 1, "modal-dialog", "modal-dialog-centered"], [1, "modal-content"], ["class", "modal-header", 4, "ngIf"], ["class", "modal-body", 4, "ngIf"], ["class", "modal-footer", 4, "ngIf"], [3, "isOpen", "loadingText"], [1, "modal-header"], ["id", "exampleModalLabel", 1, "modal-title", 3, "innerHTML"], [1, "modal-body"], [4, "ngIf"], [1, "modal-footer"], ["type", "button", "data-dismiss", "modal", 3, "click"], ["type", "button", "class", "btn btn-primary", 3, "click", 4, "ngIf"], ["type", "button", 1, "btn", "btn-primary", 3, "click"]], template: function ModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, ModalComponent_div_3_Template, 2, 1, "div", 3);
        ɵngcc0.ɵɵtemplate(4, ModalComponent_div_4_Template, 3, 1, "div", 4);
        ɵngcc0.ɵɵtemplate(5, ModalComponent_div_5_Template, 5, 7, "div", 5);
        ɵngcc0.ɵɵelement(6, "ano-loader", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isLoading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isLoading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isLoading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("isOpen", ctx.isLoading)("loadingText", ctx.loadingText);
    } }, directives: [ɵngcc1.NgIf, LoaderComponent], pipes: [LocalizationPipe], styles: [".show[_ngcontent-%COMP%]{display:block}  .cdk-overlay-dark-backdrop{background:#000}  .cdk-overlay-backdrop-showing{opacity:.8!important}"] });
__decorate([
    Input()
], ModalComponent.prototype, "dialogRef", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "title", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "dismissButtonText", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "submitButtonText", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "dismissButtonClass", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "loadingText", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "form", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "isConfirmation", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "withoutSubmit", void 0);
__decorate([
    Input()
], ModalComponent.prototype, "isLoading", void 0);
__decorate([
    Output()
], ModalComponent.prototype, "validate", void 0);
ModalComponent = __decorate([ __param(0, Inject(MAT_DIALOG_DATA))
], ModalComponent);

let WidgetComponent = class WidgetComponent {
    constructor() { }
    ngOnInit() {
    }
};
WidgetComponent.ɵfac = function WidgetComponent_Factory(t) { return new (t || WidgetComponent)(); };
WidgetComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: WidgetComponent, selectors: [["ano-widget"]], inputs: { config: "config" }, decls: 13, vars: 20, consts: [[1, "title"], [1, "block"], ["class", "block", 4, "ngIf"], [4, "ngIf"], ["class", "info-table", 4, "ngIf"], [1, "info-table"], ["class", "info-container", 4, "ngFor", "ngForOf"], [1, "info-container"], [1, "amount"]], template: function WidgetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "h3", 0);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "currency");
        ɵngcc0.ɵɵpipe(4, "number");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "span", 1);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, WidgetComponent_span_7_Template, 2, 1, "span", 2);
        ɵngcc0.ɵɵelementStart(8, "span", 1);
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵtemplate(10, WidgetComponent_ng_container_10_Template, 2, 1, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, WidgetComponent_div_11_Template, 2, 1, "div", 4);
        ɵngcc0.ɵɵelement(12, "i");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("widget ", ctx.config.type, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate((ctx.config == null ? null : ctx.config.currency) ? ɵngcc0.ɵɵpipeBind1(3, 12, ɵngcc0.ɵɵpureFunction2(17, _c21, ctx.config.amount, ctx.config == null ? null : ctx.config.currency)) : ɵngcc0.ɵɵpipeBind2(4, 14, ctx.config.amount, ctx.config == null ? null : ctx.config.toFixed));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.config.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.additionalAmountInfo);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1("", ctx.config.period, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.additionalPeriodInfo);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config == null ? null : ctx.config.infoTable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("icon icon-", ctx.config.icon, "");
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc1.NgForOf]; }, pipes: function () { return [CurrencyPipe, NumberPipe]; }, styles: [".widget[_ngcontent-%COMP%]{border-radius:5px;padding:13px 15px 12px 20px;color:#fff;position:relative;overflow:hidden;margin-bottom:20px}.widget[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-size:1.9rem;line-height:1;color:#fff;font-family:Poppins-Bold,sans-serif;text-transform:none;margin-bottom:3px}.widget[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:14px;display:block;letter-spacing:.02rem}.widget[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{position:absolute;right:-4px;bottom:-2px;font-size:50px}.widget.primary[_ngcontent-%COMP%]{background:#007e8c}.widget.success[_ngcontent-%COMP%]{background:#bad668}.widget.warning[_ngcontent-%COMP%]{background:#ffbe00}.info-table[_ngcontent-%COMP%]{margin-top:5px;display:flex;flex-direction:column}.info-table[_ngcontent-%COMP%]   .info-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between}"] });
__decorate([
    Input()
], WidgetComponent.prototype, "config", void 0);

let ScatterChartComponent = class ScatterChartComponent {
    constructor() {
        this.id = 1;
        this.margin = 45;
        this.width = 830;
        this.offset = 40;
        this.height = 200;
    }
    ngAfterViewInit() {
        this.initChatLines();
        this.initChart();
    }
    initChatLines() {
        this.chartLines = {};
        this.legend.forEach((item) => {
            this.chartLines[item.label] = true;
        });
    }
    initChart() {
        this.calculateMax();
        this.createSvg();
        this.drawChart();
    }
    calculateMax() {
        this.max = 0;
        const availableLines = Object.entries(this.chartLines).map(([key, value]) => {
            if (value) {
                return key;
            }
        }).filter(item => item);
        this.data.forEach((item) => {
            Object.entries(item.values).forEach(([key, value]) => {
                if (!availableLines.includes(key) && (availableLines === null || availableLines === void 0 ? void 0 : availableLines.length)) {
                    return;
                }
                if (value > this.max) {
                    this.max = value + (value * 0.15);
                }
            });
        });
    }
    createSvg() {
        this.svg = d3.select(`#chart-svg-${this.id}`)
            // .attr('width', this.width + this.margin)
            // .attr('height', this.height + (this.margin * 2 + 10))
            .attr('viewBox', `0 0 ${this.width + this.margin} ${this.height + (this.margin * 2 + 10)}`)
            .append('g')
            .attr('transform', 'translate(' + this.offset + ',' + this.margin + ')');
    }
    drawChart() {
        this.drawPlot();
        this.addStyles();
    }
    drawPlot() {
        this.initTooltip();
        this.initGroups();
        this.initColors();
        this.createAxisX();
        this.createAxisY();
        this.createLines();
        this.createPoints();
    }
    initTooltip() {
        this.tooltip = d3.select(`#tooltip-container-${this.id}`).append('div')
            .attr('class', 'tooltip')
            .style('opacity', 0);
    }
    initGroups() {
        this.groups = Object.entries(this.chartLines).map((item) => {
            if (item[1]) {
                return item[0];
            }
        }).filter((item) => item);
        let removeDots = false;
        this.dataReadyLines = this.groups.map((name) => {
            let firstNull = false;
            return {
                name,
                values: this.data.filter(d => {
                    return d.values[name] !== null;
                }).map((d) => {
                    return { time: d.date, value: d.values[name], name: name };
                })
            };
        });
        this.dataReadyDots = _.cloneDeep(this.dataReadyLines);
    }
    initColors() {
        this.colors = d3.scaleOrdinal()
            .domain(this.groups)
            .range(Object.values(this.groups.map((item) => this.colorScheme[item])));
    }
    createAxisX() {
        const domain = Object.values(this.categories).map((val) => +val);
        this.x = d3.scaleLinear()
            .domain([1, domain.length])
            .range([0, this.width - 5]);
        this.svg.append('g')
            .attr('class', 'axis-x')
            .attr('transform', 'translate(0,' + this.height + ')')
            .call(d3.axisBottom(this.x).ticks(domain.length)
            .tickSizeOuter(0)
            .tickSizeInner(0));
    }
    createAxisY() {
        this.y = d3.scaleLinear()
            .domain([0, this.max > 5 ? this.max : 5])
            .range([this.height, 0]);
        const g = this.svg.append('g').attr('class', 'axis-y');
        g.call(d3.axisLeft(this.y).ticks(5)
            .tickSizeOuter(0)
            .tickSizeInner(0));
        g.append('g').append('g')
            .attr('class', 'grid-line')
            .call(d3.axisLeft(this.y)
            .tickSize(-this.width)
            .tickFormat(''));
    }
    createLines() {
        const line = d3.line()
            .x((d) => this.x(+d.time))
            .y((d) => this.y(+d.value));
        this.svg.selectAll('myLines')
            .data(this.dataReadyLines)
            .enter()
            .append('path')
            .attr('d', function (d) {
            return line(d.values);
        })
            .attr('stroke', (d) => this.colors(d.name))
            .style('stroke-width', 1)
            .style('fill', 'none');
    }
    createPoints() {
        const _this = this;
        this.svg
            .selectAll('myDots')
            .data(this.dataReadyDots)
            .enter()
            .append('g')
            .style('fill', (d) => this.colors(d.name))
            .selectAll('myPoints')
            .data(function (d) {
            return d.values;
        })
            .enter()
            .append('circle')
            .attr('cx', (d) => this.x(d.time))
            .attr('cy', (d) => this.y(d.value))
            .attr('r', 5)
            .attr('stroke', 'white')
            .on('mouseover', function (d) {
            _this.tooltip.transition()
                .duration(200)
                .style('opacity', .9);
            _this.tooltip.html(new Intl.NumberFormat('de-DE').format(d.value) + '<br/>')
                .style('background-color', _this.colors(d.name))
                .style('left', (d3.event.layerX) + 'px')
                .style('top', (d3.event.layerY - 28) + 'px');
        })
            .on('mouseout', function (d) {
            _this.tooltip.transition()
                .duration(500)
                .style('opacity', 0);
        });
    }
    addStyles() {
        d3.select('.axis-y .tick').filter(function (d) {
            return d === 0;
        }).remove();
        d3.selectAll('.axis-y .tick text').attr('x', '-10');
        d3.selectAll('.axis-x .tick text').attr('y', '10');
    }
    rerenderChart(label) {
        if (this.chartLines.hasOwnProperty(label)) {
            this.chartLines[label] = !this.chartLines[label];
        }
        d3.selectAll(`#chart-svg-${this.id} > *`).remove();
        setTimeout(() => {
            this.initChart();
        });
    }
};
ScatterChartComponent.ɵfac = function ScatterChartComponent_Factory(t) { return new (t || ScatterChartComponent)(); };
ScatterChartComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ScatterChartComponent, selectors: [["ano-scatter-chart"]], inputs: { id: "id", margin: "margin", width: "width", offset: "offset", data: "data", legend: "legend", categories: "categories", colorScheme: "colorScheme" }, decls: 3, vars: 2, consts: [[1, "chart-container"], [3, "id"]], template: function ScatterChartComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelement(1, "svg", 1);
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelement(2, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", "chart-svg-" + ctx.id);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", "tooltip-container-" + ctx.id);
    } }, styles: [".tooltip{position:absolute;text-align:center;padding:7px 28px;font:12px sans-serif;background:#b0c4de;border:1px hsla(0,0%,100%,.9);color:#fff;border-radius:4px;pointer-events:none;font-size:medium;font-weight:800}.chart-container[_ngcontent-%COMP%]{position:relative}"] });
__decorate([
    Input()
], ScatterChartComponent.prototype, "data", void 0);
__decorate([
    Input()
], ScatterChartComponent.prototype, "legend", void 0);
__decorate([
    Input()
], ScatterChartComponent.prototype, "categories", void 0);
__decorate([
    Input()
], ScatterChartComponent.prototype, "colorScheme", void 0);
__decorate([
    Input()
], ScatterChartComponent.prototype, "id", void 0);
__decorate([
    Input()
], ScatterChartComponent.prototype, "margin", void 0);
__decorate([
    Input()
], ScatterChartComponent.prototype, "width", void 0);
__decorate([
    Input()
], ScatterChartComponent.prototype, "offset", void 0);

let LegendBoxComponent = class LegendBoxComponent {
    constructor() {
        this.change = new EventEmitter();
    }
    ngOnInit() {
    }
    onCheck(label) {
        this.change.emit(label);
    }
};
LegendBoxComponent.ɵfac = function LegendBoxComponent_Factory(t) { return new (t || LegendBoxComponent)(); };
LegendBoxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LegendBoxComponent, selectors: [["ano-legend-box"]], inputs: { legend: "legend", colorScheme: "colorScheme", readOnly: "readOnly", suffix: "suffix" }, outputs: { change: "change" }, decls: 2, vars: 1, consts: [[1, "box-checkbox"], ["class", "custom-checkbox", 4, "ngFor", "ngForOf"], [1, "custom-checkbox"], ["type", "checkbox", 3, "checked", "click", 4, "ngIf"], [1, "checkmark", 3, "ngStyle"], ["type", "checkbox", 3, "checked", "click"]], template: function LegendBoxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, LegendBoxComponent_label_1_Template, 8, 9, "label", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.legend);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgStyle], pipes: [LocalizationPipe], styles: [""] });
__decorate([
    Input()
], LegendBoxComponent.prototype, "legend", void 0);
__decorate([
    Input()
], LegendBoxComponent.prototype, "colorScheme", void 0);
__decorate([
    Input()
], LegendBoxComponent.prototype, "readOnly", void 0);
__decorate([
    Input()
], LegendBoxComponent.prototype, "suffix", void 0);
__decorate([
    Output()
], LegendBoxComponent.prototype, "change", void 0);

let PieChartComponent = class PieChartComponent {
    constructor() {
        this.width = 300;
        this.height = 300;
        this.rotate = 0;
        this.id = 1;
        this.margin = 5;
        this.colorScheme = {
            label1: '#0e54a9',
            label2: '#0c1d3f',
            label3: '#007e8c',
            label4: '#ffbe00',
            label5: '#bad668'
        };
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        const _this = this;
        this.radius = Math.min(this.width, this.height) / 2 - this.margin;
        const svg = d3.select(`#pie-chart-${this.id}`)
            .attr("width", this.width)
            .attr("height", this.height)
            .append("g")
            .attr("transform", "translate(" + this.width / 2 + "," + this.height / 2 + "), rotate(" + this.rotate + ")");
        this.tooltip = d3.select(`#tooltip-container-${this.id}`).append('div')
            .attr('class', 'tooltip')
            .style('opacity', 0);
        let color = d3.scaleOrdinal()
            .domain(this.data)
            .range(Object.values(this.colorScheme));
        let pie = d3.pie()
            .value(function (d) {
            return d.value;
        });
        let data_ready = pie(d3.entries(this.data));
        // Build the pie chart: Basically, each part of the pie is a path that we build using the arc function.
        svg
            .selectAll('whatever')
            .data(data_ready)
            .enter()
            .append('path')
            .attr('d', d3.arc()
            .innerRadius(0)
            .outerRadius(this.radius))
            .attr('fill', function (d) {
            return (color(d.data.key));
        });
        svg
            .selectAll('path')
            .on('mouseover', function (d) {
            _this.tooltip.transition()
                .duration(200)
                .style('opacity', .9);
            _this.tooltip.html(new Intl.NumberFormat('de-DE').format(d.value) + '%<br/>')
                .style('background-color', color(d.data.key))
                .style('left', (d3.event.layerX) + 'px')
                .style('top', (d3.event.layerY - 28) + 'px');
        })
            .on('mouseout', function (d) {
            _this.tooltip.transition()
                .duration(500)
                .style('opacity', 0);
        });
    }
};
PieChartComponent.ɵfac = function PieChartComponent_Factory(t) { return new (t || PieChartComponent)(); };
PieChartComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PieChartComponent, selectors: [["ano-pie-chart"]], inputs: { width: "width", height: "height", rotate: "rotate", id: "id", colorScheme: "colorScheme", data: "data" }, decls: 3, vars: 2, consts: [[1, "chart-container"], [3, "id"]], template: function PieChartComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelement(1, "svg", 1);
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelement(2, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", "pie-chart-" + ctx.id);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", "tooltip-container-" + ctx.id);
    } }, styles: [_c23] });
__decorate([
    Input()
], PieChartComponent.prototype, "data", void 0);
__decorate([
    Input()
], PieChartComponent.prototype, "width", void 0);
__decorate([
    Input()
], PieChartComponent.prototype, "height", void 0);
__decorate([
    Input()
], PieChartComponent.prototype, "rotate", void 0);
__decorate([
    Input()
], PieChartComponent.prototype, "id", void 0);
__decorate([
    Input()
], PieChartComponent.prototype, "colorScheme", void 0);

let BarChartComponent = class BarChartComponent {
    constructor() {
        this.id = 1;
        this.colorScheme = {
            label1: '#0e54a9',
            label2: '#0c1d3f',
            label3: '#007e8c',
            label4: '#ffbe00',
            label5: '#bad668'
        };
        this.margin = { top: 20, right: 30, bottom: 70, left: 60 };
        this.currency = 'EUR';
        this.height = 360 - this.margin.top - this.margin.bottom;
    }
    set width(width) {
        this._width = (width || 800) - this.margin.left - this.margin.right;
    }
    get width() {
        return this._width;
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        const _this = this;
        this.max = 0;
        this.data.forEach((item) => {
            if (item.value > this.max) {
                this.max = item.value * 1.2;
            }
        });
        let svg = d3.select('#bar-chart')
            // .attr('width', this.width + this.margin.right + this.margin.left)
            // .attr('height', this.height + this.margin.top + this.margin.bottom)
            .attr("viewBox", `0 0 770 360`)
            .append('g');
        // .attr('transform',
        //     'translate(' + this.margin.left + ',' + this.margin.top + ')');
        const groups = this.data.map((item) => item.group);
        let color = d3.scaleOrdinal()
            .domain(groups)
            .range(Object.values(this.colorScheme));
        this.tooltip = d3.select(`#tooltip-container-${this.id}`).append('div')
            .attr('class', 'tooltip')
            .style('opacity', 0);
        // X axis
        let x = d3.scaleBand()
            .range([0, this.width])
            .domain(this.data.map(function (d) { return d.group; }))
            .padding(0.75);
        svg.append('g')
            .attr('class', 'axis-x')
            .attr('transform', 'translate(0,' + this.height + ')')
            .call(d3.axisBottom(x).ticks(this.data.length)
            .tickSizeOuter(0)
            .tickSizeInner(0));
        // Add Y axis
        let y = d3.scaleLinear()
            .domain([0, this.max || 10])
            .range([this.height, 0]);
        const g = svg.append('g').attr('class', 'axis-y');
        g.call(d3.axisLeft(y).ticks(5)
            .tickSizeOuter(0)
            .tickSizeInner(0));
        g.append('g').append('g')
            .attr('class', 'grid-line')
            .call(d3.axisLeft(y)
            .tickSize(-this.width)
            .tickFormat(''));
        let u = svg.selectAll('rect')
            .data(this.data);
        u.enter()
            .merge(u)
            .append('rect')
            .attr('x', function (d) { return x(d.group); })
            .attr('y', function (d) { return y(d.value); })
            .attr('width', 70)
            .attr('rx', 5)
            .attr('ry', 5)
            .attr('height', (d) => { return this.height - y(d.value); })
            .attr('fill', function (d) { return (color(d.group)); });
        u.enter()
            .append('rect')
            .merge(u)
            .attr('x', function (d) { return x(d.group); })
            .attr('y', function (d) { return y(d.value) + 5; })
            .attr('width', 70)
            .attr('height', (d) => { return this.height - y(d.value) - 5; })
            .attr('fill', function (d) { return (color(d.group)); });
        svg
            .selectAll('rect')
            .on('mouseover', function (d) {
            _this.tooltip.transition()
                .duration(200)
                .style('opacity', .9);
            _this.tooltip.html(_this.currency + ' ' + new Intl.NumberFormat('de-DE').format(d.value))
                .style('background-color', color(d.group))
                .style('left', (d3.event.layerX) + 'px')
                .style('top', (d3.event.layerY - 28) + 'px');
        })
            .on('mouseout', function (d) {
            _this.tooltip.transition()
                .duration(500)
                .style('opacity', 0);
        });
        this.addStyles();
    }
    addStyles() {
        d3.select('.axis-y .tick').filter(function (d) { return d === 0; }).remove();
        d3.selectAll('.axis-y .tick text').attr('x', '-10');
        d3.selectAll('.axis-x .tick text').attr('y', '10');
    }
};
BarChartComponent.ɵfac = function BarChartComponent_Factory(t) { return new (t || BarChartComponent)(); };
BarChartComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BarChartComponent, selectors: [["ano-bar-chart"]], inputs: { id: "id", colorScheme: "colorScheme", currency: "currency", width: "width", data: "data" }, decls: 3, vars: 1, consts: [[1, "chart-container"], ["id", "bar-chart"], [3, "id"]], template: function BarChartComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelement(1, "svg", 1);
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelement(2, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("id", "tooltip-container-" + ctx.id);
    } }, styles: [_c23] });
__decorate([
    Input()
], BarChartComponent.prototype, "data", void 0);
__decorate([
    Input()
], BarChartComponent.prototype, "id", void 0);
__decorate([
    Input()
], BarChartComponent.prototype, "colorScheme", void 0);
__decorate([
    Input()
], BarChartComponent.prototype, "width", null);
__decorate([
    Input()
], BarChartComponent.prototype, "currency", void 0);

const commonDeclarations = [];
const commonImports = [
    A11yModule,
    ClipboardModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    PortalModule,
    ScrollingModule,
];
const commonExports = [
    A11yModule,
    ClipboardModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    PortalModule,
    ScrollingModule,
];
const routes = [];

let MaterialModule = class MaterialModule {
};
MaterialModule.ɵfac = function MaterialModule_Factory(t) { return new (t || MaterialModule)(); };
MaterialModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MaterialModule });
MaterialModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            ...commonImports,
            CommonModule,
        ], A11yModule,
        ClipboardModule,
        CdkStepperModule,
        CdkTableModule,
        CdkTreeModule,
        DragDropModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatBottomSheetModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatStepperModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatTreeModule,
        PortalModule,
        ScrollingModule] });

let ImagePipe = class ImagePipe {
    constructor(environment) {
        this.environment = environment;
    }
    transform(value, ...args) {
        if (value.startsWith('data:image')) {
            return value;
        }
        return this.environment.backendApiHost + value;
    }
};
ImagePipe.ɵfac = function ImagePipe_Factory(t) { return new (t || ImagePipe)(ɵngcc0.ɵɵdirectiveInject(ENVIRONMENT, 16)); };
ImagePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "image", type: ImagePipe, pure: true });
ImagePipe = __decorate([ __param(0, Inject(ENVIRONMENT))
], ImagePipe);

let LoadingService = class LoadingService {
    constructor() {
        // public loading: EventEmitter<boolean> = new EventEmitter();
        this.loading = new BehaviorSubject(false);
    }
    loadingStart() {
        this.loading.next(true);
    }
    loadingEnd() {
        this.loading.next(false);
    }
};
LoadingService.ɵfac = function LoadingService_Factory(t) { return new (t || LoadingService)(); };
LoadingService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LoadingService_Factory() { return new LoadingService(); }, token: LoadingService, providedIn: "root" });

let FormComponent = class FormComponent {
    constructor(loadingService, formService) {
        this.loadingService = loadingService;
        this.formService = formService;
        this.clearImageButton = false;
        this.columnImageUploader = false;
        this.photoUrl = '';
        this.avatar = '';
        this.forcedEditMode = false;
        this.defaultFields = false;
        this.forcedViewMode = false;
        this.withoutSave = false;
        this.showErrorsForViewMode = false;
        this.isLightForm = false;
        this.materialForm = false;
        this.borderForm = false;
        this.inlineForm = true;
        this.isButtons = true;
        this.submit$ = new EventEmitter();
        this.cancel$ = new EventEmitter();
        this.onFileUpload$ = new EventEmitter();
        this.clearImage$ = new EventEmitter();
        this.avatar$ = new EventEmitter();
        this.deleteAvatar$ = new EventEmitter();
        this.rawFormData = {};
        this.rawImage = '';
        this.isEditMode = false;
        this.INPUT_TYPES = INPUT_TYPES;
    }
    ngOnInit() {
    }
    changeEditMode() {
        if (this.forcedEditMode) {
            this.form.markAsUntouched();
            this.submit$.emit(true);
            return;
        }
        if (this.isEditMode) {
            this.form.markAllAsTouched();
            this.form.updateValueAndValidity();
            if (this.form.invalid) {
                this.formService.submitInvalid$.emit();
                return;
            }
            if (this.success$) {
                this.success$.subscribe(res => {
                    this.isEditMode = false;
                });
                this.submit$.emit(true);
                return;
            }
        }
        this.isEditMode = !this.isEditMode;
        if (this.isEditMode) {
            this.mapFormToData();
        }
        if (!this.isEditMode) {
            this.form.markAsUntouched();
            this.submit$.emit(true);
        }
    }
    cancel() {
        this.form.reset();
        this.resetFormToRaw();
        this.isEditMode = false;
        this.cancel$.emit(true);
    }
    editButtonText() {
        if (this.isEditMode || this.forcedEditMode) {
            return this.submitButtonText || 'common.button.apply';
        }
        return 'common.button.edit';
    }
    clearForm() {
        this.form.reset();
        Object.keys(this.form.controls).forEach(control => this.form.get(control).patchValue(''));
    }
    resetFormToRaw() {
        Object.keys(this.form.controls).forEach(control => this.form.get(control).patchValue(this.rawFormData[control]));
        this.photoUrl = this.rawImage;
    }
    uploadPreviewPhoto(event) {
        this.onFileUpload$.emit(event);
    }
    clearImage(event) {
        this.clearImage$.emit(event);
    }
    mapFormToData() {
        Object.keys(this.form.controls).forEach(control => this.rawFormData[control] = this.form.get(control).value);
        this.rawImage = this.photoUrl;
    }
    fileBrowseHandler(files) {
        this.prepareFilesList(files);
    }
    prepareFilesList(files) {
        this.avatar$.emit(files);
    }
    getStartDate() {
        if (this.form.controls.hasOwnProperty('startTimestamp')) {
            return this.form.get('startTimestamp').value;
        }
        return null;
    }
    getEndDate() {
        if (this.form.controls.hasOwnProperty('endTimestamp')) {
            return this.form.get('endTimestamp').value;
        }
        return null;
    }
    getLink(value) {
        if (value && !value.startsWith('http://') && !value.startsWith('https://')) {
            return 'https://' + value;
        }
        return value;
    }
    deleteAvatar() {
        this.deleteAvatar$.emit();
    }
};
FormComponent.ɵfac = function FormComponent_Factory(t) { return new (t || FormComponent)(ɵngcc0.ɵɵdirectiveInject(LoadingService), ɵngcc0.ɵɵdirectiveInject(FormService)); };
FormComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormComponent, selectors: [["ano-form"]], inputs: { clearImageButton: "clearImageButton", columnImageUploader: "columnImageUploader", photoUrl: "photoUrl", avatar: "avatar", forcedEditMode: "forcedEditMode", defaultFields: "defaultFields", forcedViewMode: "forcedViewMode", withoutSave: "withoutSave", showErrorsForViewMode: "showErrorsForViewMode", isLightForm: "isLightForm", materialForm: "materialForm", borderForm: "borderForm", inlineForm: "inlineForm", isButtons: "isButtons", title: "title", subTitle: "subTitle", description: "description", form: "form", fieldsConfig: "fieldsConfig", withSideColumn: "withSideColumn", withAvatar: "withAvatar", submitButtonText: "submitButtonText", cancelButtonText: "cancelButtonText", cancelButtonClass: "cancelButtonClass", mainColMd7: "mainColMd7", mainColMd8: "mainColMd8", buttonsCol5: "buttonsCol5", passwordValidation: "passwordValidation", hidePasswordValidation: "hidePasswordValidation", success$: "success$", labelWidth: "labelWidth", fieldWidth: "fieldWidth", classList: "classList" }, outputs: { submit$: "submit$", cancel$: "cancel$", onFileUpload$: "onFileUpload$", clearImage$: "clearImage$", avatar$: "avatar$", deleteAvatar$: "deleteAvatar$" }, ngContentSelectors: _c16, decls: 13, vars: 43, consts: [["anoScrollToFirstError", "", 3, "forms"], [3, "isOpen"], [1, "row", "row-align-stretch"], [1, "mr-auto"], [1, "pb-10"], ["class", "body-title", 3, "mb-25", 4, "ngIf"], [4, "ngIf"], ["autocomplete", "off", 1, "inline-form", "validation-absolute", 3, "formGroup"], [4, "ngFor", "ngForOf"], ["class", "col", 4, "ngIf"], ["class", "align-self-end", 3, "edit-col", "col", "col-5", 4, "ngIf"], [1, "body-title"], [1, "row", "row-padding-0"], [3, "class", 4, "ngIf"], ["class", "form-control lnk mb-15", "target", "_blank", 3, "href", 4, "ngIf"], [3, "formControl", "defaultForm", "disabled", "invalid", "isEditMode", "multimediaUrl", "errors", "isTouched", "accept", "config", 4, "ngIf"], ["class", "form-group", 3, "id", 4, "ngIf"], ["class", "text-primary", 4, "ngIf"], ["class", "light", 4, "ngIf"], [1, "text-primary"], [1, "light"], ["target", "_blank", 1, "form-control", "lnk", "mb-15", 3, "href"], [3, "formControl", "defaultForm", "disabled", "invalid", "isEditMode", "multimediaUrl", "errors", "isTouched", "accept", "config"], [1, "form-group", 3, "id"], [3, "formControl", "defaultForm", "name", "invalid", "disabled", "errors", "isTouched", "columnImageUploader", "clearImageButton", "multimediaUrl", "accept", "config", "isEditMode", "onFileUpload$", "clearImage$"], [1, "col"], [1, "col-between"], [1, "image-wrapper"], [1, "user-photo"], ["class", "close", 3, "click", 4, "ngIf"], ["class", "img-responsive", "alt", "avatar", 3, "src", 4, "ngIf"], ["class", "img-responsive", "src", "/assets/img/mock/no-user-photo.png", "alt", "avatar", 4, "ngIf"], ["type", "file", "id", "fileDropRef", "accept", "image/*", "multiple", "", 3, "disabled", "change"], ["class", "icon icon-user-edit", 4, "ngIf"], ["class", "m-button align-self-end", 4, "ngIf"], [1, "close", 3, "click"], [1, "icon", "icon-trash2"], ["alt", "avatar", 1, "img-responsive", 3, "src"], ["src", "/assets/img/mock/no-user-photo.png", "alt", "avatar", 1, "img-responsive"], [1, "icon", "icon-user-edit"], [1, "m-button", "align-self-end"], [3, "class", "click", 4, "ngIf"], [1, "btn", 3, "click"], [3, "click"], [1, "align-self-end"], [1, "validator-container"], [3, "hideTitle", "password", 4, "ngIf"], ["class", "buttons-container", 4, "ngIf"], [3, "hideTitle", "password"], [1, "buttons-container"], [1, "btn", "btn-success", 3, "click"]], template: function FormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "ano-loader", 1);
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵtemplate(6, FormComponent_h2_6_Template, 4, 6, "h2", 5);
        ɵngcc0.ɵɵtemplate(7, FormComponent_p_7_Template, 3, 3, "p", 6);
        ɵngcc0.ɵɵprojection(8);
        ɵngcc0.ɵɵelementStart(9, "form", 7);
        ɵngcc0.ɵɵtemplate(10, FormComponent_ng_container_10_Template, 2, 1, "ng-container", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, FormComponent_div_11_Template, 10, 8, "div", 9);
        ɵngcc0.ɵɵtemplate(12, FormComponent_div_12_Template, 4, 8, "div", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("bg-white ", ctx.classList, "");
        ɵngcc0.ɵɵclassProp("card", !ctx.isLightForm)("card-with-password-validation", ctx.passwordValidation);
        ɵngcc0.ɵɵproperty("forms", ɵngcc0.ɵɵpureFunction1(41, _c26, ctx.form));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("isOpen", ɵngcc0.ɵɵpipeBind1(2, 39, ctx.loadingService.loading));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵclassProp("col", ctx.forcedViewMode || ctx.withoutSave)("col-md-8", !ctx.forcedViewMode && !ctx.withoutSave && !ctx.mainColMd7 || ctx.passwordValidation || ctx.mainColMd8)("col-md-7", ctx.mainColMd7);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("card-body", !ctx.isLightForm);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.description);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("light-form", ctx.isLightForm)("inline-form", ctx.inlineForm)("form-without-border", !ctx.borderForm && ctx.inlineForm)("material-form", ctx.materialForm)("full-20", ctx.isLightForm)("border-form", ctx.borderForm)("edit", (ctx.isEditMode || ctx.forcedEditMode) && !ctx.defaultFields)("view", !ctx.isEditMode && !ctx.forcedEditMode || ctx.defaultFields);
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.fieldsConfig);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.withAvatar);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.withAvatar && !ctx.forcedViewMode && !ctx.hidePasswordValidation);
    } }, directives: [ScrollToFirstErrorDirective, LoaderComponent, ɵngcc1.NgIf, ɵngcc4.ɵNgNoValidate, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc1.NgForOf, InputComponent, ɵngcc4.NgControlStatus, ɵngcc4.FormControlDirective, PasswordValidatorComponent], pipes: [ɵngcc1.AsyncPipe, LocalizationPipe], styles: ["select.form-control[_ngcontent-%COMP%]{height:100%;border-radius:0;padding-left:2px;-webkit-appearance:none}.card[_ngcontent-%COMP%]{margin-bottom:20px}.cancel-button[_ngcontent-%COMP%]{margin-right:10px}.btn[_ngcontent-%COMP%]{min-width:110px}.col-between[_ngcontent-%COMP%]{align-items:flex-end}.user-photo[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{opacity:0;position:absolute;z-index:2;width:100%;height:100%;top:0;left:0}.dropdown-item-select[_ngcontent-%COMP%]{padding:10px}  .select-dropdown{top:35px!important}.lnk[_ngcontent-%COMP%]{display:table-cell;vertical-align:middle}  .caret{top:15px!important}.icon-trash2[_ngcontent-%COMP%]{z-index:100;cursor:pointer;position:absolute;color:#fc4349;right:10px;top:5px}.image-wrapper[_ngcontent-%COMP%]   .icon-trash2[_ngcontent-%COMP%]{color:#fff;top:10px;text-shadow:none}h2[_ngcontent-%COMP%]   small[_ngcontent-%COMP%]{text-transform:none}.buttons-container[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;padding-right:20px;padding-bottom:10px}.buttons-container[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{margin-bottom:10px}app-password-validator[_ngcontent-%COMP%]{display:block;padding-top:65px}.card-with-password-validation[_ngcontent-%COMP%]   .validator-container[_ngcontent-%COMP%]{padding-right:20px}.card-with-password-validation[_ngcontent-%COMP%]     .bullet-list{font-size:14px;margin-bottom:10px;padding-left:0}.card-with-password-validation[_ngcontent-%COMP%]   .card-body[_ngcontent-%COMP%]{padding-top:10px}.validator-container[_ngcontent-%COMP%]{height:auto}.form-control-label[_ngcontent-%COMP%]{text-transform:none}.form-control.lnk.mb-15[_ngcontent-%COMP%]{display:block!important}"] });
__decorate([
    Input()
], FormComponent.prototype, "title", void 0);
__decorate([
    Input()
], FormComponent.prototype, "subTitle", void 0);
__decorate([
    Input()
], FormComponent.prototype, "description", void 0);
__decorate([
    Input()
], FormComponent.prototype, "form", void 0);
__decorate([
    Input()
], FormComponent.prototype, "fieldsConfig", void 0);
__decorate([
    Input()
], FormComponent.prototype, "clearImageButton", void 0);
__decorate([
    Input()
], FormComponent.prototype, "withSideColumn", void 0);
__decorate([
    Input()
], FormComponent.prototype, "withAvatar", void 0);
__decorate([
    Input()
], FormComponent.prototype, "submitButtonText", void 0);
__decorate([
    Input()
], FormComponent.prototype, "cancelButtonText", void 0);
__decorate([
    Input()
], FormComponent.prototype, "columnImageUploader", void 0);
__decorate([
    Input()
], FormComponent.prototype, "photoUrl", void 0);
__decorate([
    Input()
], FormComponent.prototype, "avatar", void 0);
__decorate([
    Input()
], FormComponent.prototype, "forcedEditMode", void 0);
__decorate([
    Input()
], FormComponent.prototype, "defaultFields", void 0);
__decorate([
    Input()
], FormComponent.prototype, "forcedViewMode", void 0);
__decorate([
    Input()
], FormComponent.prototype, "withoutSave", void 0);
__decorate([
    Input()
], FormComponent.prototype, "showErrorsForViewMode", void 0);
__decorate([
    Input()
], FormComponent.prototype, "isLightForm", void 0);
__decorate([
    Input()
], FormComponent.prototype, "materialForm", void 0);
__decorate([
    Input()
], FormComponent.prototype, "borderForm", void 0);
__decorate([
    Input()
], FormComponent.prototype, "inlineForm", void 0);
__decorate([
    Input()
], FormComponent.prototype, "cancelButtonClass", void 0);
__decorate([
    Input()
], FormComponent.prototype, "mainColMd7", void 0);
__decorate([
    Input()
], FormComponent.prototype, "mainColMd8", void 0);
__decorate([
    Input()
], FormComponent.prototype, "buttonsCol5", void 0);
__decorate([
    Input()
], FormComponent.prototype, "passwordValidation", void 0);
__decorate([
    Input()
], FormComponent.prototype, "hidePasswordValidation", void 0);
__decorate([
    Input()
], FormComponent.prototype, "success$", void 0);
__decorate([
    Input()
], FormComponent.prototype, "isButtons", void 0);
__decorate([
    Input()
], FormComponent.prototype, "labelWidth", void 0);
__decorate([
    Input()
], FormComponent.prototype, "fieldWidth", void 0);
__decorate([
    Input()
], FormComponent.prototype, "classList", void 0);
__decorate([
    Output()
], FormComponent.prototype, "submit$", void 0);
__decorate([
    Output()
], FormComponent.prototype, "cancel$", void 0);
__decorate([
    Output()
], FormComponent.prototype, "onFileUpload$", void 0);
__decorate([
    Output()
], FormComponent.prototype, "clearImage$", void 0);
__decorate([
    Output()
], FormComponent.prototype, "avatar$", void 0);
__decorate([
    Output()
], FormComponent.prototype, "deleteAvatar$", void 0);
FormComponent = __decorate([ __param(0, Inject(LoadingService)),
    __param(1, Inject(FormService))
], FormComponent);

let NumberComponent = class NumberComponent {
    constructor() { }
    ngOnInit() {
    }
};
NumberComponent.ɵfac = function NumberComponent_Factory(t) { return new (t || NumberComponent)(); };
NumberComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NumberComponent, selectors: [["ano-number"]], inputs: { data: "data" }, decls: 3, vars: 3, consts: [[1, "number-container"]], template: function NumberComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵpipe(2, "number");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx.data));
    } }, pipes: function () { return [NumberPipe]; }, styles: [".number-container[_ngcontent-%COMP%]{width:40%;text-align:end}"] });
__decorate([
    Input()
], NumberComponent.prototype, "data", void 0);

let NumberPipe = class NumberPipe {
    transform(value, fractionDigits, ...args) {
        if (value === null || typeof value !== 'number') {
            return '0.00';
        }
        if (fractionDigits) {
            return new Intl.NumberFormat('de-DE', { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits }).format(value);
        }
        return new Intl.NumberFormat('de-DE').format(value);
    }
};
NumberPipe.ɵfac = function NumberPipe_Factory(t) { return new (t || NumberPipe)(); };
NumberPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "number", type: NumberPipe, pure: true });

let InfoPanelComponent = class InfoPanelComponent {
    constructor() {
    }
};
InfoPanelComponent.ɵfac = function InfoPanelComponent_Factory(t) { return new (t || InfoPanelComponent)(); };
InfoPanelComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InfoPanelComponent, selectors: [["ano-info-panel"]], inputs: { infoPanel: "infoPanel" }, decls: 4, vars: 5, consts: [[1, "alert", "alert-info-box", "alert-block", "alert-icon"], [1, "icon", "icon-info"]], template: function InfoPanelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "i", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "localize");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("alert-info-message", ctx.infoPanel == null ? null : ctx.infoPanel.info);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 3, ctx.infoPanel == null ? null : ctx.infoPanel.textKey), "\n");
    } }, pipes: [LocalizationPipe], styles: [""] });
__decorate([
    Input()
], InfoPanelComponent.prototype, "infoPanel", void 0);
class InfoPanelsConfig {
}
InfoPanelsConfig.startDisabledInfo = {
    textKey: 'player.disabled-start-button-text'
};
InfoPanelsConfig.startEnabledInfo = {
    textKey: 'player.start-stream-info-message',
    info: true
};
InfoPanelsConfig.streamScheduledInfo = {
    textKey: 'player.stream-scheduled-info',
    info: true
};
InfoPanelsConfig.streamStartedInfo = {
    textKey: 'stream.readonly-started-stream-alert-text'
};
InfoPanelsConfig.streamFinishedInfo = {
    textKey: 'stream.readonly-finished-stream-alert-text'
};
InfoPanelsConfig.publisherUnapprovedInfo = {
    textKey: 'streams.unapproved-publisher-alert-text'
};
InfoPanelsConfig.publisherUnapprovedContentInfo = {
    textKey: 'public-media-page.info-panel.content-wont-be-shown-info'
};
InfoPanelsConfig.streamReschedulingInfo = {
    textKey: 'streams.rescheduling-alert-text',
    info: true
};
InfoPanelsConfig.manualSurveyDisabled = {
    textKey: 'survey.manual.disabled'
};
InfoPanelsConfig.noRegistrationDuringPurchase = {
    textKey: 'media-access-modal.no-registration-warning'
};
InfoPanelsConfig.leadGenerationWarning = {
    textKey: 'media-access-modal.lead-generation-warning'
};
InfoPanelsConfig.leadGenerationAlreadyRegistered = {
    textKey: 'media-access-modal.lead-generation-already-registered',
    info: true
};
InfoPanelsConfig.accountAlreadyRegistered = {
    textKey: 'error.REGISTRATION_EMAIL_ALREADY_EXISTS'
};
InfoPanelsConfig.loggedInAsSubAccount = {
    textKey: 'subaccounts.infoPanel.loggedAsSubAccount'
};
InfoPanelsConfig.subAccountInviteSent = {
    textKey: 'subaccounts.infoPanel.inviteSent',
    info: true
};
InfoPanelsConfig.invitedSubAccount = {
    textKey: 'subaccounts.infoPanel.invited'
};
InfoPanelsConfig.needToInputCorrectPhone = {
    textKey: 'registration.needToInputCorrectPhone'
};
InfoPanelsConfig.needToConfirmPhone = {
    textKey: 'registration.needToConfirmPhone'
};
InfoPanelsConfig.phoneConfirmed = {
    textKey: 'registration.phoneConfirmed',
    info: true
};
InfoPanelsConfig.overlayDisabled = {
    textKey: 'overlay.disabled'
};
InfoPanelsConfig.streamNoDate = {
    textKey: 'stream.date.noDate'
};

let LinkedStreamsFilterComponent = class LinkedStreamsFilterComponent {
    constructor(localizationProvider, formBuilder, destroy$) {
        this.localizationProvider = localizationProvider;
        this.formBuilder = formBuilder;
        this.destroy$ = destroy$;
        this.filterByLinkedStreams$ = new EventEmitter();
        this.selectOptions = [
            {
                key: this.localizationProvider.getByKey('linkedStreamsType.Streams'),
                value: this.localizationProvider.getByKey('linkedStreamsType.Streams'),
                filters: [{ field: FILTER_TYPES.MEDIA_TYPE, value: MEDIA_TYPE.STREAM }]
            },
            {
                key: this.localizationProvider.getByKey('linkedStreamsType.VideoOnDemand'),
                value: this.localizationProvider.getByKey('linkedStreamsType.VideoOnDemand'),
                filters: [{ field: FILTER_TYPES.MEDIA_TYPE, value: MEDIA_TYPE.VIDEO }]
            }
        ];
        this.linkedStreamsFilterForm = this.formBuilder.group({
            linkedStreamsType: ['']
        });
        this.linkedStreamsFilterConfig = {
            name: 'linkedStreamsType',
            placeholder: this.localizationProvider.getByKey('linkedStreamsType.placeholder'),
            selectOptions: this.selectOptions
        };
        this.INPUT_TYPES = INPUT_TYPES;
    }
    ngOnInit() {
        this.init();
    }
    init() {
        const field = this.linkedStreamsFilterForm.get('linkedStreamsType');
        const defaultValue = this.linkedStreamsFilterConfig
            .selectOptions[this.filters[0].value === MEDIA_TYPE.STREAM ? 0 : 1].value;
        field.setValue(defaultValue);
        this.selectedFilter = this.setFilter(defaultValue.toString());
        field.valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe(filter => {
            if (filter && filter !== this.selectedFilter) {
                this.selectedFilter = this.setFilter(filter);
                this.filterByLinkedStreams$.emit(this.selectedFilter);
            }
        });
    }
    setFilter(value) {
        return this.selectOptions.find(o => o.value === value).filters;
    }
};
LinkedStreamsFilterComponent.ɵfac = function LinkedStreamsFilterComponent_Factory(t) { return new (t || LinkedStreamsFilterComponent)(ɵngcc0.ɵɵdirectiveInject(LocalizationProvider), ɵngcc0.ɵɵdirectiveInject(FormBuilder), ɵngcc0.ɵɵdirectiveInject(AutoDestroyService)); };
LinkedStreamsFilterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LinkedStreamsFilterComponent, selectors: [["ano-linked-streams-filter"]], inputs: { filters: "filters" }, outputs: { filterByLinkedStreams$: "filterByLinkedStreams$" }, features: [ɵngcc0.ɵɵProvidersFeature([AutoDestroyService])], decls: 2, vars: 1, consts: [[1, "blue-theme-filter"], [3, "formGroup", 4, "ngIf"], [3, "formGroup"], [3, "formControlName", "isEditMode", "noBorder", "config"]], template: function LinkedStreamsFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, LinkedStreamsFilterComponent_form_1_Template, 2, 9, "form", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.linkedStreamsFilterConfig == null ? null : ctx.linkedStreamsFilterConfig.selectOptions == null ? null : ctx.linkedStreamsFilterConfig.selectOptions.length);
    } }, directives: [ɵngcc1.NgIf, ɵngcc4.ɵNgNoValidate, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, InputComponent, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName], styles: [""] });
__decorate([
    Output()
], LinkedStreamsFilterComponent.prototype, "filterByLinkedStreams$", void 0);
__decorate([
    Input()
], LinkedStreamsFilterComponent.prototype, "filters", void 0);
LinkedStreamsFilterComponent = __decorate([ __param(0, Inject(LocalizationProvider)),
    __param(1, Inject(FormBuilder)),
    __param(2, Inject(AutoDestroyService))
], LinkedStreamsFilterComponent);

let SpeedometerComponent = class SpeedometerComponent {
    constructor() { }
    set data(data) {
        this._data = data;
        this.resolveChartValue();
    }
    get data() {
        return this._data;
    }
    ngOnInit() {
    }
    resolveChartValue() {
        this.chartValue = Math.ceil(this._data.percent / SPEEDOMETER_SEGMENT_SIZE);
    }
};
SpeedometerComponent.ɵfac = function SpeedometerComponent_Factory(t) { return new (t || SpeedometerComponent)(); };
SpeedometerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SpeedometerComponent, selectors: [["ano-speedometer"]], inputs: { data: "data", text: "text", topText: "topText" }, decls: 15, vars: 13, consts: [[1, "chart-bandwidth"], ["class", "mb-0 mt-10 top-text", 4, "ngIf"], ["alt", "bandwidth", 1, "bandwidth-speedometer", "mxh-75", 3, "src"], [1, "data-bandwidth", "mt-0"], [1, "mb-0"], [1, "text-primary", "no-white-space"], [1, "mb-0", "mt-10", "top-text"]], template: function SpeedometerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, SpeedometerComponent_p_1_Template, 3, 3, "p", 1);
        ɵngcc0.ɵɵelement(2, "img", 2);
        ɵngcc0.ɵɵelementStart(3, "span", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "p", 4);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵpipe(7, "localize");
        ɵngcc0.ɵɵelementStart(8, "b", 5);
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(10, "br");
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵpipe(12, "localize");
        ɵngcc0.ɵɵelementStart(13, "b", 5);
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.topText);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("src", "assets/img/graphics/bandwidth-speedometer-" + ctx.chartValue + ".svg", ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate2("", ctx.data.used.value, " ", ctx.data.used.unit, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(7, 9, ctx.text.firstLine), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate2("", ctx.data.limit.value, " ", ctx.data.limit.unit, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(12, 11, ctx.text.secondLine), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ctx.data.percent.toFixed(2), "%.");
    } }, directives: [ɵngcc1.NgIf], pipes: [LocalizationPipe], styles: [_c29] });
__decorate([
    Input()
], SpeedometerComponent.prototype, "data", null);
__decorate([
    Input()
], SpeedometerComponent.prototype, "text", void 0);
__decorate([
    Input()
], SpeedometerComponent.prototype, "topText", void 0);

let PieChartUsedComponent = class PieChartUsedComponent {
    constructor() { }
    set data(data) {
        this._data = data;
    }
    get data() {
        return this._data;
    }
    ngOnInit() {
    }
};
PieChartUsedComponent.ɵfac = function PieChartUsedComponent_Factory(t) { return new (t || PieChartUsedComponent)(); };
PieChartUsedComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PieChartUsedComponent, selectors: [["ano-pie-chart-used"]], inputs: { data: "data", id: "id", text: "text", topText: "topText" }, decls: 17, vars: 22, consts: [[1, "chart-bandwidth"], ["class", "mb-0 mt-10 top-text", 4, "ngIf"], [1, "row", "justify-content-center", 2, "margin-bottom", "-10px"], [1, "col-auto"], [3, "id", "data", "rotate", "colorScheme", "height", "width"], [1, "data-bandwidth", "mt-0"], [1, "mb-0"], [1, "text-primary", "no-white-space"], [1, "mb-0", "mt-10", "top-text"]], template: function PieChartUsedComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, PieChartUsedComponent_p_1_Template, 3, 3, "p", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelement(4, "ano-pie-chart", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "span", 5);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "p", 6);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵpipe(9, "localize");
        ɵngcc0.ɵɵelementStart(10, "b", 7);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(12, "br");
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵpipe(14, "localize");
        ɵngcc0.ɵɵelementStart(15, "b", 7);
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.topText);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("id", ctx.id)("data", ɵngcc0.ɵɵpureFunction2(18, _c27, ctx.data.percent / 100, 1 - ctx.data.percent / 100))("rotate", ctx.data.percent < 50 ? 360 * (ctx.data.percent / 100) : 0)("colorScheme", ɵngcc0.ɵɵpureFunction0(21, _c28))("height", 125)("width", 125);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate2("", ctx.data.used.value, " ", ctx.data.used.unit, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(9, 14, ctx.text.firstLine), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate2("", ctx.data.limit.value, " ", ctx.data.limit.unit, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(14, 16, ctx.text.secondLine), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ctx.data.percent.toFixed(2), "%.");
    } }, directives: [ɵngcc1.NgIf, PieChartComponent], pipes: [LocalizationPipe], styles: [_c29] });
__decorate([
    Input()
], PieChartUsedComponent.prototype, "id", void 0);
__decorate([
    Input()
], PieChartUsedComponent.prototype, "data", null);
__decorate([
    Input()
], PieChartUsedComponent.prototype, "text", void 0);
__decorate([
    Input()
], PieChartUsedComponent.prototype, "topText", void 0);

const moment = moment$1 || moment$1;
// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
const MY_FORMATS = {
    parse: {
        dateInput: 'MMMM, YYYY',
    },
    display: {
        dateInput: 'MMMM, YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};
let DatepickerComponent = class DatepickerComponent {
    constructor() {
        this.value = moment();
        this.showAllOption = true;
        this.startFromAll = false;
        this.end = moment().format("YYYY-MM-") + moment().daysInMonth();
        this.changeDate = new EventEmitter();
        this.showClear = true;
        this.date = new FormControl(this.value);
    }
    get checkDate() {
        return (this.date.value === undefined ||
            this.date.value === null ||
            this.date.value !== "All");
    }
    set dateCtrl(v) {
        this.date.setValue(v);
    }
    ngOnInit() {
        if (this.startFromAll) {
            this.resetDate();
        }
    }
    chosenYearHandler(normalizedYear) {
        const ctrlValue = this.checkDate ? this.date.value : moment();
        ctrlValue.year(normalizedYear.year());
        this.dateCtrl = ctrlValue;
    }
    chosenMonthHandler(normalizedMonth, datepicker) {
        this.chosenYearHandler(normalizedMonth);
        const ctrlValue = this.checkDate ? this.date.value : moment();
        ctrlValue.month(normalizedMonth.month());
        this.dateCtrl = ctrlValue;
        this.closeDatepicker(datepicker);
        this.showClear = this.showAllOption;
        this.changeDate.emit({
            start: +moment(this.date.value).utc().startOf("month").format("x"),
            end: +moment(this.date.value).utc().endOf("month").format("x"),
        });
    }
    clearDate(event) {
        event.stopPropagation();
        this.resetDate();
        this.changeDate.emit(null);
    }
    resetDate() {
        var _a;
        this.date.setValue("All");
        (_a = this.dp) === null || _a === void 0 ? void 0 : _a.select(undefined);
        this.showClear = false;
    }
    closeDatepicker(datepicker) {
        datepicker.close();
    }
};
DatepickerComponent.ɵfac = function DatepickerComponent_Factory(t) { return new (t || DatepickerComponent)(); };
DatepickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DatepickerComponent, selectors: [["ano-datepicker"]], viewQuery: function DatepickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(MatDatepicker, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dp = _t.first);
    } }, inputs: { value: "value", showAllOption: "showAllOption", startFromAll: "startFromAll", end: "end" }, outputs: { changeDate: "changeDate" }, features: [ɵngcc0.ɵɵProvidersFeature([
            // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
            // application's root module. We provide it at the component level here, due to limitations of
            // our example generation script.
            {
                provide: DateAdapter,
                useClass: MomentDateAdapter,
                deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
            },
            { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        ])], decls: 7, vars: 6, consts: [[1, "datepicker-wrap", 3, "click"], [4, "ngIf"], ["matInput", "", "readonly", "", 1, "datepicker-field", 3, "matDatepicker", "max", "formControl"], ["class", "datepicker-clear", "matDatepickerToggleIcon", "", 3, "click", 4, "ngIf"], ["color", "white", "matSuffix", "", 1, "datepicker-toogle", 3, "for"], ["startView", "year", "panelClass", "ano-month-picker", 3, "monthSelected"], ["dp", ""], ["matDatepickerToggleIcon", "", 1, "datepicker-clear", 3, "click"], [1, "icon", "icon-close"]], template: function DatepickerComponent_Template(rf, ctx) { if (rf & 1) {
        const _r5 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function DatepickerComponent_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const _r2 = ɵngcc0.ɵɵreference(6); return _r2.open(); });
        ɵngcc0.ɵɵtemplate(1, DatepickerComponent_div_1_Template, 2, 0, "div", 1);
        ɵngcc0.ɵɵelement(2, "input", 2);
        ɵngcc0.ɵɵtemplate(3, DatepickerComponent_div_3_Template, 2, 0, "div", 3);
        ɵngcc0.ɵɵelement(4, "mat-datepicker-toggle", 4);
        ɵngcc0.ɵɵelementStart(5, "mat-datepicker", 5, 6);
        ɵngcc0.ɵɵlistener("monthSelected", function DatepickerComponent_Template_mat_datepicker_monthSelected_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const _r2 = ɵngcc0.ɵɵreference(6); return ctx.chosenMonthHandler($event, _r2); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(6);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.date.value === "All");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("matDatepicker", _r2)("max", ctx.end)("formControl", ctx.date);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showAllOption && ctx.showClear);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("for", _r2);
    } }, directives: [ɵngcc1.NgIf, ɵngcc12.MatInput, ɵngcc13.MatDatepickerInput, ɵngcc4.DefaultValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.FormControlDirective, ɵngcc13.MatDatepickerToggle, ɵngcc14.MatSuffix, ɵngcc13.MatDatepicker, ɵngcc13.MatDatepickerToggleIcon], styles: [".datepicker-wrap[_ngcontent-%COMP%]{padding:0 .25rem 0 .5rem;display:flex;align-items:center;justify-content:space-between;max-height:30px;min-width:203px}.datepicker-field[_ngcontent-%COMP%]{border:0}.datepicker-field[_ngcontent-%COMP%], .datepicker-wrap[_ngcontent-%COMP%]{font-size:12px;background:#0e54a9;color:#fff;cursor:pointer}mat-datepicker-toggle[_ngcontent-%COMP%]{color:#fff!important}.datepicker-selected[_ngcontent-%COMP%]{background:#0e54a9;border-radius:100%}.datepicker-toogle[_ngcontent-%COMP%]{position:relative;left:7px}.datepicker-clear[_ngcontent-%COMP%]{position:relative;left:10px}"], changeDetection: 0 });
__decorate([
    ViewChild(MatDatepicker)
], DatepickerComponent.prototype, "dp", void 0);
__decorate([
    Input()
], DatepickerComponent.prototype, "value", void 0);
__decorate([
    Input()
], DatepickerComponent.prototype, "showAllOption", void 0);
__decorate([
    Input()
], DatepickerComponent.prototype, "startFromAll", void 0);
__decorate([
    Input()
], DatepickerComponent.prototype, "end", void 0);
__decorate([
    Output()
], DatepickerComponent.prototype, "changeDate", void 0);

registerLocaleData(localeNb, localeNbExtra);
let UiElementsModule = class UiElementsModule {
};
UiElementsModule.ɵfac = function UiElementsModule_Factory(t) { return new (t || UiElementsModule)(); };
UiElementsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UiElementsModule });
UiElementsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            MatPaginatorModule,
            TableModule,
            FormsModule,
            ReactiveFormsModule,
            OwlDateTimeModule,
            OwlNativeDateTimeModule,
            NgxMaskModule,
            MatSlideToggleModule,
            RouterModule,
            MaterialModule,
            AutosizeModule
        ], OwlDateTimeModule,
        OwlNativeDateTimeModule,
        TableModule, MaterialModule] });

let PlayerComponent = class PlayerComponent {
    constructor(environment) {
        this.environment = environment;
        this.videoEnded = new EventEmitter();
        this.videoClicked = new EventEmitter();
        this.overlayClicked = new EventEmitter();
        this.overlayViewed = new EventEmitter();
        this.playerSignal = new EventEmitter();
        this.fullscreenToggle = new EventEmitter();
        this.timeUpdated = new EventEmitter();
        this.STATE = STATE;
        this.state = STATE.PLAY;
    }
    ngOnInit() {
        var _a, _b;
        if (!((_a = this.config) === null || _a === void 0 ? void 0 : _a.thumbnailUrl)) {
            this.config.thumbnailUrl = '/cmsImage/fileName/video_default_8.jpg';
        }
        if (!((_b = this.config) === null || _b === void 0 ? void 0 : _b.fallbackUrl)) {
            this.config.fallbackUrl = '/cmsImage/fileName/Fallback_20Image.jpg';
        }
    }
    onVideoEnd() {
        this.videoEnded.emit(this.config.mediaSource.subtype);
    }
    onVideoClick() {
        this.videoClicked.emit(this.config.mediaSource.subtype);
    }
    onOverlayClick(overlay) {
        this.overlayClicked.emit(overlay);
    }
    onTimeUpdate(time) {
        this.timeUpdated.emit(time);
    }
    onOverlayViewed(overlay) {
        this.overlayViewed.emit(overlay);
    }
    onPlayerSignal(signal) {
        this.playerSignal.emit(signal);
    }
    onFullscreenChange(state) {
        this.fullscreenToggle.emit(state);
    }
};
PlayerComponent.ɵfac = function PlayerComponent_Factory(t) { return new (t || PlayerComponent)(ɵngcc0.ɵɵdirectiveInject(ENVIRONMENT)); };
PlayerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PlayerComponent, selectors: [["ano-player"]], inputs: { config: "config", currentLivestreamTime: "currentLivestreamTime", buttonsConfig: "buttonsConfig", marketingSocket: "marketingSocket", playerController: "playerController" }, outputs: { videoEnded: "videoEnded", videoClicked: "videoClicked", overlayClicked: "overlayClicked", overlayViewed: "overlayViewed", playerSignal: "playerSignal", fullscreenToggle: "fullscreenToggle", timeUpdated: "timeUpdated" }, decls: 3, vars: 5, consts: [[1, "player-container", 3, "ngStyle"], [4, "ngFor", "ngForOf"], [3, "config", "buttonsConfig", "currentLivestreamTime", "marketingSocket", "playerController", "videoEnded", "videoClicked", "playerSignal", "overlayClicked", "overlayViewed", "fullscreenToggle", "timeUpdate", 4, "ngIf"], [3, "class", "click", 4, "ngIf"], [3, "click"], [3, "class", 4, "ngIf"], [3, "config", "buttonsConfig", "currentLivestreamTime", "marketingSocket", "playerController", "videoEnded", "videoClicked", "playerSignal", "overlayClicked", "overlayViewed", "fullscreenToggle", "timeUpdate"]], template: function PlayerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, PlayerComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, PlayerComponent_ano_videojs_2_Template, 1, 5, "ano-videojs", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(3, _c30, "url(" + ctx.environment.backendApiHost + (ctx.config == null ? null : ctx.config.thumbnailUrl) + ")"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.config == null ? null : ctx.config.infoLines);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config == null ? null : ctx.config.mediaSource == null ? null : ctx.config.mediaSource.url);
    } }, styles: ["@charset \"UTF-8\";.player-container[_ngcontent-%COMP%]{width:100%;height:100%}.player-container[_ngcontent-%COMP%]   .status-video[_ngcontent-%COMP%]{z-index:100;position:absolute;right:15px;cursor:pointer;font-size:25px;color:#fff;text-transform:uppercase;font-family:Poppins-Bold,sans-serif;line-height:1;padding:0 4px;letter-spacing:.02rem}.player-container[_ngcontent-%COMP%]   .status-video[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{position:relative;top:2px}.player-container[_ngcontent-%COMP%]   .status-video[_ngcontent-%COMP%]   .icon-dot-12[_ngcontent-%COMP%]{top:-2px}.player-container[_ngcontent-%COMP%]   .status-video-1[_ngcontent-%COMP%]{top:15px}.player-container[_ngcontent-%COMP%]   .status-video-2[_ngcontent-%COMP%]{top:50px}.player-container[_ngcontent-%COMP%]   .status-video-3[_ngcontent-%COMP%]{top:85px}.player-container[_ngcontent-%COMP%]   .finished[_ngcontent-%COMP%]{background-color:#fc4349}.player-container[_ngcontent-%COMP%]   .scheduled[_ngcontent-%COMP%]{background-color:#0e54a9}.player-container[_ngcontent-%COMP%]   .live[_ngcontent-%COMP%]{background-color:#fc4349}.player-container[_ngcontent-%COMP%]   .donate[_ngcontent-%COMP%]{background-color:#bad668}.player-container[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{background-color:#ffbe00}.finished[_ngcontent-%COMP%]{background-color:#fc4349}button[_ngcontent-%COMP%]{display:flex;align-items:center}.loader-container[_ngcontent-%COMP%]{position:relative;width:40px}.loader-container[_ngcontent-%COMP%]     .full-spinner{right:13px}.loader-container[_ngcontent-%COMP%]     .full-spinner .css-spinner{width:40px}.loader-container[_ngcontent-%COMP%]     .full-spinner .css-spinner .bounce1, .loader-container[_ngcontent-%COMP%]     .full-spinner .css-spinner .bounce2, .loader-container[_ngcontent-%COMP%]     .full-spinner .css-spinner .bounce3{width:9px;height:9px;background-color:#0e54a9}video[_ngcontent-%COMP%]{outline:none;width:100%;height:100%}.center[_ngcontent-%COMP%]{left:50%;top:50%}app-stream-access-modal[_ngcontent-%COMP%], app-stream-age-restrictions-modal[_ngcontent-%COMP%]{position:absolute;z-index:10001}.icon-video-file[_ngcontent-%COMP%]{font-size:140px;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);color:#0e54a9;z-index:101}.volume-hover[_ngcontent-%COMP%]{bottom:285px!important}.active-chat[_ngcontent-%COMP%]{color:#2260ac}.played[_ngcontent-%COMP%]{display:flex}.vjs-paused.vjs-has-started[_ngcontent-%COMP%]     .vjs-big-play-button{display:block}.video-js.vjs-has-started[_ngcontent-%COMP%]     .show-overlay{display:block!important}.video-js[_ngcontent-%COMP%]{position:relative;width:100%!important}.video-js[_ngcontent-%COMP%]     .disabled-chat{display:none}.video-js[_ngcontent-%COMP%]     .chat-button{position:absolute;color:#0c1d3f;font-size:25px;right:19px;bottom:95px;width:25px;height:25px;font-family:icomoon!important;font-style:normal;font-weight:400;font-feature-settings:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;outline:none}.video-js[_ngcontent-%COMP%]     .chat-button.active-chat{color:#2260ac}.video-js[_ngcontent-%COMP%]     .chat-button:before{content:\"\uE934\"}.video-js[_ngcontent-%COMP%]     .left-course, .video-js[_ngcontent-%COMP%]     .left-overlay{position:absolute;width:140px;height:200px;left:25px;top:70px;background-color:transparent;display:none}.video-js[_ngcontent-%COMP%]     .right-course, .video-js[_ngcontent-%COMP%]     .right-overlay{position:absolute;width:140px;height:200px;right:25px;top:70px;background-color:transparent;display:none}.video-js[_ngcontent-%COMP%]     .bottom-course, .video-js[_ngcontent-%COMP%]     .bottom-overlay{position:absolute;width:480px;height:70px;left:50%;transform:translatex(-50%);bottom:70px;background-color:transparent;display:none}.video-js[_ngcontent-%COMP%]   video[_ngcontent-%COMP%]{position:relative;height:100%!important;width:100%!important}.video-js[_ngcontent-%COMP%]     .vjs-control-bar{background-color:transparent;bottom:30px;left:10%;width:90%}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-paused{display:none}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-playing{display:none}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-volume-panel.vjs-volume-panel-vertical{width:1em;position:absolute;right:16px;top:-30px;margin-left:30px;color:#0c1d3f;font-family:icomoon!important;speak:none;font-style:normal;font-weight:400;font-feature-settings:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;font-size:25px}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-volume-panel.vjs-volume-panel-vertical .vjs-icon-placeholder:before{content:\"\";width:1em;left:-30px}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-volume-panel.vjs-volume-panel-vertical:before{content:\"\uE933\"}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-volume-panel.vjs-volume-panel-vertical .vjs-mute-control{outline:none}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-volume-vertical{transition:none}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-hover .vjs-volume-vertical{width:1em;left:-4.8em}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-picture-in-picture-control{display:none}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-progress-holder{height:12px;background:#0c1d3f}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-play-progress:before{top:-7px;height:26px;width:26px;border-radius:50%;background:#fff}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-fullscreen-control{margin-left:30px;color:#0c1d3f;font-family:icomoon!important;speak:none;font-style:normal;font-weight:400;font-feature-settings:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;font-size:25px;width:1em;right:20px}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-fullscreen-control:before{content:\"\uE91D\"}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-fullscreen-control .vjs-icon-placeholder:before{content:\"\"}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .livestream-time{display:block;left:-100%;color:#fff;background-color:rgba(0,0,0,.4)}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-live-display{display:none}.video-js[_ngcontent-%COMP%]     button.vjs-big-play-button{border:none;position:absolute;z-index:102;top:50%;left:50%;transform:translate(-50%,-50%);width:122px;height:122px;border-radius:50%;background:rgba(12,29,63,.85);cursor:pointer}.video-js[_ngcontent-%COMP%]     button.vjs-big-play-button:after{content:\"\";position:absolute;z-index:103;top:50%;left:50%;transform:translateY(-50%);margin-left:-20px;border-top:38px solid transparent;border-bottom:38px solid transparent;border-left:60px solid #fff;cursor:pointer}.video-js[_ngcontent-%COMP%]     button.vjs-big-play-button .vjs-icon-placeholder:before{content:\"\"}.no-data[_ngcontent-%COMP%]     .video-js.vjs-paused .vjs-poster{display:block!important;background-size:cover!important}  .vjs-poster{background-size:cover!important}.video-js[_ngcontent-%COMP%]{-o-object-fit:cover;object-fit:cover}.disabled-player[_ngcontent-%COMP%]{pointer-events:none}.timeline-no-action[_ngcontent-%COMP%]{background-color:#efefef}.timeline-can-take-action[_ngcontent-%COMP%]{background-color:#5ea1f2!important}.timeline-can-take-action[_ngcontent-%COMP%]:after{border-left-color:#5ea1f2!important}.timeline-can-take-action[_ngcontent-%COMP%]:before{border-right-color:#5ea1f2!important}.timeline-action-taken[_ngcontent-%COMP%]{background-color:#0e54a9}.timeline-action-taken[_ngcontent-%COMP%]:after{border-left-color:#0e54a9!important}.timeline-action-taken[_ngcontent-%COMP%]:before{border-right-color:#0e54a9!important}.timeline-finished[_ngcontent-%COMP%]{background-color:#fc4349}.timeline-finished[_ngcontent-%COMP%]:after{border-left-color:#fc4349!important}.timeline-finished[_ngcontent-%COMP%]:before{border-right-color:#fc4349!important}"] });
__decorate([
    Input()
], PlayerComponent.prototype, "config", void 0);
__decorate([
    Input()
], PlayerComponent.prototype, "currentLivestreamTime", void 0);
__decorate([
    Input()
], PlayerComponent.prototype, "buttonsConfig", void 0);
__decorate([
    Input()
], PlayerComponent.prototype, "marketingSocket", void 0);
__decorate([
    Input()
], PlayerComponent.prototype, "playerController", void 0);
__decorate([
    Output()
], PlayerComponent.prototype, "videoEnded", void 0);
__decorate([
    Output()
], PlayerComponent.prototype, "videoClicked", void 0);
__decorate([
    Output()
], PlayerComponent.prototype, "overlayClicked", void 0);
__decorate([
    Output()
], PlayerComponent.prototype, "overlayViewed", void 0);
__decorate([
    Output()
], PlayerComponent.prototype, "playerSignal", void 0);
__decorate([
    Output()
], PlayerComponent.prototype, "fullscreenToggle", void 0);
__decorate([
    Output()
], PlayerComponent.prototype, "timeUpdated", void 0);
PlayerComponent = __decorate([ __param(0, Inject(ENVIRONMENT))
], PlayerComponent);

let SchedulerService = class SchedulerService {
    constructor() {
        this.events = new BehaviorSubject(null);
        this.stop$ = new Subject();
        this.timer = 0;
        this.tasksConfigs = [];
        this.tasks = [];
        this.clockPeriod = 1000;
        this.started = false;
    }
    schedule(schedules, restartEventIfStarTimePassed = false) {
        this.restartEvents = restartEventIfStarTimePassed;
        this.schedules = schedules;
        this.initScheduler();
        this.initTaskConfigs();
    }
    reschedule(schedules, restartEventIfStarTimePassed = false) {
        this.schedule(schedules, restartEventIfStarTimePassed);
        this.pause();
        this.start();
    }
    initScheduler() {
        this._asyncScheduler = _.cloneDeep(asyncScheduler);
        this._asyncScheduler.now = () => this.timer;
    }
    initTaskConfigs() {
        this.tasksConfigs = [];
        this.clearTasks();
        this.schedules.forEach(schedule => {
            this.tasksConfigs.push([
                {
                    completed: false,
                    state: TIME_POINT.START,
                    delay: schedule.timePointStart,
                    schedule: schedule
                },
                {
                    completed: false,
                    state: TIME_POINT.STOP,
                    delay: schedule.timePointStop,
                    schedule: schedule
                },
            ]);
        });
    }
    start(time) {
        if (this.started) {
            return;
        }
        this.started = true;
        this.stop$ = new Subject();
        this.setTimer(time);
        this.startClock();
        this.runTasks();
    }
    setTimer(time) {
        if (time || time === 0) {
            this.timer = time;
        }
        else {
            this.timer = this.timer || 0;
        }
    }
    startClock() {
        const interval$ = interval(this.clockPeriod);
        interval$.pipe(observeOn(this._asyncScheduler), takeUntil(this.stop$)).subscribe(() => {
            this.timer += this.clockPeriod;
        });
    }
    runTasks() {
        this.clearTasks();
        this.resetTasksToNotCompleted();
        this.tasksConfigs.forEach(taskConfigs => {
            taskConfigs.forEach(task => {
                if ((!this.restartEvents && this.timeIsPassed(task.delay)) || (this.restartEvents && this.timeIsPassed(task.delay) && task.completed)) {
                    return;
                }
                if (task.completed) {
                    return;
                }
                if (this.timeIsPassed(task.delay) && !task.completed && this.restartEvents) {
                    task.completed = false;
                    this.events.next({
                        type: task.schedule.eventType,
                        entityId: task.schedule.entityId,
                        timePoint: task.state,
                        entity: task.schedule.entity
                    });
                    return;
                }
                this.tasks.push(this._asyncScheduler.schedule(this.task, task.delay - this.timer, {
                    context: this,
                    state: task.state,
                    schedule: task.schedule
                }));
            });
        });
    }
    timeIsPassed(delay) {
        return delay - this.timer < 0;
    }
    task(schedulerState) {
        schedulerState.context.tasksConfigs.forEach(taskConfigRow => {
            taskConfigRow.forEach(taskConfig => {
                if (taskConfig.schedule.entityId === schedulerState.schedule.entityId && taskConfig.state === schedulerState.state) {
                    taskConfig.completed = true;
                }
            });
        });
        schedulerState.context.events.next({
            type: schedulerState.schedule.eventType,
            entityId: schedulerState.schedule.entityId,
            timePoint: schedulerState.state,
            entity: schedulerState.schedule.entity
        });
    }
    pause() {
        this.stop$.next();
        this.stop$.complete();
        this.clearTasks();
        this.started = false;
    }
    stop() {
        if (this.stop$) {
            this.stop$.next();
            this.stop$.complete();
            this.stop$ = null;
        }
        this.clearTasks();
        // this.resetTasksToNotCompleted();
        this.timer = 0;
        this.started = false;
    }
    clearTasks() {
        this.tasks.forEach(task => task.unsubscribe());
        this.tasks = [];
    }
    resetTasksToNotCompleted() {
        this.tasksConfigs.forEach(taskConfigs => taskConfigs.forEach(task => {
            task.completed = false;
            this.events.next({
                type: task.schedule.eventType,
                entityId: task.schedule.entityId,
                timePoint: TIME_POINT.STOP,
                entity: task.schedule.entity
            });
        }));
    }
    isScheduled() {
        var _a;
        return !!((_a = this.schedules) === null || _a === void 0 ? void 0 : _a.length);
    }
};
SchedulerService.ɵfac = function SchedulerService_Factory(t) { return new (t || SchedulerService)(); };
SchedulerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: SchedulerService, factory: function (t) { return SchedulerService.ɵfac(t); } });
var TIME_POINT;
(function (TIME_POINT) {
    TIME_POINT["START"] = "START";
    TIME_POINT["STOP"] = "STOP";
})(TIME_POINT || (TIME_POINT = {}));

const getTokenWithoutPrefix = (token) => {
    if (!token || !token.includes(':')) {
        return token;
    }
    return token.split(':')[1];
};

class WebSocketConnector {
    constructor() {
        this.KEEP_ALIVE_INTERVAL = 240000;
    }
    connect(url, token = null, protocols, keepAlive) {
        if (!this.subject) {
            protocols = [getTokenWithoutPrefix(token), ...protocols]
                .filter(protocol => protocol !== '');
            this.subject = this.create(url, protocols);
            if (keepAlive) {
                this.keepAliveTimeInterval = setInterval(() => {
                    this.subject.next({ type: 'KEEP_ALIVE' });
                }, this.KEEP_ALIVE_INTERVAL);
            }
        }
        return this.subject;
    }
    create(url, protocols) {
        this.ws = new WebSocket(url, protocols);
        const observable = new Observable((obs) => {
            this.ws.onmessage = obs.next.bind(obs);
            this.ws.onerror = obs.error.bind(obs);
            this.ws.onclose = obs.complete.bind(obs);
            return this.ws.close.bind(this.ws);
        });
        const observer = {
            next: (data) => {
                if (this.ws.readyState === WebSocket.OPEN) {
                    this.ws.send(JSON.stringify(data));
                }
            },
            complete: () => {
                this.close();
            }
        };
        return Subject.create(observer, observable);
    }
    close() {
        if (!this.closed()) {
            this.ws.close();
            this.subject = null;
            clearInterval(this.keepAliveTimeInterval);
        }
    }
    closed() {
        return !this.ws || [WebSocket.CLOSED, WebSocket.CLOSING].includes(this.ws.readyState);
    }
}

let MarketingService = class MarketingService {
    constructor(environment, apiUrls) {
        this.environment = environment;
        this.apiUrls = apiUrls;
        this.MARKETING_SOCKET = `${this.environment.webSocketHost}${this.apiUrls.ROOT_URL}${this.apiUrls.MARKETING_SOCKET}`;
    }
    connectToSocket(mediaId, mediaType) {
        if (!this.connection) {
            this.connection = new WebSocketConnector().connect(this.MARKETING_SOCKET, null, [mediaId, mediaType], true);
        }
        return this.connection.pipe(map((response) => {
            return JSON.parse(response.data);
        }));
    }
    events() {
        return this.connection.pipe(map((response) => {
            return JSON.parse(response.data);
        }));
    }
};
MarketingService.ɵfac = function MarketingService_Factory(t) { return new (t || MarketingService)(ɵngcc0.ɵɵinject(ENVIRONMENT), ɵngcc0.ɵɵinject(API_URLS)); };
MarketingService.ɵprov = i0.ɵɵdefineInjectable({ factory: function MarketingService_Factory() { return new MarketingService(i0.ɵɵinject(ENVIRONMENT), i0.ɵɵinject(API_URLS)); }, token: MarketingService, providedIn: "root" });
MarketingService = __decorate([ __param(0, Inject(ENVIRONMENT)),
    __param(1, Inject(API_URLS))
], MarketingService);

let VideojsComponent = class VideojsComponent {
    constructor(destroy$, 
    // @Inject(SchedulerService) private schedulerService: SchedulerService,
    marketingService, localize, environment) {
        this.destroy$ = destroy$;
        this.marketingService = marketingService;
        this.localize = localize;
        this.environment = environment;
        this.MEDIA_SUBTYPE = MEDIA_SUBTYPE;
        this.videoEnded = new EventEmitter();
        this.videoClicked = new EventEmitter();
        this.playerSignal = new EventEmitter();
        this.overlayClicked = new EventEmitter();
        this.overlayViewed = new EventEmitter();
        this.fullscreenToggle = new EventEmitter();
        this.timeUpdate = new EventEmitter();
        this.overlaysSettings = [];
        this.stopped = false;
        this.overlayClickCanceler$ = new Subject();
        this.isFullscreen = false;
        this.paused = true;
        this.started = false;
        this.startedMain = false;
        this.playButton = true;
        this.timeGenerator$ = new BehaviorSubject(null);
    }
    set _playerController(controller) {
        if (!controller) {
            return;
        }
        this.playerController = controller;
        this.playerController.pipe(takeUntil(this.destroy$), filter(res => !!res)).subscribe((signal) => {
            this.stopped = signal.play;
            if (signal.play) {
                this.player.play();
            }
            else {
                this.player.pause();
            }
        });
    }
    set _config(config) {
        this.config = config;
        this.overlays = this.resolveOverlaysTime(config.overlays) || [];
        this.courses = this.resolveOverlaysTime(config.courses) || [];
        this.retryCounter = 0;
        this.initOptions();
        this.initPlayer();
        this.handlePlayerErrors();
        this.resetOverlays();
        this.listenManualOverlaysActions();
    }
    set buttonsConfig(config) {
        this._buttonsConfig = config;
        this.initButtons();
    }
    get buttonsConfig() {
        return this._buttonsConfig;
    }
    set _currentLivestreamTime(time) {
        if (!time) {
            this.currentLivestreamTime = null;
            return;
        }
        this.currentLivestreamTime = Math.floor(time / 1000);
        this.initTimeGenerator();
    }
    ngOnInit() {
        // if (this.config.mediaSource.type === MEDIA_FORMAT.STREAM) {
        this.player.controlBar.liveDisplay.hide();
        const timeControl = this.player.controlBar.addChild('button', {});
        timeControl.addClass('livestream-time');
        // }
    }
    ngAfterViewInit() {
        this.refreshContainerSize();
        fromEvent(window, 'resize')
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
            setTimeout(() => this.refreshContainerSize(), 200);
        });
    }
    ngOnDestroy() {
        this.destroyPlayer();
    }
    initTimeGenerator() {
        if (this.config.mediaType === MEDIA_TYPE.STREAM && !this.config.isRecord) {
            if (this.livestreamTimeInterval) {
                return;
            }
            this.livestreamTimeInterval = interval(1000);
            this.livestreamTimeInterval.pipe(takeUntil(this.destroy$)).subscribe(() => {
                this.currentLivestreamTime++;
                const time = { type: ITimeType.CLOCK_TIME, time: Math.floor(new Date().getTime() / 1000) };
                this.timeGenerator$.next(time);
            });
        }
        else {
            this.player.on('timeupdate', () => {
                const time = { type: ITimeType.MEDIA_TIME, time: this.player.currentTime() };
                this.timeGenerator$.next(time);
            });
        }
    }
    destroyPlayer() {
        if (!this.player) {
            return;
        }
        this.player.dispose();
    }
    listenEvents() {
        if (this.eventsSubscribed) {
            return;
        }
        this.listenPlayerSignals();
        this.listenClick();
        this.listenPlayerErrors();
        this.listenQualityChange();
        this.listenTimeGenerator();
        this.listenTimeUpdate();
        if (!this.player) {
            return;
        }
        this.eventsSubscribed = true;
    }
    listenTimeUpdate() {
        this.timeUpdate.pipe(takeUntil(this.destroy$)).subscribe((time) => {
            this.checkOverlays(time);
            this.updateVideoTimer(time);
        });
    }
    listenManualOverlaysActions() {
        if (this.config.mediaType !== MEDIA_TYPE.STREAM) {
            return;
        }
        this.marketingService.connectToSocket(this.config.mediaId, this.config.mediaType)
            .pipe(takeUntil(this.destroy$), filter(res => !!res))
            .subscribe((res) => {
            if (res.results.data.type !== MARKETING_ENTITY_TYPE.OVERLAY) {
                return;
            }
            const overlay = this.config.overlays.find(ovr => ovr.id === res.results.data.id);
            if (!overlay) {
                return;
            }
            // TODO *turn overlay*
        });
    }
    // private adjustOverlaySchedule(overlay: IPublicOverlay, action: MARKETING_ACTION, status: SURVEY_STATUS): void {
    //     const newEventTime = (this.schedulerService.timer + 1000);
    //     if (action === MARKETING_ACTION.SHOW) {
    //         overlay.startTime = newEventTime;
    //         overlay.endTime = overlay.startTime + (overlay.duration * 1000);
    //     }
    //     if (action === MARKETING_ACTION.HIDE) {
    //         overlay.startTime = newEventTime;
    //         overlay.endTime = new Date().getTime() + 1000;
    //     }
    //
    //     if (action === MARKETING_ACTION.UPDATE_STATUS) {
    //         overlay.active = status === SURVEY_STATUS.ACTIVE;
    //         overlay.endTime = this.schedulerService.timer / 1000;
    //     }
    //
    //     overlay.status = action;
    //     overlay.isManualStart = true;
    // }
    initOptions() {
        var _a;
        this.options = {
            techOrder: ['html5'],
            preload: false,
            poster: this.environment.backendApiHost + this.config.thumbnailUrl,
            autoplay: false,
            controls: (_a = this.config) === null || _a === void 0 ? void 0 : _a.controlsDisabled,
            errorDisplay: false,
            controlBar: {
                volumePanel: { inline: true },
                fullscreenToggle: true
            },
            html5: {
                hls: {
                    overrideNative: true,
                    smoothQualityChange: true,
                    limitRenditionByPlayerDimensions: false,
                    useDevicePixelRatio: true
                }
            },
            sources: [this.source()],
            bigPlayButton: this.config.mediaSource.url !== 'no-video',
            inactivityTimeout: 3000
        };
    }
    source() {
        return {
            src: this.config.mediaSource.url,
            type: this.config.mediaSource.type
        };
    }
    initPlayer() {
        if (this.player) {
            this.setupPlayer(true);
            this.initTimeGenerator();
            return;
        }
        this.player = videojs(this.target.nativeElement, this.options);
        this.setupPlayer();
        this.listenEvents();
        this.initTimeGenerator();
    }
    setupPlayer(reinitPlayer = false) {
        var _a;
        if (reinitPlayer) {
            this.player.src(this.source());
            this.player.controls((_a = this.config) === null || _a === void 0 ? void 0 : _a.controlsDisabled);
            this.player.load();
        }
        if (this.config.vr && this.config.mediaSource.subtype === MEDIA_SUBTYPE.MAIN) {
            this.player.vr({ projection: '360' });
        }
        if (this.config.playFrom || this.config.playFrom === 0) {
            this.player.currentTime(this.config.playFrom);
            this.player.play();
        }
        if (reinitPlayer) {
            if (this.config.autoplay) {
                this.player.play();
            }
        }
        else {
            if (this.config.mediaSource.subtype === MEDIA_SUBTYPE.MAIN) {
                this.addGradient();
            }
        }
    }
    listenQualityChange() {
        const qualityLevels = this.player.qualityLevels();
        console.log(qualityLevels);
        qualityLevels.on('change', function () {
            console.log('Quality Level changed!');
            console.log('Quality level list: ', qualityLevels);
            console.log('New level:', qualityLevels[qualityLevels.selectedIndex]);
        });
    }
    listenPlayerErrors() {
        this.player.on('error', (e) => {
            if (this.config.showFallback) {
                this.player.poster(this.environment.backendApiHost + this.config.fallbackUrl);
            }
            else {
                this.player.poster(this.environment.backendApiHost + this.config.thumbnailUrl);
            }
            switch (this.retryCounter) {
                case 0:
                    this.retryCounter++;
                    setTimeout(() => {
                        this.initPlayer();
                    }, 2000);
                    break;
                case 1:
                    this.retryCounter++;
                    setTimeout(() => {
                        this.initPlayer();
                    }, 6000);
                    break;
                case 2:
                    this.retryCounter++;
                    setTimeout(() => {
                        this.initPlayer();
                    }, 10000);
                    break;
            }
        });
    }
    addGradient() {
        const gradient = this.player.addChild('button', {});
        gradient.addClass('player-gradient');
        gradient.on('click', () => {
            if (this.config.disabled) {
                return;
            }
            if (this.paused) {
                this.player.play();
            }
            else {
                this.player.pause();
            }
            this.paused = !this.paused;
        });
    }
    handlePlayerErrors() {
        this.player.on('error', () => {
            if (!this.config.reloadOnError) {
                return;
            }
            this.player.reset();
            this.player.src(this.source());
            this.player.load();
            if (this.config.showFallback) {
                this.player.poster(this.environment.backendApiHost + this.config.fallbackUrl);
            }
            else {
                this.player.poster(this.environment.backendApiHost + this.config.thumbnailUrl);
            }
        });
    }
    // private applyUnstopable(): void {
    // const rewindPanel = document.querySelector('.vjs-control-bar');
    // if (!rewindPanel) {
    //     return;
    // }
    // if (this.config.unstoppable) {
    //     rewindPanel.classList.add('disabled-controls');
    // } else {
    //     rewindPanel.classList.remove('disabled-controls');
    // }
    // }
    initButtons() {
        if (!this.buttonsConfig) {
            return;
        }
        const container = this.addComponentButtons();
        this.buttonsConfig.forEach((button) => {
            var _a;
            this.removeButtonIfExists(button);
            if (button.disabled) {
                return;
            }
            let playerButton;
            if (!button.standAlone) {
                playerButton = container.addChild('button', { buttonId: button.cssIconClass });
            }
            else {
                playerButton = this.player.addChild('button', { buttonId: button.cssIconClass });
            }
            playerButton.addClass(button.cssIconClass);
            playerButton.on('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                button.action();
            });
            playerButton.on('touchstart', (e) => {
                e.preventDefault();
                e.stopPropagation();
                button.action();
            });
            (_a = button.stateSubject$) === null || _a === void 0 ? void 0 : _a.pipe(takeUntil(this.destroy$)).subscribe((state) => {
                this.toggleButtonState(playerButton, state);
            });
        });
    }
    removeButtonIfExists(button) {
        const existingButton = this.player.children().find(item => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.el_) === null || _a === void 0 ? void 0 : _a.classList.contains(button.cssIconClass); });
        if (existingButton) {
            this.player.removeChild(existingButton);
        }
    }
    toggleButtonState(button, state) {
        if (state) {
            button.addClass('active-button');
            return;
        }
        button.removeClass('active-button');
    }
    resetOverlays() {
        ['left-overlay', 'right-overlay', 'bottom-overlay'].forEach((clazz) => {
            const overlay = this.player.children().find(item => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.el_) === null || _a === void 0 ? void 0 : _a.classList.contains(clazz); });
            if (overlay) {
                this.player.removeChild(overlay);
            }
        });
        const leftOverlay = this.player.addChild('button', {});
        leftOverlay.addClass('left-overlay');
        const rightOverlay = this.player.addChild('button', {});
        rightOverlay.addClass('right-overlay');
        const bottomOverlay = this.player.addChild('button', {});
        bottomOverlay.addClass('bottom-overlay');
        this.overlaysSettings = [
            {
                type: OVERLAY_TYPE.LEFT,
                width: 140,
                class: 'left-overlay',
                button: leftOverlay
            },
            {
                type: OVERLAY_TYPE.RIGHT,
                width: 140,
                class: 'right-overlay',
                button: rightOverlay
            },
            {
                type: OVERLAY_TYPE.BOTTOM,
                width: 480,
                class: 'bottom-overlay',
                button: bottomOverlay
            }
        ];
    }
    listenPlayerSignals() {
        if (!this.player) {
            return;
        }
        // this.player.off('ended');
        // this.player.off('play');
        // this.player.off('fullscreenchange');
        this.player.on('canplay', () => {
            this.playButton = true;
        });
        this.player.on('ended', () => {
            this.videoEnded.emit();
            this.playerSignal.emit({ stop: true });
            if (this.config.mediaSource.subtype === MEDIA_SUBTYPE.TEASER || this.config.mediaSource.subtype === MEDIA_SUBTYPE.TRAILER) {
                this.playButton = false;
            }
        });
        this.player.on('play', () => {
            var _a, _b;
            this.paused = false;
            const time = this.currentLivestreamTime || this.config.playFrom || this.player.currentTime();
            this.config.playFrom = null;
            this.startedMain = ((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.mediaSource) === null || _b === void 0 ? void 0 : _b.subtype) === MEDIA_SUBTYPE.MAIN;
            this.playerSignal.emit({ start: Math.floor(time) * 1000 });
        });
        this.player.on('pause', () => {
            this.paused = true;
            if (this.player.currentTime() >= this.player.duration()) {
                return;
            }
            this.playerSignal.emit({ pause: true });
        });
        this.player.on('fullscreenchange', () => {
            this.isFullscreen = !this.isFullscreen;
            this.fullscreenToggle.emit(this.isFullscreen);
        });
    }
    listenClick() {
        if (!this.player) {
            return;
        }
        // this.player.off('click');
        this.player.on('click', (e) => {
            if (!['VIDEO'].includes(e.target.tagName)) {
                return;
            }
            this.clickCallback();
        });
        this.player.on('touchstart', (e) => {
            if (!['VIDEO', 'BUTTON'].includes(e.target.tagName)) {
                return;
            }
            this.clickCallback(true);
        });
    }
    clickCallback(touched) {
        if (this.config.unstoppable && !this.stopped) {
            this.player.play();
            this.openLink();
            this.videoClicked.emit();
            return;
        }
        this.stopped = !this.stopped;
        if (!touched) {
            return;
        }
        if (this.stopped) {
            this.player.pause();
        }
        else {
            this.player.play();
        }
    }
    openLink() {
        if (this.config.mediaSource.clickUrl) {
            window.open(this.config.mediaSource.clickUrl, '_blank');
        }
    }
    listenTimeGenerator() {
        this.timeGenerator$.pipe(takeUntil(this.destroy$)).subscribe((time) => {
            this.timeUpdate.emit(time);
        });
    }
    checkOverlays(time) {
        switch (time.type) {
            case ITimeType.MEDIA_TIME:
                this.processMediaTimeOverlay(time.time);
                break;
            case ITimeType.CLOCK_TIME:
                this.processClockTimeOverlay(time.time);
                break;
        }
    }
    processClockTimeOverlay(currentTime) {
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        const startDayTime = Math.floor(currentDate.getTime() / 1000);
        const timezoneOffset = currentDate.getTimezoneOffset() * 60;
        [...this.overlays, ...this.courses].forEach(over => {
            var _a;
            if (!over.active || ((_a = over.controls) === null || _a === void 0 ? void 0 : _a.isManual)) {
                return;
            }
            if ((currentTime + timezoneOffset) >= (startDayTime + over.startTime) && (currentTime + timezoneOffset) <= (startDayTime + over.startTime + 1)) {
                over.controls.isClosed = false;
            }
            if (over.controls.isClosed) {
                return;
            }
            if ((currentTime + timezoneOffset) >= (startDayTime + over.startTime) && (currentTime + timezoneOffset) <= (startDayTime + over.endTime)) {
                if (!over.controls.isShowing) {
                    this.renderOverlay(over);
                }
                return;
            }
            if (over.controls.isShowing) {
                this.removeOverlay(over);
            }
        });
    }
    processMediaTimeOverlay(seconds) {
        [...this.overlays, ...this.courses].forEach(over => {
            var _a;
            if (!over.active || ((_a = over.controls) === null || _a === void 0 ? void 0 : _a.isManual)) {
                return;
            }
            if (seconds >= over.startTime && seconds <= (over.startTime + 1)) {
                over.controls.isClosed = false;
            }
            if (over.controls.isClosed) {
                return;
            }
            if (seconds >= over.startTime && seconds <= over.endTime) {
                if (!over.controls.isShowing) {
                    this.renderOverlay(over);
                }
                return;
            }
            if (over.controls.isShowing) {
                this.removeOverlay(over);
            }
        });
    }
    updateVideoTimer(iTime) {
        switch (iTime.type) {
            case ITimeType.CLOCK_TIME:
                document.querySelector('.livestream-time').innerHTML = this.convertToTime(this.currentLivestreamTime);
                break;
            case ITimeType.MEDIA_TIME:
                document.querySelector('.livestream-time').innerHTML = this.convertToTime(iTime.time);
                break;
        }
    }
    convertToTime(time) {
        const seconds = Math.floor(time) % 60;
        const minutes = Math.floor(time / 60) % 60;
        const hours = Math.floor(time / 3600);
        if (hours) {
            return `${this.timeFormatter(hours)}:${this.timeFormatter(minutes)}:${this.timeFormatter(seconds)}`;
        }
        return `${this.timeFormatter(minutes)}:${this.timeFormatter(seconds)}`;
    }
    timeFormatter(numb) {
        return numb >= 10 ? '' + numb : '0' + numb;
    }
    renderOverlay(overlay) {
        const settings = this.getOverlaySettings(overlay.position);
        const container = this.getOverlayContainer(settings);
        container.appendChild(this.buildOverlayLayout(overlay));
        overlay.controls.isShowing = true;
        this.emitOverlayView(overlay);
        this.initOverlaySubscribers(overlay);
    }
    getOverlayContainer(settings) {
        return document.querySelector('.' + settings.class);
    }
    getOverlaySettings(position) {
        return this.overlaysSettings.find(item => item.type === position);
    }
    getOverlayElement(overlay, childClass) {
        if (!childClass) {
            return document.getElementById(`overlay-${overlay.id}`);
        }
        return document.querySelector(`#overlay-${overlay.id} .${childClass}`);
    }
    removeOverlay(overlay, closedByBtn = false) {
        overlay.controls.isShowing = false;
        overlay.controls.isClosed = closedByBtn;
        const el = this.getOverlayElement(overlay);
        if (!el) {
            return;
        }
        el.remove();
    }
    buildOverlayLayout(overlay) {
        const picture = (overlay === null || overlay === void 0 ? void 0 : overlay.picture) ? this.environment.backendApiHost + overlay.picture.photoUrl : null;
        const el = document.createElement('div');
        el.id = `overlay-${overlay.id}`;
        el.classList.add('overlay');
        el.innerHTML = overlay.isCourses ? this.buildCourseLayout(overlay, picture) : this.buildBannerLayout(overlay, picture);
        return el;
    }
    buildCourseLayout(overlay, pictureUrl) {
        return `
                <div style="${this.getCourseBackground(overlay, pictureUrl)}"
                class="overlay-box course-box">
                    <p class="text ${overlay.color.toLowerCase()}">
                    ${overlay.textDescription}</p>
                    <button class="btn btn-primary btn-still">
                        ${this.localize.getByKey('course.button.stillHere')}
                    </button>
                </div>`;
    }
    getCourseBackground(overlay, pictureUrl) {
        if (pictureUrl) {
            return `background-image: url(${pictureUrl});`;
        }
        const color = overlay.color.toLowerCase() === 'black' ? 'white' : 'black';
        return `background-color: ${color}`;
    }
    buildBannerLayout(overlay, pictureUrl) {
        return `<span class="icon icon-close close-overlay"></span>
                <a href="${(overlay === null || overlay === void 0 ? void 0 : overlay.url) ? this.buildOverlayUrl(overlay.url) : 'javascript:void(0)'}" target="${overlay.url ? '_blank' : '_self'}">
                <div style="
                    background-image: url(${pictureUrl});"
                    class="overlay-box clickable">
                    </div>
                </a>`;
    }
    buildOverlayUrl(url) {
        let res = url;
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
            res = 'https://' + url;
        }
        return res;
    }
    refreshContainerSize() {
        const height = Math.floor(this.videoWrapper.nativeElement.clientWidth * 0.5625);
        this.videoWrapper.nativeElement.style.height = height + 'px';
    }
    addComponentButtons() {
        this.player.removeChild('component');
        const container = this.player.addChild('component');
        container.addClass('buttons-player-box');
        this.setComponents();
        return container;
    }
    setComponents() {
        var _a;
        if (this.config.componentRef) {
            this.player.el().appendChild(this.config.componentRef);
        }
        if ((_a = this.config.componentRefs) === null || _a === void 0 ? void 0 : _a.length) {
            this.config.componentRefs.filter((ref) => !(ref === null || ref === void 0 ? void 0 : ref.hide)).forEach((ref) => {
                this.player.el().appendChild(ref.ref);
            });
        }
    }
    emitOverlayView(overlay) {
        if (overlay.controls.isShowed) {
            return;
        }
        overlay.controls.isShowed = true;
        this.overlayViewed.emit(overlay);
    }
    initOverlaySubscribers(overlay) {
        this.overlayClickSubscribe(overlay, 'close-overlay', () => {
            this.removeOverlay(overlay, true);
        });
        this.overlayClickSubscribe(overlay, 'clickable', () => {
            this.overlayClicked.emit(overlay);
        });
        this.overlayClickSubscribe(overlay, 'btn-still', () => {
            this.overlayClicked.emit(overlay);
            this.removeOverlay(overlay, true);
        });
    }
    overlayClickSubscribe(overlay, clazz, cb) {
        const el = this.getOverlayElement(overlay, clazz);
        if (!el) {
            return;
        }
        fromEvent(this.getOverlayElement(overlay, clazz), 'click')
            .subscribe((event) => {
            cb();
        });
    }
    resolveOverlaysTime(overlays) {
        return overlays;
        // return overlays?.map((overlay) => {
        //     overlay.endTime = overlay.duration; // TEMPORARY FIX!!!
        //     return overlay;
        // });
    }
};
VideojsComponent.ɵfac = function VideojsComponent_Factory(t) { return new (t || VideojsComponent)(ɵngcc0.ɵɵdirectiveInject(AutoDestroyService), ɵngcc0.ɵɵdirectiveInject(MarketingService), ɵngcc0.ɵɵdirectiveInject(LocalizationProvider), ɵngcc0.ɵɵdirectiveInject(ENVIRONMENT)); };
VideojsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VideojsComponent, selectors: [["ano-videojs"]], viewQuery: function VideojsComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c31, 7);
        ɵngcc0.ɵɵviewQuery(_c32, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.videoWrapper = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.target = _t.first);
    } }, inputs: { _playerController: ["playerController", "_playerController"], _config: ["config", "_config"], buttonsConfig: "buttonsConfig", _currentLivestreamTime: ["currentLivestreamTime", "_currentLivestreamTime"], marketingSocket: "marketingSocket", externalPlayerSignal: "externalPlayerSignal" }, outputs: { videoEnded: "videoEnded", videoClicked: "videoClicked", playerSignal: "playerSignal", overlayClicked: "overlayClicked", overlayViewed: "overlayViewed", fullscreenToggle: "fullscreenToggle", timeUpdate: "timeUpdate" }, features: [ɵngcc0.ɵɵProvidersFeature([AutoDestroyService, SchedulerService, MarketingService])], decls: 4, vars: 4, consts: [["videoWrapper", ""], ["oncontextmenu", "return false;", "webkit-playsinline", "", "playsinline", "", "crossorigin", "anonymous", 1, "video-js", 2, "width", "100%", "height", "100%"], ["target", ""]], template: function VideojsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", null, 0);
        ɵngcc0.ɵɵelement(2, "video", 1, 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hidden-controls", (ctx.config == null ? null : ctx.config.mediaSource == null ? null : ctx.config.mediaSource.subtype) !== ctx.MEDIA_SUBTYPE.MAIN && !ctx.startedMain)("no-play", !ctx.playButton);
    } }, styles: ["@charset \"UTF-8\";.hidden-controls[_ngcontent-%COMP%]     .livestream-time, .hidden-controls[_ngcontent-%COMP%]     .vjs-progress-control, .hidden-controls[_ngcontent-%COMP%]     .vjs-remaining-time{opacity:0!important}.hidden-controls[_ngcontent-%COMP%]     .vjs-remaining-time{opacity:1!important;position:absolute;left:-50px}.no-play[_ngcontent-%COMP%]     .vjs-big-play-button{display:none!important}video[_ngcontent-%COMP%]{outline:none;width:100%;height:100%}.center[_ngcontent-%COMP%]{left:50%;top:50%}app-stream-access-modal[_ngcontent-%COMP%], app-stream-age-restrictions-modal[_ngcontent-%COMP%]{position:absolute;z-index:10001}.icon-video-file[_ngcontent-%COMP%]{font-size:140px;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);color:#0e54a9;z-index:101}.volume-hover[_ngcontent-%COMP%]{bottom:285px!important} .active-button{color:#1d7dd3}.played[_ngcontent-%COMP%]{display:flex}.vjs-paused.vjs-has-started[_ngcontent-%COMP%]     .vjs-big-play-button{display:block}.video-js.vjs-has-started[_ngcontent-%COMP%]     .show-overlay{display:block!important}.video-js[_ngcontent-%COMP%]{position:relative;width:100%!important}.video-js[_ngcontent-%COMP%]:hover     .player-gradient{display:block}.video-js[_ngcontent-%COMP%]:hover     .icon-chat{display:block}.video-js[_ngcontent-%COMP%]:hover     .icon-linked{display:block}.video-js[_ngcontent-%COMP%]:hover     .icon-users{display:block}.video-js[_ngcontent-%COMP%]:hover     .icon-data-random{display:block}.video-js[_ngcontent-%COMP%]:hover     .icons-donations{display:block}.video-js[_ngcontent-%COMP%]:hover     .location{display:block}.video-js[_ngcontent-%COMP%]:hover     .icon-presentation{display:block}.video-js[_ngcontent-%COMP%]:hover     .icon-calendar{display:block}.video-js[_ngcontent-%COMP%]:hover     .icon-360{display:block}.video-js[_ngcontent-%COMP%]:hover     .icon-share-alt{display:block}.video-js[_ngcontent-%COMP%]     .vjs-control-bar.disabled-controls{display:none}.video-js[_ngcontent-%COMP%]     .disabled-chat{display:none}.video-js[_ngcontent-%COMP%]     .icon-chat, .video-js[_ngcontent-%COMP%]     .icon-data-random, .video-js[_ngcontent-%COMP%]     .icon-linked, .video-js[_ngcontent-%COMP%]     .icon-share-alt, .video-js[_ngcontent-%COMP%]     .icon-users{display:none;color:#fff;font-size:25px;width:25px;height:25px;font-family:icomoon!important;font-style:normal;font-weight:400;font-feature-settings:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;outline:none;z-index:100}.video-js[_ngcontent-%COMP%]     .icon-chat.active-button, .video-js[_ngcontent-%COMP%]     .icon-data-random.active-button, .video-js[_ngcontent-%COMP%]     .icon-linked.active-button, .video-js[_ngcontent-%COMP%]     .icon-share-alt.active-button, .video-js[_ngcontent-%COMP%]     .icon-users.active-button{color:#1d7dd3}.video-js[_ngcontent-%COMP%]     .icon-chat:before{content:\"\uE90B\"}.video-js[_ngcontent-%COMP%]     .icon-share-alt:before{content:\"\uE93A\"}.video-js[_ngcontent-%COMP%]     .icons-donations{display:none;position:absolute;color:#fff;font-size:25px;right:19px;bottom:120px;width:25px;height:25px;font-family:icomoon!important;font-style:normal;font-weight:400;font-feature-settings:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;outline:none;z-index:100}.video-js[_ngcontent-%COMP%]     .icons-donations.active-button{color:#1d7dd3}.video-js[_ngcontent-%COMP%]     .icons-donations:before{content:\"\uE951\"}.video-js[_ngcontent-%COMP%]     .location{display:none;color:#fff;font-size:25px;width:25px;height:25px;font-family:icomoon!important;font-style:normal;font-weight:400;font-feature-settings:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;outline:none;z-index:100}.video-js[_ngcontent-%COMP%]     .location.active-button{color:#1d7dd3}.video-js[_ngcontent-%COMP%]     .location:before{content:\"\uE935\"}.video-js[_ngcontent-%COMP%]     .icon-presentation{display:none;color:#fff;font-size:25px;width:25px;height:25px;font-family:icomoon!important;font-style:normal;font-weight:400;font-feature-settings:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;outline:none;z-index:100}.video-js[_ngcontent-%COMP%]     .icon-calendar{display:none;font-size:25px;width:25px;height:25px;outline:none;z-index:100}.video-js[_ngcontent-%COMP%]     .icon-360{display:none;font-size:25px;width:25px;height:25px;outline:none;z-index:100;left:19px;top:83%}.video-js[_ngcontent-%COMP%]     .player-gradient{height:220px;width:100%;position:absolute;bottom:0;left:0;transition:opacity .25s cubic-bezier(0,0,.2,1);background:linear-gradient(0deg,rgba(0,0,0,.65),rgba(34,34,34,.28) 50%,transparent 90%);display:none;outline:none;z-index:0}.video-js[_ngcontent-%COMP%]     .resize{transform:rotate(-90deg);position:absolute;z-index:1000;color:#0e2f90;font-size:25px;right:19px;bottom:20px;width:25px;height:25px;font-family:icomoon!important;font-style:normal;font-weight:400;font-feature-settings:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;outline:none}.video-js[_ngcontent-%COMP%]     .resize.active-button{color:#1d7dd3}.video-js[_ngcontent-%COMP%]     .resize:before{content:\"\uE91D\"}.video-js[_ngcontent-%COMP%]     .resize   .icon-donations{display:none;position:absolute;color:#0e2f90;font-size:25px;right:19px;bottom:120px;width:25px;height:25px;font-family:icomoon!important;font-style:normal;font-weight:400;font-feature-settings:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;outline:none;z-index:10000000}.video-js[_ngcontent-%COMP%]     .resize   .icon-donations.active-button{color:#1d7dd3}.video-js[_ngcontent-%COMP%]     .resize   .icon-donations:before{content:\"\uE951\"}.video-js[_ngcontent-%COMP%]     .left-course, .video-js[_ngcontent-%COMP%]     .left-overlay{position:absolute;width:140px;height:200px;left:25px;top:70px;background-color:transparent;display:block}.video-js[_ngcontent-%COMP%]     .right-course, .video-js[_ngcontent-%COMP%]     .right-overlay{position:absolute;width:140px;height:200px;right:25px;top:70px;background-color:transparent;display:block}.video-js[_ngcontent-%COMP%]     .bottom-course, .video-js[_ngcontent-%COMP%]     .bottom-overlay{position:absolute;width:480px;height:70px;left:50%;transform:translatex(-50%);bottom:70px;background-color:transparent;display:block}.video-js[_ngcontent-%COMP%]   video[_ngcontent-%COMP%]{position:absolute;height:100%!important;width:100%!important}.video-js[_ngcontent-%COMP%]     .vjs-control-bar{background-color:transparent;bottom:30px;left:10%;width:90%;z-index:1000}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-paused{display:none}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-playing{display:none}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-volume-panel{position:absolute;right:10px;bottom:33px;display:flex;flex-direction:row-reverse}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-volume-panel .vjs-icon-placeholder:before{font-size:2.5em;line-height:1.67;position:absolute;top:-5px}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-picture-in-picture-control{display:none}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-progress-holder{height:12px;background:#0e2f90}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-play-control{display:none}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-play-progress:before{top:-7px;height:26px;width:26px;border-radius:50%;background:#fff}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-fullscreen-control{margin-left:31px;color:#fff;font-family:icomoon!important;speak:none;font-style:normal;font-weight:400;font-feature-settings:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;font-size:25px;width:1em;right:-20px}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-fullscreen-control:before{content:\"\uE91D\"}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-fullscreen-control .vjs-icon-placeholder:before{content:\"\"}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .livestream-time{display:block;left:-102%;color:#fff;background-color:rgba(0,0,0,.4)}.video-js[_ngcontent-%COMP%]     .vjs-control-bar .vjs-live-display{display:none}.video-js[_ngcontent-%COMP%]     button.vjs-big-play-button{border:none;position:absolute;z-index:102;top:50%;left:50%;transform:translate(-50%,-50%);width:122px;height:122px;border-radius:50%;background:rgba(12,29,63,.85);cursor:pointer}.video-js[_ngcontent-%COMP%]     button.vjs-big-play-button:after{content:\"\";position:absolute;z-index:103;top:50%;left:50%;transform:translateY(-50%);margin-left:-20px;border-top:38px solid transparent;border-bottom:38px solid transparent;border-left:60px solid #fff;cursor:pointer}.video-js[_ngcontent-%COMP%]     button.vjs-big-play-button .vjs-icon-placeholder:before{content:\"\"}.no-data[_ngcontent-%COMP%]     .video-js.vjs-paused .vjs-poster{display:block!important;background-size:cover!important}  .vjs-poster{background-size:cover!important}.video-js[_ngcontent-%COMP%]{-o-object-fit:cover;object-fit:cover}.disabled-player[_ngcontent-%COMP%]{pointer-events:none}.timeline-no-action[_ngcontent-%COMP%]{background-color:#bebebe}.timeline-can-take-action[_ngcontent-%COMP%]{background-color:#5ea1f2!important}.timeline-can-take-action[_ngcontent-%COMP%]:after{border-left-color:#5ea1f2!important}.timeline-can-take-action[_ngcontent-%COMP%]:before{border-right-color:#5ea1f2!important}.timeline-action-taken[_ngcontent-%COMP%]{background-color:#0e54a9}.timeline-action-taken[_ngcontent-%COMP%]:after{border-left-color:#0e54a9!important}.timeline-action-taken[_ngcontent-%COMP%]:before{border-right-color:#0e54a9!important}.timeline-finished[_ngcontent-%COMP%]{background-color:#fc4349}.timeline-finished[_ngcontent-%COMP%]:after{border-left-color:#fc4349!important}.timeline-finished[_ngcontent-%COMP%]:before{border-right-color:#fc4349!important}  .close-overlay{position:absolute;right:0;background:#000;padding:2px;z-index:11}  .buttons-player-box{display:flex;flex-direction:column;position:absolute;z-index:100;bottom:90px;right:20px;height:100px;justify-content:flex-end}  .buttons-player-box button{margin-bottom:5px!important}  .overlay{height:100%;position:absolute;width:100%;top:0;z-index:1000}  .clickable{position:absolute;z-index:10!important}  .btn-still{position:absolute;right:18px;top:18px;z-index:15}  .left-course .btn-still,   .left-overlay .btn-still,   .right-course .btn-still,   .right-overlay .btn-still{right:21px;left:21px;top:auto;bottom:15px}  .video-js button.btn-primary{background:#0e54a9;color:#fff;border:none}  .video-js button.btn-primary:hover{background:#0c1d3f}  p.text-course{position:absolute;height:100%;margin:0;width:100%;padding:10px;opacity:1;z-index:2}  .overlay-box{width:100%;height:100%;background-position:50%;background-size:cover;padding:10px;color:#fff;text-shadow:0 0 1em #000;font-weight:700;z-index:1}  .course-box{z-index:11;padding:0!important}  .bottom-course .text-course,   .bottom-overlay .text-course{text-align:left;display:flex;align-items:center}  p.text{position:absolute;height:100%;margin:0;width:100%;padding:10px;opacity:1;z-index:2}  .black{text-shadow:0 0 1em #000;color:#000}  .white{text-shadow:0 0 1em #fff;color:#fff}  .vjs-fullscreen .left-course,   .vjs-fullscreen .left-overlay,   .vjs-fullscreen .right-course,   .vjs-fullscreen .right-overlay{top:50%!important;transform:translateY(-50%)!important}  .vjs-fullscreen .bottom-course,   .vjs-fullscreen .bottom-overlay{height:92px!important;width:624px!important}@media (max-width:767px){.video-js[_ngcontent-%COMP%]     .left-course, .video-js[_ngcontent-%COMP%]     .left-overlay{width:100px;height:120px;left:10px;top:10px}.video-js[_ngcontent-%COMP%]     .right-course, .video-js[_ngcontent-%COMP%]     .right-overlay{width:100px;height:120px;right:10px;top:10px}.video-js[_ngcontent-%COMP%]     .bottom-course, .video-js[_ngcontent-%COMP%]     .bottom-overlay{width:75%;aspect-ratio:6.8/1;height:auto}}"] });
__decorate([
    ViewChild('videoWrapper', { static: true })
], VideojsComponent.prototype, "videoWrapper", void 0);
__decorate([
    ViewChild('target', { static: true })
], VideojsComponent.prototype, "target", void 0);
__decorate([
    Input()
], VideojsComponent.prototype, "marketingSocket", void 0);
__decorate([
    Input('playerController')
], VideojsComponent.prototype, "_playerController", null);
__decorate([
    Input('config')
], VideojsComponent.prototype, "_config", null);
__decorate([
    Input()
], VideojsComponent.prototype, "buttonsConfig", null);
__decorate([
    Input('currentLivestreamTime')
], VideojsComponent.prototype, "_currentLivestreamTime", null);
__decorate([
    Input()
], VideojsComponent.prototype, "externalPlayerSignal", void 0);
__decorate([
    Output()
], VideojsComponent.prototype, "videoEnded", void 0);
__decorate([
    Output()
], VideojsComponent.prototype, "videoClicked", void 0);
__decorate([
    Output()
], VideojsComponent.prototype, "playerSignal", void 0);
__decorate([
    Output()
], VideojsComponent.prototype, "overlayClicked", void 0);
__decorate([
    Output()
], VideojsComponent.prototype, "overlayViewed", void 0);
__decorate([
    Output()
], VideojsComponent.prototype, "fullscreenToggle", void 0);
__decorate([
    Output()
], VideojsComponent.prototype, "timeUpdate", void 0);
VideojsComponent = __decorate([ __param(0, Inject(AutoDestroyService)),
    __param(1, Inject(MarketingService)),
    __param(2, Inject(LocalizationProvider)),
    __param(3, Inject(ENVIRONMENT))
], VideojsComponent);

let CmsService = class CmsService {
    constructor(apiService, apiUrls, environment) {
        this.apiService = apiService;
        this.apiUrls = apiUrls;
        this.environment = environment;
        this.rawCountryList = [];
        this.countriesList = [];
        this.restrictedRegionsList = [];
        this.genres = [];
    }
    getCountries() {
        return new Promise(resolve => {
            this.apiService.get(this.apiUrls.COUNTRIES, { host: this.environment.cmsHost, isWithoutRootUrl: true })
                .pipe(pluck('results', 'countries'), take(1)).subscribe(countries => {
                this.rawCountryList = countries;
                this.restrictedRegionsList = this.mapToRestrictedRegions(countries).sort((a, b) => a.value < b.value ? -1 : 1);
                this.countriesList = this.mapCountriesToKeyValue(countries).sort((a, b) => a.value < b.value ? -1 : 1);
                resolve(this.countriesList);
            });
        });
    }
    getCountyByCode(code) {
        return this.countriesList.find(country => country.key === code);
    }
    getCityByName(cities, cityName) {
        return cities.find(country => country.value === cityName);
    }
    getCityByCode(cities, cityCode) {
        return cities.find(country => country.key === cityCode);
    }
    getGenresOnStart() {
        return new Promise(resolve => {
            return this.apiService.get(this.apiUrls.GENRES, { host: this.environment.cmsHost, isWithoutRootUrl: true })
                .pipe(pluck('results', 'data'), take(1)).subscribe(genres => {
                this.genres = this.mapGenresToKeyValue(genres);
                resolve(this.genres);
            });
        });
    }
    mapCountriesToKeyValue(countries) {
        return countries.map(country => {
            country.value = country.nameLoc;
            country.key = country.code;
            // delete country.id;
            delete country.name;
            delete country.code;
            return country;
        });
    }
    mapCitiesToKeyValue(countries) {
        return countries.map(country => {
            country.value = country.nameLoc;
            country.key = country.name;
            // delete country.id;
            delete country.name;
            delete country.nameLoc;
            delete country.code;
            return country;
        });
    }
    mapToRestrictedRegions(countries) {
        const _countries = _.cloneDeep(countries);
        return _countries.map(country => {
            country.value = country.nameLoc;
            country.key = country.id;
            delete country.id;
            delete country.name;
            delete country.code;
            return country;
        });
    }
    getGenres() {
        return this.apiService.get(this.apiUrls.GENRES)
            .pipe(pluck('results', 'data'));
    }
    mapGenresToKeyValue(genres) {
        return genres.map(item => ({ key: item.id, value: item.name }));
    }
    getCountryByKey(key) {
        return this.rawCountryList.find(country => country.key === key);
    }
};
CmsService.ɵfac = function CmsService_Factory(t) { return new (t || CmsService)(ɵngcc0.ɵɵinject(ApiService), ɵngcc0.ɵɵinject(API_URLS), ɵngcc0.ɵɵinject(ENVIRONMENT)); };
CmsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function CmsService_Factory() { return new CmsService(i0.ɵɵinject(ApiService), i0.ɵɵinject(API_URLS), i0.ɵɵinject(ENVIRONMENT)); }, token: CmsService, providedIn: "root" });
CmsService = __decorate([ __param(0, Inject(ApiService)),
    __param(1, Inject(API_URLS)),
    __param(2, Inject(ENVIRONMENT))
], CmsService);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AutoDestroyService, [{
        type: Injectable
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableComponent, [{
        type: Component,
        args: [{
                selector: 'ano-table',
                template: "<div class=\"card\" [class.table-container]=\"config?.fullHeight\">\n    <div class=\"card-header bg-transparent p-0\" *ngIf=\"title\">\n        <h2 class=\"title-card\"><b>{{ title }}</b></h2>\n    </div>\n    <ng-content select=\"[role=searchWithButtons]\"></ng-content>\n    <ng-container *ngIf=\"withSearch || timeRangeConfig\">\n        <div class=\"table-header-area align-items-center\"\n             [class.align-content-between]=\"buttonsConfig?.length || addButton\"\n             [class.align-content-end]=\"!buttonsConfig?.length && !addButton\">\n            <div class=\"buttons-container\">\n                <button class=\"btn btn-primary add-button\" *ngIf=\"addButton\" [disabled]=\"disabledInputs || disabledAddButton\" (click)=\"addItem()\">\n                    <i class=\"icon icon-plus-circle\"></i>\n                    {{addButtonText | localize}}\n                </button>\n                <ng-container *ngIf=\"buttonsConfig?.length\">\n                    <div class=\"form-group no-margin\" *ngFor=\"let cfg of buttonsConfig\">\n                        <ano-button (click)=\"cfg.action()\" [config]=\"cfg.buttonConfig\">\n                            <ng-container>\n                                <i *ngIf=\"cfg.icon\" class=\"{{cfg.icon}}\"></i>\n                                <span>{{cfg.text | localize}}</span>\n                            </ng-container>\n                        </ano-button>\n                    </div>\n                </ng-container>\n\n            </div>\n            <div class=\"filter-and-search\" [class.justify-content-end]=\"!filtersList?.length && !timeRangeConfig && !config?.filtersWidth100\" [class.width100]=\"config?.filtersWidth100\">\n                <ng-container *ngIf=\"filtersList?.length\">\n                    <div class=\"blue-theme-filter table-filters\">\n                        <form [formGroup]=\"filtersForm\">\n                            <ng-container *ngFor=\"let filter of filtersList; let i = index\">\n                                <ano-input [formControlName]=\"filter.name\"\n                                           [isEditMode]=\"true\"\n                                           [noBorder]=\"false\"\n                                           [config]=\"{\n                            inputType: filter.isMultiselect ? INPUT_TYPES.MULTISELECT\n                                       : filter.isMultiselectInSingleDropdown ? INPUT_TYPES.MULTISELECT_IN_SINGLE_DROPDOWN\n                                       : INPUT_TYPES.SELECT,\n                            placeholder: filter.placeholder,\n                            selectOptions: filter.selectOptions\n                       }\"\n                                ></ano-input>\n                            </ng-container>\n                        </form>\n                    </div>\n                </ng-container>\n                <ng-container *ngIf=\"showDatepicker; else timeRange\">\n                    <ano-datepicker class=\"pr-2\" [startFromAll]=\"startFromAll\" (changeDate)=\"timeRangeFilter($event)\"></ano-datepicker>\n                </ng-container>\n                <ng-template #timeRange>\n                    <ano-time-range-filter *ngIf=\"timeRangeConfig\" [config]=\"timeRangeConfig\"\n                                       (filterByTimeRange$)=\"timeRangeFilter($event)\"></ano-time-range-filter>\n                </ng-template>\n                <ano-linked-streams-filter *ngIf=\"isLinkedStreamsFilters\"\n                                           [filters]=\"linkedFilters\"\n                                           (filterByLinkedStreams$)=\"filterByLinkedStreams($event)\"></ano-linked-streams-filter>\n                <div *ngIf=\"withFilters\" class=\"year-filter\">\n                    <ng-container *ngIf=\"withFilters && years?.length && !timeRangeConfig\">\n                        <div class=\"dropdown\">\n                        </div>\n                        <ano-filter-dropdown [values]=\"years\" [value]=\"'all'\"\n                                             (change)=\"searchByYear($event)\"></ano-filter-dropdown>\n                    </ng-container>\n                </div>\n                <ano-search *ngIf=\"withSearch\" class=\"border-form input-form\"  [type]=\"searchInputType\" [disabled]=\"disabledInputs\" (search$)=\"search($event)\"></ano-search>\n            </div>\n        </div>\n    </ng-container>\n    <div class=\"table-responsive\" [class.custom-scroll]=\"config?.customScroll\">\n        <table class=\"table table-material\" #tableElement>\n            <ano-loader *ngIf=\"loading\" [isOpen]=\"loading\" [containerRef]=\"tableElement\"></ano-loader>\n            <thead>\n            <ng-content select=\"[role=table-header]\"></ng-content>\n            </thead>\n            <tbody>\n            <div class=\"table-wrapper-border p-0\" [class.no-data]=\"data?.length === 0\">\n                <div class=\"text-center no-results\" *ngIf=\"data?.length === 0 && !config?.noDataLink\">\n                    {{(systemMessage || 'table.noResults') | localize}}\n                </div>\n                <div *ngIf=\"data?.length === 0 && config?.noDataLink\"  class=\"no-data-button-container\">\n                    <ano-button class=\"cancel-button\"\n                                (click)=\"goToNoDataLink(config?.noDataLink?.url)\"\n                                [config]=\"{\n                                            type: 'button',\n                                            styleType: 'primary'\n                                            }\">\n                        <ng-container>{{ config?.noDataLink?.title | localize }}</ng-container>\n                    </ano-button>\n                </div>\n                <p-table #table [value]=\"data\"\n                         [lazy]=\"true\"\n                         (onLazyLoad)=\"refreshData($event)\"\n                         [tableStyleClass]=\"'table table-sm table-border'\"\n                         [rows]=\"itemsOnPage\"\n                         [totalRecords]=\"totalItems\"\n                         [sortField]=\"defaultSortField\"\n                         [sortOrder]=\"sortOrder\"\n                >\n                    <ng-template pTemplate=\"header\" let-columns>\n                        <tr *ngIf=\"data?.length > 0\">\n                            <ng-container *ngFor=\"let col of config.columns\">\n                            <th *ngIf=\"!col.hide\"  [class.cursor-pointer]=\"col.sortField\"\n                                [style.text-align]=\"col?.textAlign\"\n                                [pSortableColumn]=\"col.sortField\" (click)=\"col.sortField && resetTableData()\">\n                                <div [class]=\"'head-cell head-cell-' + (col.class || 'left')\">\n                                    <p-sortIcon *ngIf=\"col.sortField\" [field]=\"col.sortField\"\n                                                ariaLabel=\"Activate to sort\"\n                                                ariaLabelDesc=\"Activate to sort in descending order\"\n                                                ariaLabelAsc=\"Activate to sort in ascending order\"></p-sortIcon>\n                                    <div class=\"head-cell-text\"><span>{{col.name | localize | whiteSpace}}</span></div>\n                                </div>\n                            </th>\n                            </ng-container>\n                        </tr>\n                    </ng-template>\n                    <ng-template pTemplate=\"body\" let-rowData let-columns=\"columns\">\n                        <tr [ngClass]=\"getHighlightClass(rowData)\"\n                            [class.hover]=\"isOpportunityToSelect\"\n                            [class.selected]=\"selectedRowId && selectedRowId === rowData?.id\">\n                            <ng-container *ngFor=\"let col of config.columns\">\n                                <td [width]=\"col?.width || 'auto'\" [class]=\"col.class || 'left'\" *ngIf=\"!col.hide\"\n                                    [style.text-align]=\"col?.textAlign\"\n                                    [class.hover]=\"isOpportunityToSelect\"\n                                    (click)=\"onRowClick(rowData); config.navigationUrl && !col?.preventNavigation && navigate(rowData.id)\">\n                                    <ng-container *ngIf=\"!col.tmpl\">\n                                        <ng-container *ngIf=\"!col.boolean && !col.date && !col.image\">\n                                            <ng-container *ngIf=\"col.dataField\">\n                                                {{rowData[col.dataField]}}\n                                                <ng-container *ngIf=\"col.units\">\n                                                    {{col.units}}\n                                                </ng-container>\n                                            </ng-container>\n                                            <ng-container *ngIf=\"col.dataFieldUnit\">\n                                                {{rowData[col.dataFieldUnit.parentField][col.dataFieldUnit.value]}}\n                                                {{rowData[col.dataFieldUnit.parentField][col.dataFieldUnit.unit]}}\n                                            </ng-container>\n                                        </ng-container>\n                                        <ng-container *ngIf=\"!col.boolean && col.date && !col.image\">\n                                            <ng-container *ngIf=\"col.dataField\">\n                                                {{formatDate(rowData[col.dataField])}}\n                                            </ng-container>\n                                        </ng-container>\n                                    </ng-container>\n                                    <ng-container *ngIf=\"col.tmpl\">\n                                        <ng-container\n                                                *ngTemplateOutlet=\"col.tmpl; context:{rowData: rowData}\"></ng-container>\n                                    </ng-container>\n                                </td>\n                            </ng-container>\n                        </tr>\n                        <!--<ng-content select=\"[role=table-summary]\"></ng-content>-->\n                    </ng-template>\n                    <ng-template *ngIf=\"config?.tableSummary\" pTemplate=\"summary\">\n                        <ng-container\n                                *ngTemplateOutlet=\"config.tableSummary\"></ng-container>\n                    </ng-template>\n                </p-table>\n            </div>\n            </tbody>\n        </table>\n    </div>\n    <!--    </div>-->\n    <!--    <div class=\"card-footer bg-white\" *ngIf=\"showLoadMore\">-->\n    <!--        <div class=\"row justify-content-center\">-->\n    <!--            <div class=\"col-auto\">-->\n    <!--                <button (click)=\"loadNextPage()\" class=\"btn btn-primary\">Weitere laden</button>-->\n    <!--            </div>-->\n    <!--        </div>-->\n    <!--    </div>-->\n    <div *ngIf=\"downloadButton && !loading && data?.length\"\n         class=\"table-footer-area align-content-end align-items-center\">\n        <button class=\"btn btn-success\"\n                (click)=\"download()\">{{downloadButtonText | localize}}\n          <ano-loader [isOpen]=\"isDownloadLoading\"></ano-loader>\n        </button>\n        <ng-content select=\"[role=bottomButtons]\"></ng-content>\n    </div>\n    <div *ngIf=\"!config.matPaginator && showLoadMore && !loading && data?.length > 0\"\n         class=\"table-footer-area align-content-center align-items-center\">\n        <button class=\"btn btn-primary\" (click)=\"loadNextPage()\">Weitere laden</button>\n        <ng-content select=\"[role=bottomButtons]\"></ng-content>\n    </div>\n    <div *ngIf=\"config.matPaginator && data?.length > 0\" class=\"align-content-end bg-white\">\n        <mat-paginator *ngIf=\"totalPages > 1\" [length]=\"totalItems\"\n                       [pageSize]=\"itemsOnPage\"\n                       [pageSizeOptions]=\"[10, 20, 50]\"\n                       (page)=\"goToPage($event)\">\n        </mat-paginator>\n    </div>\n    <span *ngIf=\"!config\"> no config for the table </span>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                providers: [AutoDestroyService],
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".input-form{height:40px}.input-form .form-control{line-height:1.65}.tr-flex{display:flex;align-items:center}.middle{vertical-align:middle!important;text-align:center!important}.left{text-align:left!important}tr td{vertical-align:middle;white-space:nowrap}tr td.price{width:100px;text-align:right!important}tr td.date{width:165px}tr td.actions{width:130px}tr td .long-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}tr th{text-align:center;outline:none;white-space:nowrap}.align-content-center{display:flex;justify-content:center}.icon-info{margin-left:4px;font-size:15px;position:relative;top:1px}.icon-plus-circle{margin-right:8px}.icon-plus-circle:before{vertical-align:middle}.no-results{margin:20px 0;color:#0e54a9;font-size:14px}.no-data{padding:0!important}.filter-and-search{display:flex;align-items:center;justify-content:space-between}.year-filter{margin-right:30px}.table-wrapper-border{min-height:61px}.custom-scroll:after,.custom-scroll:before{content:\"\";flex:1}.custom-scroll::-webkit-scrollbar{width:20px}.custom-scroll::-webkit-scrollbar-track{box-shadow:none;border-radius:0;background:#efefef}.custom-scroll::-webkit-scrollbar-thumb{background:#0e54a9;border-radius:3px}.table-responsive{position:relative}.no-margin{margin:0}.ui-table-wrapper thead tr th{background-color:#fff}.head-cell{align-items:center}.price{text-align:right!important}tr.hover:hover{cursor:pointer;background-color:rgba(0,126,140,.08)}tr.selected{background-color:#007e8c}tr.selected:hover{background-color:rgba(0,126,140,.3)}.table tbody .btn-box{padding-top:15px}.table tbody .btn-box .btn+.btn{margin-top:10px}.table .action-list{list-style-type:none;padding:0;margin:0;display:flex}.table .action-list li+li{margin-left:10px}.table .action-list li .icon{font-size:20px}.table .icon-waiting{font-size:15px;position:relative;top:2px}.table .icon-login{font-size:14px;position:relative;top:2px}.table .icon-download{position:relative}.table-calculate{margin-bottom:1.25rem}.table-calculate thead .price{background-color:#fff;color:#0e54a9;border:1px solid #252525;display:block;text-align:center;min-width:109px}.table-calculate tbody tr td{font-size:.875rem;color:#0e54a9}.table-calculate .dropdown-toggle:after{content:\"\";font-size:0!important;border-left:4px solid transparent!important;border-right:4px solid transparent!important;border-top:6px solid #252525!important;right:5px}.table-calculate .btn-outline-secondary{font-family:Poppins-Regular,sans-serif!important;color:#0e54a9}.table-payout thead tr th{padding-left:20px;padding-right:20px}.table-payout tr td{text-align:center}.table-payout tr td:first-child{text-align:left}.table-payout tbody tr td.title{padding-top:1rem;padding-bottom:.5rem;text-transform:uppercase}.table-wrapper-border{border:1px solid #efefef;padding:5px 20px}.table-wrapper-border .table{margin-bottom:0}.table-border thead th{border-top:none;font-size:14px;line-height:1.2;text-transform:uppercase;color:#0e54a9;font-family:Poppins-Bold,sans-serif;vert-align:middle;border-bottom:1px solid #efefef;background:#fff}.table-border thead.without-background th{background:none;border-bottom:none}.table-border tbody tr td{font-size:12px;color:#252525;border-top:1px solid #efefef}.table-border tbody tr.no-border td,.table-border tbody tr:first-child td{border-top:none}.table-border tfoot tr td{font-size:14px;line-height:1.2;text-transform:uppercase;color:#0e54a9;font-family:Poppins-Bold,sans-serif;border-top:1px solid #efefef}.table-sm tr th{padding-top:13px;padding-bottom:13px}.table-sm tr td{padding-top:5px;padding-bottom:5px}.table-sm.table-material thead th{font-size:20px;text-transform:uppercase;font-family:Poppins-Bold,sans-serif;letter-spacing:.025rem}.table-md tr td{padding:6px 15px;height:57px}.table-header-area{padding-bottom:20px;padding-top:20px}.table-footer-area{padding-top:30px;display:flex}.table-footer-area.align-content-end .btn+.btn{margin-left:30px}.table thead.align-top th{min-height:58px;vertical-align:top}.table thead.transparent th{background:transparent;border-bottom:none!important}.table .icon-edit,.table .icon-trash{margin-left:4px;font-size:15px;position:relative;top:1px}.table-middle tr td{vertical-align:middle}.table-material{margin:0}.table-material td{padding-left:1.25rem;padding-right:1.25rem;border:none;vert-align:middle}.table-material>thead{background-color:#0c1d3f}.table-material>thead tr th{font-size:1rem;line-height:2.6rem;padding-top:11px;padding-bottom:11px;border-bottom:none;letter-spacing:.04rem;text-transform:uppercase;color:#fff}.table-material>thead tr th:first-child{padding-left:.75rem}.table-material tbody{background-color:#fff}.table-material tbody tr td{font-size:.75rem;padding-top:4px;padding-bottom:5px;line-height:30px;color:#252525}.table-material tbody tr td.title{font-size:.875rem;font-family:Poppins-Bold,sans-serif;color:#0e54a9;vertical-align:bottom;line-height:18px}.table-material tfoot{background-color:#0e54a9;color:#fff}.table-material tfoot tr td{padding-top:.5rem;padding-bottom:.5rem;text-transform:uppercase}.table-link{display:flex;cursor:pointer;align-items:center}.table-link:hover{opacity:.8}.table-link i{margin-right:5px;font-size:16px}.table.table-striped thead.align-middle th{vertical-align:middle}.table.table-striped thead th{border-bottom:2px solid #0e54a9;border-top:none;font-size:14px;line-height:1.2;text-transform:uppercase;color:#0e54a9;font-family:Poppins-Bold,sans-serif}.table.table-striped td,.table.table-striped th{border-top:none;font-size:13px;color:#252525}.table.table-striped td:first-child,.table.table-striped th:first-child{padding-left:30px}.table.table-striped td:first-child.pl-normal,.table.table-striped th:first-child.pl-normal{padding:.75rem}.table.table-striped tbody tr:nth-of-type(odd){background-color:#efefef}.table.table-striped tbody th{color:#0e54a9;font-family:Poppins-Bold,sans-serif}.table.table-striped tbody th .info-block{color:#252525;font-family:Poppins-Regular,sans-serif}.table thead.text-lg th{text-transform:none;font-size:20px}.table .table-title-tr{background:none!important}.table .table-title-tr td{padding-left:.75rem!important}.table-title-box{display:block;margin-left:-3px}.table-title-box a{display:inline-block;color:#0e54a9;margin-bottom:5px;margin-top:5px}.table-title-box a .flex-block{display:flex}.table-title-box a i{position:relative;left:-3px;display:flex;width:20px;height:20px;align-items:center;justify-content:center;font-size:10px;text-decoration:none!important;transform:rotate(-90deg)}.table-title-box a span.text-block{display:block;font-size:20px;line-height:22px;font-family:Poppins-Bold,sans-serif}.table-title-box a:hover{text-decoration:none}.table-title-box a:hover span.text-block{text-decoration:underline}.table-title-box.active i{transform:rotate(0deg)}.table-col-2{width:16.666667%}.table tbody+tbody{border:none}.section-dashboard .container .wrapper-content{position:relative;min-height:calc(100vh - 25px - 55px - 21px - 28px - 24px - 28px)}.material-form .form-control-label{font-size:14px;line-height:21px;padding:20px 0;font-family:Poppins-Bold,sans-serif;color:#0e54a9;border-bottom:1px solid #efefef;margin:0}.material-form .form-control-label .light{font-family:Poppins-Regular,sans-serif}.material-form.view .form-control{font-size:14px;line-height:21px;padding:20px 0;border:none;border-bottom:1px solid #efefef!important;border-radius:0;height:auto}.material-form.view .form-control::-webkit-input-placeholder{color:#252525}.material-form.view .form-control:-moz-placeholder,.material-form.view .form-control::-moz-placeholder{color:#252525}.material-form.view .form-control:-ms-input-placeholder{color:#252525}.material-form.view select.form-control{height:100%;border-radius:0;padding-left:2px;-webkit-appearance:none}.material-form.view .form-group-select:after{display:none}.material-form.edit .form-control{font-size:14px;line-height:21px;border-radius:5px;padding:0 17px;height:30px}.material-form.edit .form-control::-webkit-input-placeholder{color:#252525}.material-form.edit .form-control:-moz-placeholder,.material-form.edit .form-control::-moz-placeholder{color:#252525}.material-form.edit .form-control:-ms-input-placeholder{color:#252525}.material-form.edit .form-control:active,.material-form.edit .form-control:focus,.material-form.edit .form-control:hover{outline:none;box-shadow:none}.material-form.edit .form-group{margin-top:12px;margin-bottom:0}.material-form.edit .form-group input:not(.invalid),.material-form.edit .form-group select:not(.invalid){border:1px solid #0c1d3f!important}.material-form.edit .row:last-child .form-control-border,.material-form.edit .row:last-child .image-wrapper{border-bottom:none}.default-form{padding:20px}.default-form .form-control{border:1px solid #0c1d3f;font-size:14px;line-height:21px;border-radius:5px;padding:10px 17px}.default-form .form-control::-webkit-input-placeholder{color:#252525}.default-form .form-control:-moz-placeholder,.default-form .form-control::-moz-placeholder{color:#252525}.default-form .form-control:-ms-input-placeholder{color:#252525}.default-form .form-control:active,.default-form .form-control:focus,.default-form .form-control:hover{outline:none;box-shadow:none}.default-form .form-group{margin-bottom:20px}.default-form input:disabled,.default-form select:disabled,.default-form textarea:disabled{color:#bebebe;border:1px solid #bebebe}.default-form input:disabled::-moz-placeholder,.default-form select:disabled::-moz-placeholder,.default-form textarea:disabled::-moz-placeholder{color:#bebebe}.default-form input:disabled:-ms-input-placeholder,.default-form select:disabled:-ms-input-placeholder,.default-form textarea:disabled:-ms-input-placeholder{color:#bebebe}.default-form input:disabled::placeholder,.default-form select:disabled::placeholder,.default-form textarea:disabled::placeholder{color:#bebebe}.page-title{margin-top:26px}.ui-breadcrumb-chevron{display:none}.ui-breadcrumb{margin:0;padding:20px 30px;background:transparent;border-radius:0}.ui-breadcrumb ul{list-style:none;display:flex;flex-direction:row;font-size:12px;padding:0}.ui-breadcrumb ul a{color:#252525}.ui-breadcrumb ul.ui-menuitem-link{color:#0e54a9}.ui-breadcrumb ul .ui-menuitem-link:before{display:inline-block;padding-right:.5rem;padding-left:.5rem;color:#485057;content:\">\"}.ui-breadcrumb ul .ui-breadcrumb-home .ui-menuitem-link:before{display:none!important}.padding-top-20{padding-top:20px!important}.padding-bottom-20{padding-bottom:20px!important}.margin-left-20{margin-left:20%!important}.dropdown-menu-xs{min-width:57px!important}.dropdown-menu-xs .dropdown-item{padding:10px 13px 10px 8px!important}.publisher .material-form.edit textarea,.withdrawal .material-form.edit textarea{height:100%!important;margin-bottom:26px!important}.withdrawal .material-form.edit input{margin-top:12px}.withdrawal .inline-form.edit textarea{height:100%!important}.withdrawal .inline-form.edit input{margin-top:0;padding-bottom:.275rem}.new-password .card-body{padding-bottom:0!important}.new-password .invalid-feedback{position:absolute!important;top:100%!important;z-index:101;font-size:11px}.page-description{font-size:.875rem!important;line-height:1.313rem!important;color:#252525!important}.video-on-demand-upload .card-body,.video-on-demand-upload>[class*=col]{padding-left:0;padding-right:0}.min-width-fit{min-width:-webkit-fit-content;min-width:-moz-fit-content;min-width:fit-content}.flex{display:flex}.padding-0{padding:0!important}.min-width-100{min-width:100%}input[type=checkbox]{width:14px}.text-align-center{text-align:center}.video-on-demand-upload .col-xl-12{padding:0}.video-on-demand-upload .title-level-3{margin-top:30px!important;margin-bottom:30px!important}.table-sm tr th{vertical-align:text-top}.change-password .invalid-feedback{position:absolute;top:35px}.image-wrapper .close{position:absolute;right:0}.summary{border-top:1px solid #efefef;font-family:Poppins-Bold,sans-serif}.summary td{text-align:center}.form-group-select.invalid:after{top:37%}.back-details .col-5.edit-col .card-body{padding:0 15px 25px}.spinner-container{display:block;position:absolute;width:70px;height:30px}.donation .input-group-text{margin-top:0!important;border:1px solid #0c1d3f!important}.donation .invalid .input-group-text{border:1px solid #fc4349!important}.back-button{margin-right:10px}.validator-container{height:123px}.head-cell{display:flex;flex-direction:row;align-items:start}.head-cell,.head-cell .head-cell-text{justify-content:center}.width100{width:100%;display:flex;justify-content:space-between}.width100 .border-form{margin-left:auto}.table-filters ano-input{margin-right:10px}.layout-fixed{table-layout:fixed}.long-text,.long-text span{white-space:nowrap}.table-sm tr th{padding-left:1.25rem!important;padding-right:1.25rem!important}::ng-deep .mat-form-field-wrapper{padding-bottom:0!important}.add-button{margin-right:20px}.buttons-container{display:flex}.dropdown-actions{width:200px;display:block}.center{text-align:center}.right{text-align:right}.left{text-align:left}.center>*{text-align:center}.right>*{text-align:right}.left>*{text-align:left}.head-cell-text{display:flex}.head-cell-center,.head-cell-center .head-cell-text{justify-content:center}.head-cell-center .head-cell-text span{text-align:center}.head-cell-right,.head-cell-right .head-cell-text{justify-content:flex-end}.head-cell-right .head-cell-text span{text-align:right}.head-cell-left,.head-cell-left .head-cell-text{justify-content:left}.head-cell-left .head-cell-text span{text-align:left}.head-cell-text span{white-space:pre-line}.no-white-space .head-cell-text span{white-space:nowrap!important}.deactivated{background-color:rgba(0,0,0,.1)}.warning{background-color:rgba(255,190,0,.2);color:#ffbe00}.no-data-button-container{display:flex;justify-content:center;margin:20px 0}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [FormBuilder]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [AutoDestroyService]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [ChangeDetectorRef]
            }] }]; }, { withFilters: [{
            type: Input
        }], withSearch: [{
            type: Input
        }], startFromAll: [{
            type: Input
        }], height: [{
            type: Input
        }], addButton: [{
            type: Input
        }], downloadButton: [{
            type: Input
        }], isDownloadLoading: [{
            type: Input
        }], sortOrder: [{
            type: Input
        }], searchInputType: [{
            type: Input
        }], disabledAddButton: [{
            type: Input
        }], showDatepicker: [{
            type: Input
        }], addItem$: [{
            type: Output
        }], download$: [{
            type: Output
        }], navigate$: [{
            type: Output
        }], timeRangeFilter$: [{
            type: Output
        }], filterByLinkedStreams$: [{
            type: Output
        }], select$: [{
            type: Output
        }], search$: [{
            type: Output
        }], searchByYear$: [{
            type: Output
        }], filter$: [{
            type: Output
        }], tableConfig: [{
            type: Input
        }], filters: [{
            type: Input
        }], selectedRowId: [{
            type: Input
        }], table: [{
            type: ViewChild,
            args: ['table', { static: false }]
        }], buttonsConfig: [{
            type: Input
        }], title: [{
            type: Input
        }], addButtonText: [{
            type: Input
        }], downloadButtonText: [{
            type: Input
        }], yearsFilters: [{
            type: Input
        }], defaultSortField: [{
            type: Input
        }], timeRangeConfig: [{
            type: Input
        }], isLinkedStreamsFilters: [{
            type: Input
        }], linkedFilters: [{
            type: Input
        }], disabledInputs: [{
            type: Input
        }], systemMessage: [{
            type: Input
        }], isOpportunityToSelect: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SnackBarService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MatSnackBar]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamEventsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [HttpClient]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [API_URLS]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [ENVIRONMENT]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LocalizationProvider, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [HttpClient]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [ApiService]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [API_URLS]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [ENVIRONMENT]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DefaultIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputComponent, [{
        type: Component,
        args: [{
                selector: 'ano-input',
                template: "<ng-container *ngIf=\"config.inputType === INPUT_TYPES.INPUT || config.inputType === INPUT_TYPES.PASSWORD\">\n  <ng-container *ngIf=\"!config.copy && !config.show\">\n    <div class=\"input-group\" [class.group-append-text]=\"config.appendText && isFocused\"\n         [class.disabled]=\"!defaultForm && (disabled || config.disabled)\">\n      <div class=\"input-group-prepend\" *ngIf=\"config.prepend\">\n        <div class=\"input-group-text\" [class.disabled]=\"!defaultForm && (disabled || config.disabled)\">\n          <i class=\"icon icon-{{config.prepend}}\"></i>\n        </div>\n      </div>\n      <ng-container *ngIf=\"config?.mask\">\n        <input #input\n               [class.img-edit]=\"!isEditMode\"\n               [class.active]=\"!isEditMode\"\n               [class.inline-edit]=\"config.isInlineEditing && !isFocused\"\n               [type]=\"config.type || 'text'\"\n               [name]=\"name\"\n               class=\"form-control {{ config.classList }}\"\n               [mask]=\"config.mask\"\n               [class.invalid]=\"invalid && (isTouched || isDirty)\"\n               [class.disabled]=\"!defaultForm && (disabled || config.disabled)\"\n               [class.append-text]=\"config.appendText\"\n               [placeholder]=\"getPlaceholder(config.placeholder, config.isRequired)\"\n               [required]=\"config.isRequired\"\n               (blur)=\"onBlur($event)\"\n               [(ngModel)]=\"value\"\n               (focus)=\"onFocus($event); \"\n               (input)=\"onInput(input.value)\"\n               (change)=\"change(input.value)\"\n               (keyup)=\"onKeyUp($event)\"\n               [readonly]=\"readonly\"\n               [disabled]=\"disabled || config.disabled\" autocomplete=\"new-password\">\n      </ng-container>\n      <ng-container *ngIf=\"!config?.mask\">\n        <input #input\n               [class.inline-edit]=\"config.isInlineEditing && !isFocused\"\n               [class.active]=\"!isEditMode\"\n               [type]=\"config.type || 'text'\"\n               class=\"form-control {{ config.classList }}\"\n               [class.invalid]=\"invalid && isTouched\"\n               [class.append-text]=\"config.appendText\"\n               [class.disabled]=\"!defaultForm && (disabled || config.disabled)\"\n               [placeholder]=\"getPlaceholder(config.placeholder, config.isRequired)\"\n               [required]=\"config.isRequired\"\n               (blur)=\"onBlur($event)\"\n               [(ngModel)]=\"value\"\n               (focus)=\"onFocus($event); \"\n               (input)=\"onInput(input.value)\"\n               (change)=\"change(input.value)\"\n               (keyup)=\"onKeyUp($event)\"\n               [readonly]=\"readonly\"\n               [disabled]=\"disabled || config.disabled\">\n      </ng-container>\n      <button *ngIf=\"config.isInlineEditing && !isFocused\" class=\"btn btn-primary\"\n              (click)=\"enableInlineEditing()\">\n        <i class=\"icon icon-edit margin-left-3\"></i>\n      </button>\n      <div class=\"input-group-append\"\n           *ngIf=\"config.appendText\">\n        <div class=\"input-group-text\" [class.disabled]=\"!defaultForm && (disabled || config.disabled)\"\n             [class.invalid]=\"invalid && isTouched\">\n          {{config.appendText | localize}}\n        </div>\n      </div>\n      <div class=\"input-group-append\"\n           *ngIf=\"config.appendIcon\">\n        <div class=\"input-group-text\" [class.disabled]=\"!defaultForm && (disabled || config.disabled)\"\n             [class.invalid]=\"invalid && isTouched\">\n          <i class=\"icon icon-{{config.appendIcon}}\"></i>\n        </div>\n      </div>\n    </div>\n  </ng-container>\n  <ng-container *ngIf=\"config.copy || config.show\">\n    <div class=\"input-group\">\n      <input #input\n             [type]=\"config.type || 'text'\"\n             [class.active]=\"!isEditMode\"\n             class=\"form-control {{ config.classList }}\"\n             [class.invalid]=\"invalid && isTouched\"\n             [placeholder]=\"getPlaceholder(config.placeholder, config.isRequired)\"\n             [required]=\"config.isRequired\"\n             [class.disabled]=\"!defaultForm && (disabled || config.disabled)\"\n             (blur)=\"onBlur($event)\"\n             [(ngModel)]=\"value\"\n             (focus)=\"onFocus($event); \"\n             (input)=\"onInput(input.value)\"\n             (change)=\"change(input.value)\"\n             (keyup)=\"onKeyUp($event)\"\n             [readonly]=\"readonly\"\n             [disabled]=\"disabled || config.disabled\">\n      <div class=\"input-group-append cursor-pointer\">\n\t\t\t\t\t\t\t\t\t<span class=\"input-group-text\"\n                                          (click)=\"copyValue(input.value)\">\n\t\t\t\t\t\t\t\t\t\t<i class=\"icon icon-copy\"></i>\n\t\t\t\t\t\t\t\t\t</span>\n      </div>\n      <!--            <div class=\"flex-form-group-buttons\">-->\n      <!--                <ano-button *ngIf=\"config.copy\"-->\n      <!--                            (click)=\"copyValue(input.value)\"-->\n      <!--                            [config]=\"{type: 'button', styleType: 'secondary', sizeType: 'sm'}\">Copy-->\n      <!--                </ano-button>-->\n      <!--                <ano-button *ngIf=\"config.show\"-->\n      <!--                            (click)=\"togglePasswordShowing()\"-->\n      <!--                            [config]=\"{type: 'button', styleType: 'secondary', sizeType: 'sm'}\">-->\n      <!--                    {{ showPassword ? 'Hide' : 'Show' }}-->\n      <!--                </ano-button>-->\n      <!--            </div>-->\n    </div>\n  </ng-container>\n</ng-container>\n<ng-container *ngIf=\"config.inputType === INPUT_TYPES.IBAN\">\n  <input #input\n         [type]=\"config.type || 'text'\"\n         [class.active]=\"!isEditMode\"\n         class=\"form-control {{ config.classList }}\"\n         [class.invalid]=\"invalid && isTouched\"\n         [class.disabled]=\"!defaultForm && (disabled || config.disabled)\"\n         [placeholder]=\"getPlaceholder(config.placeholder, config.isRequired)\"\n         [required]=\"config.isRequired\"\n         (blur)=\"onBlur($event)\"\n         [ngModel]=\"value | iban\"\n         (ngModelChange)=\"change(input.value)\"\n         (focus)=\"onFocus($event); \"\n         (input)=\"onInput(input.value)\"\n         (change)=\"change(input.value)\"\n         (keyup)=\"onKeyUp($event)\"\n         [readonly]=\"readonly\"\n         [disabled]=\"disabled || config.disabled\">\n</ng-container>\n<ng-container *ngIf=\"config.inputType === INPUT_TYPES.SIMPLE_CHECKBOX\">\n  <div class=\"form-group flex-row flex align-items-center\">\n    <div class=\"flex-checkbox\">\n      <input #input\n             [type]=\"'checkbox'\"\n             [class.active]=\"!isEditMode\"\n             class=\"form-control {{ config.classList }}\"\n             [class.invalid]=\"invalid && isTouched\"\n             [class.disabled]=\"!defaultForm && (disabled || config.disabled)\"\n             [required]=\"config.isRequired\"\n             (blur)=\"onBlur($event)\"\n             [checked]=\"value\"\n             (focus)=\"onFocus($event);\"\n             (change)=\"checked($event)\"\n             (keyup)=\"onKeyUp($event)\"\n             [readonly]=\"readonly\"\n             [disabled]=\"disabled || config.disabled\">\n    </div>\n    <p class=\"mb-0\">\n      <ng-container *ngTemplateOutlet=\"config.placeholder;\"></ng-container>\n    </p>\n  </div>\n</ng-container>\n<ng-container *ngIf=\"config.inputType === INPUT_TYPES.PHONE\">\n  <div class=\"input-group\">\n    <input #input\n           type=\"tel\"\n           class=\"form-control {{ config.classList }}\"\n           [class.active]=\"!isEditMode\"\n           [class.invalid]=\"invalid && isTouched\"\n           [class.disabled]=\"!defaultForm && (disabled || config.disabled)\"\n           [mask]=\"mask\"\n           [patterns]=\"customPatterns\"\n           [placeholder]=\"getPlaceholder(config.placeholder, config.isRequired)\"\n           [required]=\"config.isRequired\"\n           (blur)=\"onBlur($event)\"\n           [(ngModel)]=\"value\"\n           (focus)=\"onFocus($event); \"\n           (input)=\"onInput(input.value)\"\n           (change)=\"change(input.value)\"\n           (keyup)=\"onKeyUp($event)\"\n           [readonly]=\"readonly\"\n           [class.readonly]=\"readonly\"\n           [disabled]=\"disabled || config.disabled\">\n  </div>\n</ng-container>\n<ng-container *ngIf=\"config.inputType === INPUT_TYPES.CREDIT_CARD\">\n  <input #input\n         type=\"tel\"\n         class=\"form-control {{ config.classList }}\"\n         [class.active]=\"!isEditMode\"\n         [class.invalid]=\"invalid && isTouched\"\n         [class.disabled]=\"!defaultForm && (disabled || config.disabled)\"\n         [placeholder]=\"getPlaceholder(config.placeholder, config.isRequired)\"\n         [required]=\"config.isRequired\"\n         (blur)=\"onBlur($event)\"\n         [(ngModel)]=\"value\"\n         (focus)=\"onFocus($event); \"\n         (input)=\"onInput(input.value)\"\n         (change)=\"change(input.value)\"\n         (keyup)=\"onKeyUp($event)\"\n         [readonly]=\"readonly\"\n         [disabled]=\"disabled || config.disabled\">\n  <img *ngIf=\"cardType\" [src]=\"cardType\" class=\"card-type\">\n</ng-container>\n<ng-container *ngIf=\"config.inputType === INPUT_TYPES.SELECT\n                  || config.inputType === INPUT_TYPES.MULTISELECT\n                  || config.inputType === INPUT_TYPES.MULTISELECT_IN_SINGLE_DROPDOWN\">\n  <div class=\"input-group\">\n    <ano-dropdown\n            [noBorder]=\"noBorder\"\n            [isAutocomplete]=\"config.isAutocomplete\"\n            [isClearButton]=\"config.isClearButton\"\n            [isEditMode]=\"isEditMode\"\n            [readonly]=\"readonly\"\n            [class.readonly]=\"readonly\"\n            [invalid]=\"invalid\"\n            [touched]=\"isTouched\"\n            [disabled]=\"disabled || config.disabled\"\n            [value]=\"value\"\n            [classList]=\"config.classList\"\n            [values]=\"config.selectOptions\"\n            [actionLink]=\"config.actionLink\"\n            [excludeSelected]=\"config.excludeSelected\"\n            [actionCallback]=\"config.actionCallback\"\n            [multiSelect]=\"config.inputType === INPUT_TYPES.MULTISELECT\"\n            [multiselectInSingleDropdown]=\"config.inputType === INPUT_TYPES.MULTISELECT_IN_SINGLE_DROPDOWN\"\n            [placeholder]=\"getPlaceholder(config.placeholder, config.isRequired)\"\n            (change)=\"onChange($event)\"\n            (selectedValue)=\"selectedValue($event)\"\n            (focus)=\"onFocus($event)\"\n            (blur)=\"onBlur($event)\"\n            (keyup)=\"onKeyUp($event)\"\n    ></ano-dropdown>\n  </div>\n  <p *ngIf=\"formConfig?.name === 'media' && field.name === 'paymentSystem' && currentValue\" class=\"mt-10 mb-5\">\n    {{accessOptions?.desc | localize}}\n  </p>\n  <div *ngIf=\"formConfig?.name === 'media' && field.name === 'paymentSystem' && currentValue\"\n       class=\"row row-padding-10 row-check\">\n    <div class=\"form-check mt-5 col-6\" *ngFor=\"let value of accessOptions?.values; index as i\">\n      <input type=\"checkbox\" [id]=\"value.key\" class=\"form-check-input\"\n             [(ngModel)]=\"checkModel[value.key]\"\n             [ngModelOptions]=\"{standalone: true}\"\n             [disabled]=\"readonly\"\n             (change)=\"changeCheck(value.key)\"\n             (keyup)=\"onKeyUp($event)\">\n      <label [for]=\"value.key\" class=\"form-check-label\">\n        {{value.name | localize}}\n        <i class=\"icon icon-info\" [matTooltip]=\"(value.desc | localize)\"></i>\n      </label>\n    </div>\n  </div>\n</ng-container>\n<ng-container *ngIf=\"config.inputType === INPUT_TYPES.RADIO\">\n  <ano-radio-select\n          [value]=\"value\"\n          [values]=\"config.selectOptions\"\n          (change)=\"onChange($event)\">\n  </ano-radio-select>\n</ng-container>\n<ng-container *ngIf=\"config.inputType === INPUT_TYPES.TEXTAREA\">\n  <div class=\"input-group with-border-radius\" [class.disabled]=\"!defaultForm && (disabled || config.disabled)\">\n    <textarea #inputTextArea\n              class=\"form-control {{ config.classList }}\"\n              [class.invalid]=\"invalid && isTouched\"\n              [ngStyle]=\"{resize: 'none'}\"\n              [class.disabled]=\"!defaultForm && (disabled || config.disabled)\"\n              [rows]=\"config.autosize ? 1 : 6\"\n              [autosize]=\"!!config.autosize\"\n              [class.overflow-auto]=\"!config.autosize\"\n              [placeholder]=\"getPlaceholder(config.placeholder, config.isRequired)\"\n              [required]=\"config.isRequired\"\n              [readonly]=\"readonly\"\n              [disabled]=\"disabled || config.disabled\"\n              (blur)=\"onBlur($event)\"\n              [(ngModel)]=\"value\"\n              (focus)=\"onFocus($event); \"\n              (input)=\"onInput(inputTextArea.value)\"\n              (change)=\"change(inputTextArea.value)\"\n              (keyup)=\"onKeyUp($event)\"></textarea>\n  </div>\n</ng-container>\n<ng-container *ngIf=\"config.inputType === INPUT_TYPES.DATETIME\">\n  <div class=\"input-group with-border-radius\" [class.disabled]=\"!defaultForm && (disabled || config.disabled)\">\n    <input #inputDate=\"ngModel\"\n           class=\"form-control cursor-pointer {{ config.classList }}\"\n           [class.active]=\"isEditMode && !(disabled || config.disabled)\"\n           [class.invalid]=\"invalid && isTouched\"\n           [class.disabled]=\"!defaultForm && (disabled || config.disabled)\"\n           [placeholder]=\"getPlaceholder(config.placeholder, config.isRequired)\"\n           [required]=\"config.isRequired\"\n           [readonly]=\"true\"\n           [class.readonly]=\"readonly\"\n           [disabled]=\"disabled || readonly || config.disabled\"\n           [ngModel]=\"value\"\n           (blur)=\"onBlur($event)\"\n           (focus)=\"onFocus($event);\"\n           (dateTimeInput)=\"writeDateValue(inputDate.value)\"\n           (dateTimeChange)=\"dateChange(inputDate.value)\"\n           [owlDateTime]=\"dt1\"\n           [owlDateTimeTrigger]=\"dt1\"\n           [min]=\"minDate()\"\n           [max]=\"maxDate()\"\n           (keyup)=\"onKeyUp($event)\"\n    >\n    <owl-date-time #dt1\n                   (afterPickerClosed)=\"dateChange(dt1.selected)\"\n                   [pickerType]=\"config.datetimePickerType || 'both'\"></owl-date-time>\n    <i *ngIf=\"value && !readonly && !disabled\" class=\"icon icon-close\" (click)=\"clear()\"></i>\n  </div>\n</ng-container>\n<ng-container *ngIf=\"config.inputType === INPUT_TYPES.CHECKBOX\">\n  <mat-slide-toggle [class.simple-toggle]=\"config.simpleToggle\"\n                    [class.hidden-toggle]=\"config.hiddenToggle\"\n                    (change)=\"toggleCheckbox($event)\"\n                    [disabled]=\"disabledToggle || disabled || readonly || config.disabled || config.hiddenToggle\"\n                    [checked]=\"value && !disabledToggle\">{{getPlaceholder(config.placeholder, config.isRequired)}}\n  </mat-slide-toggle>\n</ng-container>\n<ng-container *ngIf=\"config.inputType === INPUT_TYPES.TIMER\">\n  <div class=\"input-group\" [class.disabled]=\"!defaultForm && (disabled || config.disabled)\">\n    <input #inputDate=\"ngModel\"\n           type=\"time\"\n           min=\"00:00:00\"\n           max=\"16:00:00\"\n           step=\"1\"\n           class=\"form-control cursor-pointer {{ config.classList }}\"\n           [class.active]=\"isEditMode && !(disabled || config.disabled)\"\n           [class.invalid]=\"invalid && isTouched\"\n           [class.disabled]=\"!defaultForm && (disabled || config.disabled)\"\n           [placeholder]=\"getPlaceholder(config.placeholder, config.isRequired)\"\n           [required]=\"config.isRequired\"\n           [class.readonly]=\"readonly\"\n           [disabled]=\"disabled || readonly || config.disabled\"\n           [ngModel]=\"value || '00:00:00'\"\n           (blur)=\"onBlur($event)\"\n           (focus)=\"onFocus($event)\"\n           (input)=\"onInput(inputDate.value)\"\n           (change)=\"change(inputDate.value)\"\n           (keyup)=\"onKeyUp($event)\"\n    >\n    <i *ngIf=\"value && !readonly && !disabled\" class=\"icon icon-close icon-close-timer\" (click)=\"clear()\"></i>\n    <div class=\"input-group-append\">\n      <div class=\"input-group-text\" [class.disabled]=\"!defaultForm && (disabled || config.disabled)\"\n           [class.invalid]=\"invalid && isTouched\">\n        hh:mm:ss\n      </div>\n    </div>\n  </div>\n</ng-container>\n<ng-container *ngIf=\"config.inputType === INPUT_TYPES.IMAGE\">\n  <!--    <div class=\"row\" [class.column-reverse]=\"columnImageUploader\" *ngIf=\"!disabled\">-->\n  <!--        <div class=\"col-{{ columnImageUploader ? 12 : 6 }}\">-->\n  <!--                <div class=\"row\">-->\n  <!--                    <div class=\"col\">-->\n  <ng-container *ngIf=\"multimediaUrl\">\n    <div class=\"image-wrapper\" [class.img-edit]=\"!isEditMode\">\n      <div *ngIf=\"clearImageButton && !disabled\" class=\"close\" (click)=\"clearImage()\">\n        <i class=\"icon icon-trash2\"></i>\n      </div>\n      <div class=\"image-container\"\n           [ngClass]=\"coursePreview?.position ? coursePreview?.position.toLowerCase() + '-course' : ''\">\n        <p *ngIf=\"config.isCourse\"\n           style=\"color: {{coursePreview.color}}; text-shadow: 0 0 1em {{coursePreview.color === '#fff' ? '#000' : '#fff'}}\"\n           class=\"text-course\">\n          {{coursePreview.text}}\n        </p>\n        <button *ngIf=\"config.isCourse\"\n                class=\"btn btn-primary btn-still\">{{'course.button.stillHere' | localize}}</button>\n        <img *ngIf=\"multimediaType === 'photo'\" src=\"{{ multimediaUrl | image }}\">\n        <ano-player *ngIf=\"multimediaType === 'video' && playerConfig\" [config]=\"playerConfig\"></ano-player>\n      </div>\n    </div>\n  </ng-container>\n  <ng-container *ngIf=\"isEditMode && !multimediaUrl\">\n    <ano-drag-and-drop [disabled]=\"disabled || config.disabled\" #multimediaUploader [accept]=\"accept\"\n                       [videoDurationLimit]=\"config.videoDurationLimit\" [maxSize]=\"config.maxFileSize\"\n                       (files)=\"uploadPreviewMultimedia($event)\"></ano-drag-and-drop>\n  </ng-container>\n  <!--                    </div>-->\n  <!--                </div>-->\n  <!--            </ng-container>-->\n  <!--        </div>-->\n  <!--        <div class=\"col-{{ columnImageUploader ? 12 : 6 }}\" *ngIf=\"isEditMode && !photoUrl\">-->\n  <!--            <ano-drag-and-drop #photoUploader (files)=\"uploadPreviewPhoto($event)\"></ano-drag-and-drop>-->\n  <!--        </div>-->\n  <!--    </div>-->\n  <!--    <ng-container *ngIf=\"photoUrl && disabled\">-->\n  <!--        <div class=\"row\">-->\n  <!--            <div class=\"image-wrapper\">-->\n  <!--                <div *ngIf=\"clearImageButton\" class=\"close\" (click)=\"clearImage()\">X</div>-->\n  <!--                <img src=\"{{ photoUrl }}\">-->\n  <!--            </div>-->\n  <!--        </div>-->\n  <!--    </ng-container>-->\n</ng-container>\n<ng-container *ngIf=\"config.inputType === INPUT_TYPES.CURRENCY_AMOUNT\">\n  <div class=\"input-group\" [class.group-append-text]=\"config.appendText && isFocused\"\n       [class.disabled]=\"!defaultForm && (disabled || config.disabled)\">\n    <div *ngIf=\"currencyProfile\" class=\"input-group-prepend\"\n         [class.disabled]=\"!defaultForm && (disabled || config.disabled) || readonly\"\n         [class.invalid]=\"invalid && isTouched\"\n    >\n      <span class=\"input-group-text\">{{currencyProfile}}</span>\n    </div>\n    <input #input\n           cleaveMask\n           [cleaveValue]=\"input.value\"\n           [class.active]=\"!isEditMode\"\n           [type]=\"config.type || 'text'\"\n           class=\"form-control {{ config.classList }}\"\n           [class.invalid]=\"invalid && isTouched\"\n           [placeholder]=\"getPlaceholder(config.placeholder, config.isRequired)\"\n           [required]=\"config.isRequired\"\n           [class.disabled]=\"!defaultForm && (disabled || config.disabled)\"\n           (change)=\"change(input.value)\"\n           (blur)=\"onBlur($event)\"\n           [ngModel]=\"value\"\n           (focus)=\"onFocus($event); \"\n           (input)=\"onInput(input.value)\"\n           [readonly]=\"readonly\"\n           [disabled]=\"disabled || config.disabled\"\n           (keyup)=\"onKeyUp($event)\">\n    <div class=\"input-group-append\"\n         *ngIf=\"config.appendText\">\n      <div class=\"input-group-text\" [class.disabled]=\"!defaultForm && (disabled || config.disabled)\"\n           [class.invalid]=\"invalid && isTouched\">\n        {{config.appendText | localize}}\n      </div>\n    </div>\n  </div>\n</ng-container>\n<ng-container *ngFor=\"let errorEntry of errorEntries\">\n  <div class=\"invalid-feedback\" *ngIf=\"isEditMode\"\n       [ngStyle]=\"{display: isTouched || isDirty ? 'block' : 'none'}\">\n    <!--    {{ generateErrorText(INPUT_ERRORS[errorEntry[0]], mergeObjects({ placeholder: config.placeholder }, errorEntry[1])) }}-->\n    <ng-container *ngIf=\"errorEntry[0] !== 'min' && errorEntry[0] !== 'maxlength'\">\n      {{ ('error.' + errorEntry[0]) | localize }}\n    </ng-container>\n    <ng-container *ngIf=\"errorEntry[0] === 'min'\">\n      {{ ('error.' + errorEntry[0]) | localize }} {{ errorEntry[1].min }}\n    </ng-container>\n    <ng-container *ngIf=\"errorEntry[0] === 'maxlength'\">\n      {{ ('error.' + errorEntry[0] + '.start') | localize }} {{ errorEntry[1].requiredLength }} {{ ('error.' + errorEntry[0] + '.end') | localize }}\n    </ng-container>\n    <ng-container *ngIf=\"errorEntry[1] === 'value'\">\n      {{ errorEntry[1].value }}\n    </ng-container>\n  </div>\n</ng-container>\n<ng-container *ngIf=\"infoMessage && isFocused\">\n  <div class=\"info-message\">{{infoMessage | localize}}</div>\n</ng-container>\n\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => InputComponent_1),
                        multi: true
                    },
                    {
                        provide: OwlDateTimeIntl,
                        useClass: DefaultIntl
                    },
                    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_NATIVE_FORMATS },
                    AutoDestroyService
                ],
                changeDetection: ChangeDetectionStrategy.Default,
                styles: ["@charset \"UTF-8\";.is-empty,.is-invalid{background-image:unset}.not-empty{position:absolute;width:25px;height:13px;top:19px;right:2%;background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='gray' viewBox='-2 -2 7 7'%3e%3cpath stroke='gray' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E\");background-repeat:no-repeat;background-position:center right calc(.375em + .1875rem);background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.help-textarea{resize:none;height:200px}input[type=date]{position:relative;color:#fff;background-color:#fff}input[type=date]::-webkit-datetime-edit{color:transparent;background-color:transparent}input[type=date]:before{position:absolute;background-color:#fff;top:0;left:0;padding:10px 15px;content:attr(data-date);display:inline-block;color:#000;width:94%;height:48px;border-radius:25px}input[type=date]:after{content:\"\u25BC\";color:#555;padding:0 5px;position:absolute;top:14px;right:10px}input[type=date]::-webkit-calendar-picker-indicator{position:absolute;top:0;left:0;right:0;bottom:0;width:auto;height:auto;color:transparent;background:transparent}input[type=date]::-webkit-inner-spin-button{z-index:1}input[type=date]::-webkit-clear-button{display:none}.input-clear-icon{top:12px;right:8%;z-index:100;opacity:0}.input-clear-icon-visible{opacity:1}.medical-textarea{padding-left:15px!important;padding-right:15px!important;font-size:1rem!important;font-weight:400!important;line-height:1.5!important}.row{display:flex;justify-content:center}.column-reverse{flex-direction:column}.image-wrapper{display:flex;flex-direction:row-reverse;justify-content:space-between;padding:0 0 15px}.image-wrapper img{width:100%}.image-container{position:relative;width:100%}input:disabled,select:disabled,textarea:disabled{background-color:#fff}input:disabled::-moz-placeholder,select:disabled::-moz-placeholder,textarea:disabled::-moz-placeholder{color:#b6bbc5}input:disabled:-ms-input-placeholder,select:disabled:-ms-input-placeholder,textarea:disabled:-ms-input-placeholder{color:#b6bbc5}input:disabled::placeholder,select:disabled::placeholder,textarea:disabled::placeholder{color:#b6bbc5}.invalid{color:#fc4349!important;border-color:#fc4349!important}.invalid::-moz-placeholder{color:#fc4349}.invalid:-ms-input-placeholder{color:#fc4349}.invalid::placeholder{color:#fc4349}.invalid-feedback{color:#fc4349}.info-message{font-size:12px;line-height:1.2;margin-top:0;color:#ffcc14}::ng-deep .form-control-select{outline:none}.form-control-select:after{content:\"\";border-left:5px solid transparent;border-right:5px solid transparent;border-top:7px solid #0c1d3f;display:inline-block;position:absolute;right:40px;top:28%}.disabled.form-control-select:after{border:none!important}.flex-form-group{display:flex;flex-direction:row;justify-content:space-between}.flex-form-group .form-control{width:60%;overflow:auto}.flex-form-group .flex-form-group-buttons{width:40%;padding:0 5px;display:flex;flex-direction:row;justify-content:space-between;align-items:center;border-bottom:1px solid #ddd}select{outline:none}::ng-deep .mat-slide-toggle .mat-slide-toggle-ripple{display:none}::ng-deep .mat-slide-toggle-content{color:#252525;font-family:Poppins-Regular,sans-serif;font-size:14px}::ng-deep .mat-slide-toggle.mat-checked .mat-slide-toggle-thumb{background:#bad668!important}::ng-deep .mat-slide-toggle-bar{background-color:#efefef!important;width:40px!important;height:20px!important;border-radius:20px!important}::ng-deep .mat-slide-toggle-thumb{background-color:#727272}::ng-deep .mat-slide-toggle.mat-checked .mat-slide-toggle-bar{background-color:#efefef!important;width:40px!important;height:20px!important;border-radius:20px!important}::ng-deep .mat-slide-toggle-thumb-container{top:0!important}::ng-deep .mat-slide-toggle.mat-checked .mat-slide-toggle-thumb-container{transform:translate3d(20px,0,0)!important;top:0!important}::ng-deep label.mat-slide-toggle-label{flex-direction:row-reverse;justify-content:space-between}::ng-deep mat-slide-toggle.mat-slide-toggle{display:flex}::ng-deep mat-slide-toggle.mat-slide-toggle.simple-toggle{height:auto}::ng-deep .mat-select-arrow-wrapper{opacity:0!important}::ng-deep .mat-select-panel{transform:translateX(3px) translateY(38px) scale(1)!important;border:1px solid #0c1d3f!important;padding-top:5px!important;min-width:calc(100% + 27px)!important;box-shadow:none!important}::ng-deep .mat-form-field-infix{border:none!important;padding-top:3px!important}::ng-deep .mat-form-field-appearance-legacy .mat-form-field-underline{display:none!important}::ng-deep mat-slide-toggle.mat-slide-toggle.simple-toggle .mat-slide-toggle-label{margin-bottom:0!important}::ng-deep mat-slide-toggle.mat-slide-toggle.simple-toggle .mat-slide-toggle-content{white-space:normal!important;line-height:1.5}::ng-deep mat-slide-toggle.mat-slide-toggle.simple-toggle .mat-slide-toggle-bar{margin-right:0!important}::ng-deep .mat-autocomplete-panel.mat-autocomplete-visible{height:auto}::ng-deep .mat-select{box-shadow:none!important}::ng-deep .mat-slide-toggle.hidden-toggle .mat-slide-toggle-bar{opacity:.38!important}::ng-deep .mat-disabled.hidden-toggle{opacity:1!important}.alert,h3{text-align:center}.group-append-text{border-radius:5px;box-shadow:0 0 0 .2rem rgba(14,84,169,.25)}.with-border-radius .form-control{border-top-right-radius:5px!important;border-bottom-right-radius:5px!important}.append-text{border-right:none!important}.append-text:focus{box-shadow:none}.input-group-text.invalid{border-color:#fc4349}.flex-checkbox{width:26px}.flex-checkbox input{height:20px}.flex{display:flex}.inline-edit{margin-right:15px;border-top-right-radius:5px!important;border-bottom-right-radius:5px!important}.margin-left-3{margin-left:3px}.card-type{position:absolute;width:40px;right:6px;top:4px}.input-group{box-shadow:none!important}.input-group ano-dropdown{width:100%}.icon-close{zoom:.8;cursor:pointer;position:absolute;right:30px;top:20px}.icon-close-timer{right:88px;top:19px}input[type=search]::-webkit-search-cancel-button:hover,input[type=search]::-webkit-search-decoration:hover{cursor:pointer}.input-group.disabled:not(.default-form) .form-control{color:#bebebe;border-color:#bebebe}.input-group.disabled:not(.default-form) .form-control::-moz-placeholder{color:#bebebe}.input-group.disabled:not(.default-form) .form-control:-ms-input-placeholder{color:#bebebe}.input-group.disabled:not(.default-form) .form-control::placeholder{color:#bebebe}.input-group.disabled:not(.default-form) .form-control:disabled::-moz-placeholder{color:#bebebe}.input-group.disabled:not(.default-form) .form-control:disabled:-ms-input-placeholder{color:#bebebe}.input-group.disabled:not(.default-form) .form-control:disabled::placeholder{color:#bebebe}.input-group.disabled:not(.default-form) .input-group-text{color:#bebebe;border-color:#bebebe!important}.input-group-text.disabled{color:#bebebe;border-color:#bebebe}.input-group-text.disabled .icon,.input-group.disabled input{color:#bebebe}.row-check{justify-content:flex-start}.form-check-input{margin:0!important;position:relative}.form-check-label{margin-left:10px}.form-check input,.form-check label{cursor:pointer}input:disabled{color:#bebebe;border-color:#bebebe}.input-group-prepend.disabled .input-group-text{border-color:#bebebe!important;color:#bebebe!important}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [AutoDestroyService]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [SnackBarService]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [ChangeDetectorRef]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DateTimeAdapter]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [LocalizationProvider]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [StreamEventsService]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [ENVIRONMENT]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [CURRENT_CURRENCY]
            }] }]; }, { config: [{
            type: Input
        }], multimediaUrl: [{
            type: Input
        }], multimediaType: [{
            type: Input
        }], clearImageButton: [{
            type: Input
        }], isCleanable: [{
            type: Input
        }], isTextarea: [{
            type: Input
        }], isInputShow: [{
            type: Input
        }], disabled: [{
            type: Input
        }], isClearButton: [{
            type: Input
        }], readonly: [{
            type: Input
        }], disabledToggle: [{
            type: Input
        }], columnImageUploader: [{
            type: Input
        }], invalid: [{
            type: Input
        }], isEditMode: [{
            type: Input
        }], noBorder: [{
            type: Input
        }], accept: [{
            type: Input
        }], blur: [{
            type: Output
        }], input$: [{
            type: Output
        }], onFileUpload$: [{
            type: Output
        }], clearImage$: [{
            type: Output
        }], toggle$: [{
            type: Output
        }], checked$: [{
            type: Output
        }], checkedPayments$: [{
            type: Output
        }], multimediaUploader: [{
            type: ViewChild,
            args: ['multimediaUploader', { static: false }]
        }], input: [{
            type: ViewChild,
            args: ['input', { static: false }]
        }], inputDate: [{
            type: ViewChild,
            args: ['inputDate', { static: false }]
        }], defaultForm: [{
            type: Input
        }], formConfig: [{
            type: Input
        }], field: [{
            type: Input
        }], coursePreview: [{
            type: Input
        }], errors: [{
            type: Input
        }], infoMessage: [{
            type: Input
        }], formIndex: [{
            type: Input
        }], isTouched: [{
            type: Input
        }], isDirty: [{
            type: Input
        }], name: [{
            type: Input
        }], playerConfig: [{
            type: Input
        }], formMain: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WhiteSpacePipe, [{
        type: Pipe,
        args: [{
                name: 'whiteSpace'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DragAndDropComponent, [{
        type: Component,
        args: [{
                selector: 'ano-drag-and-drop',
                template: "<!--<div class=\"container\" appDnd (fileDropped)=\"onFileDropped($event)\">-->\n<!--<input type=\"file\" #fileDropRef id=\"fileDropRef\" multiple (change)=\"fileBrowseHandler($event.target.files)\" />-->\n<!--<img src=\"assets/img/dnd/ic-upload-file.svg\" alt=\"\">-->\n<!--<h3>Drag and drop file here</h3>-->\n<!--<h3>or</h3>-->\n<!--<label for=\"fileDropRef\">Browse for file</label>-->\n<!--</div>-->\n<div class=\"wrapper-drag-and-drop\" [class.disabled]=\"disabled\" appDnd (fileDropped)=\"onFileDropped($event)\">\n    <input [disabled]=\"disabled\" type=\"file\" [accept]=\"accept\" #fileDropRef id=\"fileDropRef\" multiple (change)=\"fileBrowseHandler($event.target.files)\" />\n    <i class=\"icon icon-plus\"></i>\n    <span class=\"text-xlg\">{{ \"video.drag\" | localize }}</span>\n    <span class=\"text-xs\">{{ \"video.or\" | localize}}</span>\n    <button class=\"btn btn-primary btn-sm\" (click)=\"fileDropRef.click()\">{{ \"video.select\" | localize}}</button>\n</div>\n\n",
                styles: [".wrapper-drag-and-drop{text-align:center;margin:0 auto;position:relative}.wrapper-drag-and-drop input{opacity:0;position:absolute;z-index:2;width:100%;height:100%;top:0;left:0}.wrapper-drag-and-drop button{z-index:4}.wrapper-drag-and-drop.disabled{border-color:#b6bbc5!important}.wrapper-drag-and-drop.disabled .icon,.wrapper-drag-and-drop.disabled .text-xlg,.wrapper-drag-and-drop.disabled .text-xs{color:#b6bbc5!important}.wrapper-drag-and-drop.disabled .btn-primary{background-color:#b6bbc5!important}.fileover{-webkit-animation:shake 1s;animation:shake 1s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}@-webkit-keyframes shake{0%{transform:translate(1px,1px) rotate(0deg)}10%{transform:translate(-1px,-2px) rotate(-1deg)}20%{transform:translate(-3px) rotate(1deg)}30%{transform:translate(3px,2px) rotate(0deg)}40%{transform:translate(1px,-1px) rotate(1deg)}50%{transform:translate(-1px,2px) rotate(-1deg)}60%{transform:translate(-3px,1px) rotate(0deg)}70%{transform:translate(3px,1px) rotate(-1deg)}80%{transform:translate(-1px,-1px) rotate(1deg)}90%{transform:translate(1px,2px) rotate(0deg)}to{transform:translate(1px,-2px) rotate(-1deg)}}@keyframes shake{0%{transform:translate(1px,1px) rotate(0deg)}10%{transform:translate(-1px,-2px) rotate(-1deg)}20%{transform:translate(-3px) rotate(1deg)}30%{transform:translate(3px,2px) rotate(0deg)}40%{transform:translate(1px,-1px) rotate(1deg)}50%{transform:translate(-1px,2px) rotate(-1deg)}60%{transform:translate(-3px,1px) rotate(0deg)}70%{transform:translate(3px,1px) rotate(-1deg)}80%{transform:translate(-1px,-1px) rotate(1deg)}90%{transform:translate(1px,2px) rotate(0deg)}to{transform:translate(1px,-2px) rotate(-1deg)}}"]
            }]
    }], function () { return []; }, { disabled: [{
            type: Input
        }], maxSize: [{
            type: Input
        }], files: [{
            type: Output
        }], accept: [{
            type: Input
        }], videoDurationLimit: [{
            type: Input
        }], fileDropRef: [{
            type: ViewChild,
            args: ['fileDropRef', { static: false }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CleaveMaskDirective, [{
        type: Directive,
        args: [{
                selector: '[cleaveMask]',
                providers: []
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }]; }, { appCleaveMask: [{
            type: Input
        }], value: [{
            type: Input,
            args: ['cleaveValue']
        }], onInput: [{
            type: HostListener,
            args: ['input']
        }], onKeyPress: [{
            type: HostListener,
            args: ['keypress', ['$event']]
        }], onBlur: [{
            type: HostListener,
            args: ['blur']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DndDirective, [{
        type: Directive,
        args: [{
                selector: '[appDnd]'
            }]
    }], function () { return []; }, { fileDropped: [{
            type: Output
        }], 
    // Dragover listener
    onDragOver: [{
            type: HostListener,
            args: ['dragover', ['$event']]
        }], fileOver: [{
            type: HostBinding,
            args: ['class.fileover']
        }], 
    // Dragleave listener
    onDragLeave: [{
            type: HostListener,
            args: ['dragleave', ['$event']]
        }], 
    // Drop listener
    ondrop: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RadioSelectComponent, [{
        type: Component,
        args: [{
                selector: 'ano-radio-select',
                template: "<div class=\"radio-select\" *ngIf=\"values?.length\">\n    <ng-container *ngFor=\"let value of values\">\n        <div class=\"radio-item active-radio\" (click)=\"!value.selected && select(value)\" [class.active-radio]=\"value.selected\" [ngStyle]=\"{width: (100 / values.length) + '%'}\">\n            <span>{{value.value}}</span>\n        </div>\n    </ng-container>\n    <!--<div class=\"radio-item\"><span>Item 2</span></div>-->\n</div>",
                styles: [".radio-select{width:100%;height:40px;border:1px solid #0e54a9;border-left:none;display:flex;flex-direction:row;justify-content:center}.radio-select .radio-item{border-left:1px solid #0e54a9;text-align:center;vertical-align:center;display:flex;justify-content:center;align-items:center;cursor:pointer;color:#0e54a9}.radio-select .radio-item.active-radio{background:#0e54a9;color:#fff}"]
            }]
    }], function () { return []; }, { change: [{
            type: Output
        }], value: [{
            type: Input
        }], values: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownComponent, [{
        type: Component,
        args: [{
                selector: 'ano-dropdown',
                template: "<div class=\"dropdown-wrapper\">\n    <input type=\"hidden\" [value]=\"value\"/>\n    <div *ngIf=\"!isAutocomplete\" (click)=\"toggle()\"\n         class=\"form-control form-group-select {{ classList }}\"\n         [class.cursor-pointer]=\"!(disabled || !isEditMode)\"\n         [class.invalid]=\"touched && invalid\"\n         [class.select-opened]=\"opened\"\n         [class.readonly]=\"readonly\"\n         [class.disabled]=\"disabled\"\n         [class.placeholder]=\"!value\"\n    ><span class=\"cut-placeholder\">{{ (getValue() || placeholder) | localize }}</span></div>\n    <input *ngIf=\"isAutocomplete\" (click)=\"toggle()\"\n           class=\"form-control form-group-select {{ classList }}\"\n           [class.cursor-pointer]=\"!(disabled || !isEditMode)\"\n           #autocomplete\n           [class.invalid]=\"touched && invalid\"\n           [class.select-opened]=\"opened\"\n           [class.disabled]=\"disabled && isEditMode\"\n           [placeholder]=\"placeholder | localize\"\n           [readonly]=\"readonly\"\n           [disabled]=\"disabled || !isEditMode\"\n           [value]=\"getValue() | localize\"\n           (input)=\"updateValue(autocomplete.value)\"\n           autocomplete=\"no\"\n    >\n    <i class=\"icon icon-close\" *ngIf=\"isClearButton\" (click)=\"clear()\"></i>\n    <span *ngIf=\"isAutocomplete && isEditMode\" class=\"caret down\" [class.invalid-caret]=\"touched && invalid\"\n          [class.disabled-caret]=\"disabled\"></span>\n    <div class=\"form-control select-dropdown\" [class.invalid]=\"touched && invalid\" *ngIf=\"opened\">\n        <ng-container *ngIf=\"!values.length && !actionLink && !actionCallback\">\n            <span class=\"form-control no-border dropdown-item-select {{ classList }}\" style=\"position: relative\">\n                {{'common.noItems' | localize}}\n            </span>\n        </ng-container>\n        <ng-container *ngIf=\"!values.length && actionLink\">\n            <span class=\"form-control no-border dropdown-item-select {{ classList }}\" style=\"position: relative\">\n                <a [routerLink]=\"actionLink.link\">{{ actionLink.text | localize}}</a>\n            </span>\n        </ng-container>\n        <ng-container *ngIf=\"!values.length && actionCallback\">\n            <span class=\"form-control no-border dropdown-item-select {{ classList }}\" style=\"position: relative\">\n                <a (click)=\"runCallback()\">{{ actionCallback.text | localize}}</a>\n            </span>\n        </ng-container>\n        <ng-container *ngIf=\"values.length\">\n            <ng-container *ngFor=\"let val of values\">\n                <ng-container *ngIf=\"showValue(val)\">\n                    <span class=\"form-control dropdown-item-select {{ classList }}\" [class.no-border]=\"noBorder\"\n                          [class.selected]=\"selected(val)\"\n                          [class.multiselect-single-dropdown]=\"multiselectInSingleDropdown\"\n                          (click)=\"selectValue(val)\" style=\"position: relative\">\n                        {{val.value | localize}} <i *ngIf=\"multiselectInSingleDropdown && selected(val)\" class=\"icon icon-check\"></i>\n                    </span>\n                </ng-container>\n            </ng-container>\n        </ng-container>\n    </div>\n</div>\n",
                styles: [".select-opened{border-radius:5px 5px 0 0!important;border-bottom-color:transparent!important}.select-dropdown{position:absolute!important;top:40px;border-top-color:transparent!important;border-radius:0 0 5px 5px!important;z-index:102!important;height:auto!important;max-height:250px;overflow:scroll;padding:0!important;background-color:#fff!important}.select-dropdown::-webkit-scrollbar{display:none}.form-group-select{cursor:default}.form-group-select:after{top:49%}.dropdown-input{cursor:auto}.selected{font-family:Poppins-Bold,sans-serif}.dropdown-wrapper{position:relative}.dropdown-item-select{cursor:default;border-radius:0!important;color:#0e54a9;border:none;white-space:normal}.dropdown-item-select:last-child{border-radius:0 0 3px 3px!important}.dropdown-item-select:hover{background-color:#efefef!important}.placeholder{color:#252525}.invalid{color:#fc4349;border-color:#fc4349!important}.invalid:after{border-top:7px solid #fc4349}.invalid::-moz-placeholder{color:#fc4349}.invalid:-ms-input-placeholder{color:#fc4349}.invalid::placeholder{color:#fc4349}.invalid .input-group-text{border-color:#fc4349}.disabled{border-color:#b6bbc5!important;color:#b6bbc5!important}.disabled-caret{display:none!important}.readonly:after{display:none}.dropdown-item-select,.form-group-select{display:flex!important;align-items:center!important}.caret{display:block;position:absolute;right:10px;top:18px;border-left:5px solid transparent;border-right:5px solid transparent;border-top:7px solid #0c1d3f;z-index:11}.invalid-caret{border-top-color:#fc4349}.disabled.form-group-select:after{border-color:transparent!important}.cut-placeholder{max-width:190px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.form-control.select-dropdown{margin-top:-4px}.form-control.select-dropdown .dropdown-item-select{padding-top:10px;padding-bottom:10px}.no-border{border-color:transparent!important}i.icon-close{position:absolute;top:13px;right:30px;font-size:13px;cursor:pointer;font-weight:700}i.icon-close:hover{color:#666}.multiselect-single-dropdown{justify-content:space-between}.multiselect-single-dropdown .icon{font-size:14px}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }]; }, { isClearButton: [{
            type: Input
        }], multiSelect: [{
            type: Input
        }], multiselectInSingleDropdown: [{
            type: Input
        }], isAutocomplete: [{
            type: Input
        }], isEditMode: [{
            type: Input
        }], readonly: [{
            type: Input
        }], noBorder: [{
            type: Input
        }], excludeSelected: [{
            type: Input
        }], change: [{
            type: Output
        }], focus: [{
            type: Output
        }], blur: [{
            type: Output
        }], selectedValue: [{
            type: Output
        }], values: [{
            type: Input
        }], closeDropdown: [{
            type: HostListener,
            args: ['document: click', ['$event']]
        }], value: [{
            type: Input
        }], autocomplete: [{
            type: ViewChild,
            args: ['autocomplete']
        }], classList: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], disabled: [{
            type: Input
        }], touched: [{
            type: Input
        }], invalid: [{
            type: Input
        }], actionLink: [{
            type: Input
        }], actionCallback: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonComponent, [{
        type: Component,
        args: [{
                selector: 'ano-button',
                template: "<button class=\"btn btn-{{ config.styleType }} {{ config.sizeType ? 'btn-' + config.sizeType : '' }} {{ config.marginRight ? 'margin-right' : ''}} {{config.marginBottom}} {{config.classList}}\"\n        [type]=\"config.type\"\n        [disabled]=\"config.isDisabled || isDisabled\">\n  <ng-content></ng-content>\n</button>\n",
                styles: [".margin-bottom{margin-bottom:20px}.icon-back-arrow{font-size:30px;position:absolute;left:6px;top:6px;font-weight:800}.width110px{width:110px;text-align:end}.width100perc{width:110%}.full-width{width:100%}"]
            }]
    }], function () { return []; }, { isDisabled: [{
            type: Input
        }], emitterButtonAction: [{
            type: Output
        }], config: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SearchInputComponent, [{
        type: Component,
        args: [{
                selector: 'ano-search-input',
                template: "<header class=\"header search-header\" id=\"searchHeader\">\n  <div class=\"container\" [class.flex]=\"isShowBackButton\">\n    <a class=\"header-nav\" *ngIf=\"isShowBackButton\" (click)=\"close()\">\n      <i class=\"icon-close\"></i>\n    </a>\n    <div class=\"form-group header-field search-btn-group\" [class.width-90]=\"isShowBackButton\">\n      <form action=\".\"\n        (ngSubmit)=\"getSearchResults()\"\n        [formGroup]=\"form\">\n        <input #searchInput (input)=\"searchModelChange()\"\n               class=\"form-control\"\n               formControlName=\"searchString\"\n               [placeholder]=\"'searchInput.placeholder.search'\"\n                type=\"search\"\n                name=\"search\" id=\"act_search\" />\n\n        <button (click)=\"clearSearchResults()\"\n                *ngIf=\"searchStatus.clear\"\n                class=\"close\"\n                type=\"button\">\n          <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <button *ngIf=\"!searchStatus.clear\"\n                [disabled]=\"!form.get('searchString').value\"\n                class=\"close\"\n                type=\"submit\">\n          <i class=\"icon-search\"></i>\n        </button>\n      </form>\n    </div>\n  </div>\n</header>\n",
                styles: [".header-nav{width:10%}.width-90{width:90%}.flex{display:flex}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [FormBuilder]
            }] }]; }, { searchStringEmitter: [{
            type: Output
        }], searchCloseEmitter: [{
            type: Output
        }], searchInput: [{
            type: ViewChild,
            args: ['searchInput', { static: false }]
        }], rounded: [{
            type: Input
        }], isShowBackButton: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LocalizationPipe, [{
        type: Pipe,
        args: [{
                name: 'localize'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [LocalizationProvider]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoaderComponent, [{
        type: Component,
        args: [{
                selector: 'ano-loader',
                template: "<div *ngIf=\"isOpen\" [ngClass]=\"{ 'avatar-spinner': theme === LOADER_THEMES.AVATAR,\n                                 'rounded-spinner': rounded,\n                                 'block-spinner': theme === LOADER_THEMES.BLOCK }\"\n     class=\"full-spinner\" [style.width]=\"width || '100%'\">\n    <p *ngIf=\"loadingText\">{{loadingText | localize}}</p>\n    <div class=\"css-spinner\">\n        <div class=\"bounce1\"></div>\n        <div class=\"bounce2\"></div>\n        <div class=\"bounce3\"></div>\n    </div>\n    <p *ngIf=\"progress\" class=\"progress-text\">{{ progress }}</p>\n</div>\n",
                styles: [".wrapper{position:absolute;top:0;left:0;z-index:9999;background:#212529;height:calc(100vh - 61px);width:100%;display:flex;align-items:center;justify-content:center}.full-spinner{flex-direction:column}.progress-text{font-size:16px}"]
            }]
    }], function () { return []; }, { isOpen: [{
            type: Input
        }], loadingText: [{
            type: Input
        }], progress: [{
            type: Input
        }], theme: [{
            type: Input
        }], containerRef: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FilterDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'ano-filter-dropdown',
                template: "<div class=\"dropdown cursor-pointer\" [class.show]=\"opened\">\n    <button class=\"btn btn-outline-primary dropdown-toggle btn-dropdown-xs\" (click)=\"toggleFilter()\">\n        {{ getValue() | localize}}\n    </button>\n    <div class=\"dropdown-menu dropdown-menu-xs\" [class.show]=\"opened\">\n        <!--<div class=\"dropdown-menu dropdown-menu-xs  open\">-->\n        <ng-container *ngFor=\"let val of values\">\n            <a class=\"dropdown-item\" (click)=\"selectValue(val)\" style=\"position: relative\">{{val.value | localize}}</a>\n        </ng-container>\n        <!--        <a class=\"dropdown-item\">2018</a>-->\n        <!--        <a class=\"dropdown-item\">...</a>-->\n        <!--        <a class=\"dropdown-item\">2010</a>-->\n    </div>\n</div>\n",
                styles: [".dropdown-menu{max-height:137px;overflow:scroll;-ms-overflow-style:none}.dropdown-menu::-webkit-scrollbar{display:none}.dropdown-toggle{text-transform:none;min-width:90px}.btn-dropdown-xs{height:38px;border-radius:5px}.dropdown .dropdown-toggle:after{margin-top:1px}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }]; }, { change: [{
            type: Output
        }], focus: [{
            type: Output
        }], blur: [{
            type: Output
        }], closeDropdown: [{
            type: HostListener,
            args: ['document: click', ['$event']]
        }], value: [{
            type: Input
        }], classList: [{
            type: Input
        }], values: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], disabled: [{
            type: Input
        }], touched: [{
            type: Input
        }], invalid: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SearchComponent, [{
        type: Component,
        args: [{
                selector: 'ano-search',
                template: "<form action=\".\" class=\"border-form\" [formGroup]=\"searchForm\" [ngStyle]=\"{width: 100 + '%'}\">\n    <div class=\"form-group\">\n        <ano-input formControlName=\"search\"\n                   [config]=\"{\n                   disabled: disabled,\n                   inputType: INPUT_TYPES.INPUT,\n                   placeholder: 'common.search' | localize,\n                   type: type,\n                   prepend: 'search'\n                   }\"></ano-input>\n    </div>\n</form>\n",
                providers: [AutoDestroyService],
                styles: [""]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [FormBuilder]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [AutoDestroyService]
            }] }]; }, { search$: [{
            type: Output
        }], type: [{
            type: Input
        }], searchClear: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TimeRangeFilterComponent, [{
        type: Component,
        args: [{
                selector: 'ano-time-range-filter',
                template: "<div class=\"blue-theme-filter\">\n    <form [formGroup]=\"timeRangeFilterForm\" *ngIf=\"timeRangeFilterConfig?.selectOptions?.length\">\n        <ano-input [formControlName]=\"timeRangeFilterConfig.name\"\n                   [isEditMode]=\"true\"\n                   [noBorder]=\"false\"\n                   [config]=\"{\n                            inputType: INPUT_TYPES.SELECT,\n                            placeholder: timeRangeFilterConfig.placeholder,\n                            selectOptions: timeRangeFilterConfig.selectOptions\n                          }\"></ano-input>\n    </form>\n</div>\n",
                providers: [AutoDestroyService],
                styles: [""]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [FormBuilder]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [AutoDestroyService]
            }] }]; }, { filterByTimeRange$: [{
            type: Output
        }], config: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IbanPipe, [{
        type: Pipe,
        args: [{
                name: 'iban'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StringCutPipe, [{
        type: Pipe,
        args: [{
                name: 'stringCut'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScrollToFirstErrorDirective, [{
        type: Directive,
        args: [{
                selector: '[anoScrollToFirstError]',
                providers: [AutoDestroyService]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [FormService]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [AutoDestroyService]
            }] }]; }, { forms: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PasswordValidatorComponent, [{
        type: Component,
        args: [{
                selector: 'ano-password-validator',
                template: "<p class=\"mb-5\" *ngIf=\"!hideTitle\">{{'registration_confirmation.validation.title' | localize}}</p>\n<ul class=\"bullet-list\">\n    <li [class.text-success]=\"passwordValidators.twelveCharactersLong\"\n        [class.text-danger]=\"!passwordValidators.twelveCharactersLong\">\n        <i [class.icon-check]=\"passwordValidators.twelveCharactersLong\"\n           [class.icon-minus]=\"!passwordValidators.twelveCharactersLong\"\n           class=\"icon\"></i>\n        {{'registration_confirmation.validation.has-12-characters' | localize}}\n    </li>\n    <li [class.text-success]=\"passwordValidators.hasUpperCaseCharacter\"\n        [class.text-danger]=\"!passwordValidators.hasUpperCaseCharacter\">\n        <i [class.icon-check]=\"passwordValidators.hasUpperCaseCharacter\"\n           [class.icon-minus]=\"!passwordValidators.hasUpperCaseCharacter\"\n           class=\"icon\"></i>\n        {{'registration_confirmation.validation.has-uppercase' | localize}}\n    </li>\n    <li [class.text-success]=\"passwordValidators.hasNonAlphanumeric\"\n        [class.text-danger]=\"!passwordValidators.hasNonAlphanumeric\">\n        <i [class.icon-check]=\"passwordValidators.hasNonAlphanumeric\"\n           [class.icon-minus]=\"!passwordValidators.hasNonAlphanumeric\"\n           class=\"icon\"></i>\n        {{'registration_confirmation.validation.has-non-alphanumeric' | localize}}\n    </li>\n</ul>\n\n",
                styles: [".bullet-list{margin-bottom:25px;padding-left:15px;list-style-type:none}.bullet-list li{font-size:12px}"]
            }]
    }], function () { return []; }, { password: [{
            type: Input
        }], hideTitle: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BillsTableComponent, [{
        type: Component,
        args: [{
                selector: 'ano-bills-table',
                template: "<h4 *ngIf=\"config.title\"><b>{{config.title | localize}}</b></h4>\n<ano-table class=\"bills\" [tableConfig]=\"config.tableConfig\"\n           [showDatepicker]=\"config.withTimeRange\"\n           [startFromAll]=\"true\"\n           [withSearch]=\"config.withSearch\"\n           [timeRangeConfig]=\"config.withTimeRange && timeRangeConfig\"\n           (timeRangeFilter$)=\"onTimeRangeFilter($event)\"\n></ano-table>\n",
                styles: [""]
            }]
    }], function () { return []; }, { timeRangeFilter$: [{
            type: Output
        }], table: [{
            type: ViewChild,
            args: ['tableComponent', { static: true }]
        }], config: [{
            type: Input
        }], timeRangeConfig: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DateFormatPipe, [{
        type: Pipe,
        args: [{
                name: 'dateFormat'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CurrencyPipe, [{
        type: Pipe,
        args: [{
                name: 'currency'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalComponent, [{
        type: Component,
        args: [{
                selector: 'ano-modal',
                template: "<div class=\"modal show\">\n    <div class=\"modal-dialog modal-dialog-centered\" role=\"document\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\" *ngIf=\"!isLoading\">\n                <h5 class=\"modal-title\" id=\"exampleModalLabel\" [innerHTML]=\"title\"></h5>\n            </div>\n            <div class=\"modal-body\" *ngIf=\"!isLoading\">\n                <ng-content></ng-content>\n                <ng-container *ngIf=\"data && data.text\">\n                    {{ data.text }}\n                </ng-container>\n            </div>\n            <div class=\"modal-footer\" *ngIf=\"!isLoading\">\n                <button (click)=\"dismiss()\" type=\"button\" class=\"btn btn-danger {{dismissButtonClass}}\"\n                        data-dismiss=\"modal\">{{ dismissButtonText | localize}}</button>\n                <button *ngIf=\"!withoutSubmit\" (click)=\"apply()\" type=\"button\"\n                        class=\"btn btn-primary\">{{ submitButtonText | localize }}</button>\n            </div>\n            <ano-loader [isOpen]=\"isLoading\" [loadingText]=\"loadingText\"></ano-loader>\n        </div>\n    </div>\n</div>\n",
                styles: [".show{display:block}::ng-deep .cdk-overlay-dark-backdrop{background:#000}::ng-deep .cdk-overlay-backdrop-showing{opacity:.8!important}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, { dismissButtonText: [{
            type: Input
        }], submitButtonText: [{
            type: Input
        }], dismissButtonClass: [{
            type: Input
        }], loadingText: [{
            type: Input
        }], isConfirmation: [{
            type: Input
        }], withoutSubmit: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], validate: [{
            type: Output
        }], dialogRef: [{
            type: Input
        }], title: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WidgetComponent, [{
        type: Component,
        args: [{
                selector: 'ano-widget',
                template: "<div class=\"widget {{config.type}}\">\n    <h3 class=\"title\">{{config?.currency ? ({amount: config.amount, currency: config?.currency} | currency) :(config.amount | number: config?.toFixed)}}</h3>\n    <span class=\"block\">{{config.title}}</span>\n    <span  *ngIf=\"config.additionalAmountInfo\" class=\"block\">({{config.additionalAmountInfo}})</span>\n    <span class=\"block\">{{config.period}} <ng-container *ngIf=\"config.additionalPeriodInfo\">({{config.additionalPeriodInfo}})</ng-container></span>\n    <div class=\"info-table\" *ngIf=\"config?.infoTable\">\n        <div class=\"info-container\" *ngFor=\"let item of config.infoTable\">\n            <span>{{item.title}}</span>\n            <span class=\"amount\">{{item.amount | number: config?.toFixed}}</span>\n        </div>\n    </div>\n    <i class=\"icon icon-{{config.icon}}\"></i>\n</div>\n",
                styles: [".widget{border-radius:5px;padding:13px 15px 12px 20px;color:#fff;position:relative;overflow:hidden;margin-bottom:20px}.widget .title{font-size:1.9rem;line-height:1;color:#fff;font-family:Poppins-Bold,sans-serif;text-transform:none;margin-bottom:3px}.widget span{font-size:14px;display:block;letter-spacing:.02rem}.widget .icon{position:absolute;right:-4px;bottom:-2px;font-size:50px}.widget.primary{background:#007e8c}.widget.success{background:#bad668}.widget.warning{background:#ffbe00}.info-table{margin-top:5px;display:flex;flex-direction:column}.info-table .info-container{display:flex;flex-direction:row;justify-content:space-between}"]
            }]
    }], function () { return []; }, { config: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScatterChartComponent, [{
        type: Component,
        args: [{
                selector: 'ano-scatter-chart',
                template: "<div class=\"chart-container\">\n    <svg [id]=\"'chart-svg-' + id\"></svg>\n    <div [id]=\"'tooltip-container-' + id\"></div>\n</div>\n",
                styles: ["::ng-deep.tooltip{position:absolute;text-align:center;padding:7px 28px;font:12px sans-serif;background:#b0c4de;border:1px hsla(0,0%,100%,.9);color:#fff;border-radius:4px;pointer-events:none;font-size:medium;font-weight:800}.chart-container{position:relative}"]
            }]
    }], function () { return []; }, { id: [{
            type: Input
        }], margin: [{
            type: Input
        }], width: [{
            type: Input
        }], offset: [{
            type: Input
        }], data: [{
            type: Input
        }], legend: [{
            type: Input
        }], categories: [{
            type: Input
        }], colorScheme: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LegendBoxComponent, [{
        type: Component,
        args: [{
                selector: 'ano-legend-box',
                template: "<div class=\"box-checkbox\">\n    <label class=\"custom-checkbox\" *ngFor=\"let legendItem of legend\">{{legendItem.title | localize}}\n        <br><b>{{legendItem.count}}{{suffix}}</b>\n        <input type=\"checkbox\" *ngIf=\"!readOnly\" [checked]=\"true\" (click)=\"onCheck(legendItem.label)\">\n        <span class=\"checkmark\" [ngStyle]=\"{'backgroundColor': colorScheme[legendItem.label]}\"></span>\n    </label>\n</div>\n",
                styles: [""]
            }]
    }], function () { return []; }, { change: [{
            type: Output
        }], legend: [{
            type: Input
        }], colorScheme: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], suffix: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PieChartComponent, [{
        type: Component,
        args: [{
                selector: 'ano-pie-chart',
                template: "<div class=\"chart-container\">\n    <svg [id]=\"'pie-chart-' + id\"></svg>\n    <div [id]=\"'tooltip-container-' + id\"></div>\n</div>\n",
                styles: ["::ng-deep.tooltip{position:absolute;text-align:center;padding:7px 28px;font:12px sans-serif;background:#b0c4de;border:1px solid hsla(0,0%,100%,.9);color:#fff;border-radius:4px;pointer-events:none;font-size:medium;font-weight:800}.chart-container{position:relative}"]
            }]
    }], function () { return []; }, { width: [{
            type: Input
        }], height: [{
            type: Input
        }], rotate: [{
            type: Input
        }], id: [{
            type: Input
        }], colorScheme: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BarChartComponent, [{
        type: Component,
        args: [{
                selector: 'ano-bar-chart',
                template: "<div class=\"chart-container\">\n    <svg id=\"bar-chart\"></svg>\n    <div [id]=\"'tooltip-container-' + id\"></div>\n</div>\n",
                styles: ["::ng-deep.tooltip{position:absolute;text-align:center;padding:7px 28px;font:12px sans-serif;background:#b0c4de;border:1px solid hsla(0,0%,100%,.9);color:#fff;border-radius:4px;pointer-events:none;font-size:medium;font-weight:800}.chart-container{position:relative}"]
            }]
    }], function () { return []; }, { id: [{
            type: Input
        }], colorScheme: [{
            type: Input
        }], currency: [{
            type: Input
        }], width: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MaterialModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ...commonDeclarations,
                ],
                imports: [
                    ...commonImports,
                    CommonModule,
                ],
                exports: [
                    ...commonExports
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MaterialModule, { imports: function () { return [A11yModule,
        ClipboardModule,
        CdkStepperModule,
        CdkTableModule,
        CdkTreeModule,
        DragDropModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatBottomSheetModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatStepperModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatTreeModule,
        PortalModule,
        ScrollingModule, CommonModule]; }, exports: function () { return [A11yModule,
        ClipboardModule,
        CdkStepperModule,
        CdkTableModule,
        CdkTreeModule,
        DragDropModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatBottomSheetModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatStepperModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatTreeModule,
        PortalModule,
        ScrollingModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ImagePipe, [{
        type: Pipe,
        args: [{
                name: 'image'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [ENVIRONMENT]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoadingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormComponent, [{
        type: Component,
        args: [{
                selector: 'ano-form',
                template: "<div [class.card]=\"!isLightForm\" class=\"bg-white {{classList}}\" [class.card-with-password-validation]=\"passwordValidation\" anoScrollToFirstError [forms]=\"[form]\">\n    <ano-loader [isOpen]=\"loadingService.loading | async\"></ano-loader>\n    <div class=\"row row-align-stretch\">\n        <div class=\"mr-auto\"\n             [class.col]=\"forcedViewMode || withoutSave\"\n             [class.col-md-8]=\"(!forcedViewMode && !withoutSave && !mainColMd7) || passwordValidation || mainColMd8\"\n             [class.col-md-7]=\"mainColMd7\"\n        >\n            <!--            was updated here-->\n            <div [class.card-body]=\"!isLightForm\" class=\"pb-10\">\n                <h2 class=\"body-title\" [class.mb-25]=\"description\" *ngIf=\"title\">{{title | localize}}\n                    <small *ngIf=\"subTitle\">({{subTitle | localize}})</small>\n                </h2>\n                <p *ngIf=\"description\">{{description | localize}}</p>\n                <ng-content></ng-content>\n                <form class=\"inline-form validation-absolute\" [class.light-form]=\"isLightForm\"\n                      [class.inline-form]=\"inlineForm\"\n                      [class.form-without-border]=\"!borderForm && inlineForm\"\n                      [class.material-form]=\"materialForm\"\n                      [class.full-20]=\"isLightForm\"\n                      [class.border-form]=\"borderForm\"\n                      [class.edit]=\"(isEditMode || forcedEditMode) && !defaultFields\"\n                      [class.view]=\"(!isEditMode && !forcedEditMode) || defaultFields\" [formGroup]=\"form\"  autocomplete=\"off\">\n                    <ng-container *ngFor=\"let field of fieldsConfig; let last = last;\">\n                        <ng-container *ngIf=\"!field.hidden\">\n                            <div class=\"row row-padding-0\"\n                                 [class.publisher-image]=\"field.name === 'newPicture'\"\n                                 [class.form-group]=\"borderForm\"\n                                 [class.align-items-top]=\"field.config.inputType !== INPUT_TYPES.TEXTAREA\"\n                                 [class.text-area-wrapper]=\"field.config.inputType === INPUT_TYPES.TEXTAREA\">\n                                <label *ngIf=\"field.config.label\"\n                                       class=\"col-md-{{labelWidth || (forcedViewMode ? 4 : passwordValidation ? 7 : 6)}} form-control-label\">{{ field.config.label | localize }}\n                                    <span\n                                            *ngIf=\"field.config.isRequired\"\n                                            class=\"text-primary\">*</span>\n                                    <span\n                                            *ngIf=\"field.config.optional\"\n                                            class=\"light\">(optional)</span></label>\n                                <div class=\"col-md-{{fieldWidth || (forcedViewMode ? 8 : passwordValidation ? 5 : 6)}}\"\n                                     [class.form-control-border]=\"isEditMode || field.config.isLink\">\n                                    <a class=\"form-control lnk mb-15\" target=\"_blank\"\n                                       *ngIf=\"field.config.isLink && ((!isEditMode && !forcedEditMode) || (forcedEditMode && defaultFields))\"\n                                       [href]=\"getLink(form.get(field.name).value)\">{{getLink(form.get(field.name).value)}}</a>\n                                    <ano-input\n                                            *ngIf=\"!field.config.isLink && ((!isEditMode && !forcedEditMode) || (forcedEditMode && defaultFields))\"\n                                            [formControl]=\"form.get(field.name)\"\n                                            [defaultForm]=\"true\"\n                                            [disabled]=\"!defaultFields\"\n                                            [invalid]=\"form.get(field.name).invalid\"\n                                            [isEditMode]=\"isEditMode || defaultFields\"\n                                            [multimediaUrl]=\"photoUrl\"\n                                            [errors]=\"defaultFields || showErrorsForViewMode ? form.get(field.name).errors : null\"\n                                            [isTouched]=\"defaultFields || showErrorsForViewMode ? form.get(field.name).touched : null\"\n                                            [accept]=\"field.config.accept\"\n                                            [config]=\"{\n\t\t\t\t\t\t\t\t           \t\t\tisAutocomplete: field.config.isAutocomplete,\n                                                    inputType: field.config.inputType,\n                                                    label: field.config.label,\n                                                    placeholder: field.config.placeholder,\n                                                    isRequired: field.config.isRequired,\n                                                    selectOptions: field.config.selectOptions,\n                                                    datetimeType: field.config.datetimeType,\n                                                    type: field.config.type,\n                                                    startDate: getStartDate(),\n                                                    endDate: getEndDate(),\n                                                    copy: field.config.copy,\n                                                    show: field.config.show,\n                                                    accept: field.config.accept,\n                                                    mask: field.config.mask,\n                                                    removeSpaces: field.config.removeSpaces,\n                                                    autosize: field.config.autosize\n                                                    }\"\n                                    ></ano-input>\n                                    <div class=\"form-group\" [id]=\"field.name\"\n                                         *ngIf=\"(isEditMode || forcedEditMode) && !defaultFields\">\n                                        <ano-input [formControl]=\"form.get(field.name)\"\n                                                   [defaultForm]=\"true\"\n                                                   [name]=\"field.name\"\n                                                   [invalid]=\"form.get(field.name).invalid\"\n                                                   [disabled]=\"field.config.disabled\"\n                                                   [errors]=\"form.get(field.name).errors\"\n                                                   [isTouched]=\"form.get(field.name).touched\"\n                                                   [columnImageUploader]=\"columnImageUploader\"\n                                                   [clearImageButton]=\"clearImageButton\"\n                                                   [multimediaUrl]=\"photoUrl\"\n                                                   [accept]=\"field.config.accept\"\n                                                   [config]=\"{\n\t\t\t\t\t\t\t\t\t           \t\tisAutocomplete: field.config.isAutocomplete,\n                                                    inputType: field.config.inputType,\n                                                    label: field.config.label,\n                                                    placeholder: field.config.placeholder,\n                                                    isRequired: field.config.isRequired,\n                                                    selectOptions: field.config.selectOptions,\n                                                    datetimeType: field.config.datetimeType,\n                                                    type: field.config.type,\n                                                    startDate: getStartDate(),\n                                                    endDate: getEndDate(),\n                                                    accept: field.config.accept,\n                                                    mask: field.config.mask,\n                                                    removeSpaces: field.config.removeSpaces,\n                                                    autosize: field.config.autosize\n                                                    }\"\n                                                   (onFileUpload$)=\"uploadPreviewPhoto($event)\"\n                                                   (clearImage$)=\"clearImage($event)\"\n                                                   [isEditMode]=\"isEditMode\"\n                                        ></ano-input>\n                                    </div>\n                                </div>\n                            </div>\n                        </ng-container>\n                    </ng-container>\n                </form>\n            </div>\n        </div>\n            <div class=\"col\" *ngIf=\"withAvatar\">\n                <div class=\"col-between\">\n                    <div class=\"image-wrapper\">\n                        <div class=\"user-photo\">\n                            <div class=\"close\" *ngIf=\"isEditMode && avatar\" (click)=\"deleteAvatar()\">\n                                <i class=\"icon icon-trash2\"></i>\n                            </div>\n                            <img *ngIf=\"avatar\" class=\"img-responsive\" [src]=\"avatar\" alt=\"avatar\">\n                            <img *ngIf=\"!avatar\" class=\"img-responsive\" src=\"/assets/img/mock/no-user-photo.png\"\n                                 alt=\"avatar\">\n                            <input type=\"file\" id=\"fileDropRef\" accept=\"image/*\" multiple\n                                   (change)=\"fileBrowseHandler($event.target['files'])\" [disabled]=\"!isEditMode\"\n                                   [class.cursor-pointer]=\"isEditMode\"/>\n                            <i class=\"icon icon-user-edit\" *ngIf=\"isEditMode\"></i>\n                        </div>\n                    </div>\n                    <div class=\"m-button align-self-end\" *ngIf=\"!forcedViewMode\">\n                        <button class=\"btn cancel-button {{ cancelButtonClass || 'btn-danger' }}\" *ngIf=\"isEditMode\" (click)=\"cancel()\">{{'common.button.close' | localize}}\n                        </button>\n                        <button class=\"btn\"\n                                [class.btn-primary]=\"!isEditMode\"\n                                [class.btn-success]=\"isEditMode\"\n                                (click)=\"changeEditMode()\"\n                        >{{ editButtonText() | localize}}</button>\n                    </div>\n                </div>\n            </div>\n            <div  class=\"align-self-end\" [class.edit-col]=\"buttonsCol5 && isEditMode\" [class.col]=\"passwordValidation || !buttonsCol5 || (buttonsCol5 && !isEditMode)\" [class.col-5]=\"buttonsCol5 && isEditMode\" *ngIf=\"!withAvatar && !forcedViewMode && !hidePasswordValidation\">\n                <div class=\"validator-container\">\n                <ano-password-validator *ngIf=\"passwordValidation && isEditMode\"\n                                        [hideTitle]=\"true\"\n                                        [password]=\"form.get('newPassword').value\"></ano-password-validator>\n                </div>\n                <div class=\"buttons-container\" *ngIf=\"!withoutSave\">\n                    <button class=\"btn cancel-button {{ cancelButtonClass || 'btn-danger' }}\" *ngIf=\"isEditMode\" (click)=\"cancel()\">{{'common.button.close' | localize}}</button>\n                    <button class=\"btn btn-success\"\n                            [class.btn-primary]=\"!isEditMode\"\n                            [class.btn-success]=\"isEditMode\"\n                            (click)=\"changeEditMode()\">{{ editButtonText() | localize }}</button>\n                </div>\n            </div>\n    </div>\n</div>\n",
                styles: ["select.form-control{height:100%;border-radius:0;padding-left:2px;-webkit-appearance:none}.card{margin-bottom:20px}.cancel-button{margin-right:10px}.btn{min-width:110px}.col-between{align-items:flex-end}.user-photo input{opacity:0;position:absolute;z-index:2;width:100%;height:100%;top:0;left:0}.dropdown-item-select{padding:10px}::ng-deep .select-dropdown{top:35px!important}.lnk{display:table-cell;vertical-align:middle}::ng-deep .caret{top:15px!important}.icon-trash2{z-index:100;cursor:pointer;position:absolute;color:#fc4349;right:10px;top:5px}.image-wrapper .icon-trash2{color:#fff;top:10px;text-shadow:none}h2 small{text-transform:none}.buttons-container{display:flex;justify-content:flex-end;padding-right:20px;padding-bottom:10px}.buttons-container .btn{margin-bottom:10px}app-password-validator{display:block;padding-top:65px}.card-with-password-validation .validator-container{padding-right:20px}.card-with-password-validation ::ng-deep .bullet-list{font-size:14px;margin-bottom:10px;padding-left:0}.card-with-password-validation .card-body{padding-top:10px}.validator-container{height:auto}.form-control-label{text-transform:none}.form-control.lnk.mb-15{display:block!important}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [LoadingService]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [FormService]
            }] }]; }, { clearImageButton: [{
            type: Input
        }], columnImageUploader: [{
            type: Input
        }], photoUrl: [{
            type: Input
        }], avatar: [{
            type: Input
        }], forcedEditMode: [{
            type: Input
        }], defaultFields: [{
            type: Input
        }], forcedViewMode: [{
            type: Input
        }], withoutSave: [{
            type: Input
        }], showErrorsForViewMode: [{
            type: Input
        }], isLightForm: [{
            type: Input
        }], materialForm: [{
            type: Input
        }], borderForm: [{
            type: Input
        }], inlineForm: [{
            type: Input
        }], isButtons: [{
            type: Input
        }], submit$: [{
            type: Output
        }], cancel$: [{
            type: Output
        }], onFileUpload$: [{
            type: Output
        }], clearImage$: [{
            type: Output
        }], avatar$: [{
            type: Output
        }], deleteAvatar$: [{
            type: Output
        }], title: [{
            type: Input
        }], subTitle: [{
            type: Input
        }], description: [{
            type: Input
        }], form: [{
            type: Input
        }], fieldsConfig: [{
            type: Input
        }], withSideColumn: [{
            type: Input
        }], withAvatar: [{
            type: Input
        }], submitButtonText: [{
            type: Input
        }], cancelButtonText: [{
            type: Input
        }], cancelButtonClass: [{
            type: Input
        }], mainColMd7: [{
            type: Input
        }], mainColMd8: [{
            type: Input
        }], buttonsCol5: [{
            type: Input
        }], passwordValidation: [{
            type: Input
        }], hidePasswordValidation: [{
            type: Input
        }], success$: [{
            type: Input
        }], labelWidth: [{
            type: Input
        }], fieldWidth: [{
            type: Input
        }], classList: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NumberComponent, [{
        type: Component,
        args: [{
                selector: 'ano-number',
                template: "<div class=\"number-container\">{{data | number}}</div>\n",
                styles: [".number-container{width:40%;text-align:end}"]
            }]
    }], function () { return []; }, { data: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NumberPipe, [{
        type: Pipe,
        args: [{
                name: 'number'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InfoPanelComponent, [{
        type: Component,
        args: [{
                selector: 'ano-info-panel',
                template: "<div class=\"alert alert-info-box alert-block alert-icon\"\n     [class.alert-info-message]=\"infoPanel?.info\">\n    <i class=\"icon icon-info\"></i>\n    {{infoPanel?.textKey | localize}}\n</div>",
                styles: [""]
            }]
    }], function () { return []; }, { infoPanel: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LinkedStreamsFilterComponent, [{
        type: Component,
        args: [{
                selector: 'ano-linked-streams-filter',
                template: "<div class=\"blue-theme-filter\">\n    <form [formGroup]=\"linkedStreamsFilterForm\" *ngIf=\"linkedStreamsFilterConfig?.selectOptions?.length\">\n        <ano-input [formControlName]=\"linkedStreamsFilterConfig.name\"\n                   [isEditMode]=\"true\"\n                   [noBorder]=\"false\"\n                   [config]=\"{\n                            inputType: INPUT_TYPES.SELECT,\n                            placeholder: linkedStreamsFilterConfig.placeholder,\n                            selectOptions: linkedStreamsFilterConfig.selectOptions\n                          }\"></ano-input>\n    </form>\n</div>\n",
                providers: [AutoDestroyService],
                styles: [""]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [LocalizationProvider]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [FormBuilder]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [AutoDestroyService]
            }] }]; }, { filterByLinkedStreams$: [{
            type: Output
        }], filters: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SpeedometerComponent, [{
        type: Component,
        args: [{
                selector: 'ano-speedometer',
                template: "<div class=\"chart-bandwidth\">\n    <p class=\"mb-0 mt-10 top-text\" *ngIf=\"topText\">{{topText | localize}}</p>\n    <img class=\"bandwidth-speedometer mxh-75\" [src]=\"'assets/img/graphics/bandwidth-speedometer-' + chartValue + '.svg'\"\n         alt=\"bandwidth\"/>\n    <span class=\"data-bandwidth mt-0\">{{data.used.value}} {{data.used.unit}}</span>\n    <p class=\"mb-0\">{{text.firstLine | localize}}\n        <b class=\"text-primary no-white-space\">{{data.limit.value}} {{data.limit.unit}}</b>\n        <br>\n        {{text.secondLine | localize}} <b class=\"text-primary no-white-space\">{{data.percent.toFixed(2)}}%.</b>\n    </p>\n</div>\n",
                styles: [".no-white-space{white-space:nowrap}"]
            }]
    }], function () { return []; }, { data: [{
            type: Input
        }], text: [{
            type: Input
        }], topText: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PieChartUsedComponent, [{
        type: Component,
        args: [{
                selector: 'ano-pie-chart-used',
                template: "<div class=\"chart-bandwidth\">\n    <p class=\"mb-0 mt-10 top-text\" *ngIf=\"topText\">{{topText | localize}}</p>\n    <div class=\"row justify-content-center\" style=\"margin-bottom: -10px;\">\n        <div class=\"col-auto\">\n            <ano-pie-chart [id]=\"id\" [data]=\"{value1: (data.percent / 100), value2: 1 - data.percent / 100}\" [rotate]=\"data.percent < 50 ? 360 * (data.percent / 100) : 0\"\n                           [colorScheme]=\"{label1: '#0e54a9', label2: '#e6eef6'}\" [height]=\"125\"\n                           [width]=\"125\"></ano-pie-chart>\n        </div>\n    </div>\n    <span class=\"data-bandwidth mt-0\">{{data.used.value}} {{data.used.unit}}</span>\n    <p class=\"mb-0\">{{text.firstLine | localize}}\n        <b class=\"text-primary no-white-space\">{{data.limit.value}} {{data.limit.unit}}</b>\n        <br>\n        {{text.secondLine | localize}} <b class=\"text-primary no-white-space\">{{data.percent.toFixed(2)}}%.</b>\n    </p>\n</div>\n",
                styles: [".no-white-space{white-space:nowrap}"]
            }]
    }], function () { return []; }, { data: [{
            type: Input
        }], id: [{
            type: Input
        }], text: [{
            type: Input
        }], topText: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatepickerComponent, [{
        type: Component,
        args: [{
                selector: "ano-datepicker",
                template: "<div class=\"datepicker-wrap\" (click)=\"dp.open()\">\n  <div *ngIf=\"date.value === 'All'\">\n    All\n  </div>\n  <input\n    class=\"datepicker-field\"\n    matInput\n    readonly\n    [matDatepicker]=\"dp\"\n    [max]=\"end\"\n    [formControl]=\"date\"\n  />\n  <div *ngIf=\"showAllOption && showClear\"\n  class=\"datepicker-clear\"\n  matDatepickerToggleIcon\n  (click)=\"clearDate($event)\">\n    <i class=\"icon icon-close\"></i>\n  </div>\n  <mat-datepicker-toggle\n    class=\"datepicker-toogle\"\n    color=\"white\"\n    matSuffix\n    [for]=\"dp\"\n  ></mat-datepicker-toggle>\n  <mat-datepicker\n    #dp\n    startView=\"year\"\n    panelClass=\"ano-month-picker\"\n    (monthSelected)=\"chosenMonthHandler($event, dp)\"\n  >\n  </mat-datepicker>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
                    // application's root module. We provide it at the component level here, due to limitations of
                    // our example generation script.
                    {
                        provide: DateAdapter,
                        useClass: MomentDateAdapter,
                        deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
                    },
                    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
                ],
                styles: [".datepicker-wrap{padding:0 .25rem 0 .5rem;display:flex;align-items:center;justify-content:space-between;max-height:30px;min-width:203px}.datepicker-field{border:0}.datepicker-field,.datepicker-wrap{font-size:12px;background:#0e54a9;color:#fff;cursor:pointer}mat-datepicker-toggle{color:#fff!important}.datepicker-selected{background:#0e54a9;border-radius:100%}.datepicker-toogle{position:relative;left:7px}.datepicker-clear{position:relative;left:10px}"]
            }]
    }], function () { return []; }, { value: [{
            type: Input
        }], showAllOption: [{
            type: Input
        }], startFromAll: [{
            type: Input
        }], end: [{
            type: Input
        }], changeDate: [{
            type: Output
        }], dp: [{
            type: ViewChild,
            args: [MatDatepicker]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UiElementsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    TableComponent,
                    InputComponent,
                    DragAndDropComponent,
                    CleaveMaskDirective,
                    DndDirective,
                    RadioSelectComponent,
                    DropdownComponent,
                    ButtonComponent,
                    // PlayerComponent,
                    // VideojsComponent,
                    SearchInputComponent,
                    WhiteSpacePipe,
                    LocalizationPipe,
                    LoaderComponent,
                    FilterDropdownComponent,
                    SearchComponent,
                    TimeRangeFilterComponent,
                    IbanPipe,
                    StringCutPipe,
                    FormComponent,
                    ScrollToFirstErrorDirective,
                    PasswordValidatorComponent,
                    BillsTableComponent,
                    DateFormatPipe,
                    CurrencyPipe,
                    ModalComponent,
                    WidgetComponent,
                    ScatterChartComponent,
                    LegendBoxComponent,
                    PieChartComponent,
                    BarChartComponent,
                    ImagePipe,
                    NumberComponent,
                    NumberPipe,
                    InfoPanelComponent,
                    LinkedStreamsFilterComponent,
                    SpeedometerComponent,
                    PieChartUsedComponent,
                    DatepickerComponent
                ],
                imports: [
                    CommonModule,
                    MatPaginatorModule,
                    TableModule,
                    FormsModule,
                    ReactiveFormsModule,
                    OwlDateTimeModule,
                    OwlNativeDateTimeModule,
                    NgxMaskModule,
                    MatSlideToggleModule,
                    RouterModule,
                    MaterialModule,
                    AutosizeModule
                ],
                exports: [
                    TableComponent,
                    InputComponent,
                    DragAndDropComponent,
                    RadioSelectComponent,
                    DropdownComponent,
                    ButtonComponent,
                    // PlayerComponent,
                    // VideojsComponent,
                    SearchInputComponent,
                    OwlDateTimeModule,
                    OwlNativeDateTimeModule,
                    LocalizationPipe,
                    LoaderComponent,
                    FilterDropdownComponent,
                    SearchComponent,
                    TimeRangeFilterComponent,
                    IbanPipe,
                    StringCutPipe,
                    FormComponent,
                    ScrollToFirstErrorDirective,
                    PasswordValidatorComponent,
                    BillsTableComponent,
                    DateFormatPipe,
                    CurrencyPipe,
                    ModalComponent,
                    WidgetComponent,
                    ScatterChartComponent,
                    LegendBoxComponent,
                    TableModule,
                    PieChartComponent,
                    BarChartComponent,
                    MaterialModule,
                    ImagePipe,
                    NumberPipe,
                    NumberComponent,
                    InfoPanelComponent,
                    LinkedStreamsFilterComponent,
                    SpeedometerComponent,
                    PieChartUsedComponent,
                    DatepickerComponent
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UiElementsModule, { declarations: function () { return [TableComponent, InputComponent, DragAndDropComponent, CleaveMaskDirective, DndDirective, RadioSelectComponent, DropdownComponent, ButtonComponent, SearchInputComponent, WhiteSpacePipe, LocalizationPipe, LoaderComponent, FilterDropdownComponent, SearchComponent, TimeRangeFilterComponent, IbanPipe, StringCutPipe, FormComponent, ScrollToFirstErrorDirective, PasswordValidatorComponent, BillsTableComponent, DateFormatPipe, CurrencyPipe, ModalComponent, WidgetComponent, ScatterChartComponent, LegendBoxComponent, PieChartComponent, BarChartComponent, ImagePipe, NumberComponent, NumberPipe, InfoPanelComponent, LinkedStreamsFilterComponent, SpeedometerComponent, PieChartUsedComponent, DatepickerComponent]; }, imports: function () { return [CommonModule,
        MatPaginatorModule,
        TableModule,
        FormsModule,
        ReactiveFormsModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        NgxMaskModule,
        MatSlideToggleModule,
        RouterModule, MaterialModule, AutosizeModule]; }, exports: function () { return [TableComponent, InputComponent, DragAndDropComponent, RadioSelectComponent, DropdownComponent, ButtonComponent, SearchInputComponent, OwlDateTimeModule,
        OwlNativeDateTimeModule, LocalizationPipe, LoaderComponent, FilterDropdownComponent, SearchComponent, TimeRangeFilterComponent, IbanPipe, StringCutPipe, FormComponent, ScrollToFirstErrorDirective, PasswordValidatorComponent, BillsTableComponent, DateFormatPipe, CurrencyPipe, ModalComponent, WidgetComponent, ScatterChartComponent, LegendBoxComponent, TableModule, PieChartComponent, BarChartComponent, MaterialModule, ImagePipe, NumberPipe, NumberComponent, InfoPanelComponent, LinkedStreamsFilterComponent, SpeedometerComponent, PieChartUsedComponent, DatepickerComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PlayerComponent, [{
        type: Component,
        args: [{
                selector: 'ano-player',
                template: "<div class=\"player-container\" [ngStyle]=\"{'background-image': 'url(' + environment.backendApiHost + config?.thumbnailUrl + ')', 'background-size': 'cover', 'background-position': 'center'}\">\n    <ng-container *ngFor=\"let infoLine of config?.infoLines; let i = index\">\n        <span  class=\"status-video status-video-{{i + 1}} {{infoLine.cssClass}}\" *ngIf=\"infoLine\n         && (infoLine.showOn !== STATE.PLAY || state === STATE.PLAY)\n         && (infoLine.showOn !== STATE.STOP || state === STATE.STOP)\" (click)=\"infoLine?.action()\">\n            <i *ngIf=\"infoLine.cssIconClass\" class=\"icon icon-{{infoLine.cssIconClass}}\"></i> {{ infoLine.text | localize }}\n        </span>\n    </ng-container>\n    <ano-videojs *ngIf=\"config?.mediaSource?.url\"\n                 [config]=\"config\"\n                 [buttonsConfig]=\"buttonsConfig\"\n                 [currentLivestreamTime]=\"currentLivestreamTime\"\n                 [marketingSocket]=\"marketingSocket\"\n                 [playerController]=\"playerController\"\n                 (videoEnded)=\"onVideoEnd()\"\n                 (videoClicked)=\"onVideoClick()\"\n                 (playerSignal)=\"onPlayerSignal($event)\"\n                 (overlayClicked)=\"onOverlayClick($event)\"\n                 (overlayViewed)=\"onOverlayViewed($event)\"\n                 (fullscreenToggle)=\"onFullscreenChange($event)\"\n                 (timeUpdate)=\"onTimeUpdate($event)\"\n    ></ano-videojs>\n</div>\n\n\n",
                styles: ["@charset \"UTF-8\";.player-container{width:100%;height:100%}.player-container .status-video{z-index:100;position:absolute;right:15px;cursor:pointer;font-size:25px;color:#fff;text-transform:uppercase;font-family:Poppins-Bold,sans-serif;line-height:1;padding:0 4px;letter-spacing:.02rem}.player-container .status-video .icon{position:relative;top:2px}.player-container .status-video .icon-dot-12{top:-2px}.player-container .status-video-1{top:15px}.player-container .status-video-2{top:50px}.player-container .status-video-3{top:85px}.player-container .finished{background-color:#fc4349}.player-container .scheduled{background-color:#0e54a9}.player-container .live{background-color:#fc4349}.player-container .donate{background-color:#bad668}.player-container .info{background-color:#ffbe00}.finished{background-color:#fc4349}button{display:flex;align-items:center}.loader-container{position:relative;width:40px}.loader-container ::ng-deep .full-spinner{right:13px}.loader-container ::ng-deep .full-spinner .css-spinner{width:40px}.loader-container ::ng-deep .full-spinner .css-spinner .bounce1,.loader-container ::ng-deep .full-spinner .css-spinner .bounce2,.loader-container ::ng-deep .full-spinner .css-spinner .bounce3{width:9px;height:9px;background-color:#0e54a9}video{outline:none;width:100%;height:100%}.center{left:50%;top:50%}app-stream-access-modal,app-stream-age-restrictions-modal{position:absolute;z-index:10001}.icon-video-file{font-size:140px;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);color:#0e54a9;z-index:101}.volume-hover{bottom:285px!important}.active-chat{color:#2260ac}.played{display:flex}.vjs-paused.vjs-has-started ::ng-deep .vjs-big-play-button{display:block}.video-js.vjs-has-started ::ng-deep .show-overlay{display:block!important}.video-js{position:relative;width:100%!important}.video-js ::ng-deep .disabled-chat{display:none}.video-js ::ng-deep .chat-button{position:absolute;color:#0c1d3f;font-size:25px;right:19px;bottom:95px;width:25px;height:25px;font-family:icomoon!important;font-style:normal;font-weight:400;font-feature-settings:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;outline:none}.video-js ::ng-deep .chat-button.active-chat{color:#2260ac}.video-js ::ng-deep .chat-button:before{content:\"\uE934\"}.video-js ::ng-deep .left-course,.video-js ::ng-deep .left-overlay{position:absolute;width:140px;height:200px;left:25px;top:70px;background-color:transparent;display:none}.video-js ::ng-deep .right-course,.video-js ::ng-deep .right-overlay{position:absolute;width:140px;height:200px;right:25px;top:70px;background-color:transparent;display:none}.video-js ::ng-deep .bottom-course,.video-js ::ng-deep .bottom-overlay{position:absolute;width:480px;height:70px;left:50%;transform:translatex(-50%);bottom:70px;background-color:transparent;display:none}.video-js video{position:relative;height:100%!important;width:100%!important}.video-js ::ng-deep .vjs-control-bar{background-color:transparent;bottom:30px;left:10%;width:90%}.video-js ::ng-deep .vjs-control-bar .vjs-paused{display:none}.video-js ::ng-deep .vjs-control-bar .vjs-playing{display:none}.video-js ::ng-deep .vjs-control-bar .vjs-volume-panel.vjs-volume-panel-vertical{width:1em;position:absolute;right:16px;top:-30px;margin-left:30px;color:#0c1d3f;font-family:icomoon!important;speak:none;font-style:normal;font-weight:400;font-feature-settings:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;font-size:25px}.video-js ::ng-deep .vjs-control-bar .vjs-volume-panel.vjs-volume-panel-vertical .vjs-icon-placeholder:before{content:\"\";width:1em;left:-30px}.video-js ::ng-deep .vjs-control-bar .vjs-volume-panel.vjs-volume-panel-vertical:before{content:\"\uE933\"}.video-js ::ng-deep .vjs-control-bar .vjs-volume-panel.vjs-volume-panel-vertical .vjs-mute-control{outline:none}.video-js ::ng-deep .vjs-control-bar .vjs-volume-vertical{transition:none}.video-js ::ng-deep .vjs-control-bar .vjs-hover .vjs-volume-vertical{width:1em;left:-4.8em}.video-js ::ng-deep .vjs-control-bar .vjs-picture-in-picture-control{display:none}.video-js ::ng-deep .vjs-control-bar .vjs-progress-holder{height:12px;background:#0c1d3f}.video-js ::ng-deep .vjs-control-bar .vjs-play-progress:before{top:-7px;height:26px;width:26px;border-radius:50%;background:#fff}.video-js ::ng-deep .vjs-control-bar .vjs-fullscreen-control{margin-left:30px;color:#0c1d3f;font-family:icomoon!important;speak:none;font-style:normal;font-weight:400;font-feature-settings:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;font-size:25px;width:1em;right:20px}.video-js ::ng-deep .vjs-control-bar .vjs-fullscreen-control:before{content:\"\uE91D\"}.video-js ::ng-deep .vjs-control-bar .vjs-fullscreen-control .vjs-icon-placeholder:before{content:\"\"}.video-js ::ng-deep .vjs-control-bar .livestream-time{display:block;left:-100%;color:#fff;background-color:rgba(0,0,0,.4)}.video-js ::ng-deep .vjs-control-bar .vjs-live-display{display:none}.video-js ::ng-deep button.vjs-big-play-button{border:none;position:absolute;z-index:102;top:50%;left:50%;transform:translate(-50%,-50%);width:122px;height:122px;border-radius:50%;background:rgba(12,29,63,.85);cursor:pointer}.video-js ::ng-deep button.vjs-big-play-button:after{content:\"\";position:absolute;z-index:103;top:50%;left:50%;transform:translateY(-50%);margin-left:-20px;border-top:38px solid transparent;border-bottom:38px solid transparent;border-left:60px solid #fff;cursor:pointer}.video-js ::ng-deep button.vjs-big-play-button .vjs-icon-placeholder:before{content:\"\"}.no-data ::ng-deep .video-js.vjs-paused .vjs-poster{display:block!important;background-size:cover!important}::ng-deep .vjs-poster{background-size:cover!important}.video-js{-o-object-fit:cover;object-fit:cover}.disabled-player{pointer-events:none}.timeline-no-action{background-color:#efefef}.timeline-can-take-action{background-color:#5ea1f2!important}.timeline-can-take-action:after{border-left-color:#5ea1f2!important}.timeline-can-take-action:before{border-right-color:#5ea1f2!important}.timeline-action-taken{background-color:#0e54a9}.timeline-action-taken:after{border-left-color:#0e54a9!important}.timeline-action-taken:before{border-right-color:#0e54a9!important}.timeline-finished{background-color:#fc4349}.timeline-finished:after{border-left-color:#fc4349!important}.timeline-finished:before{border-right-color:#fc4349!important}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [ENVIRONMENT]
            }] }]; }, { videoEnded: [{
            type: Output
        }], videoClicked: [{
            type: Output
        }], overlayClicked: [{
            type: Output
        }], overlayViewed: [{
            type: Output
        }], playerSignal: [{
            type: Output
        }], fullscreenToggle: [{
            type: Output
        }], timeUpdated: [{
            type: Output
        }], config: [{
            type: Input
        }], currentLivestreamTime: [{
            type: Input
        }], buttonsConfig: [{
            type: Input
        }], marketingSocket: [{
            type: Input
        }], playerController: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SchedulerService, [{
        type: Injectable
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarketingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [ENVIRONMENT]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [API_URLS]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VideojsComponent, [{
        type: Component,
        args: [{
                selector: 'ano-videojs',
                template: "<div #videoWrapper [class.hidden-controls]=\"config?.mediaSource?.subtype !== MEDIA_SUBTYPE.MAIN && !startedMain\" [class.no-play]=\"!playButton\">\n    <video style=\"width: 100%; height: 100%;\" #target class=\"video-js\" oncontextmenu=\"return false;\" webkit-playsinline playsinline crossorigin=\"anonymous\"></video>\n</div>\n",
                providers: [AutoDestroyService, SchedulerService, MarketingService],
                styles: ["@charset \"UTF-8\";.hidden-controls ::ng-deep .livestream-time,.hidden-controls ::ng-deep .vjs-progress-control,.hidden-controls ::ng-deep .vjs-remaining-time{opacity:0!important}.hidden-controls ::ng-deep .vjs-remaining-time{opacity:1!important;position:absolute;left:-50px}.no-play ::ng-deep .vjs-big-play-button{display:none!important}video{outline:none;width:100%;height:100%}.center{left:50%;top:50%}app-stream-access-modal,app-stream-age-restrictions-modal{position:absolute;z-index:10001}.icon-video-file{font-size:140px;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);color:#0e54a9;z-index:101}.volume-hover{bottom:285px!important}::ng-deep.active-button{color:#1d7dd3}.played{display:flex}.vjs-paused.vjs-has-started ::ng-deep .vjs-big-play-button{display:block}.video-js.vjs-has-started ::ng-deep .show-overlay{display:block!important}.video-js{position:relative;width:100%!important}.video-js:hover ::ng-deep .player-gradient{display:block}.video-js:hover ::ng-deep .icon-chat{display:block}.video-js:hover ::ng-deep .icon-linked{display:block}.video-js:hover ::ng-deep .icon-users{display:block}.video-js:hover ::ng-deep .icon-data-random{display:block}.video-js:hover ::ng-deep .icons-donations{display:block}.video-js:hover ::ng-deep .location{display:block}.video-js:hover ::ng-deep .icon-presentation{display:block}.video-js:hover ::ng-deep .icon-calendar{display:block}.video-js:hover ::ng-deep .icon-360{display:block}.video-js:hover ::ng-deep .icon-share-alt{display:block}.video-js ::ng-deep .vjs-control-bar.disabled-controls{display:none}.video-js ::ng-deep .disabled-chat{display:none}.video-js ::ng-deep .icon-chat,.video-js ::ng-deep .icon-data-random,.video-js ::ng-deep .icon-linked,.video-js ::ng-deep .icon-share-alt,.video-js ::ng-deep .icon-users{display:none;color:#fff;font-size:25px;width:25px;height:25px;font-family:icomoon!important;font-style:normal;font-weight:400;font-feature-settings:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;outline:none;z-index:100}.video-js ::ng-deep .icon-chat.active-button,.video-js ::ng-deep .icon-data-random.active-button,.video-js ::ng-deep .icon-linked.active-button,.video-js ::ng-deep .icon-share-alt.active-button,.video-js ::ng-deep .icon-users.active-button{color:#1d7dd3}.video-js ::ng-deep .icon-chat:before{content:\"\uE90B\"}.video-js ::ng-deep .icon-share-alt:before{content:\"\uE93A\"}.video-js ::ng-deep .icons-donations{display:none;position:absolute;color:#fff;font-size:25px;right:19px;bottom:120px;width:25px;height:25px;font-family:icomoon!important;font-style:normal;font-weight:400;font-feature-settings:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;outline:none;z-index:100}.video-js ::ng-deep .icons-donations.active-button{color:#1d7dd3}.video-js ::ng-deep .icons-donations:before{content:\"\uE951\"}.video-js ::ng-deep .location{display:none;color:#fff;font-size:25px;width:25px;height:25px;font-family:icomoon!important;font-style:normal;font-weight:400;font-feature-settings:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;outline:none;z-index:100}.video-js ::ng-deep .location.active-button{color:#1d7dd3}.video-js ::ng-deep .location:before{content:\"\uE935\"}.video-js ::ng-deep .icon-presentation{display:none;color:#fff;font-size:25px;width:25px;height:25px;font-family:icomoon!important;font-style:normal;font-weight:400;font-feature-settings:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;outline:none;z-index:100}.video-js ::ng-deep .icon-calendar{display:none;font-size:25px;width:25px;height:25px;outline:none;z-index:100}.video-js ::ng-deep .icon-360{display:none;font-size:25px;width:25px;height:25px;outline:none;z-index:100;left:19px;top:83%}.video-js ::ng-deep .player-gradient{height:220px;width:100%;position:absolute;bottom:0;left:0;transition:opacity .25s cubic-bezier(0,0,.2,1);background:linear-gradient(0deg,rgba(0,0,0,.65),rgba(34,34,34,.28) 50%,transparent 90%);display:none;outline:none;z-index:0}.video-js ::ng-deep .resize{transform:rotate(-90deg);position:absolute;z-index:1000;color:#0e2f90;font-size:25px;right:19px;bottom:20px;width:25px;height:25px;font-family:icomoon!important;font-style:normal;font-weight:400;font-feature-settings:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;outline:none}.video-js ::ng-deep .resize.active-button{color:#1d7dd3}.video-js ::ng-deep .resize:before{content:\"\uE91D\"}.video-js ::ng-deep .resize ::ng-deep .icon-donations{display:none;position:absolute;color:#0e2f90;font-size:25px;right:19px;bottom:120px;width:25px;height:25px;font-family:icomoon!important;font-style:normal;font-weight:400;font-feature-settings:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;outline:none;z-index:10000000}.video-js ::ng-deep .resize ::ng-deep .icon-donations.active-button{color:#1d7dd3}.video-js ::ng-deep .resize ::ng-deep .icon-donations:before{content:\"\uE951\"}.video-js ::ng-deep .left-course,.video-js ::ng-deep .left-overlay{position:absolute;width:140px;height:200px;left:25px;top:70px;background-color:transparent;display:block}.video-js ::ng-deep .right-course,.video-js ::ng-deep .right-overlay{position:absolute;width:140px;height:200px;right:25px;top:70px;background-color:transparent;display:block}.video-js ::ng-deep .bottom-course,.video-js ::ng-deep .bottom-overlay{position:absolute;width:480px;height:70px;left:50%;transform:translatex(-50%);bottom:70px;background-color:transparent;display:block}.video-js video{position:absolute;height:100%!important;width:100%!important}.video-js ::ng-deep .vjs-control-bar{background-color:transparent;bottom:30px;left:10%;width:90%;z-index:1000}.video-js ::ng-deep .vjs-control-bar .vjs-paused{display:none}.video-js ::ng-deep .vjs-control-bar .vjs-playing{display:none}.video-js ::ng-deep .vjs-control-bar .vjs-volume-panel{position:absolute;right:10px;bottom:33px;display:flex;flex-direction:row-reverse}.video-js ::ng-deep .vjs-control-bar .vjs-volume-panel .vjs-icon-placeholder:before{font-size:2.5em;line-height:1.67;position:absolute;top:-5px}.video-js ::ng-deep .vjs-control-bar .vjs-picture-in-picture-control{display:none}.video-js ::ng-deep .vjs-control-bar .vjs-progress-holder{height:12px;background:#0e2f90}.video-js ::ng-deep .vjs-control-bar .vjs-play-control{display:none}.video-js ::ng-deep .vjs-control-bar .vjs-play-progress:before{top:-7px;height:26px;width:26px;border-radius:50%;background:#fff}.video-js ::ng-deep .vjs-control-bar .vjs-fullscreen-control{margin-left:31px;color:#fff;font-family:icomoon!important;speak:none;font-style:normal;font-weight:400;font-feature-settings:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;font-size:25px;width:1em;right:-20px}.video-js ::ng-deep .vjs-control-bar .vjs-fullscreen-control:before{content:\"\uE91D\"}.video-js ::ng-deep .vjs-control-bar .vjs-fullscreen-control .vjs-icon-placeholder:before{content:\"\"}.video-js ::ng-deep .vjs-control-bar .livestream-time{display:block;left:-102%;color:#fff;background-color:rgba(0,0,0,.4)}.video-js ::ng-deep .vjs-control-bar .vjs-live-display{display:none}.video-js ::ng-deep button.vjs-big-play-button{border:none;position:absolute;z-index:102;top:50%;left:50%;transform:translate(-50%,-50%);width:122px;height:122px;border-radius:50%;background:rgba(12,29,63,.85);cursor:pointer}.video-js ::ng-deep button.vjs-big-play-button:after{content:\"\";position:absolute;z-index:103;top:50%;left:50%;transform:translateY(-50%);margin-left:-20px;border-top:38px solid transparent;border-bottom:38px solid transparent;border-left:60px solid #fff;cursor:pointer}.video-js ::ng-deep button.vjs-big-play-button .vjs-icon-placeholder:before{content:\"\"}.no-data ::ng-deep .video-js.vjs-paused .vjs-poster{display:block!important;background-size:cover!important}::ng-deep .vjs-poster{background-size:cover!important}.video-js{-o-object-fit:cover;object-fit:cover}.disabled-player{pointer-events:none}.timeline-no-action{background-color:#bebebe}.timeline-can-take-action{background-color:#5ea1f2!important}.timeline-can-take-action:after{border-left-color:#5ea1f2!important}.timeline-can-take-action:before{border-right-color:#5ea1f2!important}.timeline-action-taken{background-color:#0e54a9}.timeline-action-taken:after{border-left-color:#0e54a9!important}.timeline-action-taken:before{border-right-color:#0e54a9!important}.timeline-finished{background-color:#fc4349}.timeline-finished:after{border-left-color:#fc4349!important}.timeline-finished:before{border-right-color:#fc4349!important}::ng-deep .close-overlay{position:absolute;right:0;background:#000;padding:2px;z-index:11}::ng-deep .buttons-player-box{display:flex;flex-direction:column;position:absolute;z-index:100;bottom:90px;right:20px;height:100px;justify-content:flex-end}::ng-deep .buttons-player-box button{margin-bottom:5px!important}::ng-deep .overlay{height:100%;position:absolute;width:100%;top:0;z-index:1000}::ng-deep .clickable{position:absolute;z-index:10!important}::ng-deep .btn-still{position:absolute;right:18px;top:18px;z-index:15}::ng-deep .left-course .btn-still,::ng-deep .left-overlay .btn-still,::ng-deep .right-course .btn-still,::ng-deep .right-overlay .btn-still{right:21px;left:21px;top:auto;bottom:15px}::ng-deep .video-js button.btn-primary{background:#0e54a9;color:#fff;border:none}::ng-deep .video-js button.btn-primary:hover{background:#0c1d3f}::ng-deep p.text-course{position:absolute;height:100%;margin:0;width:100%;padding:10px;opacity:1;z-index:2}::ng-deep .overlay-box{width:100%;height:100%;background-position:50%;background-size:cover;padding:10px;color:#fff;text-shadow:0 0 1em #000;font-weight:700;z-index:1}::ng-deep .course-box{z-index:11;padding:0!important}::ng-deep .bottom-course .text-course,::ng-deep .bottom-overlay .text-course{text-align:left;display:flex;align-items:center}::ng-deep p.text{position:absolute;height:100%;margin:0;width:100%;padding:10px;opacity:1;z-index:2}::ng-deep .black{text-shadow:0 0 1em #000;color:#000}::ng-deep .white{text-shadow:0 0 1em #fff;color:#fff}::ng-deep .vjs-fullscreen .left-course,::ng-deep .vjs-fullscreen .left-overlay,::ng-deep .vjs-fullscreen .right-course,::ng-deep .vjs-fullscreen .right-overlay{top:50%!important;transform:translateY(-50%)!important}::ng-deep .vjs-fullscreen .bottom-course,::ng-deep .vjs-fullscreen .bottom-overlay{height:92px!important;width:624px!important}@media (max-width:767px){.video-js ::ng-deep .left-course,.video-js ::ng-deep .left-overlay{width:100px;height:120px;left:10px;top:10px}.video-js ::ng-deep .right-course,.video-js ::ng-deep .right-overlay{width:100px;height:120px;right:10px;top:10px}.video-js ::ng-deep .bottom-course,.video-js ::ng-deep .bottom-overlay{width:75%;aspect-ratio:6.8/1;height:auto}}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [AutoDestroyService]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [MarketingService]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [LocalizationProvider]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [ENVIRONMENT]
            }] }]; }, { videoEnded: [{
            type: Output
        }], videoClicked: [{
            type: Output
        }], playerSignal: [{
            type: Output
        }], overlayClicked: [{
            type: Output
        }], overlayViewed: [{
            type: Output
        }], fullscreenToggle: [{
            type: Output
        }], timeUpdate: [{
            type: Output
        }], _playerController: [{
            type: Input,
            args: ['playerController']
        }], _config: [{
            type: Input,
            args: ['config']
        }], buttonsConfig: [{
            type: Input
        }], _currentLivestreamTime: [{
            type: Input,
            args: ['currentLivestreamTime']
        }], videoWrapper: [{
            type: ViewChild,
            args: ['videoWrapper', { static: true }]
        }], target: [{
            type: ViewChild,
            args: ['target', { static: true }]
        }], marketingSocket: [{
            type: Input
        }], externalPlayerSignal: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CmsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [ApiService]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [API_URLS]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [ENVIRONMENT]
            }] }]; }, null); })();

const getFileNameFromResponseContentDisposition = (res) => {
    const contentDisposition = res.headers.get('content-disposition') || '';
    const matches = /filename = ([^;]+)/ig.exec(contentDisposition);
    const fileName = (matches[1] || 'untitled').trim();
    return fileName;
};

function localizationProviderFactory(provider, cmsService) {
    return () => Promise.all([provider.load(), cmsService.getCountries(), cmsService.getGenresOnStart()]);
}

/*
 * Public API Surface of ui-elements
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ACTIONS, API_URLS, ApiService, ApiUrls, AutoDestroyService, BILL_MEDIA_TYPE, BILL_STATUS, BILL_TYPE, BarChartComponent, BillsTableComponent, ButtonComponent, CARD_TYPE, COURSE_COLOR, CURRENCY_SYMBOLS, CURRENCY_VALUES, CURRENT_CURRENCY, CUR_SYM, CleaveMaskDirective, CmsService, CurrencyPipe, CustomValidators, DATETIME_INPUT_TYPE, DATETIME_PICKER_TYPE, DateFormatPipe, DateHelper, DatepickerComponent, DefaultIntl, DndDirective, DragAndDropComponent, DropdownComponent, ENVIRONMENT, EXTERNAL_PLAYER_SIGNAL, FILTER_MEDIA_TYPES, FILTER_TYPES, FilterDropdownComponent, FormComponent, FormService, INPUT_TYPES, ITimeType, IbanPipe, ImagePipe, InfoPanelComponent, InfoPanelsConfig, InputComponent, LOADER_THEMES, LegendBoxComponent, LinkedStreamsFilterComponent, LoaderComponent, LoadingService, LocalizationPipe, LocalizationProvider, MARKETING_ACTION, MARKETING_ENTITY_TYPE, MEDIA_FILTERS_FIELDS, MEDIA_FORMAT, MEDIA_SUBTYPE, MEDIA_TYPE, MY_FORMATS, MY_NATIVE_FORMATS, MarketingService, ModalComponent, NEW_ID_PARAM, NewPaymentsSlots$1 as NewPaymentsSlots, NumberComponent, NumberPipe, OVERLAY_TYPE, PAYMENT_SYSTEM, PHONE_MASK, PRICE_VALIDATION_TYPE, PUBLISHER_FILTERS, PasswordValidatorComponent, PaymentsStream, PaymentsVideo, PieChartComponent, PieChartUsedComponent, PlayerComponent, RECORD_STATUS, RadioSelectComponent, SPEEDOMETER_SEGMENT_SIZE, STATE, STREAM_STATUS, SUBSCRIPTION_TYPE, SUB_ACCOUNT_TYPE, SURVEY_STATUS, ScatterChartComponent, SchedulerService, ScrollToFirstErrorDirective, SearchComponent, SearchInputComponent, SnackBarService, SpeedometerComponent, StreamEventsService, StreamMarketingToolsOverlaysTypes, StringCutPipe, TEMPLATE_ID, TIME_POINT, TIME_TYPE, TableComponent, TimeRangeFilterComponent, USER_TYPE, UiElementsModule, VIEWER_FILTERS, VideojsComponent, WIDGET_TYPE, WebSocketConnector, WhiteSpacePipe, WidgetComponent, asBoolean, cutString, getFileNameFromResponseContentDisposition, getWithDecimals, isAlphanumeric, localizationProviderFactory, obfuscateEmail, revertString, MaterialModule as ɵa, commonDeclarations as ɵb, commonImports as ɵc, commonExports as ɵd };

